'use strict';

angular.module('hes.constants', []);
angular.module('hes', ['smart-table']);
angular.module('hes.config', ['hes.constants']);

angular.lowercase = angular.$$lowercase;

angular.module('goApp', [
  'templates-dist',
  'ngCookies',
  'ngResource',
  'ngAnimate',
  'ngMessages',
  'ngSanitize',
  'ngDialog',
  'ngMedia',
  'ui.router',
  'hes',
  'hes.config',
  'hes.constants',
  'ng.shims.placeholder',
  'jlareau.bowser',
  'ipCookie',
  'angulartics',
  'angulartics.google.analytics',
  'angularFileUpload',
  'angular.filter',
  'ui.tree',
  'ui.grid',
  'ui.grid.resizeColumns',
  'ui.grid.autoResize',
  'ui.grid.exporter',
  'angular-inview',
  'minicolors',
  'ui.timepicker',
  'ngMaterial',
  'ngconstant',
  'ngIdle',
  'ngAnimate',
  'html5.sortable',
  angularDragula(angular),
  'ngQuill',
  'betsol.intlTelInput'
]);
'use strict';

angular.module('goApp').config(function($stateProvider, $urlRouterProvider, $locationProvider) {

  $stateProvider.state('go', {
    controller: 'ConfigController',
    templateProvider: ['hesTemplateService', function(hesTemplateService) {
      return hesTemplateService.getTemplate('/scripts/app.html');
    }],
    resolve: {
      site: ['ConfigService',
        function(ConfigService) {
          return ConfigService.getSite();
        }
      ]
    },
    abstract: true
  });

  $stateProvider.state('go.u', {
    controller: 'ConfigUserController',
    templateProvider: ['hesTemplateService', function(hesTemplateService) {
      return hesTemplateService.getTemplate('/scripts/config/userView.html');
    }],
    resolve: {
      user: ['CurrentUser', '$state',
        function(CurrentUser, $state) {
          return CurrentUser.get(true).then(function(user) {
            return user;
          }, function(error) {
            $state.transitionTo('go.welcome');
            return null;
          });
        }
      ]
    },
    abstract: true
  });

  // tab states
  $stateProvider.state('go.u.personal', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });

  $stateProvider.state('go.u.content', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });

  $stateProvider.state('go.u.settings', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });

  $stateProvider.state('go.u.coordinator', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });


  $stateProvider.state('go.u.usermenu', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });

  $stateProvider.state('go.u.evaluations', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });

  $stateProvider.state('go.help', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });

  $stateProvider.state('go.privacy_terms', {
    abstract: true,
    controller: "TabsController",
    templateProvider: ['hesTemplateService',
      function(hesTemplateService) {
        return hesTemplateService.getTemplate('/scripts/tabs/secondary-tabs-only-layout.html');
      }
    ]
  });

  $urlRouterProvider.when('/home/', ['$rootScope', function($scope) {
    var route = '/home';

    if ($scope.user && $scope.user.isCoordinator()) {
      route = '/coordinator';
    }

    return route;
  }]);

  $locationProvider.html5Mode(true);

  $urlRouterProvider.otherwise('/');



});
'use strict';

angular.module('goApp').run(function($rootScope, $q, HesSocket, CurrentUser, CurrentSite, $timeout, Notification, Post, MessageService) {
  setup();

  $rootScope.$on('userLoggedIn', setup);
  $rootScope.$on('userLoggedOut', tearDown);

  function setup() {
    //tearDown();
    $q.all([
      HesSocket.connect(),
      CurrentSite.get(),
      CurrentUser.get()
    ]).then(function(data){
      var socket = data[0],
          site = data[1],
          user = data[2];

      if(site.flags.is_launchpad_plus && site.features_on) {
        HesSocket.emit('joinChannel', {
          channel: site.websocket_channel
        });
        HesSocket.emit("joinChannel", {
          channel: user.websocket_channel
        });
      }

      // attach listeners
      
      HesSocket.on('userUpdated', function(data) {
        var data = convertDataStringToJSON(data);
      });

      HesSocket.on('conversationAlert', function(payload) {
        var data = payload.data;
        data = convertDataStringToJSON(data);

        if (payload.type == 'message') {
          MessageService.handleRealTimeMessage(data);
          if (!payload.muted) {
            data.doAlert = true;
            $rootScope.$broadcast('newConversationMessage', data);
          }
        } else if (payload.type == 'action') {
          if (!payload.muted) {
            MessageService.handleRealTimeMessage(data[0]);
          }
        } else if (payload.type == 'conversation') {
          MessageService.handleRealTimeConversation(data);
          $rootScope.$broadcast('newConversationMessage', data);
        } else if (payload.type == 'remove_conversation') {
          MessageService.handleRealTimeConversationRemove(data);
        }

        // will trigger call to API /notificaitons/count to get all counts
        $rootScope.$broadcast('modelUpdate', {model:'Message'});
      });

      HesSocket.on('notificationPublished', function(data) {
        var data = convertDataStringToJSON(data);
        $rootScope.$broadcast('notificationPublished', new Notification(data.notification));
      });

      HesSocket.on('modelUpdate', function(data) {
        var data = convertDataStringToJSON(data);
        $rootScope.$broadcast('modelUpdate', data);
      });

      // Listens for new posts from the server.
      HesSocket.on('newPostCreated', function(data) {
        data = convertDataStringToJSON(data);
        Post.show(data,
          function(post) {
            post.init();
            CurrentUser.get().then(function(user) {
              if (user.id != post.user.id) {
                $rootScope.$broadcast('newPost', post);
              }
            });
          },
          function(rejection) {});
      });
      // end listers
    });
  }

  function tearDown() {
    console.log("tearing down websocket");
    HesSocket.disconnect();
  }


  function convertDataStringToJSON(data) {
    if (angular.isString(data)) {
      try {
        data = JSON.parse(data);
      } catch (e) {
        data = data;
      }
    }
    return data;
  }




});
angular.module('templates-dist', ['/scripts/404/404.html', '/scripts/500/500.html', '/scripts/app.html', '/scripts/authentication/impersonate.html', '/scripts/badges/badgePopup.html', '/scripts/badges/badgesEditor.html', '/scripts/badges/badgesList.html', '/scripts/badges/confirm-delete.html', '/scripts/badges/user_badges.html', '/scripts/billboard/admin/billboard-edit.html', '/scripts/billboard/admin/billboards.html', '/scripts/billboard/billboard-agent.html', '/scripts/billboard/blocks/banner/banner_block.html', '/scripts/billboard/blocks/banner/evaluation_block.html', '/scripts/billboard/blocks/coming_soon/coming_soon_block.html', '/scripts/billboard/blocks/enter/enter_block.html', '/scripts/billboard/blocks/opt_in/feature_block.html', '/scripts/billboard/blocks/opt_in/friend_block.html', '/scripts/billboard/blocks/opt_in/hero_block.html', '/scripts/billboard/blocks/opt_in/hero_block_no-shadow.html', '/scripts/billboard/blocks/opt_in/hero_block_v2.html', '/scripts/billboard/blocks/opt_in/mobile_block.html', '/scripts/billboard/blocks/opt_in/video_block.html', '/scripts/billboard/blocks/placeholder/placeholder_block.html', '/scripts/billboard/blocks/placeholder/placeholder_block_no_shadow.html', '/scripts/billboard/blocks/registration_closed/registration_closed_block.html', '/scripts/billboard/shrink-arrow.html', '/scripts/breadcrumb/breadcrumb.html', '/scripts/challenges/admin/views/challenge-edit.html', '/scripts/challenges/admin/views/challenges.html', '/scripts/challenges/views/_active.html', '/scripts/challenges/views/_completed.html', '/scripts/challenges/views/_completed_popup.html', '/scripts/challenges/views/_confirm_complete.html', '/scripts/challenges/views/_pending.html', '/scripts/challenges/views/_pending_popup.html', '/scripts/challenges/views/_placeholder.html', '/scripts/challenges/views/active.html', '/scripts/challenges/views/challenge-timer.html', '/scripts/challenges/views/completed.html', '/scripts/challenges/views/select-challenge.html', '/scripts/challenges/views/select-user.html', '/scripts/choose-logging/choose-logging.html', '/scripts/config/mainLayout.html', '/scripts/config/userView.html', '/scripts/contact/contact.html', '/scripts/content/confirmDeleteContent.html', '/scripts/content/contentAddEdit.html', '/scripts/content/contentPreview.html', '/scripts/content/keywords/keywords.html', '/scripts/content/welcome/welcomeEdit.html', '/scripts/coordinator/eligibility/eligibilityFile.html', '/scripts/coordinator/flagged_posts/flagged_posts.html', '/scripts/coordinator/notifications/confirmSendMessage.html', '/scripts/coordinator/notifications/notifications.html', '/scripts/coordinator/reports/reports.html', '/scripts/coordinator/stats/stats.html', '/scripts/coordinator/upcoming_launches/upcoming_launches.template.html', '/scripts/coordinator/users.html', '/scripts/countdown/countdown.html', '/scripts/countdown/countdownPage.html', '/scripts/customEmails/customEmails.html', '/scripts/customEmails/dialogs/previewDialog.html', '/scripts/customEmails/editor/customEmailsEditor.html', '/scripts/customEmails/queued_emails/index.template.html', '/scripts/customEmails/queued_emails/show.template.html', '/scripts/devices/apple_health_popup.html', '/scripts/devices/choose/choose-device-view.html', '/scripts/devices/choose/choose-layout.html', '/scripts/devices/choose/choose-view.html', '/scripts/devices/connection_error.html', '/scripts/devices/connection_successful.html', '/scripts/devices/device_information.html', '/scripts/devices/device_options.html', '/scripts/devices/fitbit_connection_error.html', '/scripts/devices/fitbit_summary.html', '/scripts/devices/garmin_connection_error.html', '/scripts/devices/google_health_connect.html', '/scripts/devices/google_health_connection_error.html', '/scripts/devices/google_health_connection_success.html', '/scripts/devices/googlefit_connection_error.html', '/scripts/devices/health_connect_popup.html', '/scripts/devices/marketplace/marketplace.html', '/scripts/dialogs/confirmationDialog.html', '/scripts/dialogs/confirmationReverseDialog.html', '/scripts/dialogs/confirmationUnsavedDialog.html', '/scripts/dialogs/email.html', '/scripts/dialogs/informationDialog.html', '/scripts/dialogs/sendSmsDialog.html', '/scripts/dialogs/uploading.html', '/scripts/eligibility/confirmDeleteElig.html', '/scripts/eligibility/confirmDeleteEligFile.html', '/scripts/eligibility/confirmResetElig.html', '/scripts/eligibility/eligLabelHover.html', '/scripts/eligibility/eligibilities.html', '/scripts/eligibility/eligibility.html', '/scripts/eligibility/eligibilityCreateEdit.html', '/scripts/eligibility/eligibilityFile.html', '/scripts/entries-chart/entries-chart.template.html', '/scripts/entries/banners/coming_soon.html', '/scripts/entries/banners/enter_logging.html', '/scripts/entries/banners/enter_no_logging.html', '/scripts/entries/banners/logging_ended.html', '/scripts/entries/banners/opt_in_logging.html', '/scripts/entries/banners/opt_in_no_logging.html', '/scripts/entries/banners/registration_closed.html', '/scripts/entries/views/entries.html', '/scripts/entries/views/entry-edit-desktop.html', '/scripts/entries/views/entry-edit-mobile.html', '/scripts/entries/views/entry-edit.html', '/scripts/entries/views/entry-show-desktop.html', '/scripts/entries/views/entry-show-mobile.html', '/scripts/entries/views/entry-show.html', '/scripts/entries/views/why-steps.html', '/scripts/errors/errorBanner.html', '/scripts/evaluations/evaluation.html', '/scripts/evaluations/siteEvaluation-createEdit.html', '/scripts/evaluations/siteEvaluationQuestion-createEdit.html', '/scripts/evaluations/userEvaluation.html', '/scripts/faqs/faqs.html', '/scripts/feedback/feedback.html', '/scripts/footer/footer.html', '/scripts/footer/footer_acme.html', '/scripts/footer/mobile-overlay.html', '/scripts/friendships/_pager.template.html', '/scripts/friendships/friends-list.html', '/scripts/friendships/friends-pending.html', '/scripts/friendships/friends-search.html', '/scripts/friendships/friendship-placeholder.html', '/scripts/friendships/friendship.html', '/scripts/galleries/image_gallery.html', '/scripts/galleries/image_gallery_placeholder.html', '/scripts/goals/admin/goal-admin-edit.html', '/scripts/goals/admin/goals-list-admin.html', '/scripts/goals/goal-create.html', '/scripts/goals/goal-share-popup.html', '/scripts/goals/goal-view-popup.html', '/scripts/goals/goal_gallery.html', '/scripts/goals/goals-active.html', '/scripts/goals/goals-choose.html', '/scripts/goals/goals-completed.html', '/scripts/header/header.html', '/scripts/header/megaMenu/megaMenu.html', '/scripts/header/user-menu/user-menu.html', '/scripts/header/user-menu/userMenuItemsList.html', '/scripts/header/welcomeHeader.html', '/scripts/hes/hesImgCropper.html', '/scripts/hes/loadingGif.html', '/scripts/hes/main_layout.html', '/scripts/highContrast/highContrast.html', '/scripts/home/_billboards.html', '/scripts/home/_home_normal.html', '/scripts/home/_home_plus.html', '/scripts/home/banner.html', '/scripts/home/home.html', '/scripts/home/homepageTile/challenges.html', '/scripts/home/homepageTile/chart.html', '/scripts/home/homepageTile/goals.html', '/scripts/home/homepageTile/recipes.html', '/scripts/home/homepageTile/tips.html', '/scripts/home/homepageTile/wall.html', '/scripts/home/video-popup.html', '/scripts/icons/iconTemplate.html', '/scripts/idleTimeout/idleTimeout.html', '/scripts/imageViewer/imageViewer.html', '/scripts/imageViewer/imageViewerDialog.html', '/scripts/loadMoreButton/loadMoreButton.html', '/scripts/location/confirmDeleteLocation.html', '/scripts/location/locationCreateEdit.html', '/scripts/location/locations.html', '/scripts/location/prompt_location/promptLocationDialog.html', '/scripts/login/login.html', '/scripts/login/logout.html', '/scripts/mdHesPopover/md-hes-popover.html', '/scripts/messages/confirmRemoveMember.html', '/scripts/messages/conversation.html', '/scripts/messages/conversationSettings.html', '/scripts/messages/conversationsList.html', '/scripts/notifications/alert.html', '/scripts/notifications/notifications.html', '/scripts/password/forgotten_password.html', '/scripts/password/pilot_password.html', '/scripts/password/reset_password.html', '/scripts/password/reset_password_confirmation.html', '/scripts/photoUpload/customPhotoUpload.html', '/scripts/photoUpload/photoUpload.html', '/scripts/privacy/privacy.html', '/scripts/profile/profileUpload.html', '/scripts/programs/logging_content/preview_logging_content.template.html', '/scripts/programs/programCreateEdit.html', '/scripts/recipes/recipes-layout.html', '/scripts/recipes/views/recipe.html', '/scripts/recipes/views/recipes.html', '/scripts/registration/eligibilityCheck.html', '/scripts/registration/indv_leaderboard_info.html', '/scripts/registration/participant_confidentiality.html', '/scripts/registration/readMoreHover.html', '/scripts/registration/registration.html', '/scripts/reports/confirm_delete_report.html', '/scripts/reports/createSaveAsDialog.html', '/scripts/reports/limit-50k-dialog.html', '/scripts/reports/masterDashboardReports.html', '/scripts/reports/reports.html', '/scripts/resources/views/resourcePreview.html', '/scripts/resources/views/resources.html', '/scripts/searchInput/searchInput.html', '/scripts/settings/dashboard.html', '/scripts/settings/message-popup.html', '/scripts/settings/settings-email.html', '/scripts/settings/settings-tracking.html', '/scripts/settings/settings.html', '/scripts/shareResource/email/emailResource.html', '/scripts/shareResource/shareDial.html', '/scripts/shareResource/shareToWall/shareToWall.html', '/scripts/site_map/site_map.html', '/scripts/sites/activity/activitiesList.html', '/scripts/sites/activity/activityEditor.html', '/scripts/sites/banners/banners.html', '/scripts/sites/coordinatorsBox/coordinatorsBox.html', '/scripts/sites/eopReporting/eopReporting.html', '/scripts/sites/site-createEdit.html', '/scripts/sites/site.html', '/scripts/sites/sites.html', '/scripts/sms/dialogs/editSmsDialog.html', '/scripts/sms/dialogs/sendSmsDialog.html', '/scripts/sms/queued/queued.html', '/scripts/sms/send.html', '/scripts/sms/show/show.template.html', '/scripts/ssoDetail/ssoDetail.html', '/scripts/ssoDetail/ssoDetailCreateEdit.html', '/scripts/ssoDetail/ssoDetailDestroy.html', '/scripts/star-rating/starRating.html', '/scripts/stats/campaigns_container.html', '/scripts/stats/gokp_legacy_stats.html', '/scripts/stats/legacy_stats.html', '/scripts/stats/stats.html', '/scripts/table/actionColTemplate.html', '/scripts/table/hesTable.html', '/scripts/table/htmlColTemplate.html', '/scripts/tablePager/tablePager.html', '/scripts/tabs/secondary-tabs-only-layout.html', '/scripts/tabs/tabbed-tile-layout.html', '/scripts/terms/terms.html', '/scripts/themes/editTheme.html', '/scripts/tips/tips-layout.html', '/scripts/tips/views/tip.html', '/scripts/tips/views/tips.html', '/scripts/totalSteps/total-steps.html', '/scripts/unsubscribe/unsubscribe.html', '/scripts/upload/fileUpload.html', '/scripts/upload/fileUploadPhoto.html', '/scripts/upload/hesUploadImage.html', '/scripts/upload/hesUploadImageDialog.html', '/scripts/users/confirmUserDelete.html', '/scripts/users/users.html', '/scripts/users/usersPopover.html', '/scripts/utilities/Pikaday/examples/amd.html', '/scripts/utilities/Pikaday/examples/jquery-amd.html', '/scripts/utilities/Pikaday/examples/jquery.html', '/scripts/utilities/Pikaday/examples/moment.html', '/scripts/walkthrough/walkthrough.template.html', '/scripts/wall/comments/resourceComments.html', '/scripts/wall/comments/wallComments.html', '/scripts/wall/expert/wall_expert.html', '/scripts/wall/following/followingUsers.html', '/scripts/wall/following/toggleFollow.html', '/scripts/wall/guidelines/guidelines.html', '/scripts/wall/post/create/createPost.html', '/scripts/wall/post/create/tagUsers/tagUsersDialog.html', '/scripts/wall/post/menu/postMenu.html', '/scripts/wall/post/post.html', '/scripts/wall/post/shared/sharedPost.html', '/scripts/wall/post/tagged/allTaggedUsersDialog.html', '/scripts/wall/post/tagged/taggedUsers.html', '/scripts/wall/posts/posts.html', '/scripts/wall/views/singlePost.html', '/scripts/wall/views/wall.html', '/scripts/webcart/webcart.html', '/scripts/webcart/webcartLink.html', '/scripts/welcome/welcome.html']);

angular.module("/scripts/404/404.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/404/404.html",
    "<div class='page-tile tile-height-4'>\n" +
    "  <div class='page-title'>\n" +
    "    <span class='content'>404</span>\n" +
    "    <span class='bottom-border hide-on-mobile'></span>\n" +
    "  </div>\n" +
    "\n" +
    "  <div>\n" +
    "    <p>Sorry, the page you have requested cannot be found.</p>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/500/500.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/500/500.html",
    "<div class='page-tile tile-height-4'>\n" +
    "  <div class='page-title'>\n" +
    "    <span class='content'>ERROR</span>\n" +
    "    <span class='bottom-border hide-on-mobile'></span>\n" +
    "  </div>\n" +
    "\n" +
    "  <div>\n" +
    "    <p>Oops, an unexpected error has occurred. If you continue to get this page please <a ng-if=\"user\" ui-sref=\"go.contact\">let us know</a><a ng-if=\"!user\" ui-sref=\"contactus\">let us know</a>. Thanks!</p>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/app.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/app.html",
    "<div ng-if='isWelcomePage()' class=\"app welcome\">\n" +
    "	<div ui-view></div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if='!isWelcomePage() && isUserPage()' class='app'>\n" +
    "  <div ui-view></div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if='!isWelcomePage() && !isUserPage()' class='app'>\n" +
    "  <div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/hes/main_layout.html')\"></div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"$state.current.name === 'go.dynamic'\">\n" +
    "	<div hes-alert></div>\n" +
    "  <div ui-view></div>\n" +
    "</div>\n" +
    "<div go-footer class=\"no-print footer\"></div>\n" +
    "<walkthrough ng-if=\"user && site.id != 5\"></walkthrough>");
}]);

angular.module("/scripts/authentication/impersonate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/authentication/impersonate.html",
    "<p>Please wait, impersonating user...</p>");
}]);

angular.module("/scripts/badges/badgePopup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/badges/badgePopup.html",
    " <div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    " <div class=\"dialog-title popup-badge-title\" markdown-div ng-model=\"popupBadge.name\" no-paragraph title=\"popupBadge.description\">\n" +
    " </div>\n" +
    " <div class=\"center\">\n" +
    "  <img class='popup-badge-image center' hes-image='{{popupBadge.image.url}}' use-domain='true' no-theme='true' alt=\"{{ popupBadge.alt }}\" />\n" +
    "</div>\n" +
    "<div markdown ng-model=\"popupBadge.popup_text\"></div>\n" +
    "<div>\n" +
    "  <em>{{ popupBadge.earned_on }}</em>\n" +
    "</div>");
}]);

angular.module("/scripts/badges/badgesEditor.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/badges/badgesEditor.html",
    "<div class=\"col3\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div class=\"standard-header\">{{ badge.name || 'New Badge' }}</div>\n" +
    "    <div class=\"navigate-action\">\n" +
    "      <a class='back-link' ng-click=\"reloadBadges()\">Back To Badges</a>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"tile-inner\" ng-if=\"!settings.loading\">\n" +
    "      <div class=\"font-lg\">\n" +
    "\n" +
    "        <div hes-validator class=\"edit-content tips\">\n" +
    "          <br/>\n" +
    "          <div class=\"badge-edit-box\">\n" +
    "\n" +
    "            <div>\n" +
    "              <div style=\"margin-bottom: 12px;\">\n" +
    "                <textarea ng-show=\"!!settings.nameMarkdown\" rows=\"1\" id=\"edit_name\" ng-model=\"badge.name\"></textarea>\n" +
    "                <label class='primary-label'>Name&nbsp;\n" +
    "                  <a ng-click=\"settings.nameMarkdown = !settings.nameMarkdown\">toggle markup</a>\n" +
    "                </label>\n" +
    "                <ng-quill-editor ng-model=\"badge.name\" required>\n" +
    "                  <ng-quill-toolbar>\n" +
    "                    <div>\n" +
    "                      <div class=\"ql-formats\">\n" +
    "                        <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                        <button class=\"ql-italic\"></button>\n" +
    "                        <button class=\"ql-underline\"></button>\n" +
    "                        <button class=\"ql-strike\"></button>\n" +
    "                      </div>\n" +
    "                      <div class=\"ql-formats\">\n" +
    "                        <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                        <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "                      </div>\n" +
    "                      <div class=\"ql-formats\">\n" +
    "                        <button class=\"ql-link\"></button>\n" +
    "                        <button class=\"ql-image\"></button>\n" +
    "                      </div>\n" +
    "                    </div>\n" +
    "                  </ng-quill-toolbar>\n" +
    "                </ng-quill-editor>\n" +
    "              </div>\n" +
    "              <table class=\"badge-edit\">\n" +
    "                <tbody>\n" +
    "                  <tr>\n" +
    "                    <td>\n" +
    "                      <label class='primary-label' for='name'>Name</label>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                      <input name='name' id='name' hes-required placeholder=\"Give it a name.\" ng-model='badge.name'/> \n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                  <tr>\n" +
    "                    <td>\n" +
    "                      <label class='primary-label' for='category'>Category</label>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                      <select id='category' hes-required ng-options='c as humanize(c) for c in data.categories' ng-model=\"badge.category\"></select>\n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                  <tr ng-if=\"getFieldLabel(badge.category, 'goal')\">\n" +
    "                    <td>\n" +
    "                      <label class='primary-label' for='goal'>{{ getFieldLabel(badge.category, 'goal') }}</label>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                      <input ng-if=\"!isCampaignBadge(badge.category)\" name='goal' id='goal' hes-required placeholder=\"Give it a goal.\" ng-model='badge.goal'/>\n" +
    "                      <select ng-if=\"isCampaignBadge(badge.category)\" name='goal' id='goal'  ng-options='a.domain_name as a.domain_name for a in dbSite.app_options' hes-required placeholder=\"Give it a goal.\" ng-model='badge.goal3'/></select>\n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                  <tr ng-if=\"getFieldLabel(badge.category, 'goal2')\">\n" +
    "                    <td>\n" +
    "                      <label class='primary-label' for='goal2'>{{ getFieldLabel(badge.category, 'goal2') }}</label>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                      <input name='goal2' id='goal2' hes-required placeholder=\"Give it another goal.\" ng-model='badge.goal2'/>\n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                  <tr ng-if=\"badge.category == 'distance_traveled'\">\n" +
    "                    <td>\n" +
    "                      <label class='primary-label' for='min_program_length'>Min Program Length</label>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                      <input name='minimum_program_length' id='min_program_length' hes-required placeholder=\"Give it a length.\" ng-model='badge.minimum_program_length'/>\n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </div>\n" +
    "\n" +
    "            <div style=\"margin-bottom: 12px;\">\n" +
    "              <textarea ng-show=\"!!settings.descriptionMarkdown\" rows=\"3\" id=\"edit_content\" ng-model=\"badge.description\"></textarea>\n" +
    "              <label class='primary-label'>Description&nbsp;\n" +
    "                <a ng-click=\"settings.descriptionMarkdown = !settings.descriptionMarkdown\">toggle markup</a>\n" +
    "              </label>\n" +
    "              <ng-quill-editor ng-model=\"badge.description\" required>\n" +
    "                <ng-quill-toolbar>\n" +
    "                  <div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                      <button class=\"ql-italic\"></button>\n" +
    "                      <button class=\"ql-underline\"></button>\n" +
    "                      <button class=\"ql-strike\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                      <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-link\"></button>\n" +
    "                      <button class=\"ql-image\"></button>\n" +
    "                      <button class=\"ql-clean\"></button>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </ng-quill-toolbar>\n" +
    "              </ng-quill-editor>\n" +
    "            </div>\n" +
    "            <div style=\"margin-bottom: 12px;\">\n" +
    "              <textarea ng-show=\"!!settings.popupMarkdown\" rows=\"3\" id=\"edit_content\" ng-model=\"badge.popup_text\"></textarea>\n" +
    "              <label class='primary-label'>Pop-up&nbsp;\n" +
    "                <a ng-click=\"settings.popupMarkdown = !settings.popupMarkdown\">toggle markup</a>\n" +
    "              </label>\n" +
    "              <ng-quill-editor ng-model=\"badge.popup_text\" required>\n" +
    "                <ng-quill-toolbar>\n" +
    "                  <div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                      <button class=\"ql-italic\"></button>\n" +
    "                      <button class=\"ql-underline\"></button>\n" +
    "                      <button class=\"ql-strike\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                      <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-link\"></button>\n" +
    "                      <button class=\"ql-image\"></button>\n" +
    "                      <button class=\"ql-clean\"></button>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </ng-quill-toolbar>\n" +
    "              </ng-quill-editor>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <label>Icon</label>\n" +
    "              <input hes-file-upload\n" +
    "                     ng-model='badge.image'\n" +
    "                     start=\"_.noop\"\n" +
    "                     complete=\"_.noop\"\n" +
    "                     thumbnail-url=\"badge.image.url\">\n" +
    "              </input>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <label class='primary-label' for='hidden'>Hidden</label>\n" +
    "              <input type='checkbox' name='hidden' id='hidden' ng-model='badge.hidden'/>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "              <label class='primary-label' for='notify_earned'>Notify Earned</label>\n" +
    "              <input type='checkbox' name='notify_earned' id='notify_earned' ng-model='badge.notify_earned'/>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"button-container\">\n" +
    "            <div go-fade-in-out on-switch='settings.saving' delay=200 class=\"font-sm\">Saving...</div>\n" +
    "            <span class='save-feedback' ng-show=\"settings.saved\" hes-timed-message show=\"settings.saved\">Saved!</span>\n" +
    "            <button type='button' hes-validate-click='saveBadge(badge)' ng-class=\"{disabled: settings.isSaving}\" ng-disabled=\"settings.saving\">Save</button>\n" +
    "            <span class=\"float-left\">\n" +
    "              <button type='button' ng-show=\"!badge.isNew() && isUnchanged()\" ng-click='showPreview()'>Preview</button>\n" +
    "              <button type='button' ng-show=\"!isUnchanged()\" ng-click='reset()'>Reset</button>\n" +
    "            </span>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/badges/badgesList.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/badges/badgesList.html",
    "<div class=\"col3\">\n" +
    "  <div ui-view></div>\n" +
    "  <div class=\"page-tile lg\" ng-if=\"$state.current.name === 'go.u.site.badges'\">\n" +
    "    <div class=\"standard-header\">Badges\n" +
    "      <div class=\"navigate-action\">\n" +
    "        <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\">Back To Site</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"tile-inner\">\n" +
    "      <div class=\"inline\">\n" +
    "        <div hes-loading-gif loading=\"settings.loading\"></div>\n" +
    "      </div>\n" +
    "      <div ng-show=\"!settings.loading\">\n" +
    "        <a class=\"action-link go-right\" ui-sref=\"go.u.site.badges.new\">Create New Badge</a>\n" +
    "        <a class=\"action-link go-right\" ng-click=\"saveOrder()\">Save Order</a>\n" +
    "        <br/>\n" +
    "        <div class=\"badge-locked-img\">\n" +
    "          <label>Badge Locked Image</label>\n" +
    "          <input hes-file-upload\n" +
    "                 ng-model='dbSite.badge_locked_image'\n" +
    "                 start=\"_.noop\"\n" +
    "                 complete=\"saveLockedImage()\"\n" +
    "                 thumbnail-url=\"dbSite.badge_locked_image.url\">\n" +
    "          </input>\n" +
    "        </div>\n" +
    "        <div class=\"badge-list\">\n" +
    "        <span ng-repeat=\"badges in data.badges | groupBy:'category' | toArray:true | orderBy:'sequence'\">\n" +
    "        <span class=\"move-up\">&uarr;</span>\n" +
    "        <span class=\"move-down\">&darr;</span>\n" +
    "        <h2>{{ humanize(badges.$key) }}</h2>\n" +
    "          <ol class=\"font-lg\">\n" +
    "            <li ng-repeat=\"badge in badges\" class=\"badge-item\" data-id=\"{{ badge.id }}\">\n" +
    "              <span class=\"move-up\">&uarr;</span>\n" +
    "              <span class=\"move-down\">&darr;</span>\n" +
    "              <span ng-bind-html=\"badge.name\"></span>\n" +
    "              <span ng-if=\"!isCampaignBadge(badge.category)\">{{ [badge.goal, badge.goal2].join(' ') }}</span>\n" +
    "              <span ng-if=\"isCampaignBadge(badge.category)\">({{ badge.goal3 }})</span>\n" +
    "              <span class=\"go-right\">\n" +
    "                <a ui-sref=\"go.u.site.badges.edit({badgeId: badge.id})\">Edit</a>\n" +
    "              </span>\n" +
    "              <span class=\"go-right\">\n" +
    "                <a ng-click=\"confirmDeleteBadge(badge)\" ng-if=\"isBadgeEdited(badge) || dbSite.isDefault()\">{{dbSite.isDefault() ? 'Delete' : 'Reset'}}</a>\n" +
    "              </span>\n" +
    "            </li>\n" +
    "          </ol>\n" +
    "        </span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/badges/confirm-delete.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/badges/confirm-delete.html",
    "<p>Are you sure you want to delete Badge: \"{{ badge.name }}\"?</p>\n" +
    "<div class=\"center\">\n" +
    "  <button ng-click=\"confirm(badge)\">Confirm</button>\n" +
    "  <button ng-click=\"closeThisDialog()\">Cancel</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/badges/user_badges.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/badges/user_badges.html",
    "<div class='userbadges'>\n" +
    "	<span class=\"group\" ng-repeat=\"(category,badges) in data.badges\">\n" +
    "	 	<div  id=\"badge_{{badge.id}}\"\n" +
    "					class=\"userbadge\"\n" +
    "					ng-class=\"{'earned': !!badge.earned_on}\"\n" +
    "					ng-click=\"showPopup(badge)\"\n" +
    "					ng-repeat=\"badge in badges\"\n" +
    "					ng-show=\"showBadge(badges[$index - 1], badge)\"\n" +
    "					aria-label=\"{{ !!badge.earned_on ? 'Earned Badge, ' + badge.name : 'Unearned Badge' }}\"\n" +
    "					aria-describedby=\"description-{{badge.id}}\">\n" +
    "			<img alt=\"\" ng-if=\"badge.earned_on\" hes-image=\"{{ badge.image.url }}\"></img>\n" +
    "			<span ng-if=\"!badge.earned_on\" class=\"unearned-badge {{badge.category}}\" hes-icon icon-name=\"standard:unearned-badge\"></span>\n" +
    "			<!-- <img alt=\"\" ng-if=\"!badge.earned_on\" class=\"{{badge.category}}\" hes-image=\"placeholders/unearned-badge.svg\"></img> -->\n" +
    "			<div class=\"text-wrapper\">\n" +
    "				<div class=\"name p-inline\" id=\"{{badge.id}}\" ng-show=\"!!badge.earned_on\" ng-class=\"{'unearned': !badge.earned_on }\" ng-bind-html=\"badge.name\">\n" +
    "				</div>\n" +
    "				<div class=\"description\" id=\"description-{{badge.id}}\" ng-bind-html=\"badge.description\"></div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</span>\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<!-- <div class='userbadges'>\n" +
    "	<div class=\"group\" ng-repeat=\"(category,badges) in data.badges\">\n" +
    "		<h2>{{ category }}</h2>\n" +
    "		<div class=\"badge-row\">\n" +
    "		 	<div  id=\"badge_{{badge.id}}\"\n" +
    "						class=\"userbadge\"\n" +
    "						ng-class=\"{'earned': !!badge.earned_on}\"\n" +
    "						ng-click=\"showPopup(badge)\"\n" +
    "						ng-repeat=\"badge in badges\"\n" +
    "						aria-label=\"{{ !!badge.earned_on ? 'Earned Badge, ' + badge.name : 'Unearned Badge' }}\"\n" +
    "						aria-describedby=\"description-{{badge.id}}\">\n" +
    "				<img alt=\"\" ng-if=\"badge.earned_on\" hes-image=\"{{ badge.image.url }}\"></img>\n" +
    "				<img alt=\"\" ng-if=\"!badge.earned_on\" hes-image=\"{{ badge.locked_image.url }}\"></img>\n" +
    "				<div class=\"text-wrapper\">\n" +
    "					<div class=\"name\" id=\"{{badge.id}}\" ng-class=\"{'unearned': !badge.earned_on }\">\n" +
    "						{{ badge.earned_on ? badge.name : \"Unearned\" }}\n" +
    "					</div>\n" +
    "					<div class=\"description\" id=\"description-{{badge.id}}\" ng-bind-html=\"badge.description\"></div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div> -->\n" +
    "");
}]);

angular.module("/scripts/billboard/admin/billboard-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/admin/billboard-edit.html",
    "<!-- billboard edit -->\n" +
    "\n" +
    "<div>\n" +
    "  <div class=\"standard-header\">\n" +
    "    <div class=\"navigate-action\">\n" +
    "      <a ng-if=\"returnParams.group != 'banner'\" class='back-link' ui-sref=\"go.u.billboards(returnParams)\">Back To {{view.groupLabel}}s</a>\n" +
    "      <a ng-if=\"returnParams.group == 'banner'\" class='back-link' ui-sref=\"go.u.site.banners({siteId: returnParams.site_id})\">Back To {{view.groupLabel}}s</a>\n" +
    "    </div>\n" +
    "  </div> \n" +
    " <div class=\"padded-page\" layout=\"row\" layout-align=\"start start\" ng-hide=\"view.newStartFresh || view.isEdit\">\n" +
    "   <div flex=\"25\">\n" +
    "    <h2>Copy Default</h2>\n" +
    "    <br/>\n" +
    "    <div>\n" +
    "      <label for=\"billboard_type\">{{view.groupLabel}} Type</label>\n" +
    "      <select id=\"billboard_type\"\n" +
    "        ng-options='t as t for t in view.groupTypes',\n" +
    "        ng-model='data.copy_billboard.type'\n" +
    "        ng-change=\"getDefaultsByType()\">\n" +
    "        <option selected value=\"\">Choose...</option>\n" +
    "      </select>\n" +
    "      </div>\n" +
    "      <div ng-if=\"data.copy_billboard.type\">\n" +
    "        <label for=\"billboard_type\">Default {{view.groupLabel}}</label>\n" +
    "        <select id=\"billboard_type\"\n" +
    "        ng-options='t.id as t.name for t in data.copy_billboard.default_billboards',\n" +
    "        ng-model='data.copy_billboard.billboard_id'>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "      <div ng-show=\"!!data.copy_billboard.billboard_id\">\n" +
    "        <button ng-click=\"copyToSite()\">Copy Default</button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div flex=\"10\" ng-hide=\"view.newCopy\">\n" +
    "      <h2>OR</h2>\n" +
    "    </div>\n" +
    "    <div flex=\"30\" ng-hide=\"view.newCopy\">\n" +
    "      <button ng-click=\"startFresh()\">Start Fresh</button>\n" +
    "    </div>\n" +
    " </div>\n" +
    "\n" +
    "\n" +
    "  <form class=\"hes\" name=\"billboard\" ng-show=\"view.isEdit || view.newStartFresh\">\n" +
    "    <fieldset>\n" +
    "      <legend>{{view.groupLabel + ' Edit'}}</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <!-- col 1 -->\n" +
    "        <span>\n" +
    "          <label for=\"billboard_type\">Type</label>\n" +
    "          <select id=\"billboard_type\"\n" +
    "            ng-options=\"t as t for t in data.block_types\"\n" +
    "            ng-model=\"data.billboard.billboard_type\"\n" +
    "            ng-disabled=\"data.billboard.id\"\n" +
    "            ng-change='autoBuildBlocks()'>\n" +
    "          </select>\n" +
    "\n" +
    "          <div ng-if=\"showApp()\">\n" +
    "            <label for=\"billboard_app_id\">App</label>\n" +
    "            <select id=\"billboard_app_id\"\n" +
    "              ng-model=\"data.billboard.app_domain\"\n" +
    "              ng-options=\"app.domain_name as app.domain_name for app in site.app_options\"\n" +
    "              ng-disabled=\"data.billboard.id\">\n" +
    "            </select>\n" +
    "          </div>\n" +
    "\n" +
    "          <label for=\"billboard_name\">Name</label>\n" +
    "          <input id=\"billboard_name\" type=\"text\" ng-model=\"data.billboard.name\"></input>\n" +
    "\n" +
    "        </span>\n" +
    "\n" +
    "        <!-- col 2 -->\n" +
    "        <span class=\"pull-right\">\n" +
    "          <label>block sequence</label>\n" +
    "          <div ui-tree>\n" +
    "            <ol ui-tree-nodes=\"\" ng-model=\"data.billboard.blocks\">\n" +
    "              <li ng-repeat=\"block in data.billboard.blocks\" ui-tree-node>\n" +
    "                <span ui-tree-handle class='block-tree-node'>{{ block.name }} </span>\n" +
    "                - <a ng-click=\"editBlock(block)\">edit</a>\n" +
    "                <a ng-if=\"data.block.id && data.block.id == block.id\" ng-click=\"data.block = null;\">close</a>\n" +
    "              </li>\n" +
    "            </ol>\n" +
    "          </div>\n" +
    "          <a ng-if=\"data.billboard.billboard_type && data.billboard.blocks.length > 1\" ng-click=\"editBlock(data.billboard.buildBlock())\">Build Block</a>\n" +
    "\n" +
    "\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <button ng-click=\"saveBillboard(data.billboard)\">Save Billboard</button>\n" +
    "        <button class=\"secondary\" ng-if=\"showPreview()\" ng-click=\"previewBillboard(data.billboard)\">Preview Billboard</button>\n" +
    "      </div>\n" +
    "\n" +
    "    </fieldset>\n" +
    "  </form>\n" +
    "  <!-- block edit -->\n" +
    "  <form class=\"billboard-hes\" name=\"block\" ng-if=\"data.block\">\n" +
    "    <fieldset>\n" +
    "      <legend>Block Details</legend>\n" +
    "\n" +
    "      <div class=\"row\" ng-if=\"data.templates[0] != 'placeholder_block'\">\n" +
    "        <label for=\"block_template\">Template</label>\n" +
    "        <select id=\"block_template\"\n" +
    "          ng-model=\"data.block.template\"\n" +
    "          ng-options=\"t as t for t in data.templates\"\n" +
    "          ng-init=\"data.block.template = data.block.template || data.templates[0]\"\n" +
    "          ng-change=\"editBlock(data.block)\">\n" +
    "        </select>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\" ng-if=\"data.templates[0] == 'placeholder_block' || data.templates[0] == 'hero_block'\">\n" +
    "        <label for=\"block_template\">Text Shadow</label>\n" +
    "        <div hes-checkbox aria-describedBy=\"block_template\"\n" +
    "          type=\"checkbox\" id=\"block_template\"\n" +
    "          ng-model=\"data.block.template\"\n" +
    "          ng-init=\"data.block.template = data.block.template || data.templates[0]\"\n" +
    "          ng-true-value=\"{{ data.templates[0] }}\"\n" +
    "          ng-false-value=\"{{ data.templates[1] }}\"\n" +
    "          name='block_template'\n" +
    "          class='hes-checkbox margin-10-right inline'\n" +
    "          label-name='block_template'\n" +
    "          ng-change=\"editBlock(data.block)\"></div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"name\">Name</label>\n" +
    "          <input id=\"name\" type=\"text\" ng-model=\"data.block.name\"></input>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <fieldset class=\"row dyna-billboard-elm\" ng-if=\"data.block_models\" ng-repeat=\"(attributes, models) in data.block_models | groupBy: 'attributes'\">\n" +
    "          <legend>{{ humanizeAttributes(attributes) }}</legend>\n" +
    "          <div class=\"row dyna-billboard-elm\" ng-repeat=\"model in models\">\n" +
    "            <label for=\"{{model.model}}.{{model.key}}\">{{ humanizeKeys(model) }} </label>\n" +
    "\n" +
    "            <div ng-if=\"isUploadable(model.key)\"\n" +
    "              hes-file-upload\n" +
    "              start=\"_.noop\"\n" +
    "              complete=\"_.noop\"\n" +
    "              use-cloud=\"true\"\n" +
    "              allow-any-type=\"true\"\n" +
    "              allow-any-size=\"true\"\n" +
    "              thumbnail-url=\"data.block.config_json[model.attributes][model.key].url\"\n" +
    "              show-remove\n" +
    "              use-domain=\"false\"\n" +
    "              id=\"{{model.model}}.{{model.key}}\"\n" +
    "              ng-model=\"data.block.config_json[model.attributes][model.key]\">\n" +
    "            </div>\n" +
    "\n" +
    "            <md-radio-group md-no-ink\n" +
    "              ng-model=\"data.block.config_json[model.attributes][model.key]\"\n" +
    "              ng-change=\"console.log(data.block.config_json[model.attributes][model.key])\"\n" +
    "              ng-if=\"isAlign(model.key)\"\n" +
    "              class=\"resource-filters\" tabindex=\"-1\">\n" +
    "              <md-radio-button tabindex=\"0\"\n" +
    "                value=\"left\"\n" +
    "                aria-label=\"Left aligned\"\n" +
    "                class=\"md-primary\">\n" +
    "                Left\n" +
    "              </md-radio-button>\n" +
    "              <md-radio-button tabindex=\"0\"\n" +
    "                value=\"center\"\n" +
    "                aria-label=\"Center aligned\">\n" +
    "                Center\n" +
    "              </md-radio-button>\n" +
    "              <md-radio-button tabindex=\"0\"\n" +
    "                value=\"right\"\n" +
    "                aria-label=\"Right aligned\">\n" +
    "                Right\n" +
    "              </md-radio-button>\n" +
    "              <md-radio-button tabindex=\"0\"\n" +
    "                value=\"\"\n" +
    "                aria-label=\"default\">\n" +
    "                Default\n" +
    "              </md-radio-button>\n" +
    "            </md-radio-group>\n" +
    "\n" +
    "            <input type=\"text\"\n" +
    "              class=\"colorpicker\"\n" +
    "              ng-if=\"isColor(model.key)\"\n" +
    "              ng-model=\"data.block.config_json[model.attributes][model.key]\"\n" +
    "              minicolors=\"colorpickerSettings\">\n" +
    "            </input>\n" +
    "\n" +
    "            <input type=\"text\"\n" +
    "              ng-if=\"isLink(model.key)\"\n" +
    "              ng-model=\"data.block.config_json[model.attributes][model.key]\">\n" +
    "            </input>\n" +
    "\n" +
    "            <span \n" +
    "              ng-if=\"!isButton(model.tagName) && \n" +
    "              !isUploadable(model.key) && \n" +
    "              !isColor(model.key) && \n" +
    "              !isAlign(model.key) && \n" +
    "              !isLink(model.key)\">\n" +
    "              <label for='edit_content'>\n" +
    "                <a ng-click=\"data.contentMarkdown = !data.contentMarkdown\">toggle markup</a>\n" +
    "              </label>\n" +
    "              <textarea ng-show=\"!!data.contentMarkdown\" rows=\"4\" id=\"edit_content\" ng-model=\"data.block.config_json[model.attributes][model.key]\"></textarea>  \n" +
    "              <ng-quill-editor \n" +
    "              id=\"{{model.model}}.{{model.key}}\"\n" +
    "              ng-model=\"data.block.config_json[model.attributes][model.key]\">\n" +
    "                <ng-quill-toolbar>\n" +
    "                  <div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                      <button class=\"ql-italic\"></button>\n" +
    "                      <button class=\"ql-underline\"></button>\n" +
    "                      <button class=\"ql-strike\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                      <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-link\"></button>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </ng-quill-toolbar>\n" +
    "              </ng-quill-editor>\n" +
    "            </span>\n" +
    "\n" +
    "            <span ng-if=\"isButton(model.tagName) && \n" +
    "              !isUploadable(model.key) && \n" +
    "              !isColor(model.key) && \n" +
    "              !isAlign(model.key) && \n" +
    "              !isLink(model.key)\">\n" +
    "              <textarea rows=\"1\" id=\"edit_content\" ng-model=\"data.block.config_json[model.attributes][model.key]\"></textarea>  \n" +
    "            </span>\n" +
    "\n" +
    "          </div>\n" +
    "        </fieldset>\n" +
    "      </div>\n" +
    "\n" +
    "      <button ng-click=\"saveBillboard(data.billboard)\">Save Block</button>\n" +
    "\n" +
    "      <a class=\"float-right\" ng-if=\"data.billboard.blocks.length > 1\" ng-click=\"destroyBlock(data.block)\">Delete Block</a>\n" +
    "    </fieldset>\n" +
    "\n" +
    "  </form>\n" +
    "  <!-- Preview -->\n" +
    "  <div class=\"billboard\" id=\"{{ removeSpace(data.billboard.name) }}\" ng-class=\"{'full-width': data.billboard.billboard_type == 'opt_in'}\" ng-if=\"data.block.template\" get-block-models>\n" +
    "    <div class=\"block\" ng-include=\"data.block.getTemplatePath(data.billboard)\" ng-init=\"$watch('block = data.block')\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/billboard/admin/billboards.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/admin/billboards.html",
    "<div class='padded-page'>\n" +
    "  <div class='padded-page'>\n" +
    "    <div class=\"standard-header\">{{billboardLabel()}}s\n" +
    "      <div class=\"navigate-action\" ng-if=\"!!$state.params.site_id\">\n" +
    "        <a class='back-link' ui-sref=\"go.u.site({siteId: $state.params.site_id})\">Back To Site</a>\n" +
    "      </div>\n" +
    "    </div> \n" +
    "    <div class=\"promotions-content\">\n" +
    "      <div layout='row' layout-align='start space-between'>\n" +
    "        <a class=\"red-link-button cursor\" ng-click=\"newBillboard()\">{{ $state.params.site_id ? \"Create \" + billboardLabel() : \"Create New \" + billboardLabel() }} </a>\n" +
    "      </div> \n" +
    "      <br>\n" +
    "      <!-- <a class=\"red-link-button cursor\" ng-click=\"billboardToggle()\">{{ allBillboards ? 'Hide non-default' : 'Show all') }}</a> -->\n" +
    "      <div hes-table tbl-data=\"data.tblBillboards\" ng-if=\"allBillboards\"></div>\n" +
    "      <div hes-table tbl-data=\"data.defaultBillboards\" ng-if=\"!allBillboards\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/billboard/billboard-agent.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/billboard-agent.html",
    "<div class=\"billboard\" ng-class=\"{\n" +
    "  'full-width': billboard.billboard_type == 'opt_in',\n" +
    "  'shrunk': (!user.flags.is_hero_expanded && billboard.billboard_type != 'banner' && billboard.billboard_type != 'opt_in'),\n" +
    "  'after-shrunk': (!user.flags.is_hero_expanded && billboard.billboard_type != 'banner' && billboard.billboard_type != 'opt_in')\n" +
    "  }\">\n" +
    "  <span class=\"shrink-arrow\"\n" +
    "        ng-click=\"user.updateFlags({is_hero_expanded: !user.flags.is_hero_expanded })\"\n" +
    "        ng-if=\"billboard.billboard_type && billboard.billboard_type != 'banner'\"\n" +
    "        class=\"block\"\n" +
    "        ng-include=\"'/scripts/billboard/shrink-arrow.html'\">\n" +
    "  </span>\n" +
    "  <div class=\"block block-{{block.id}} site-{{billboard.site_id}}\" ng-repeat=\"block in billboard.blocks\" ng-include=\"block.getTemplatePath(billboard)\"></div>\n" +
    "</div>");
}]);

angular.module("/scripts/billboard/blocks/banner/banner_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/banner/banner_block.html",
    "<section class=\"banner-block\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image background-color>\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div style=\"height:100%;\" flex=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"text-center\">\n" +
    "    <div class=\"flex-wrapper\">\n" +
    "      <h2  block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "      <p block-attributes=\"block.config_json\" key=\"header_secondary\" text color></p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/banner/evaluation_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/banner/evaluation_block.html",
    "<section class=\"banner-block\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image ng-click=\"goToProgram(currentProgram.id)\">\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div style=\"height:100%;\" flex=\"grow\" layout=\"row\" layout-align=\"center center\" class=\"text-center\">\n" +
    "    <div class=\"flex-wrapper\">\n" +
    "      <h2 class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "      <p class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_secondary\" text color></p>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/coming_soon/coming_soon_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/coming_soon/coming_soon_block.html",
    "<section class=\"coming-soon-block\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image></div>\n" +
    "  <div class=\"bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"container coming-soon\">\n" +
    "\n" +
    "    <div class=\"text-right optin-left\">\n" +
    "      <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "    \n" +
    "    <h2 class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "\n" +
    "    <p class=\"shadow\" block-attributes=\"block.config_json\" key=\"content_main\" text color></p>\n" +
    "\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/enter/enter_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/enter/enter_block.html",
    "<section class=\"enter-block\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image></div>\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"container\">\n" +
    "    <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "\n" +
    "    <h2 class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "\n" +
    "    <p class=\"shadow\" block-attributes=\"block.config_json\" key=\"content_main\" text color></p>\n" +
    "\n" +
    "    <div class=\"button-wrapper\" block-attributes=\"block.config_json\" key=\"button_container\" aligned>\n" +
    "        <button block-attributes=\"block.config_json\" key=\"button_optin\"\n" +
    "          text background-color color ng-click=\"goToProgram(currentProgram.id)\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/opt_in/feature_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/opt_in/feature_block.html",
    "<section class=\"feature-block\" block-attributes=\"block.config_json\" key=\"color_background\" background-color>\n" +
    "  <!-- <div class=\"bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div> -->\n" +
    "\n" +
    "\n" +
    "  <div class=\"container\">\n" +
    "\n" +
    "    <h2 block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "    <p block-attributes=\"block.config_json\" key=\"header_secondary\" text color></p>\n" +
    "\n" +
    "    <div class=\"image-container\">\n" +
    "      <span class=\"text-center\">\n" +
    "        <img block-attributes=\"block.config_json\" key=\"image_left\" image></img>\n" +
    "        <p block-attributes=\"block.config_json\" key=\"image_left_text\" text color></p>\n" +
    "      </span>\n" +
    "      <span class=\"text-center\">\n" +
    "        <img block-attributes=\"block.config_json\" key=\"image_center\" image></img>\n" +
    "        <p block-attributes=\"block.config_json\" key=\"image_center_text\" text color></p>\n" +
    "      </span>\n" +
    "      <span class=\"text-center\">\n" +
    "        <img block-attributes=\"block.config_json\" key=\"image_right\" image></img>\n" +
    "        <p block-attributes=\"block.config_json\" key=\"image_right_text\" text color></p>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/opt_in/friend_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/opt_in/friend_block.html",
    "<section class=\"friend-block\" block-attributes=\"block.config_json\" key=\"image_background\" background-image>\n" +
    "  <div class=\"bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"container\">\n" +
    "\n" +
    "    <div class=\"text-right\">\n" +
    "      <h2 class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "      <p class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_secondary\" text color></p>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/opt_in/hero_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/opt_in/hero_block.html",
    "<section class=\"hero-block\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image></div>\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"container optin-hero\">\n" +
    "\n" +
    "    <div class=\"text-right optin-left\">\n" +
    "      <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "\n" +
    "    <h2 class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "\n" +
    "    <p class=\"shadow mobile-font\" block-attributes=\"block.config_json\" key=\"content_main\" text color></p>\n" +
    "\n" +
    "    <div class=\"button-wrapper\" block-attributes=\"block.config_json\" key=\"button_container\" aligned>\n" +
    "        <button block-attributes=\"block.config_json\" key=\"button_optin\"\n" +
    "          text background-color color ng-click=\"goToProgram(currentProgram.id)\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- <div class=\"text-center pin-bottom\">\n" +
    "    <a block-attributes=\"block.config_json\" key=\"learn_more\" text color ng-click=\"scroll($event)\">Learn More\n" +
    "    </a>\n" +
    "    <div>\n" +
    "      <span class=\"arrow\" hes-icon icon-name=\"standard:arrow\" ng-click=\"scroll($event)\"></span>\n" +
    "    </div>\n" +
    "  </div> -->\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/opt_in/hero_block_no-shadow.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/opt_in/hero_block_no-shadow.html",
    "<section class=\"hero-block\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image></div>\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"container optin-hero\">\n" +
    "\n" +
    "    <div class=\"text-right optin-left\">\n" +
    "      <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "\n" +
    "    <h2 block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "\n" +
    "    <p class=\"mobile-font\" block-attributes=\"block.config_json\" key=\"content_main\" text color></p>\n" +
    "\n" +
    "    <div class=\"button-wrapper\" block-attributes=\"block.config_json\" key=\"button_container\" aligned>\n" +
    "        <button block-attributes=\"block.config_json\" key=\"button_optin\"\n" +
    "          text background-color color ng-click=\"goToProgram(currentProgram.id)\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/opt_in/hero_block_v2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/opt_in/hero_block_v2.html",
    "<section class=\"hero-block version-2\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image background-color></div>\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"container optin-hero\">\n" +
    "\n" +
    "    <div class=\"hero-logo\" block-attributes=\"block.config_json\" key=\"app_logo_align\" absolute-aligned>\n" +
    "      <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "\n" +
    "    <h2 block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "\n" +
    "    <p class=\"hero-main-content mobile-font\" block-attributes=\"block.config_json\" key=\"content_main\" text color></p>\n" +
    "\n" +
    "    <div class=\"button-wrapper\" block-attributes=\"block.config_json\" key=\"button_container\" aligned>\n" +
    "        <button block-attributes=\"block.config_json\" key=\"button_optin\"\n" +
    "          text background-color color ng-click=\"goToProgram(currentProgram.id)\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"text-center pin-bottom\">\n" +
    "    <div block-attributes=\"block.config_json\" key=\"learn_more\" color>\n" +
    "      <div block-attributes=\"block.config_json\" key=\"learn_more\" text></div>\n" +
    "      <span class=\"arrow\" hes-icon icon-name=\"standard:arrow\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/opt_in/mobile_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/opt_in/mobile_block.html",
    "<section class=\"mobile-block\" block-attributes=\"block.config_json\" key=\"color_background\" background-color>\n" +
    "  <!-- <div class=\"bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div> -->\n" +
    "\n" +
    "\n" +
    "  <div class=\"container\">\n" +
    "\n" +
    "    <span>\n" +
    "      <h2 block-attributes=\"block.config_json\" key=\"header_main\" text></h2>\n" +
    "      <p block-attributes=\"block.config_json\" key=\"header_secondary\" text></p>\n" +
    "    </span>\n" +
    "\n" +
    "    <span class=\"right-side\">\n" +
    "      <img block-attributes=\"block.config_json\" key=\"image_main\" image></img>\n" +
    "    </span>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/opt_in/video_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/opt_in/video_block.html",
    "<section class=\"video-block\" block-attributes=\"block.config_json\" key=\"color_background\" background-color>\n" +
    "  <!-- <div class=\"bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div> -->\n" +
    "\n" +
    "\n" +
    "  <div class=\"container\">\n" +
    "\n" +
    "    <span class=\"video\">\n" +
    "      <video id=\"optin-video\" crossorigin=\"anonymous\" block-attributes=\"block.config_json\" key=\"video_main\" video poster-image video-caption controls></video>\n" +
    "    </span>\n" +
    "\n" +
    "    <span class=\"video-optin\">\n" +
    "      <div>\n" +
    "        <h2 block-attributes=\"block.config_json\" key=\"header_main\" class=\"video-block__text\" text></h2>\n" +
    "      </div>\n" +
    "      <div class=\"button-wrapper\" block-attributes=\"block.config_json\" key=\"button_container\" aligned>\n" +
    "        <button block-attributes=\"block.config_json\" key=\"button_optin\"\n" +
    "          text background-color color ng-click=\"goToProgram(currentProgram.id)\"></button>\n" +
    "      </div>\n" +
    "    </span>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/placeholder/placeholder_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/placeholder/placeholder_block.html",
    "<section class=\"placeholder-block\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image></div>\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div class=\"container\">\n" +
    "\n" +
    "    <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "\n" +
    "    <h2 class=\"shadow\" block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "\n" +
    "    <p class=\"shadow mobile-font\" block-attributes=\"block.config_json\" key=\"content_main\" text color></p>\n" +
    "\n" +
    "    <div class=\"button-wrapper\" block-attributes=\"block.config_json\" key=\"button_container\" aligned>\n" +
    "        <button block-attributes=\"block.config_json\" key=\"button_optin\"\n" +
    "          text background-color color link></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/placeholder/placeholder_block_no_shadow.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/placeholder/placeholder_block_no_shadow.html",
    "<section class=\"placeholder-block\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image></div>\n" +
    "  <div class=\"bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div class=\"container\">\n" +
    "\n" +
    "    <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "\n" +
    "    <h2 block-attributes=\"block.config_json\" key=\"header_main\" text color></h2>\n" +
    "\n" +
    "    <p class=\"mobile-font\" block-attributes=\"block.config_json\" key=\"content_main\" text color></p>\n" +
    "    \n" +
    "    <div class=\"button-wrapper\" block-attributes=\"block.config_json\" key=\"button_container\" aligned>\n" +
    "        <button block-attributes=\"block.config_json\" key=\"button_optin\"\n" +
    "          text background-color color link></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/blocks/registration_closed/registration_closed_block.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/blocks/registration_closed/registration_closed_block.html",
    "<section class=\"registration_closed-block\">\n" +
    "  <div class=\"bg-image\" block-attributes=\"block.config_json\" key=\"image_backgroud\" background-image></div>\n" +
    "  <div class=\"bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "\n" +
    "  <div class=\"container reg-closed\">\n" +
    "\n" +
    "    <img block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "\n" +
    "    <div class=\"content-wrap\">\n" +
    "      <h2 class=\"shadow mobile-font\" block-attributes=\"block.config_json\" key=\"content_main\" text color></h2>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</section>");
}]);

angular.module("/scripts/billboard/shrink-arrow.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/billboard/shrink-arrow.html",
    "<svg viewBox=\"0 0 23 16\" id=\"arrow-down\">\n" +
    "  <g filter=\"url(#filter0_d)\">\n" +
    "  <path d=\"M5.85345 4.3051C5.4439 3.9133 4.7634 3.89827 4.33351 4.27154C3.90363 4.64481 3.88715 5.26502 4.2967 5.65682C4.2967 5.65682 10.7147 11.7029 10.7334 11.7194C11.1769 12.1058 11.8801 12.0913 12.304 11.6871L18.7021 5.65688C19.1123 5.2657 19.097 4.64547 18.6678 4.27154C18.2386 3.89762 17.5581 3.91161 17.1478 4.30278L11.8404 9.22008C11.6487 9.39768 11.3526 9.39771 11.1608 9.22016L5.85345 4.3051Z\" fill=\"white\"/>\n" +
    "  </g>\n" +
    "  <defs>\n" +
    "  <filter id=\"filter0_d\" x=\"0\" y=\"0\" width=\"23\" height=\"16\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\n" +
    "  <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\n" +
    "  <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"/>\n" +
    "  <feOffset/>\n" +
    "  <feGaussianBlur stdDeviation=\"2\"/>\n" +
    "  <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0\"/>\n" +
    "  <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow\"/>\n" +
    "  <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow\" result=\"shape\"/>\n" +
    "  </filter>\n" +
    "  </defs>\n" +
    "</svg>");
}]);

angular.module("/scripts/breadcrumb/breadcrumb.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/breadcrumb/breadcrumb.html",
    "<a hes-focus set-focus=\"{{$last ? false : true}}\" \n" +
    "  ng-class=\"{'last-crumb': $last}\" \n" +
    "  ng-repeat-start=\"crumb in $ctrl.crumbs\" \n" +
    "  ui-sref=\"{{crumb.state}}\"\n" +
    "  tabindex=\"{{$last ? -1 : 0}}\"\n" +
    "  ng-init=\"crumb.display = crumb.display + '&nbsp;'\"\n" +
    "  ng-bind-html=\"crumb.display\" ng-if=\"!crumb.isButton\">\n" +
    "</a>\n" +
    "<button ng-if=\"crumb.isButton\" class=\"link-look\" ng-click=\"crumb.onClick()\">\n" +
    "  <span ng-bind-html=\"crumb.display\"></span>\n" +
    "</button>\n" +
    "<span ng-repeat-end>{{!$last ? '>' : ''}}&nbsp;</span>");
}]);

angular.module("/scripts/challenges/admin/views/challenge-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/admin/views/challenge-edit.html",
    "<a class='back-link' ui-sref=\"go.u.site.challenges\">Back to challenges</a>\n" +
    "\n" +
    "<form>\n" +
    "\n" +
    "  <div class=\"challenge-edit-box\">\n" +
    "\n" +
    "    <label>Name</label>\n" +
    "    <input ng-model=\"data.challenge.name\"></input>\n" +
    "    \n" +
    "    <div style=\"margin-bottom: 12px;\">\n" +
    "      <textarea ng-show=\"!!settings.descriptionMarkdown\" rows=\"3\" id=\"edit_content\" ng-model=\"data.challenge.description\"></textarea>\n" +
    "      <label>Description\n" +
    "        <a ng-click=\"settings.descriptionMarkdown = !settings.descriptionMarkdown\">toggle markup</a>\n" +
    "      </label>\n" +
    "      <ng-quill-editor ng-model=\"data.challenge.description\">\n" +
    "        <ng-quill-toolbar>\n" +
    "          <div>\n" +
    "            <div class=\"ql-formats\">\n" +
    "              <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "              <button class=\"ql-italic\"></button>\n" +
    "              <button class=\"ql-underline\"></button>\n" +
    "              <button class=\"ql-strike\"></button>\n" +
    "            </div>\n" +
    "            <div class=\"ql-formats\">\n" +
    "              <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "              <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "            </div>\n" +
    "            <div class=\"ql-formats\">\n" +
    "              <button class=\"ql-link\"></button>\n" +
    "              <button class=\"ql-image\"></button>\n" +
    "              <button class=\"ql-clean\"></button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </ng-quill-toolbar>\n" +
    "      </ng-quill-editor>\n" +
    "    </div>\n" +
    "    <span ng-if=\"data.challenge.description_html\">\n" +
    "      <label>Description as HTML</label>\n" +
    "      <div ng-bind-html=\"data.challenge.description_html\"></div>\n" +
    "    </span>\n" +
    "\n" +
    "    <label>Icon</label>\n" +
    "    <input hes-file-upload\n" +
    "          ng-model='data.challenge.image'\n" +
    "          start=\"_.noop\"\n" +
    "          complete=\"_.noop\"\n" +
    "          thumbnail-url=\"data.challenge.image.url\">\n" +
    "    </input>\n" +
    "    <div>\n" +
    "      <label>Month</label>\n" +
    "      <select ng-options=\"item.value as item.month for item in data.months\" ng-model='data.challenge.month_integer'></select>\n" +
    "    </div>\n" +
    "\n" +
    "    <label>Is Current</label>\n" +
    "    <input type=\"checkbox\" ng-model=\"data.challenge.is_current\"></input>\n" +
    "    <br/>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "  <button ng-click=\"save(data.challenge)\">Save</button>\n" +
    "  \n" +
    "</form>");
}]);

angular.module("/scripts/challenges/admin/views/challenges.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/admin/views/challenges.html",
    "<a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "\n" +
    "<div class='padded-page'>\n" +
    "  <div class='padded-page'> \n" +
    "    <h4>All Challenges</h4>\n" +
    "    <div class=\"promotions-content\">\n" +
    "      <a class=\"red-link-button\" ui-sref=\"go.u.site.challenge_edit\">Create New Challenge</a>\n" +
    "      <div hes-table tbl-data=\"data.tblElements\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/_active.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/_active.html",
    "<div class=\"challenge\">\n" +
    "  <div class=\"cell\">\n" +
    "    <img ng-if=\"user_challenge.challenge.image.url\" alt=\"\" hes-image=\"{{ user_challenge.challenge.image.url }}\"></img>\n" +
    "    <div ng-if=\"!user_challenge.challenge.image.url\" class=\"challenge-icon-container\">\n" +
    "      <span hes-icon icon-name='standard:challenge-icon'></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"cell padded\">\n" +
    "    <span class=\"name\">\n" +
    "      <strong>{{ user_challenge.challenge.name }}</strong>\n" +
    "      <challenge-timer challenge=user_challenge seconds=true></challenge-timer>\n" +
    "    </span>\n" +
    "    <p class=\"description\" hes-external-links ng-bind-html=\"user_challenge.challenge.description_html\"></p>\n" +
    "    <div class=\"layout-align-space-between\">\n" +
    "\n" +
    "    <span class=\"meta\" ng-if=\"user_challenge.sender_id == user.id\">       <!-- User is a sender -->\n" +
    "      <span class=\"partner\">Sent to <b>{{ user_challenge.partner(user.id).full_name }}</b> on <span class=\"createdat\">{{ user_challenge.created_at | date : 'EEE, MMM d' }}.</span>\n" +
    "        <br/>\n" +
    "        <em ng-if=\"!user_challenge.receiver_completed_at\">{{ user_challenge.partner(user.id).first_name }} is still working on this challenge.</em>\n" +
    "        <em ng-if=\"user_challenge.receiver_completed_at\">{{ user_challenge.partner(user.id).first_name }} completed this challenge on {{ user_challenge.receiver_completed_at | date : 'EEE, MMM d' }}.</em>\n" +
    "      </span>\n" +
    "\n" +
    "    </span>\n" +
    "\n" +
    "    <span class=\"meta\" ng-if=\"user_challenge.receiver_id == user.id\"> <!-- User is a receiver-->\n" +
    "      <span class=\"partner\">Received from <b>{{ user_challenge.partner(user.id).full_name }}</b> on <span class=\"createdat\">{{ user_challenge.created_at | date : 'EEE, MMM d' }}</span>\n" +
    "      <br/>\n" +
    "      <em ng-if=\"user_challenge.sender_completed_at\">{{ user_challenge.partner(user.id).first_name }} completed this challenge on {{ user_challenge.sender_completed_at | date : 'EEE, MMM d' }}.</em>\n" +
    "      <em ng-if=\"!user_challenge.sender_completed_at\">{{ user_challenge.partner(user.id).first_name }} is still working on this challenge.</em>\n" +
    "      </span>\n" +
    "\n" +
    "    </span>\n" +
    "\n" +
    "    <span class=\"action sm md\" ng-if=\"!user_challenge.isCompleted(user.id)\">\n" +
    "      <button ng-click=\"confirmComplete(user_challenge)\"\n" +
    "              aria-label=\"Complete the {{ user_challenge.challenge.name }} challenge\">Complete</button>\n" +
    "    </span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"button-wrapper xs\" ng-if=\"!user_challenge.isCompleted(user.id)\">\n" +
    "    <button ng-click=\"confirmComplete(user_challenge)\"\n" +
    "            aria-label=\"Complete the {{ user_challenge.challenge.name }} challenge\">Complete</button>\n" +
    "  </div>\n" +
    "  \n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/_completed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/_completed.html",
    "<div class=\"challenge\">\n" +
    "    <div class=\"cell\">\n" +
    "      <img ng-if=\"user_challenge.challenge.image.url\" alt=\"\" hes-image=\"{{ user_challenge.challenge.image.url }}\"></img>\n" +
    "      <div ng-if=\"!user_challenge.challenge.image.url\" class=\"challenge-icon-container\">\n" +
    "        <span hes-icon icon-name='standard:challenge-icon'></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"cell padded\">\n" +
    "      <span class=\"name layout-align-space-between\">\n" +
    "        <strong>{{ user_challenge.challenge.name }}</strong>\n" +
    "        <span class=\"timeremaining completed\" ng-if=\"user_challenge.is_completed\">Completed Successfully</span>\n" +
    "      </span>\n" +
    "      <p class=\"description\" hes-external-links ng-bind-html=\"user_challenge.challenge.description_html\"></p>\n" +
    "      <div class=\"meta\">\n" +
    "        <!-- User -->\n" +
    "        <!-- Completed/Expired for user -->\n" +
    "        <p class=\"partner\"><b>{{ user.profile.full_name }}</b> ⁠&mdash; <em>{{ user_challenge.userStatus(user.id) }}</em> on {{ user_challenge.userCompletionDate(user.id) | date : 'EEE, MMM d'}}\n" +
    "        </p>\n" +
    "\n" +
    "        <!-- Co-challenger -->\n" +
    "        <p class=\"partner\"><b>{{ user_challenge.partner(user.id).full_name }}</b> &mdash; <em>{{ user_challenge.partnerStatus(user.id) }}</em>\n" +
    "          <!-- In progress for co-challenger -->\n" +
    "          <span class=\"partner margin-left-minus-5\" ng-if=\"user_challenge.partnerStatus(user.id) == 'in-progress'\">\n" +
    "            , must complete by {{ user_challenge.partnerCompletionDate(user.id) | date : 'EEE, MMM d' }}</span>\n" +
    "          <!-- Completed/Expired for co-challenger -->\n" +
    "          <span class=\"partner\" ng-if=\"user_challenge.partnerStatus(user.id) != 'in-progress'\"> on {{ user_challenge.partnerCompletionDate(user.id) | date : 'EEE, MMM d' }}</span>\n" +
    "\n" +
    "        </p>\n" +
    "      </div>\n" +
    "      </p> \n" +
    "    </div>\n" +
    "  </div>");
}]);

angular.module("/scripts/challenges/views/_completed_popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/_completed_popup.html",
    "<div>\n" +
    "  <h2>Success!</h2>\n" +
    "  <br/><br/>\n" +
    "  <div class=\"completed-icon\">\n" +
    "    <span hes-icon icon-name=\"standard:challenge-completed\" alt=\"\"></span>\n" +
    "  </div>\n" +
    "  <br/>\n" +
    "\n" +
    "  <br/>\n" +
    "  <div>\n" +
    "    {{ data.user_challenge.partner(user.id).full_name }} finished the {{ data.user_challenge.challenge.name }} challenge, so it's now complete.\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/_confirm_complete.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/_confirm_complete.html",
    "<div>\n" +
    "  <h2>{{ data.user_challenge.challenge.name }}</h2>\n" +
    "  <br/>\n" +
    "\n" +
    "  <div flex layout=\"row\" layout-align=\"center center\">\n" +
    "    <button style=\"width:300px;height:50px;\" ng-click=\"updateStatus(data.user_challenge, 'complete')\">I completed this Challenge</button>\n" +
    "  </div>\n" +
    "  <br/>\n" +
    "\n" +
    "  <div class=\"text-right\">\n" +
    "    <a role=\"button\" ng-click=\"closeThisDialog()\" tabindex=\"0\">Cancel</a>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/_pending.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/_pending.html",
    "<div class=\"challenge\">\n" +
    "  <div class=\"cell\">\n" +
    "    <img ng-if=\"user_challenge.challenge.image.url\" alt=\"\" hes-image=\"{{ user_challenge.challenge.image.url }}\"></img>\n" +
    "    <div ng-if=\"!user_challenge.challenge.image.url\" class=\"challenge-icon-container\">\n" +
    "      <span hes-icon icon-name='standard:challenge-icon'></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"cell padded\">\n" +
    "    <span class=\"name\">\n" +
    "      <strong>{{ user_challenge.challenge.name }}</strong>\n" +
    "      <em>(pending)</em>\n" +
    "    </span>\n" +
    "    <p class=\"description\" hes-external-links ng-bind-html=\"user_challenge.challenge.description_html\"></p>\n" +
    "    <div class=\"layout-align-space-between\">\n" +
    "    <span class=\"meta\">\n" +
    "        <span class=\"partner\" ng-if=\"user_challenge.sender_id == user.id\">Sent to <b>{{ user_challenge.partner(user.id).full_name }}</b> on <span class=\"createdat\">{{ user_challenge.created_at | date : 'EEE, MMM d' }}.</span></span>\n" +
    "        <span class=\"partner\" ng-if=\"user_challenge.receiver_id == user.id\">Received from <b>{{ user_challenge.partner(user.id).full_name }}</b> on <span class=\"createdat\">{{ user_challenge.created_at | date : 'EEE, MMM d' }}</span></span>\n" +
    "    </span>\n" +
    "\n" +
    "    <!-- if user is the sender of the challenge -->\n" +
    "    <span class=\"action sm md\" ng-if=\"user_challenge.isSender(user.id)\">\n" +
    "      <button class=\"secondary\" ng-click=\"updateStatus(user_challenge, 'cancel')\"\n" +
    "              aria-label=\"Withdraw from the {{ user_challenge.challenge.name }} challenge\">Withdraw</button>\n" +
    "    </span>\n" +
    "    <!-- if user is the receiver of the challenge -->\n" +
    "    <span class=\"action sm md\" ng-if=\"!user_challenge.isSender(user.id)\">\n" +
    "      <a role=\"button\"\n" +
    "      class=\"margin-10-right decline-btn-mobile\"\n" +
    "         ng-click=\"updateStatus(user_challenge, 'cancel')\"\n" +
    "         aria-label=\"Decline the {{ user_challenge.challenge.name }} challenge\" tabindex=\"0\">Decline</a> \n" +
    "      <button ng-click=\"updateStatus(user_challenge, 'accept')\"\n" +
    "              aria-label=\"Accept the {{ user_challenge.challenge.name }} challenge\">Accept</button>\n" +
    "    </span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"button-wrapper-ad button-wrapper-50 xs\" ng-if=\"!user_challenge.isSender(user.id)\">\n" +
    "    <a role=\"button\"\n" +
    "    class=\"margin-10-right decline-btn-mobile\"\n" +
    "       ng-click=\"updateStatus(user_challenge, 'cancel')\"\n" +
    "       aria-label=\"Decline the {{ user_challenge.challenge.name }} challenge\" tabindex=\"0\">Decline</a> \n" +
    "    <button class=\"accept-btn\" ng-click=\"updateStatus(user_challenge, 'accept')\"\n" +
    "            aria-label=\"Accept the {{ user_challenge.challenge.name }} challenge\">Accept</button>\n" +
    "  </div>\n" +
    "  <div class=\"button-wrapper button-wrapper-50 xs\" ng-if=\"user_challenge.isSender(user.id)\">\n" +
    "    <button class=\"withdraw-btn secondary\" ng-click=\"updateStatus(user_challenge, 'cancel')\"\n" +
    "            aria-label=\"Withdraw from the {{ user_challenge.challenge.name }} challenge\">Withdraw</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/_pending_popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/_pending_popup.html",
    "<div>\n" +
    "  <h2>Way to go&hellip; you completed the {{ data.user_challenge.challenge.name }} challenge. </h2>\n" +
    "  <br/>\n" +
    "\n" +
    "  <div>\n" +
    "    {{ data.user_challenge.partner(user.id).full_name }} has {{ data.user_challenge.expiresAt().hours }} hours and {{ data.user_challenge.expiresAt().minutes }} minutes left. For this challenge to be successful, you both need to complete it before time expires.\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/_placeholder.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/_placeholder.html",
    "<div class=\"challenge\">\n" +
    "  <div class=\"cell\">\n" +
    "    <img ng-if=\"user_challenge.challenge.image.url\" alt=\"\" hes-image=\"{{ user_challenge.challenge.image.url }}\"></img>\n" +
    "    <div ng-if=\"!user_challenge.challenge.image.url\" class=\"challenge-icon-container\">\n" +
    "      <span hes-icon icon-name='standard:challenge-icon'></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"cell padded\">\n" +
    "    <div class=\"bookworm\"\n" +
    "         ng-class=\"{'fifty-worm': line == 3 }\"\n" +
    "         ng-repeat=\"line in [1,2,3]\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/active.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/active.html",
    "<div \n" +
    "  ng-if=\"showAlert\"\n" +
    "  class='alert'\n" +
    "  ng-click=\"goToAlertLink()\" \n" +
    "  tabindex=\"-1\"\n" +
    "  aria-hidden=\"true\"\n" +
    "  ng-keydown=\"ariaClick($event)\">\n" +
    "  <div tabindex=\"0\">\n" +
    "    Oops... you need to <a ui-sref='go.u.usermenu.friends.list'>Add Friends</a> to see Challenges.\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"challenges\">\n" +
    "  <div class=\"challenges-header\" flex layout=\"row\" layout-align=\"space-between center\">\n" +
    "    <div>\n" +
    "      <div ng-bind-html=\"explanations.challenges_start.content\"></div>\n" +
    "    </div>\n" +
    "    \n" +
    "    <div class=\"button-container\">\n" +
    "      <button \n" +
    "        ng-if=\"data.counts.active < data.counts.max\"\n" +
    "        class=\"challenges-btn secondary\"\n" +
    "        ui-sref=\"go.u.usermenu.challenges.select_challenge\"\n" +
    "        aria-label=\"View challenges\">\n" +
    "        {{ button_label }}\n" +
    "      </button>\n" +
    "      \n" +
    "      <div ng-if=\"data.counts.active >= data.counts.max\"\n" +
    "           style=\"text-align: left;\">\n" +
    "        <em>You can't send a new Challenge until a slot opens up.</em>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    \n" +
    "  </div>\n" +
    "\n" +
    "  <div ng-if=\"data.user_challenges && data.user_challenges.length < 5\" class=\"challenge dashed\">\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <section ng-repeat=\"user_challenge in data.user_challenges\">\n" +
    "    <div ng-if=\"showPlaceholder(user, user_challenge)\" ng-include=\"'scripts/challenges/views/_placeholder.html'\"></div>\n" +
    "    <div ng-if=\"showPending(user, user_challenge)\" ng-include=\"'scripts/challenges/views/_pending.html'\"></div>\n" +
    "    <div ng-if=\"showActive(user, user_challenge)\" ng-include=\"'scripts/challenges/views/_active.html'\"></div>\n" +
    "  </section>\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/challenge-timer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/challenge-timer.html",
    "<span class=\"timeremaining\">\n" +
    "		<div class='inactive-border' ng-show=\"!noIcon\">\n" +
    "			<div id=\"activeBorder\" class=\"active-border\">\n" +
    "			    <div id=\"circle\" class=\"circle\">\n" +
    "			        <span class=\"prec 135\" id=\"prec\"></span>\n" +
    "			    </div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<span class='challenge-ends-in' ng-if=\"!noCountdown\">\n" +
    "			Ends in\n" +
    "	        <span>{{ challenge.timeRemaining().hours }} h</span>\n" +
    "	        <span ng-if=\"challenge.timeRemaining().minutes\">{{ challenge.timeRemaining().minutes }} m</span>\n" +
    "	        <span ng-if=\"seconds\">{{ challenge.timeRemaining().seconds || 0 }} s</span>\n" +
    "	    </span>\n" +
    "      </span>");
}]);

angular.module("/scripts/challenges/views/completed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/completed.html",
    "<div class=\"challenges\">\n" +
    "  <div class=\"challenges-header\" flex layout=\"row\" layout-align=\"space-between center\">\n" +
    "    <div ng-if=\"data.has_no_completed\" ng-bind-html=\"explanations.challenges_completed.content\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div flex layout=\"row\" layout-align=\"start center\" ng-if=\"!user.stats.total_challenges\">\n" +
    "    <div class=\"cell\">\n" +
    "      <div class=\"challenge-icon-container\">\n" +
    "        <span hes-icon icon-name=\"standard:stats-challenges\"></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"cell padded-left\">\n" +
    "      <span>\n" +
    "        <b class=\"bigger\">{{ user.stats.total_completed_challenges }}</b> Challenge{{ user.stats.total_completed_challenges != 1 ? 's' : '' }}\n" +
    "      </span>\n" +
    "      <br>\n" +
    "      <span class=\"data-label\">Completed in {{ date | date : 'yyyy' }}</span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div ng-if=\"user.stats.total_challenges\">\n" +
    "    <div class=\"challenges-header\" flex layout=\"row\" layout-align=\"space-between center\">\n" +
    "\n" +
    "      <div>You've completed <b>{{ user.stats.total_completed_challenges }}</b> of <b>{{ user.stats.total_challenges }}</b> accepted challenges.</div>\n" +
    "      \n" +
    "      <div flex layout=\"row\" layout-align=\"start center\">\n" +
    "        <div class=\"cell\">\n" +
    "          <div class=\"challenge-icon-container\">\n" +
    "            <span hes-icon icon-name=\"standard:stats-challenges\"></span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"cell padded-left\">\n" +
    "          <span>\n" +
    "            <b class=\"bigger\">{{ user.stats.total_completed_challenges }}</b> Challenge{{ user.stats.total_completed_challenges != 1 ? 's' : '' }}\n" +
    "          </span>\n" +
    "          <br>\n" +
    "          <span class=\"data-label\">Completed in {{ date | date : 'yyyy' }}</span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <span ng-repeat=\"user_challenge in data.user_challenges | orderBy : completedOrExpiredDate : true\">\n" +
    "      <div ng-include=\"'scripts/challenges/views/_completed.html'\"></div>\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <hes-load-more-button on-click=\"showMore()\"\n" +
    "    ng-if=\"user.stats.total_challenges > data.limit\">\n" +
    "  </hes-load-more-button>\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/select-challenge.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/select-challenge.html",
    "<div \n" +
    "  ng-if=\"showAlert\"\n" +
    "  class='alert'\n" +
    "  ng-click=\"goToAlertLink()\" \n" +
    "  tabindex=\"-1\"\n" +
    "  aria-hidden=\"true\"\n" +
    "  ng-keydown=\"ariaClick($event)\">\n" +
    "  <div tabindex=\"0\">\n" +
    "    Oops... you need to <a ui-sref='go.u.usermenu.friends.list'>Add Friends</a> to select Challenges.\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<hes-breadcrumb crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "\n" +
    "<div class=\"challenges\">\n" +
    "  <div ng-if=\"data.selected_user\" class=\"challenge-user\">\n" +
    "    <div class=\"table\">\n" +
    "\n" +
    "      <div class=\"cell img\">\n" +
    "        <img alt=\"\" hes-image=\"{{ data.selected_user.profile.image.url }}\"></img>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"cell name\">\n" +
    "        {{ data.selected_user.profile.full_name }}\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"cell\">\n" +
    "        <button class=\"secondary\" ng-click=\"data.selected_user = null\">Deselect</button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <p class=\"margin-0-top no-margin-down\" ng-bind-html=\"explanations.challenges_select.content\"></p>\n" +
    "\n" +
    "  <div class=\"challenge\" ng-repeat=\"challenge in data.challenges\">\n" +
    "    <div>\n" +
    "      <div class=\"cell\">\n" +
    "        <img ng-if=\"challenge.image.url\" alt=\"\" hes-image=\"{{ challenge.image.url }}\"></img>\n" +
    "        <div ng-if=\"!challenge.image.url\" class=\"challenge-icon-container\">\n" +
    "          <a href=\"\" ng-click=\"selectChallenge(challenge)\">\n" +
    "            <span hes-icon icon-name='standard:challenge-icon'></span>\n" +
    "            <!-- <img class=\"plus-icon absolute-center select-challenge-default\" hes-image=\"/images/placeholders/plus.png\" alt=\"Select {{ challenge.name }}\"> -->\n" +
    "            <!-- <md-tooltip md-direction=\"bottom\">Select {{ challenge.name }}</md-tooltip> -->\n" +
    "          </a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"cell padded\">\n" +
    "        <span class=\"name new\">\n" +
    "          <strong>{{ challenge.name }}</strong>\n" +
    "        </span>\n" +
    "        <p class=\"description new\" hes-external-links ng-bind-html=\"challenge.description_html\">\n" +
    "        </p>\n" +
    "        <div class=\"text-right sm md\">\n" +
    "          <button class=\"secondary\"\n" +
    "            ng-if=\"!data.selected_user && hasFriends\"\n" +
    "            ng-click=\"selectChallenge(challenge)\"\n" +
    "            aria-label=\"Select {{ challenge.name }} challenge\">\n" +
    "            Select\n" +
    "          </button>\n" +
    "          <button class=\"secondary\"\n" +
    "            ng-if=\"data.selected_user && hasFriends\"\n" +
    "            ng-click=\"sendChallenge(data.selected_user, challenge)\"\n" +
    "            aria-label=\"Select {{ challenge.name }} challenge\">\n" +
    "            Select\n" +
    "          </button>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "      <div class=\"text-right xs button-wrapper\">\n" +
    "        <button class=\"secondary\"\n" +
    "          ng-if=\"!data.selected_user && hasFriends\"\n" +
    "          ng-click=\"selectChallenge(challenge)\"\n" +
    "          aria-label=\"Select {{ challenge.name }} challenge\">\n" +
    "          Select\n" +
    "        </button>\n" +
    "        <button class=\"secondary\"\n" +
    "          ng-if=\"data.selected_user && hasFriends\"\n" +
    "          ng-click=\"sendChallenge(data.selected_user, challenge)\"\n" +
    "          aria-label=\"Select {{ challenge.name }} challenge\">\n" +
    "          Select\n" +
    "        </button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/challenges/views/select-user.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/challenges/views/select-user.html",
    "<hes-breadcrumb crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "\n" +
    "<div class=\"challenges\">\n" +
    "  \n" +
    "  <div class=\"challenge\">\n" +
    "    <div class=\"cell\">\n" +
    "      <img ng-if=\"data.selected_challenge.image.url\" alt=\"\" hes-image=\"{{ data.selected_challenge.image.url }}\"></img>\n" +
    "      <div ng-if=\"!data.selected_challenge.image.url\" class=\"challenge-icon-container\">\n" +
    "        <span hes-icon icon-name='standard:challenge-icon'></span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"cell padded\">\n" +
    "      <div flex layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n" +
    "        <div>\n" +
    "          <span class=\"name\">\n" +
    "            <strong>{{ data.selected_challenge.name }}</strong>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        \n" +
    "        <div>\n" +
    "          <button class=\"secondary\"\n" +
    "                  ui-sref=\"go.u.usermenu.challenges.select_challenge\"\n" +
    "                  aria-label=\"Deselect {{ data.selected_challenge.name }} challenge\">\n" +
    "            Deselect\n" +
    "          </button>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <p class=\"description\" hes-external-links ng-bind-html=\"data.selected_challenge.description_html\"></p>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  \n" +
    "  <div ng-if=\"data.has_no_friends\" ng-bind-html=\"explanations.challenges_no_peers.content\"></div>\n" +
    "  \n" +
    "  <div ng-if=\"!data.has_no_friends\">\n" +
    "    <div class='search'>\n" +
    "      <input type='text' ng-model='data.query' placeholder=\"Search your {{ site.friend_label_plural }}\" ng-change='onSearchChange(data.query)' />\n" +
    "      <span class=\"clear-search\" hes-icon icon-name=\"standard:close-x\" ng-if=\"data.query\" ng-click=\"clearQuery()\" aria-label=\"Clear search\"></span>\n" +
    "    </div>\n" +
    "\n" +
    "    <div>\n" +
    "\n" +
    "      <div class=\"challenge-user\"\n" +
    "           ng-repeat=\"_friend in data.users\"\n" +
    "           ng-init=\"friend = _friend.getFriend()\">\n" +
    "        <div class=\"table\">\n" +
    "\n" +
    "          <div class=\"cell img\">\n" +
    "            <img alt=\"\" hes-image=\"{{ friend.profile.image.url }}\"></img>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"cell name\">\n" +
    "            {{ friend.profile.full_name }}\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"cell\">\n" +
    "            <button class=\"secondary\"\n" +
    "                    aria-label=\"Select {{ friend.profile.full_name }}.\"\n" +
    "                    ng-click=\"sendChallenge(friend, data.selected_challenge)\">\n" +
    "              Select\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  \n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/choose-logging/choose-logging.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/choose-logging/choose-logging.html",
    "<div layout=\"row\" class=\"choice-box-container\">\n" +
    "  <div class=\"choice-box device\">\n" +
    "    <div class=\"device-icon\"\n" +
    "      ng-class=\"{'unselected': $ctrl.user.isLoggingManually()}\">\n" +
    "      <span hes-icon icon-name=\"devices:watch\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"device-action\" layout=\"row\" layout-align=\"center center\">\n" +
    "      <button class=\"secondary\" ng-click=\"$ctrl.chooseDevice()\">\n" +
    "        Connect Device/App\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"choice-box manual\" ng-class=\"{'selected': $ctrl.user.isLoggingManually()}\">\n" +
    "    <div class=\"device-icon\"\n" +
    "      tabindex=\"{{ $ctrl.user.isLoggingManually() ? 0 : -1 }}\"\n" +
    "      aria-label=\"You are now logging manually\">\n" +
    "      <span hes-icon icon-name=\"devices:finger-click\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"device-action\" layout=\"row\" layout-align=\"center center\">\n" +
    "      <button class=\"secondary\" \n" +
    "        ng-click=\"$ctrl.chooseManual()\"\n" +
    "        ng-if=\"!$ctrl.view.saving && !$ctrl.user.isLoggingManually()\">\n" +
    "        Log Manually\n" +
    "      </button>\n" +
    "      <div ng-if=\"!!$ctrl.view.saving\">Saving...</div>\n" +
    "      <div ng-if=\"$ctrl.user.isLoggingManually()\" \n" +
    "        ng-bind-html=\"$ctrl.view.logManualContent.title\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/config/mainLayout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/config/mainLayout.html",
    "<div>\n" +
    "  <header id=\"mainHeader\" class=\"no-print\" ng-include=\"hesTemplateService.getTemplateUrl('/scripts/header/header.html')\"></header>\n" +
    "  <div class=\"app-content site-content\">\n" +
    "    <div class=\"page\" ui-view role='main'>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/config/userView.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/config/userView.html",
    "<div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/config/mainLayout.html')\"></div>");
}]);

angular.module("/scripts/contact/contact.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/contact/contact.html",
    "\n" +
    "<!-- Form -->\n" +
    "<form class='contact-form form-wrapper' ng-submit='submitContactRequest()'>\n" +
    "	<div class='contact-message' markdown ng-model='messages.contact.content'></div>\n" +
    "	<div ng-show='contactRequestSent'>\n" +
    "			<p ng-bind-html=\"explanations.contact_request_sent.content\"></p>\n" +
    "	</div>\n" +
    "	<div class=\"input-wrapper\" ng-hide='contactRequestSent' layout=\"row\" layout-wrap>\n" +
    "			<div class='section-wrapper' flex='100' flex-gt-xs='50'>\n" +
    "					<label for=\"first_name\">First Name\n" +
    "							<div class=\"inline invalid-text margin-sm-left\" ng-show=\"firstNameRequired\">*</div>\n" +
    "					</label>\n" +
    "					<input class=\"mobile-center width-auto\" id=\"first_name\" name=\"first_name\" type='text' placeholder='First Name'\n" +
    "								 ng-model='contactRequest.first_name' ng-class=\"{'invalid-field': firstNameRequired}\"/>\n" +
    "			</div>\n" +
    "\n" +
    "			<div class='section-wrapper' flex='100' flex-gt-xs='50'>\n" +
    "					<label for=\"last_name\">Last Name\n" +
    "							<div class=\"inline invalid-text margin-sm-left\" ng-show=\"lastNameRequired\">*</div>\n" +
    "					</label>\n" +
    "					<input class=\"mobile-center width-auto\" id=\"last_name\" name=\"last_name\" type='text' placeholder='Last Name'\n" +
    "								 ng-model='contactRequest.last_name' ng-class=\"{'invalid-field': lastNameRequired}\"/>\n" +
    "			</div>\n" +
    "			<div class='section-wrapper' flex='100' flex-gt-xs='50'>\n" +
    "					<label for=\"email\">Email\n" +
    "							<div class=\"inline invalid-text margin-sm-left\" ng-show=\"emailRequired\">*</div>\n" +
    "					</label>\n" +
    "					<input class=\"mobile-center width-auto\" id=\"email\" name=\"email\" type='text' placeholder='Email'\n" +
    "								 ng-model='contactRequest.email' ng-class=\"{'invalid-field': emailRequired}\"/>\n" +
    "			</div>\n" +
    "			<div class='section-wrapper' flex='100' flex-gt-xs='50'>\n" +
    "					<label for=\"phone_number\">Phone</label>\n" +
    "					<input class=\"mobile-center width-auto\" id=\"phone_number\" name=\"phone_number\" type='text' placeholder='Phone'\n" +
    "								 ng-model='contactRequest.phone' \"/><br/>\n" +
    "			</div>\n" +
    "			<div class='section-wrapper' flex='95'>\n" +
    "					<label for=\"comments\">Comments\n" +
    "							<div class=\"inline invalid-text margin-sm-left\" ng-show=\"commentsRequired\">*</div>\n" +
    "					</label>\n" +
    "					<textarea id=\"comments\" name=\"comments\" class=\"mobile-center width-auto\" placeholder='Comments'\n" +
    "										ng-model='contactRequest.comments'\n" +
    "										ng-class=\"{'invalid-textarea': commentsRequired}\"></textarea>\n" +
    "			</div>\n" +
    "	</div>\n" +
    "	<div ng-hide='contactRequestSent' class='button-center'>\n" +
    "			<button type='submit' ng-disabled='sendingContactRequest'>Send</button>\n" +
    "			<!-- Error -->\n" +
    "			<span class=\"padding-md invalid row\" ng-show='contactRequestError'>There was an error sending your message.</span>\n" +
    "\n" +
    "			<!-- Incorrect Phone Format -->\n" +
    "			<div class=\"invalid-text text-right\" ng-show=\"contactRequest.invalid\">* Required Fields</div>\n" +
    "	</div>\n" +
    "</form>");
}]);

angular.module("/scripts/content/confirmDeleteContent.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/content/confirmDeleteContent.html",
    "<p>Are you sure you want to delete \"{{content.title}}\"?</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm(content)\">Confirm</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/content/contentAddEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/content/contentAddEdit.html",
    "<div class=\"page\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div class=\"standard-header\">{{'Site ' + contentConfig.data.category + ' Content'}}</div>\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "      <br />\n" +
    "      <a class='action-link go-right' ng-click=\"createNewContent()\" ng-show=\"contentConfig.editContent === null\">Create New Content</a>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div>\n" +
    "      <form class=\"hes\" name='welcomeContentForm' ng-if=\"contentConfig.editContent !== null\" ng-submit='save(contentConfig.editContent.index)'>\n" +
    "        <legend>{{'Edit ' + contentConfig.editContent.key.toUpperCase() + ' Content'}}</legend>\n" +
    "        <fieldset>\n" +
    "          <a class='back-link float-right hes-popover' hes-popover template='/scripts/content/keywords/keywords.html' event='click' hide-event='click' popover-class='hes-popover-style no-print keyword-container'>See Keywords</a>\n" +
    "          <div ng-if=\"!settings.hideKeyField\" class=\"row\">\n" +
    "            <label for='edit_key'>Key</label>\n" +
    "\n" +
    "            <select ng-if=\"contentConfig.editContent.category != 'location_resources'\" ng-if=\"!contentConfig.showNewKey\"  id='edit_key' type='text' ng-model='contentConfig.editContent.key' style=\"width: max-content; padding-right: 15px;\" ng-options=\"option for option in contentConfig.contentKeys\"></select>\n" +
    "            <select ng-if=\"contentConfig.editContent.category == 'location_resources'\"\n" +
    "                    id='location'\n" +
    "                    type='text'\n" +
    "                    ng-model='contentConfig.editContent.key'>\n" +
    "                    <option ng-repeat=\"loc in dbSite.nested_locations\" value=\"{{loc.name}}\">{{loc.name}}</option>\n" +
    "                    <optgroup ng-repeat='top_loc in dbSite.nested_locations' label=\"{{top_loc.name}}\">\n" +
    "                      <option ng-repeat=\"loc in top_loc.locations\" value=\"{{loc.name}}\">{{loc.name}}</option>\n" +
    "                    </optgroup>\n" +
    "            </select>\n" +
    "\n" +
    "            <a ng-if=\"!contentConfig.showNewKey && settings.allowAddKeys\" class=\"action-link\" ng-click=\"showAddKey()\">Add New Key</a>\n" +
    "            <input ng-if=\"contentConfig.showNewKey\" ng-model='contentConfig.newKey'/>\n" +
    "            <a ng-if=\"contentConfig.showNewKey\" class=\"action-link\" ng-click=\"addNewKey()\">Save</a>&nbsp;&nbsp;<a ng-if=\"contentConfig.showNewKey\" class=\"action-link\" ng-click=\"cancelAddKey()\">Cancel</a>\n" +
    "          </div>\n" +
    "          <!--For Auto generated email keys-->\n" +
    "          <div class=\"row\" ng-if=\"contentConfig.editContent.category == 'auto_generated_emails'\">\n" +
    "            <div ng-if=\"contentConfig.editContent.key =='confirmation'\">Sent immediately after an account is created during opt in of campaign 1. </div>\n" +
    "            <div ng-if=\"contentConfig.editContent.key =='campaign_logging_begin'\">Sent to all users that have an ELE account but didn’t opt in.</div>\n" +
    "            <div ng-if=\"contentConfig.editContent.key =='confirmation_optin_close'\">Sent immediately after an account is created after campaign 1 opt in closes.</div>\n" +
    "            <div ng-if=\"contentConfig.editContent.key =='lets_go_email'\">Sent the day after the last loggable date of campaign 1 to all users. Also immediately sent to new registrants when a campaign is not live.</div>\n" +
    "            <div ng-if=\"contentConfig.editContent.key =='next_campaign_optin'\">Sent to all users when opt in begins for new campaign.</div>\n" +
    "            <div ng-if=\"contentConfig.editContent.key =='next_campaign_logging_begins'\">sent first day of logging begins for active campaign to users that haven’t opted in.</div>\n" +
    "            <div ng-if=\"contentConfig.editContent.key =='welcome_email'\">Sent immediately after an account is created during loggable dates of any campaign besides campaign 1.</div>\n" +
    "          </div>\n" +
    "          <div class=\"row\" ng-if='settings.showGroup'>\n" +
    "            <label for='edit_group'>{{settings.groupLabel()}}</label>\n" +
    "            <select ng-if=\"!contentConfig.showNewGroup\"  id='edit_group' type='text' ng-model='contentConfig.editContent.group' ng-options=\"option for option in contentConfig.contentGroups\"></select>\n" +
    "            <a ng-if=\"!contentConfig.showNewGroup && settings.allowAddGroups\" class=\"action-link\" ng-click=\"showAddGroup()\">Add New Group</a>\n" +
    "            <input ng-if=\"contentConfig.showNewGroup\" ng-model='contentConfig.newGroup'/>\n" +
    "            <a ng-if=\"contentConfig.showNewGroup\" class=\"action-link\" ng-click=\"addNewGroup()\">Save</a>&nbsp;&nbsp;<a ng-if=\"contentConfig.showNewGroup\" class=\"action-link\" ng-click=\"cancelAddGroup()\">Cancel</a>\n" +
    "          </div>\n" +
    "          <div class=\"row\" ng-if=\"settings.showSequence\">\n" +
    "            <label for=\"edit_sequence\">{{settings.sequenceLabel()}}</label>\n" +
    "            <input id=\"edit_sequence\" type='text' ng-model=\"contentConfig.editContent.sequence\"/>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"row\" ng-if=\"settings.hasCustomFieldsForCategory\">\n" +
    "            <div ng-repeat=\"field in settings.customFields.fields\">\n" +
    "              <div ng-if=\"field.type === 'text'\">\n" +
    "                <label for='{{category}}-custom-field-{{index}}'>{{field.title}}</label>\n" +
    "                <input id='{{category}}-custom-field-{{index}}' type='text' ng-model=\"contentConfig.editContent[field.modelName]\"/>\n" +
    "              </div>\n" +
    "              <div ng-if=\"field.type === 'textarea'\">\n" +
    "                <label for='{{category}}-custom-field-{{index}}'>{{field.title}}</label>\n" +
    "                <textarea rows=\"4\" id=\"{{category}}-custom-field-{{index}}\" ng-model=\"contentConfig.editContent[field.modelName]\"></textarea>\n" +
    "              </div>\n" +
    "              <div ng-if=\"field.type === 'image'\">\n" +
    "                <div class=\"tip-image\">\n" +
    "                  <h5 ng-if=\"uploadingFull\">Uploading...</h5>\n" +
    "                  <div class='padding-5'>\n" +
    "                    <div>\n" +
    "                      <span hes-file-upload\n" +
    "                      show-remove\n" +
    "                      ng-model='contentConfig.editContent[field.modelName]'\n" +
    "                      label='{{field.title}}'\n" +
    "                      label-class='upload-button'\n" +
    "                      class='drag-here'\n" +
    "                      image-class=\"md-img-rect\"\n" +
    "                      no-resize='true'\n" +
    "                      allow-drop=\"true\"\n" +
    "                      allow-any-type\n" +
    "                      allow-any-size\n" +
    "                      thumbnail-url=\"contentConfig.editContent[field.modelName].url\"\n" +
    "                      ></span>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div style=\"padding-left: 5%;\" ng-if=\"!settings.hideTitle()\">\n" +
    "              <label for='edit_title'>\n" +
    "                {{settings.titleLabel()}}&nbsp;\n" +
    "                <a ng-if=\"!settings.hideRichTextTitle()\" ng-click=\"settings.titleMarkdown = !settings.titleMarkdown\">toggle markup</a>\n" +
    "              </label>\n" +
    "              <textarea ng-show=\"!!settings.hideRichTextTitle() || !!settings.titleMarkdown\" rows=\"4\" id=\"edit_title\" ng-model=\"contentConfig.editContent.title\"></textarea>\n" +
    "              <ng-quill-editor ng-if=\"!settings.hideRichTextTitle()\" ng-model=\"contentConfig.editContent.title\">\n" +
    "                <ng-quill-toolbar>\n" +
    "                  <div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <select class=\"ql-header\"></select>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                      <button class=\"ql-italic\"></button>\n" +
    "                      <button class=\"ql-underline\"></button>\n" +
    "                      <button class=\"ql-strike\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                      <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-link\"></button>\n" +
    "                      <button class=\"ql-clean\"></button>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </ng-quill-toolbar>\n" +
    "              </ng-quill-editor>\n" +
    "          </div>\n" +
    "          <br ng-if=\"settings.showDescription()\" />\n" +
    "          <div class=\"row\" ng-if=\"settings.showDescription()\">\n" +
    "            <label for='edit_description'>\n" +
    "              {{settings.descriptionLabel()}}&nbsp;\n" +
    "              <a ng-if=\"settings.useRichTextDescription()\" ng-click=\"settings.descriptionMarkdown = !settings.descriptionMarkdown\">toggle markup</a>\n" +
    "            </label>\n" +
    "            <input ng-if=\"!settings.useRichTextDescription()\" id='edit_description' type='text' ng-model='contentConfig.editContent.description'/>\n" +
    "            <textarea ng-if=\"settings.useRichTextDescription()\" ng-show=\"!!settings.descriptionMarkdown\" rows=\"4\" id=\"edit_description\" ng-model=\"contentConfig.editContent.description\"></textarea>\n" +
    "            <ng-quill-editor ng-if=\"settings.useRichTextDescription()\" ng-model=\"contentConfig.editContent.description\">\n" +
    "              <ng-quill-toolbar>\n" +
    "                <div>\n" +
    "                  <div class=\"ql-formats\">\n" +
    "                    <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                    <button class=\"ql-italic\"></button>\n" +
    "                    <button class=\"ql-underline\"></button>\n" +
    "                    <button class=\"ql-strike\"></button>\n" +
    "                  </div>\n" +
    "                  <div class=\"ql-formats\">\n" +
    "                    <button class=\"ql-link\"></button>\n" +
    "                    <button class=\"ql-clean\"></button>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </ng-quill-toolbar>\n" +
    "            </ng-quill-editor>\n" +
    "          </div>\n" +
    "          <br />\n" +
    "          <span ng-if=\"showToolbar($state.params.category)\">\n" +
    "            <div style=\"padding-left: 5%;\" ng-if=\"!settings.hideContent()\">\n" +
    "              <label for='edit_content'>{{settings.contentLabel()}}&nbsp;\n" +
    "                <a ng-if=\"!settings.hideRichTextContent()\" ng-click=\"settings.contentMarkdown = !settings.contentMarkdown\">toggle markup</a>\n" +
    "              </label>\n" +
    "              <textarea ng-show=\"!!settings.hideRichTextContent() || !!settings.contentMarkdown\" rows=\"4\" id=\"edit_content\" ng-model=\"contentConfig.editContent.content\"></textarea>  \n" +
    "              <ng-quill-editor ng-if=\"!settings.hideRichTextContent()\" ng-model=\"contentConfig.editContent.content\">\n" +
    "                <ng-quill-toolbar>\n" +
    "                  <div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <select class=\"ql-header\"></select>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                      <button class=\"ql-italic\"></button>\n" +
    "                      <button class=\"ql-underline\"></button>\n" +
    "                      <button class=\"ql-strike\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                      <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "                    </div>\n" +
    "                    <div class=\"ql-formats\">\n" +
    "                      <button class=\"ql-link\"></button>\n" +
    "                      <button class=\"ql-image\"></button>\n" +
    "                      <button class=\"ql-clean\"></button>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </ng-quill-toolbar>\n" +
    "              </ng-quill-editor>\n" +
    "            </div>\n" +
    "            <br />\n" +
    "            <div class=\"row\" ng-if=\"!settings.hideSummary()\">\n" +
    "              <div ng-if=\"showToolbar($state.params.category)\">\n" +
    "                <label for='edit_summary'>{{settings.summaryLabel()}}&nbsp;\n" +
    "                  <a ng-if=\"!settings.hideRichTextSummary()\" ng-click=\"settings.summaryMarkdown = !settings.summaryMarkdown\">toggle markup</a>\n" +
    "                </label>\n" +
    "                <textarea ng-show=\"!!settings.hideRichTextSummary() || !!settings.summaryMarkdown\" rows=\"4\" id=\"edit_content\" ng-model=\"contentConfig.editContent.summary\"></textarea>\n" +
    "                <ng-quill-editor ng-if=\"!settings.hideRichTextSummary()\" ng-model=\"contentConfig.editContent.summary\">\n" +
    "                  <ng-quill-toolbar>\n" +
    "                    <div>\n" +
    "                      <div class=\"ql-formats\">\n" +
    "                        <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                        <button class=\"ql-italic\"></button>\n" +
    "                        <button class=\"ql-underline\"></button>\n" +
    "                        <button class=\"ql-strike\"></button>\n" +
    "                      </div>\n" +
    "                      <div class=\"ql-formats\">\n" +
    "                        <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                        <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "                      </div>\n" +
    "                      <div class=\"ql-formats\">\n" +
    "                        <button class=\"ql-link\"></button>\n" +
    "                        <button class=\"ql-image\"></button>\n" +
    "                        <button class=\"ql-clean\"></button>\n" +
    "                      </div>\n" +
    "                    </div>\n" +
    "                  </ng-quill-toolbar>\n" +
    "                </ng-quill-editor>\n" +
    "              </div>\n" +
    "              <!-- <div ng-if=\"!showToolbar($state.params.category)\">\n" +
    "                <label for='edit_summary'>{{settings.summaryLabel()}}</label>\n" +
    "                <textarea ng-model=\"contentConfig.editContent.summary\"></textarea>\n" +
    "              </div> -->\n" +
    "            </div>\n" +
    "          </span>\n" +
    "          <span ng-if=\"!showToolbar($state.params.category)\">\n" +
    "            <div class=\"row\" ng-if=\"!settings.hideContent()\">\n" +
    "              <label for='edit_content'>{{settings.contentLabel()}}</label>\n" +
    "              <!-- <textarea rows=\"4\" id=\"edit_content\" ng-model=\"contentConfig.editContent.content\"></textarea> -->\n" +
    "              <textarea ng-model=\"contentConfig.editContent.content\"></textarea>\n" +
    "            </div>\n" +
    "            <div class=\"row\" ng-if=\"!settings.hideSummary()\">\n" +
    "              <label for='edit_summary'>{{settings.summaryLabel()}}</label>\n" +
    "              <!-- <textarea rows=\"4\" id=\"edit_summary\" ng-model=\"contentConfig.editContent.summary\"></textarea> -->\n" +
    "              <textarea ng-model=\"contentConfig.editContent.summary\"></textarea>\n" +
    "            </div>\n" +
    "          </span>\n" +
    "          <br />\n" +
    "          <div class=\"row\" ng-if=\"settings.showImage()\">\n" +
    "            {{settings.image1Label}}\n" +
    "            <div class=\"tip-image\">\n" +
    "              <div class='padding-5'>\n" +
    "                <div>\n" +
    "                  <span hes-file-upload\n" +
    "                  show-remove\n" +
    "                  ng-model='contentConfig.editContent.image1'\n" +
    "                  label='{{settings.image1Label}}'\n" +
    "                  label-class='upload-button'\n" +
    "                  class='drag-here'\n" +
    "                  image-class=\"md-img-rect\"\n" +
    "                  no-resize='true'\n" +
    "                  allow-drop=\"true\"\n" +
    "                  allow-any-type\n" +
    "                  allow-any-size\n" +
    "                  thumbnail-url=\"contentConfig.editContent.image1.url\"\n" +
    "                  ></span>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <br />\n" +
    "          <div class=\"row\" ng-if=\"settings.showSecondImage()\">\n" +
    "            {{settings.image2Label}}\n" +
    "            <div class=\"tip-image\">\n" +
    "              <div class='padding-5'>\n" +
    "                <div>\n" +
    "                   <span hes-file-upload\n" +
    "                   show-remove\n" +
    "                      ng-model='contentConfig.editContent.image2'\n" +
    "                      label='{{settings.image2Label}}'\n" +
    "                      label-class='upload-button'\n" +
    "                      class='drag-here'\n" +
    "                      image-class=\"md-img-rect\"\n" +
    "                      no-resize='true'\n" +
    "                      allow-drop=\"true\"\n" +
    "                      allow-any-type\n" +
    "                      allow-any-size\n" +
    "                      thumbnail-url=\"contentConfig.editContent.image2.url\"\n" +
    "                      ></span>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <br />\n" +
    "          <div class=\"row clearfix\" ng-if=\"settings.showMobileImage1()\">\n" +
    "            {{settings.mobileImage1Label}}\n" +
    "            <div class=\"tip-image\">\n" +
    "              <h5 id='uploadingTextFull' ng-if=\"uploadingFull\">Uploading...</h5>\n" +
    "              <div class='padding-5'>\n" +
    "                <div>\n" +
    "                  <span hes-file-upload\n" +
    "                  show-remove\n" +
    "                    ng-model='contentConfig.editContent.mobile_image1'\n" +
    "                    label='{{settings.mobileImage1Label}}'\n" +
    "                    label-class='upload-button'\n" +
    "                    class='drag-here'\n" +
    "                    image-class=\"md-img-rect\"\n" +
    "                    no-resize='true'\n" +
    "                    allow-drop=\"true\"\n" +
    "                    allow-any-type\n" +
    "                    allow-any-size\n" +
    "                    thumbnail-url=\"contentConfig.editContent.mobile_image1.url\"\n" +
    "                    ></span>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <br />\n" +
    "          <div class=\"row clearfix\" ng-if=\"settings.showEmailImage()\">\n" +
    "            <div class=\"tip-image\">\n" +
    "              <h5 id='uploadingTextFull' ng-if=\"uploadingFull\">Uploading...</h5>\n" +
    "              <div class='padding-5'>\n" +
    "                <div>\n" +
    "                  <span hes-file-upload\n" +
    "                  show-remove\n" +
    "                    ng-model='contentConfig.editContent.email_image'\n" +
    "                    label='Email Image'\n" +
    "                    label-class='upload-button'\n" +
    "                    class='drag-here'\n" +
    "                    image-class=\"md-img-rect\"\n" +
    "                    no-resize='true'\n" +
    "                    allow-drop=\"true\"\n" +
    "                    allow-any-type\n" +
    "                    allow-any-size\n" +
    "                    thumbnail-url=\"contentConfig.editContent.email_image.url\"\n" +
    "                    ></span>\n" +
    "                  <div hes-image-gallery allow-remove='true' ng-model='contentConfig.editContent.email_image' label=\"Email Image\" image-result-size=\"md\" folder-location=\"/content\"></div>\n" +
    "                  <div class='font-md'>\n" +
    "                    <div>Email Image</div>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <br />\n" +
    "          <div class=\"row\" ng-if=\"!settings.hideHiddenCheckbox\">\n" +
    "            <input type=\"checkbox\" ng-model=\"contentConfig.editContent.hidden\"/>\n" +
    "            <label>Hidden?</label>\n" +
    "          </div>\n" +
    "          <div class=\"row\"\n" +
    "               ng-if=\"contentConfig.editContent.category == 'terms' || contentConfig.editContent.category == 'privacy'\"\n" +
    "               required-terms-checkbox\n" +
    "               custom-content=\"contentConfig.editContent\">\n" +
    "          </div>\n" +
    "        </fieldset>\n" +
    "        <div class='button-container'>\n" +
    "          <button class='link-look' ng-click=\"cancelEdit()\">Cancel</a>\n" +
    "           <button ng-disabled=\"settings.saving\" ng-class=\"{disabled: settings.isSaving}\" type='submit'>Save</button>\n" +
    "           <div class='save-feedback' ng-show=\"settings.showSaving\">\n" +
    "            Saving...\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "    <div class=\"row sortable-content-list content-view\"\n" +
    "    ng-if=\"contentConfig.editContent === null\"\n" +
    "    ng-model=\"contentConfig.contents\"\n" +
    "    html-sortable=\"settings.showSequence ? sortableOptions : 'destroy'\">\n" +
    "    <div ng-repeat=\"content in contentConfig.contents | orderBy: 'sequence'\" class=\"clearfix content-item\">\n" +
    "      <div class=\"drag-handle\" ng-if=\"settings.showSequence\">\n" +
    "        <svg class=\"\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" width=\"30\" height=\"30\" focusable=\"false\"><title>drag</title><path stroke=\"#ccc\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M4 7h22M4 15h22M4 23h22\"></path></svg>\n" +
    "      </div>\n" +
    "      <span ng-if=\"!content.confirmSwitch\">\n" +
    "        {{settings.hideKeyField ? plainText(content.title) : isContentEdited(content) ? (content.hidden ? 'Hidden' : 'Edited') : 'Default'}}\n" +
    "        <span class=\"font-bold\" ng-if=\"!!content.sequence || content.sequence === 0\">{{settings.sequenceLabel() + \" \" + content.sequence}}</span>\n" +
    "        {{settings.hideKeyField ? (settings.showGroup ? content.group : '') : (': ' + plainText(content.title || content.key))}}\n" +
    "      </span>\n" +
    "      <span>\n" +
    "        <a class=\"action-link\" ng-if=\"content.isEdited && !content.confirmSwitch\" ng-click=\"confirmUseDefault(content)\">Switch To Default</a>\n" +
    "        <span ng-if=\"content.isEdited && content.confirmSwitch\">Switch to using the default?</span>\n" +
    "        <a ng-if=\"content.isEdited && content.confirmSwitch\" class=\"action-link\" ng-click=\"cancelSwitchToDefault(content)\">No</a>\n" +
    "        <a ng-if=\"content.isEdited && content.confirmSwitch\" class=\"action-link\" ng-click=\"switchToDefault(content, $index)\">Yes</a>\n" +
    "        <a class=\"action-link\" ng-click=\"content.show = !content.show\">{{content.show ? 'Hide' : 'Show'}}</a>\n" +
    "      </span>\n" +
    "\n" +
    "      <div class=\"content\" ng-include=\"contentConfig.data.html\" ng-if=\"content.show\"></div>\n" +
    "      <div>\n" +
    "        <a class=\"action-link margin-0\" ng-click=\"doEdit(content, $index)\">Edit</a>&nbsp;&nbsp;\n" +
    "        <a ng-if=\"(content.site_id === dbSite.id || content.site_id === null) && dbSite.isDefault()\" class=\"action-link\" ng-click=\"confirmDeleteContent(content, $index)\">Delete</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/content/contentPreview.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/content/contentPreview.html",
    "<div class=\"content-preview\">\n" +
    "  <div class='title' ng-if=\"content.title_html !== ''\" ng-bind-html='content.title_html' hes-external-links></div>\n" +
    "  <div class='image' ng-if=\"content.image.url !== '/images/custom_content/default.png'\"><img ng-src=\"{{content.image.url}}\"/></div>\n" +
    "  <div class='summary' ng-if=\"content.summary_html !== ''\" ng-bind-html='content.summary_html' hes-external-links></div>\n" +
    "  <div class='' ng-if=\"content.content_html !== ''\" ng-bind-html='content.content_html' hes-external-links></div>\n" +
    "</div>");
}]);

angular.module("/scripts/content/keywords/keywords.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/content/keywords/keywords.html",
    "<div ng-controller='KeywordController'>\n" +
    "	<div>\n" +
    "		<table>\n" +
    "			<tr>\n" +
    "				<td class='keyword-key-td'><b>Keyword</b></td>\n" +
    "				<td class='keyword-value-td'><b>Value</b></td>\n" +
    "			</tr>\n" +
    "			<tr ng-repeat='keyword in keywords'>\n" +
    "				<td class='keyword-key-td'>{{keyword[0]}}</td>\n" +
    "				<td class='keyword-value-td'>{{keyword[1]}}</td>\n" +
    "		</table>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/content/welcome/welcomeEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/content/welcome/welcomeEdit.html",
    "<div class=\"padded-page\">\n" +
    "  <div>\n" +
    "    <h4>Promotion Welcome Content</h4>\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.promotion({promotionId: data.promotionId})\">Back To Promotion</a>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <form class=\"hes\" name='welcomeContentForm' ng-if=\"welcomeConfig.editContent !== null\" ng-submit='save(welcomeConfig.editContent.index)'>\n" +
    "      <legend>{{'Edit ' + welcomeConfig.editContent.key.toUpperCase() + ' Content'}}</legend>\n" +
    "      <fieldset>\n" +
    "        <div class=\"row\">\n" +
    "          <label for='edit_title'>Title</label>\n" +
    "          <input id='edit_title' type='text' ng-model='welcomeConfig.editContent.title'/>\n" +
    "          <label for='edit_content'>What Content</label>\n" +
    "          <textarea rows=\"4\" id=\"edit_content\" ng-model=\"welcomeConfig.editContent.content\"></textarea>\n" +
    "        </div>\n" +
    "      </fieldset>\n" +
    "      <div class='bottom-row-rel center'>\n" +
    "        <a class='back-link' ng-click=\"cancelEdit()\">Cancel</a>\n" +
    "        <button ng-disabled=\"settings.saving\" ng-class=\"{disabled: settings.isSaving}\" type='submit'>Save</button>\n" +
    "        <div class='save-feedback' ng-show=\"settings.showSaving\">\n" +
    "          Saving...\n" +
    "          <!-- <img src='/images/loading-go-e6.gif' alt=\"moving chevrons\"/> -->\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "    <div class=\"row welcome-mobile content-view\" ng-show=\"welcomeConfig.editContent === null\">\n" +
    "      <div ng-repeat=\"content in welcomeConfig.contents | orderBy: '+sequence'\">\n" +
    "\n" +
    "        <span ng-if=\"!content.confirmSwitch\">{{isContentEdited(content) ? 'Edited' : 'Default'}}{{': ' + content.key}}</span>\n" +
    "        <span>\n" +
    "          <a class=\"action-link\" ng-if=\"content.isEdited && !content.confirmSwitch\" ng-click=\"confirmUseDefault(content)\">Switch To Default</a>\n" +
    "          <span ng-if=\"content.isEdited && content.confirmSwitch\">Switch to using the default?</span>\n" +
    "          <a ng-if=\"content.isEdited && content.confirmSwitch\" class=\"action-link\" ng-click=\"cancelSwitchToDefault(content)\">No</a>\n" +
    "          <a ng-if=\"content.isEdited && content.confirmSwitch\" class=\"action-link\" ng-click=\"switchToDefault(content, $index)\">Yes</a>\n" +
    "        </span>\n" +
    "        <div ng-include=\"'/scripts/welcome/content-container.html'\"></div>\n" +
    "        <a class=\"action-link\" ng-click=\"doEdit(content, $index)\">Edit</a>\n" +
    "        <hr>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/eligibility/eligibilityFile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/eligibility/eligibilityFile.html",
    "<div>\n" +
    "  <div class=\"standard-header\">Eligibility Files</div>\n" +
    "\n" +
    "  <!-- Eligibility Files -->\n" +
    "  <div>\n" +
    "    <span hes-file-upload complete='uploadDone' ng-model='eligibilityFile.filename' label='Upload File' allow-any-size allow-any-type is-secure></span>\n" +
    "    <div error-banner priority=1></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div hes-table tbl-data=\"data.tblData\" loading=\"settings.loading\" custom-no-data-msg=\"No files uploaded.\"></div>\n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/flagged_posts/flagged_posts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/flagged_posts/flagged_posts.html",
    "<div class=\"bg-secondary\">\n" +
    "\n" +
    "  <hes-create-post ng-if=\"allowCreate()\" class=\"card\" \n" +
    "    on-create=\"placeNewPost(newPost)\" wallable=\"site\"></hes-create-post>\n" +
    "  \n" +
    "  <div class=\"card text-center container\" ng-if=\"!settings.flaggedWall.posts.length && !view.wall.loading\">\n" +
    "    <p ng-if=\"$state.params.filter == 'friends' && data.has_no_friends\" ng-bind-html=\"explanations.wall_no_peers.content\">\n" +
    "    </p>\n" +
    "    <p ng-if=\"$state.params.filter != 'friends' || !data.has_no_friends\" ng-bind-html=\"explanations.wall_no_posts.content\"></p>\n" +
    "  </div>\n" +
    "  <hes-post class=\"card\" \n" +
    "    ng-repeat-start=\"post in settings.flaggedWall.posts | orderBy: '-created_at'\"\n" +
    "    post=\"post\"\n" +
    "    wallable=\"site\"\n" +
    "    on-delete=\"removePost(post)\"\n" +
    "    on-update=\"removePost(post)\">\n" +
    "  </hes-post>\n" +
    "  <div ng-repeat-end class=\"card thin\" ng-if=\"post.showComments()\">\n" +
    "    <hes-wall-comments post=\"post\" wallable=\"site\"></hes-wall-comments>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/notifications/confirmSendMessage.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/notifications/confirmSendMessage.html",
    "<div>Send this message to all {{ data.selected_location ? data.selected_location.name : '' }} participants?</div>\n" +
    "<div ng-bind-html=\"message\" class=\"confMessage\"></div>\n" +
    "<div class=\"center\">\n" +
    "  <a ng-click = \"closeThisDialog()\" class=\"padding-10-right\">Cancel</a> \n" +
    "  <button ng-click = \"confirm()\">Send</button>\n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/notifications/notifications.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/notifications/notifications.html",
    "<div class=\"coordinator\">\n" +
    "\n" +
    "  <!-- Reports -->\n" +
    "  <div class=\"coord-reports half-page\">\n" +
    "    <h2>Notifications</h2>\n" +
    "\n" +
    "    <div class=\"tile-inner\">\n" +
    "\n" +
    "        <div class=\"location-space\">\n" +
    "          <div><label for=\"message\">Message</label></div>\n" +
    "          <textarea class=\"post inline growing-input\"\n" +
    "            id=\"message\"\n" +
    "            growing-input=\"\"\n" +
    "            height-offset=\"0\"\n" +
    "            min-height=\"100\"\n" +
    "            placeholder=\"Add your message…\"\n" +
    "            aria-label=\"Add your message…\"\n" +
    "            ng-model=\"data.current_message\"\n" +
    "            aria-invalid=\"false\">\n" +
    "          </textarea>\n" +
    "        </div>\n" +
    "\n" +
    "        <div \n" +
    "          layout=\"row\" \n" +
    "          layout-wrap \n" +
    "          class=\"location-space\"\n" +
    "          ng-if=\"site.flags.is_location_displayed && is_regional_coordinator_or_above\">\n" +
    "          <label flex='100' for=\"location1\">{{site.getLocationLabel(0)}}</label>\n" +
    "\n" +
    "          <div \n" +
    "            ng-if=\"is_coordinator_or_above\"\n" +
    "            flex='100' \n" +
    "            flex-gt-xs='40'>\n" +
    "            <select \n" +
    "              class='lg' \n" +
    "              id=\"location1\" \n" +
    "              ng-model='locationFilter.parentLocation' \n" +
    "              ng-options=\"location as location.name for location in locations\"\n" +
    "              ng-change=\"locationChanged('parent')\" \n" +
    "              name='Location'>\n" +
    "            <option value=''>All {{site.getLocationLabel(0)}}s</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "\n" +
    "          <div \n" +
    "            ng-if=\"is_regional_coordinator\"\n" +
    "            flex='100' \n" +
    "            flex-gt-xs='40'>\n" +
    "            <select \n" +
    "              class='lg' \n" +
    "              id=\"location1\" \n" +
    "              ng-model='locationFilter.parentLocation' \n" +
    "              ng-options=\"location as location.name for location in locations | filter:{name:locationFilter.parentLocation.name}\"\n" +
    "              ng-change=\"locationChanged('parent')\" \n" +
    "              name='Location'>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "\n" +
    "          <div \n" +
    "            flex='100' \n" +
    "            flex-gt-xs='40' \n" +
    "            ng-if='displayChildLocations()'>\n" +
    "            <select \n" +
    "              class='lg' \n" +
    "              id=\"location2\" \n" +
    "              ng-model='locationFilter.childLocation' \n" +
    "              ng-options='location as location.name for location in locationFilter.parentLocation.locations' \n" +
    "              ng-change=\"locationChanged('child')\" \n" +
    "              name='Location'>\n" +
    "            <option value=''>All {{site.getLocationLabel(1)}}s</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"send-message\">\n" +
    "          <button ng-click=\"confirmSend(data.current_message)\">Send Notification</button>\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <br/><br/>\n" +
    "    <h5>Previously Sent Notifications</h5>\n" +
    "    <div class=\"notifications white-border\" hes-no-scroll-page>\n" +
    "      <div class=\"notification\" ng-repeat=\"notification in data.previous_notifications\">\n" +
    "        <div style=\"display: flex;\">\n" +
    "          <div class=\"date\">{{notification.getCreatedOn()}}</div>\n" +
    "          <details style=\"color: gray;padding-left: 15px;width: 100%;\">\n" +
    "            <summary>Markdown</summary>\n" +
    "            <div class=\"message\" ng-bind=\"notification.message\"></div>\n" +
    "          </details>\n" +
    "        </div>\n" +
    "        <div class=\"message\" markdown no-paragraph ng-model=\"notification.message\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/reports/reports.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/reports/reports.html",
    "<div class=\"coordinator\">\n" +
    "\n" +
    "  <!-- Reports -->\n" +
    "  <div class=\"coord-reports half-page\">\n" +
    "    <h2>Reports</h2>\n" +
    "\n" +
    "\n" +
    "    <div class=\"tile-inner\" ng-show=\"!loadingReports\">\n" +
    "        <p ng-if=\"reportingPrograms.length > 0\">Select a logo below to create or view a report.</p>\n" +
    "        <p ng-if=\"reportingPrograms.length === 0\">There are currently no reports available to run.</p>\n" +
    "\n" +
    "        <div class=\"reporting-programs-wrapper padding-lg-right-left\">\n" +
    "          <div class=\"reporting-programs-group\" ng-if=\"group.programs.length\" ng-repeat=\"group in sortedReportingPrograms\">\n" +
    "            <div class=\"reporting-programs-group-name\">{{group.name}}</div>\n" +
    "            <div class=\"reporting-program\" ng-repeat=\"program in group.programs\">\n" +
    "              <div class=\"reporting-logo\" ng-click=\"goToProgramReports(program)\">\n" +
    "                  <img ng-show=\"program.logo && program.logo.url\" hes-image=\"{{program.logo.url}}\" alt=\"{{program.name}}\" no-theme\n" +
    "                       use-domain=\"true\"/>\n" +
    "                  <div ng-show=\"!program.logo || !program.logo.url\">\n" +
    "                    {{ program.name }}\n" +
    "                  </div>\n" +
    "              </div>\n" +
    "              <div class=\"program-timespan\">{{program.effective_date_start | date: 'mediumDate'}} &dash;\n" +
    "                                            {{program.effective_date_end | date: 'mediumDate'}}\n" +
    "              </div>\n" +
    "              <div class=\"program-error\" ng-show=\"program.reportsError\">Unable to connect to <em>{{program.promotion.app_name\n" +
    "                                                                                                 || 'this challenge'}}</em>.\n" +
    "              </div>\n" +
    "              </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/stats/stats.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/stats/stats.html",
    "<div class=\"stats\">\n" +
    "  <div class=\"stats-container\">\n" +
    "    <div class=\"stats-header\">\n" +
    "      <h2>Stats</h2>\n" +
    "      <select ng-options=\"year as year for year in availableYears\"\n" +
    "              ng-model=\"data.selected_year\"\n" +
    "              ng-change=\"getDataFor(data.selected_year)\">\n" +
    "      </select>\n" +
    "\n" +
    "    </div>\n" +
    "    <div class=\"stats-data\">\n" +
    "      <div class=\"stats__item\">\n" +
    "        <div class=\"row\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-challenges\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number challenges-color\">{{ data.stats.total_completed_challenges }}</div>\n" +
    "            <div class=\"data-label\">Successful Challenges</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-goals\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number goals-color\">{{ data.stats.total_completed_goals }}</div>\n" +
    "            <div class=\"data-label\">Goals Completed</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"stats__item\">\n" +
    "        <div class=\"row\" ng-if=\"site.flags.is_logging_enabled\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-steps\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number steps-color\">{{ data.stats.total_steps | number }}</div>\n" +
    "            <div class=\"data-label\">Steps Taken</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-badges\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number badges-color\">{{ data.stats.total_badges_earned }}</div>\n" +
    "            <div class=\"data-label\">Badges Earned</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  \n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/upcoming_launches/upcoming_launches.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/upcoming_launches/upcoming_launches.template.html",
    "<div class=\"coordinator\">\n" +
    "\n" +
    "  <!-- Reports -->\n" +
    "  <div class=\"coord-reports half-page\">\n" +
    "    <h2>Upcoming Launches</h2>\n" +
    "\n" +
    "\n" +
    "    <div class=\"tile-inner\">\n" +
    "        <p ng-if=\"site.programs.upcoming.length > 0 || site.hasComingSoonPrograms()\">Select a logo below to preview a program before it launches.</p>\n" +
    "        <p ng-if=\"site.programs.upcoming.length === 0 && !site.hasComingSoonPrograms()\">There are currently no programs to preview.</p>\n" +
    "\n" +
    "        <div class=\"reporting-programs-wrapper padding-lg-right-left\">\n" +
    "\n" +
    "          <div class=\"reporting-program\" ng-repeat=\"program in site.programs.upcoming\">\n" +
    "            <div class=\"reporting-logo\" ng-click=\"goToProgram(program.id)\">\n" +
    "              <img ng-show=\"program.logo && program.logo.url\" hes-image=\"{{program.logo.url}}\" alt=\"{{program.name}}\" no-theme\n" +
    "                   use-domain=\"true\"/>\n" +
    "            </div>\n" +
    "            <div class=\"program-timespan\">{{program.effective_date_start | date: 'mediumDate'}} &dash;\n" +
    "                                          {{program.effective_date_end | date: 'mediumDate'}}\n" +
    "            </div>\n" +
    "            <div class=\"program-error\" ng-show=\"program.reportsError\">Unable to connect to <em>{{program.promotion.app_name\n" +
    "                                                                                               || 'this challenge'}}</em>.\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"reporting-program\" ng-repeat=\"program in site.programs.current\">\n" +
    "            <div ng-if=\"program.logging_state == 'coming_soon'\">\n" +
    "              <div class=\"reporting-logo\" ng-click=\"goToProgram(program.id)\">\n" +
    "                <img ng-show=\"program.logo && program.logo.url\" hes-image=\"{{program.logo.url}}\" alt=\"{{program.name}}\" no-theme\n" +
    "                     use-domain=\"true\"/>\n" +
    "              </div>\n" +
    "              <div class=\"program-timespan\">{{program.effective_date_start | date: 'mediumDate'}} &dash;\n" +
    "                                            {{program.effective_date_end | date: 'mediumDate'}}\n" +
    "              </div>\n" +
    "              <div class=\"program-error\" ng-show=\"program.reportsError\">Unable to connect to <em>{{program.promotion.app_name\n" +
    "                                                                                                 || 'this challenge'}}</em>.\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/coordinator/users.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/coordinator/users.html",
    "<div>\n" +
    "  <div class=\"team-table\">\n" +
    "    <div hes-table tbl-data=\"data.table\" show-export=\"true\" report-name=\"'Participants'\" show-no-data=\"true\" loading=\"data.loading\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/countdown/countdown.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/countdown/countdown.html",
    "<div class=\"countdown-time highlight\">\n" +
    "  <div class=\"countdown-label\">Days</div>\n" +
    "  <div class=\"time-digit\">{{countdown.days}}</div>\n" +
    "</div>\n" +
    "<div class=\"countdown-time colon\">\n" +
    "  <div class=\"time-digit\">:</div>\n" +
    "</div>\n" +
    "<div class=\"countdown-time\">\n" +
    "  <div class=\"countdown-label\">Hours</div>\n" +
    "  <div class=\"time-digit\">{{countdown.hours}}</div>\n" +
    "</div>\n" +
    "<div class=\"countdown-time colon\">\n" +
    "  <div class=\"time-digit\">:</div>\n" +
    "</div>\n" +
    "<div class=\"countdown-time\">\n" +
    "  <div class=\"countdown-label\">Minutes</div>\n" +
    "  <div class=\"time-digit\">{{countdown.minutes}}</div>\n" +
    "</div>\n" +
    "<div class=\"countdown-time colon\">\n" +
    "  <div class=\"time-digit\">:</div>\n" +
    "</div>\n" +
    "<div class=\"countdown-time\">\n" +
    "  <div class=\"countdown-label seconds\">Seconds</div>\n" +
    "  <div class=\"time-digit seconds\">{{countdown.seconds}}</div>\n" +
    "</div>");
}]);

angular.module("/scripts/countdown/countdownPage.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/countdown/countdownPage.html",
    "<div ng-controller='CountdownController'>\n" +
    "  <div class=\"padded-page extra-padding\" ng-if=\"setup.loading\">\n" +
    "    <div class=\"padded-page\">\n" +
    "      <div class=\"countdown\">\n" +
    "\n" +
    "        <!-- Content -->\n" +
    "<!--         <div class='countdown-title mobile-only'>\n" +
    "          <div markdown ng-model='data.countdownContentBanner.content_html'></div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"center title\">\n" +
    "          <h4><span no-paragraph markdown ng-model=\"data.countdownContent.title_html\"></span></h4>\n" +
    "        </div> -->\n" +
    "\n" +
    "        <div markdown ng-model='data.countdownContent.content_html'></div>\n" +
    "\n" +
    "        <!-- Countdown -->\n" +
    "        <div hes-countdown end-date=\"data.startDate\" class=\"countdown-table\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/customEmails/customEmails.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/customEmails/customEmails.html",
    "<div class=\"send-email-page clearfix\">\n" +
    "    <div class=\"page-tile lg\">\n" +
    "        <div class=\"standard-header\">Email Templates</div>\n" +
    "        <div>\n" +
    "            <a class='back-link' ui-sref=\"go.u.site.queued_emails({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back Queued Emails</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-3\">\n" +
    "        <div class=\"form-wrapper block\">\n" +
    "            <div class=\"alert alert-danger\" ng-show=\"validationErrors.length\">\n" +
    "                <ul>\n" +
    "                    <li ng-repeat=\"error in validationErrors\">{{error}}</li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "            <div class=\"input-wrapper\">\n" +
    "                <label for=\"template\">Template</label>\n" +
    "                <select name=\"template\" id=\"template\"  ng-init=\"email.template = data.templates[0].id\" ng-model=\"email.template\" ng-options=\"template.id as template.name for template in data.templates\">\n" +
    "                    <option value=\"\">--Choose--</option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "            <div class=\"input-wrapper\">\n" +
    "                <label for=\"recipients\">Recipients <span class=\"font-normal\">(separate with new lines, comas, semicolons, or pipes)</span></label>\n" +
    "                <textarea name=\"recipients\" required id=\"recipients\" ng-change=\"recipientsChangeHandler()\" ng-model=\"email.rawRecipients\"></textarea>\n" +
    "            </div>\n" +
    "            <div class=\"recipients-filters\">\n" +
    "                <div ng-repeat=\"filter in data.filters\" ng-if=\"!filter.options || (filter.options && filter.options.length)\">\n" +
    "                    <table>\n" +
    "                        <tr>\n" +
    "                            <td>\n" +
    "                                <div type=\"checkbox\" id=\"{{filter.key}}\" ng-model=\"filter.isSelected\" hes-checkbox class=\"hes-checkbox inline\"></div>\n" +
    "                            </td>\n" +
    "                            <td>\n" +
    "                                <div class=\"checkbox-label\">{{filter.text}}</div>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </table>\n" +
    "\n" +
    "                    <div ng-if=\"filter.key !== 'LOCATION_PARTICIPANTS'\">\n" +
    "                        <div class=\"margin-md-bottom-top\" ng-show=\"filter.key !== 'ALL_PARTICIPANTS' && filter.key !== 'ALL_SUBSCRIBED_PARTICIPANTS'\">\n" +
    "                            <select ng-change=\"filterSelectChangeHandler(filter)\" ng-model=\"filter.value\" ng-options=\"option.key as option.value for option in filter.options\">\n" +
    "                                <option value=\"\">-- Choose --</option>\n" +
    "                            </select>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div ng-if=\"filter.key === 'LOCATION_PARTICIPANTS'\">\n" +
    "                        <div ng-repeat=\"selectedLocation in email.selectedLocations track by $index\">\n" +
    "                            <select name=\"{{location.name}}-{{$index}}\" id=\"{{location.name}}-{{$index}}\" ng-options=\"location.key as location.value for location in filter.options\" ng-model=\"selectedLocation\" class=\"margin-md-top\" ng-change=\"setSelectedLocation(selectedLocation, $index)\">\n" +
    "                                <option value=\"\">-- Choose --</option>\n" +
    "                            </select>\n" +
    "                            <a class=\"clear-input\" ng-click=\"removeLocation($index, filter)\">&times;</a>\n" +
    "                        </div>\n" +
    "                        <div class=\"margin-md-bottom\">\n" +
    "                            <button ng-click=\"addLocation(filter)\" ng-show=\"email.selectedLocations.length < filter.options.length\">Add location</button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"input-wrapper\">\n" +
    "                <label for=\"from_address\">From\n" +
    "                    <div class=\"info-circle\"> \n" +
    "                        <span>i</span>\n" +
    "                        <md-tooltip md-direction=\"top\">Change at: promotion -> edit, From Name & From Address</md-tooltip>\n" +
    "                    </div>\n" +
    "                </label>\n" +
    "                \n" +
    "                <p type=\"text\" class=\"full-width\" name=\"from_address\">{{email.from_address}}</p>\n" +
    "            </div>\n" +
    "            <div class=\"input-wrapper\">\n" +
    "                <label for=\"subject\">Subject</label>\n" +
    "                <input type=\"text\" class=\"full-width\" name=\"subject\" required id=\"subject\" ng-model=\"email.subject\">\n" +
    "            </div>\n" +
    "            <div class=\"input-wrapper\" ng-repeat=\"prom in email.prompts\">\n" +
    "                <label class=\"font-normal\" for=\"prompt-{{$index}}\">{{prom.name}}</label>\n" +
    "                <input type=\"text\" name=\"prompt-{{$index}}\" id=\"prompt-{{$index}}\" ng-model=\"prom.label\" ng-if=\"prom.type === 'text'\"/>\n" +
    "                <textarea type=\"text\" name=\"prompt-{{$index}}\" id=\"prompt-{{$index}}\" ng-model=\"prom.label\" ng-if=\"prom.type === 'html'\"></textarea>\n" +
    "                <select name=\"prompt-{{$index}}\"\n" +
    "                        id=\"prompt-{{$index}}\" \n" +
    "                        ng-model=\"prom.label\"\n" +
    "                        ng-if=\"prom.type === 'url'\"\n" +
    "                        ng-options=\"p.logo.url as p.displayName() for p in dbSite.programs\">\n" +
    "                </select>\n" +
    "            </div>\n" +
    "            <div ng-show=\"!email.prompts.length\" class=\"padding-lg-bottom-top\">This template has no options.</div>\n" +
    "\n" +
    "            <div class=\"text-center mobile-only padding-lg-top margin-lg-bottom-top\">\n" +
    "                <div class=\"buttons-wrapper\">\n" +
    "                    <button ng-click=\"previewEmail();\" ng-disabled=\"!isFormFilled()\">Preview</button>\n" +
    "                    <button ng-click=\"sendEmail();\" ng-disabled=\"!isFormFilled()\">Send</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"input-wrapper\">\n" +
    "                <table>\n" +
    "                    <tr>\n" +
    "                        <td>\n" +
    "                            <div type=\"checkbox\" id=\"use_date\" ng-model=\"date.useDate\" hes-checkbox class=\"hes-checkbox inline\"></div>\n" +
    "                        </td>\n" +
    "                        <td>\n" +
    "                            <div class=\"checkbox-label\">Use send at date</div>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "            <div class=\"input-wrapper\" ng-if=\"date.useDate\">\n" +
    "                <label for=\"date\">Date to Send</label>\n" +
    "                <div class=\"date-input-wrapper clearfix\">\n" +
    "                    <img class=\"date-input-image float-left hide-on-mobile\" hes-hover-image=\"/icons/calendar-dark-grey.svg\" hes-image=\"/icons/calendar-light-grey.svg\" hes-trigger-click-on=\"#date\"/>\n" +
    "                    <input type=\"text\" name=\"date\" id=\"date\" class=\"float-left\" hes-date-select date-format=\"options.dateFormat\" ng-model=\"date.sendDate\">\n" +
    "                </div>\n" +
    "                <div class=\"time-input-wrapper\">\n" +
    "                    <input ui-timepicker type=\"text\" name=\"time\" id=\"time\" ng-model=\"date.sendTime\"> Eastern Time\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"text-center hide-on-mobile padding-lg-top margin-lg-bottom-top\">\n" +
    "                <div class=\"buttons-wrapper\">\n" +
    "                    <button ng-click=\"previewEmail();\" ng-disabled=\"!isFormFilled()\">Preview</button>\n" +
    "                    <button ng-click=\"sendEmail();\" ng-disabled=\"!isFormFilled()\">{{ date.useDate ? \"Save\" : \"Send\" }}</button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("/scripts/customEmails/dialogs/previewDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/customEmails/dialogs/previewDialog.html",
    "<div>\n" +
    "    <div class=\"padding-md-bottom-top center font-md\">\n" +
    "        <div markdown ng-model=\"previewHtml\" no-paragraph></div>\n" +
    "    </div>\n" +
    "    <div class=\"center\">\n" +
    "        <button class=\"done\" ng-click=\"confirm()\">OK</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("/scripts/customEmails/editor/customEmailsEditor.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/customEmails/editor/customEmailsEditor.html",
    "<div class=\"col3\">\n" +
    "    <div class=\"page-tile lg\">\n" +
    "        <div class=\"standard-header\">Email Templates</div>\n" +
    "        <div>\n" +
    "            <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div>\n" +
    "        <div class=\"input-wrapper\">\n" +
    "            <label for=\"template\">Template</label>\n" +
    "            <select name=\"template\" id=\"template\" ng-change=\"currentTemplateChangeHandler()\" ng-model=\"currentTemplate.id\" ng-options=\"template.id as template.name for template in data.templates\">\n" +
    "            </select>\n" +
    "            <a ng-click=\"createNewTemplate()\" class=\"margin-md-left\">Add new template</a>\n" +
    "        </div>\n" +
    "        <p>\n" +
    "            <a ng-show=\"currentTemplate.template\" ng-click=\"deleteTemplate()\" ng-disabled=\"status.deletingTemplate\">Delete template</a>\n" +
    "        </p>\n" +
    "    </div>\n" +
    "    <form class=\"hes\">\n" +
    "        <legend>Template Content</legend>\n" +
    "        <fieldset class=\"margin-xlg-bottom\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"input-wrapper full-width\">\n" +
    "                    <label for=\"templateName\">Name</label>\n" +
    "                    <input type=\"text\" name=\"templateName\" id=\"templateName\" ng-model=\"currentTemplate.template.name\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"input-wrapper\">\n" +
    "                    <label for=\"templateHTML\">HTML</label>\n" +
    "                    <textarea class=\"high\" type=\"text\" name=\"templateHTML\" id=\"templateHTML\" ng-model=\"currentTemplate.template.html\"></textarea>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </fieldset>\n" +
    "\n" +
    "        <legend>Prompts</legend>\n" +
    "        <fieldset ng-class=\"{'padding-md': currentTemplate.template.prompts}\">\n" +
    "            <div ng-repeat=\"prompt in currentTemplate.template.prompts\" class=\"prompt-wrapper\">\n" +
    "                <div class=\"row clearfix\">\n" +
    "                    <div class=\"input-wrapper half-width\">\n" +
    "                        <span class=\"font-bold\" for=\"name-{{$index}}\">Name: </span>{{prompt.name}}\n" +
    "                    </div>\n" +
    "                    <div class=\"input-wrapper half-width\">\n" +
    "                        <span class=\"font-bold\" for=\"label-{{$index}}\">Display name</span>{{prompt.label}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"row clearfix\">\n" +
    "                    <div class=\"input-wrapper half-width\">\n" +
    "                        <span class=\"font-bold\" for=\"type-{{$index}}\">Type</span>{{prompt.type}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <hr ng-hide=\"$last\">\n" +
    "            </div>\n" +
    "        </fieldset>\n" +
    "    </form>\n" +
    "    <div class=\"text-right margin-xlg-bottom-top\">\n" +
    "        <a ui-sref=\"go.u.site({siteId: dbSite.id})\">Cancel</a>\n" +
    "        <button ng-click=\"saveTemplate()\" class=\"margin-lg-left\" ng-disabled=\"status.savingTemplate\">Save</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("/scripts/customEmails/queued_emails/index.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/customEmails/queued_emails/index.template.html",
    "<div class='col3'>\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div class=\"standard-header\">Queued Emails</div>\n" +
    "    <div>\n" +
    "        <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "    </div>\n" +
    "    <a style=\"float:right;\" ui-sref=\"go.u.site.custom-emails.send\">Send Custom Email</a>\n" +
    "    <div class=\"sites-content\">\n" +
    "      <div hes-table tbl-data=\"data.table\" show-export=\"true\" report-name=\"'queued emails'\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/customEmails/queued_emails/show.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/customEmails/queued_emails/show.template.html",
    "<div>\n" +
    "  <strong>key:</strong> <div id=\"key\">{{ mail.name }}  <a ui-sref=\"go.u.site.custom-emails.send({site_id: mail.site_id, id: mail.id})\">edit</a></div>\n" +
    "</div>\n" +
    "<div>\n" +
    "  <strong>number of recipients:</strong> {{ mail.recipients.length }}\n" +
    "</div>\n" +
    "<div>\n" +
    "  <strong>recipients:</strong><br/>\n" +
    "  <textarea readonly ng-model='mail.recipients'> \n" +
    "  </textarea>\n" +
    "</div>\n" +
    "<div>\n" +
    "  <strong>filters:</strong><br/>\n" +
    "  <ul>\n" +
    "    <li ng-repeat=\"obj in mail.filters\">{{ obj.key }}</li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "<div>\n" +
    "  <strong>subject:</strong> {{ mail.subject }}\n" +
    "</div>\n" +
    "<div>\n" +
    "  <strong>html:</strong><br/>\n" +
    "  <div class=\"padding-md-bottom-top center font-md\">\n" +
    "    <div markdown ng-model=\"mail.html_body\" no-paragraph></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "\n" +
    "<hr/>\n" +
    "\n" +
    "<div>\n" +
    "  <strong>markup:</strong><br>\n" +
    "  <textarea rows=\"20\" style=\"overflow-y:scroll\" readonly>{{ mail.html_body }}</textarea>\n" +
    "</div>\n" +
    "<div>\n" +
    "  <strong>recipients sql:</strong><br/>\n" +
    "  <textarea readonly ng-model='mail.sql'> \n" +
    "  </textarea>\n" +
    "</div>");
}]);

angular.module("/scripts/devices/apple_health_popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/apple_health_popup.html",
    "<div>\n" +
    "  <h2 ng-bind-html='content.hk.sync.title'></h2>\n" +
    "  <p ng-bind-html='content.hk.sync.content'></p>\n" +
    "  <div>\n" +
    "    <a tabindex=\"0\" ng-href='{{content.hk.ios_app_link.title}}' target='_blank'>\n" +
    "      <img style=\"width:150px;\" alt=\"\" hes-image='{{content.hk.ios_app_link.image1.url}}' no-theme use-domain=\"true\"></img>\n" +
    "    </a>\n" +
    "  </div>\n" +
    "  <div class=\"text-right\">\n" +
    "    <button ng-click=\"closeThisDialog()\">OK</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/devices/choose/choose-device-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/choose/choose-device-view.html",
    "<hes-breadcrumb crumbs=\"ChooseLogCtrl.view.crumbs\"></hes-breadcrumb>\n" +
    "<hes-marketplace></hes-marketplace>");
}]);

angular.module("/scripts/devices/choose/choose-layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/choose/choose-layout.html",
    "<div class=\"tile logging-frame\">\n" +
    "  <div class=\"page-top\" layout=\"row\" layout-align=\"start center\">\n" +
    "    Log Activity\n" +
    "  </div>\n" +
    "  <h1 class=\"visuallyhidden\">{{$state.current.title}}</h1>\n" +
    "  <div class=\"frame choose-log\">\n" +
    "    <ui-view></ui-view>\n" +
    "    <div class=\"device-connected-action\" layout=\"row\" layout-align=\"end center\">\n" +
    "      <button ng-if=\"user.hasChosenLogging()\" ng-click=\"ChooseLogCtrl.allDone()\">Continue</button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/devices/choose/choose-view.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/choose/choose-view.html",
    "<span>\n" +
    "  <div>\n" +
    "    <h2>\n" +
    "      <span ng-bind-html=\"::ChooseLogCtrl.view.activityContent.title\"></span>\n" +
    "    </h2>\n" +
    "  </div>\n" +
    "  <div markdown-div ng-model=\"::ChooseLogCtrl.view.activityContent.content_html\"></div>\n" +
    "  <hes-choose-logging user=\"user\" site=\"site\" \n" +
    "    on-select-device=\"ChooseLogCtrl.showDevices()\">\n" +
    "  </hes-choose-logging>\n" +
    "</span>");
}]);

angular.module("/scripts/devices/connection_error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/connection_error.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div class=\"device-connected-container\">\n" +
    "  <div class=\"center font-bold font-lg\">Oops! Your Fitbit Connection Failed</div>\n" +
    "	<div ng-switch=\"error_code\">\n" +
    "    <p ng-switch-when=\"5C0P3\">\n" +
    "      Try this: return to the <a ui-sref=\"go.u.settings.tracking\">settings</a> page and click Connect on the Fitbit item, when prompted check all the boxes to ensure your data is shared with your <em>{{ site.name }}</em> account, then click Allow.\n" +
    "    </p>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/devices/connection_successful.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/connection_successful.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div class='center loading-marketplace' ng-show='!connectionCompleted'>\n" +
    "	<div hes-loading-gif loading='!connectionCompleted'></div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"device-connected-container\" ng-show='connectionCompleted'>\n" +
    "	\n" +
    "	<!-- Validic -->\n" +
    "	<div ng-show='validicConnected'>\n" +
    "		<div class='center font-bold font-lg font-uppercase'>Connection Successful</div>\n" +
    "\n" +
    "		<p>You’re now connected to <em>{{site.name}}</em>. Look for your steps to add up &mdash; automatically &mdash; on the Progress page (syncing times vary).</p>\n" +
    "		<p><em>Note:</em> Although your {{user.formattedActiveDevice()}} account may track more, only steps count in <em>{{site.name}}</em>.</p>\n" +
    "	</div>\n" +
    "	\n" +
    "	<!-- Non-Validic -->\n" +
    "	<div ng-show='connected'>\n" +
    "		<div class='center font-bold font-lg font-uppercase'>Connection Successful</div>\n" +
    "\n" +
    "		<p>Your Fitbit<sup>&reg;</sup> tracker is now connected to <em>{{site.name}}</em>.</p>\n" +
    "		<div>Syncing Your Device</div>\n" +
    "		<p>Put on your Fitbit in the morning, then watch your steps add up. <em>{{site.name}}</em> steps automatically update each time you sync with the Fitbit mobile app. If your steps don’t reflect what's on your device, be sure you’re synced.</p>\n" +
    "		<p><strong>Note</strong>: Although the Fitbit tracks more, only steps count toward points in <em>{{site.name}}</em>.</p>\n" +
    "	</div>\n" +
    "	\n" +
    "	<!-- Garmin -->\n" +
    "	<div ng-show='garminConnected'>\n" +
    "		<div class='center font-bold font-lg font-uppercase'>Connection Successful</div>\n" +
    "		<p>Your device is connected. Steps will automatically sync to your account.</p>\n" +
    "		<p>Although Garmin tracks more data, only steps count in <em>{{ site.name }}</em>.</p>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Validic Not Connected -->\n" +
    "	<div ng-show='validicNotConnected'>\n" +
    "		<div class='center font-bold font-lg font-uppercase'>Connection Unsuccessful</div>\n" +
    "\n" +
    "		<p>Oops!</p>\n" +
    "	  <p>Your device or app didn’t sync. To try again or pick a different option, go to <a ng-click='redirectToConnect()'>Connect Your Device/App</a>.</p>\n" +
    "	</div>\n" +
    "\n" +
    "	<div class=\"got-it-button\">\n" +
    "		<button ng-click=\"closeThisDialog()\" ng-keydown=\"ariaClick($event)\" autofocus=\"true\" hes-autofocus aria-label=\"Close Connection Successful Button\" class=\"text-center\">Got it</button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/devices/device_information.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/device_information.html",
    "<div class=\"pane padding-20\" ng-show='deviceUser.isAnyDeviceConnected()'>\n" +
    "	<div class=\"font-sub-header margin-20-bottom\" ng-hide=\"deviceUser.isAppleHealthConnected() || deviceUser.isHealthConnectConnected()\">{{deviceUser.formattedActiveDevice()}}</div>\n" +
    "	\n" +
    "	<!-- Fitbit Info -->\n" +
    "	<div ng-show='deviceUser.isFitbitConnected()'>\n" +
    "		\n" +
    "		<!-- Subscription Broken -->\n" +
    "		<div ng-show='(deviceUser.subscriptions.apiSubscriptions && deviceUser.subscriptions.apiSubscriptions.length === 0) || deviceUser.fitbit_is_broken'>\n" +
    "				<p>Subscription to Fitbit data has been broken. User must reconnect to Fitbit.</p>\n" +
    "		</div>\n" +
    "		\n" +
    "		<!-- Subscriptions -->\n" +
    "		<div ng-show='deviceUser.subscriptions.apiSubscriptions && deviceUser.subscriptions.apiSubscriptions.length > 0'>\n" +
    "				<div ng-repeat='subscription in deviceUser.subscriptions.apiSubscriptions'>\n" +
    "						<div ng-show='isCurrentSubscription(subscription)'>\n" +
    "								<p><strong>Fitbit User ID</strong>: <span class='device-data'>{{subscription.ownerId}}</span></p>\n" +
    "								<p><strong>HES Subscription ID</strong>: <span class='device-data'>{{subscription.subscriptionId}}</span></p>\n" +
    "						</div>\n" +
    "\n" +
    "						<div ng-show='!isCurrentSubscription(subscription)'>\n" +
    "								<p><strong>Fitbit User ID</strong>: <span class='device-data'>{{subscription.ownerId}}</span></p>\n" +
    "						</div>            \n" +
    "				</div>\n" +
    "		</div>\n" +
    "		\n" +
    "		<!-- Orders -->\n" +
    "		<div ng-show='deviceUser.orders.length > 0'>\n" +
    "				<strong>Orders</strong>\n" +
    "\n" +
    "				<ul>\n" +
    "						<li ng-repeat='order in deviceUser.orders'>User ordered {{order.item_key}} on {{formatFitbitDate(order.created_at)}}.</li>\n" +
    "				</ul>\n" +
    "		</div>\n" +
    "		\n" +
    "		<!-- Devices -->\n" +
    "		<div>\n" +
    "				<strong>{{deviceUser.fitbit_devices.length}} Fitbit <span ng-pluralize count='deviceUser.fitbit_devices.length' when=\"{'one': 'Device', 'other': 'Devices'}\"></span></strong>\n" +
    "				<p ng-show='deviceUser.fitbit_devices.length === 0'>No devices found.</p>\n" +
    "				\n" +
    "				<table class='fitbit-devices' ng-show='deviceUser.fitbit_devices.length > 0'>\n" +
    "						<tr class='header'>\n" +
    "								<td>ID</td>\n" +
    "								<td>Type</td>\n" +
    "								<td>Device</td>\n" +
    "								<td>Last sync time</td>\n" +
    "								<td class='other'>Other information</td>\n" +
    "						</tr>\n" +
    "						\n" +
    "						<tr ng-repeat='device in deviceUser.fitbit_devices'>\n" +
    "								<td class='device-data'>{{device.remote_id || 'N/A'}}</td>\n" +
    "								<td class='device-data'>{{device.type_of_device || 'N/A'}}</td>\n" +
    "								<td class='device-data'>{{device.device_version || 'N/A'}}</td>\n" +
    "								<td class='device-data'>{{formatFitbitDate(device.last_sync_time)}}</td>\n" +
    "								<td class='device-data' class='other'>N/A</td>\n" +
    "						</tr>\n" +
    "				</table>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	\n" +
    "	<!-- Validic Info -->\n" +
    "	<div ng-show='deviceUser.isValidicConnected()'>\n" +
    "		<p><strong>Validic User ID</strong>: <span class='device-data'>{{deviceUser.validic_user.v_id}}</span></p>\n" +
    "		<p><strong>User should be connected to</strong>: <span class='device-data'>{{deviceUser.connectedValidicApp() || 'ERROR'}}</span></p>\n" +
    "		<p><strong>User is actually connected to</strong>: <span class='device-data'>{{deviceUser.connectedValidicApp() || 'ERROR'}}</span></p>\n" +
    "	</div>\n" +
    "	\n" +
    "	<!-- Apple Health & Health Connect Info -->\n" +
    "	<div ng-show='deviceUser.isAppleHealthConnected() || deviceUser.isHealthConnectConnected()'>\n" +
    "		This user is connected to {{deviceUser.formattedActiveDevice()}}.\n" +
    "	</div>\n" +
    "	\n" +
    "	<!-- Garmin Info -->\n" +
    "	<div ng-show='deviceUser.isGarminConnected()'>\n" +
    "		This user is connected to Garmin.\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Sync History/Refresh Week -->\n" +
    "	<div ng-hide='deviceUser.isAppleHealthConnected() || deviceUser.isHealthConnectConnected()'>\n" +
    "		<p>\n" +
    "			<strong>{{deviceUser.formattedActiveDevice()}} Sync History</strong>\n" +
    "			<span ng-show='deviceUser.isValidicConnected()'>(applies Validic data to entries)</span>\n" +
    "			<span ng-show='deviceUser.isGarminConnected()'>(applies Garmin data to entries)</span>\n" +
    "		</p>\n" +
    "		\n" +
    "		<span>Refresh 1 week of data:</span>\n" +
    "		\n" +
    "		<select class='skip-hes-form' ng-model='chosenWeek' ng-options='week.week_number as week.week_label for week in deviceUser.device_weeks' ng-change='refreshWeekData(chosenWeek)'>\n" +
    "				<option value=''>-- Choose week --</option>\n" +
    "		</select>\n" +
    "		\n" +
    "		<div class='sync-history'>\n" +
    "			<div ng-repeat=\"notification in deviceNotifications | orderBy: ['-updated_at', 'id'] | limitTo: 300\" ng-show='!refreshingDeviceData && deviceNotifications.length'>\n" +
    "				<span ng-bind='getFormattedNotification(notification)'></span>\n" +
    "			</div>\n" +
    "			\n" +
    "			<div ng-show='!deviceNotifications.length'>\n" +
    "				<span>No {{deviceUser.formattedActiveDevice()}} history.</span>\n" +
    "			</div>\n" +
    "			\n" +
    "			<div class='center margin-15-top' ng-show='refreshingDeviceData'>\n" +
    "				<div hes-loading-gif loading='refreshingDeviceData'></div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	\n" +
    "	<!-- View Validic Data -->\n" +
    "	<div ng-show='deviceUser.isValidicConnected()'>\n" +
    "		<p>\n" +
    "			<strong>View Validic Data</strong>\n" +
    "			<span>(does NOT apply Validic data to entries)</span>\n" +
    "		</p>\n" +
    "		\n" +
    "		<span>View 1 week of data</span>\n" +
    "		\n" +
    "		<select class='skip-hes-form' ng-model='viewWeek' ng-options='week.week_number as week.week_label for week in deviceUser.device_weeks' ng-change='getValidicData(viewWeek)'>\n" +
    "			<option value=''>-- Choose week --</option>\n" +
    "		</select>\n" +
    "		\n" +
    "		<div>\n" +
    "			<div class='sync-history'>\n" +
    "				<div ng-repeat=\"data in validicData | orderBy: ['-timestamp'] | limitTo: 300\" ng-show='!loadingValidicData && validicData.length'>\n" +
    "					<span>{{data.timestamp | date:'yyyy-MM-dd'}} - {{data.steps}} steps</span>\n" +
    "				</div>\n" +
    "				\n" +
    "				<div ng-show='!loadingValidicData && !validicData.length'>\n" +
    "					<span>No Validic data.</span>\n" +
    "				</div>\n" +
    "				\n" +
    "				<div class='center margin-15-top' ng-show='loadingValidicData'>\n" +
    "					<div hes-loading-gif loading='loadingValidicData'></div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	\n" +
    "	<!-- Crawler -->\n" +
    "	<div ng-show='showCrawlerHistory'>\n" +
    "		<div>\n" +
    "			<strong>Crawler History</strong>\n" +
    "		</div>\n" +
    "		\n" +
    "		<div>\n" +
    "			<div class='sync-history'>\n" +
    "				<div ng-repeat=\"item in deviceCrawlerHistory track by $index | limitTo: 300\">\n" +
    "					<div ng-bind='item.timestamp'></div>\n" +
    "					<div class='detail' ng-bind='item.action'></div>\n" +
    "				</div>\n" +
    "				\n" +
    "				<div ng-show='!deviceCrawlerHistory.length'>\n" +
    "					<span>No crawler history.</span>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "\n" +
    "<div class='pane padding-20' ng-show='!deviceUser.isAnyDeviceConnected()'>\n" +
    "	<p>User is not connected to any device.</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/devices/device_options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/device_options.html",
    "<div class=\"devices-options\" ng-controller='DeviceOptionsController'>\n" +
    "\n" +
    "  <!-- Initial Options -->\n" +
    "  <div ng-show='displayInitialOptions'>\n" +
    "    <p ng-show='itemsAvailable()'>Purchase and/or sync a device with your <em>{{site.name}}</em> account<span ng-hide='site.flags.disable_manual_logging'> or log manually</span>.</p>\n" +
    "    <p ng-show='!itemsAvailable()'>Sync a device with your <em>{{site.name}}</em> account<span ng-hide='site.flags.disable_manual_logging'> or log manually</span>.</p>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- Manual Options -->\n" +
    "  <div ng-show='displayManualOptions'>\n" +
    "    <p>You are logging manually.</p>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- Connect Options -->\n" +
    "  <div ng-show='displayConnectOptions'>\n" +
    "\n" +
    "    <!-- Not Connected -->\n" +
    "    <div ng-show='!isConnected'>\n" +
    "      <p>Sync a device with your <em>{{site.name}}</em> account.</p>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Connected -->\n" +
    "    <div ng-show='isConnected'>\n" +
    "      <p>Your {{user.formattedActiveDevice()}}<span ng-show='user.isFitbitConnected()'> tracker</span><span ng-show='user.isAppleHealthConnected() || user.isHealthConnectConnected()'> app</span> is now connected to <em>{{site.name}}</em>!</p>\n" +
    "      <button ng-click='tryDisconnect(user.active_device)' ng-class='{disabled: isDisconnecting}' ng-disabled='isDisconnecting'>Disconnect</button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/devices/fitbit_connection_error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/fitbit_connection_error.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div class=\"device-connected-container\">\n" +
    "    <div class='center font-bold font-lg font-uppercase'>Connection Unsuccessful</div>\n" +
    "	  	<p class=\"center\" style=\"padding: 0 25px;\">Connecting to your Fitbit was unsuccessful. Please try again.</p>\n" +
    "      <div ng-switch=\"error_code\">\n" +
    "      <p ng-switch-when=\"5C0P3\">\n" +
    "        Try this: return to the <a href=\"#/settings/personal\">profile</a> page and click Connect Your Device/App, when prompted check all the boxes to ensure your data is shared with your <em>{{ promotion.program_name }}</em> account, then click Allow.\n" +
    "      </p>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/devices/fitbit_summary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/fitbit_summary.html",
    "<div class=\"padded-page extra-padding\">\n" +
    "  <div class=\"padded-page\">\n" +
    "    <div ng-show='!noDeviceConnected && !loading'>\n" +
    "      <div class='fitbit-chart-controls'>\n" +
    "        <span class='graph-mode'>\n" +
    "          <a href='' ng-click='switchToWeekMode()' ng-class=\"{'active' : view.timeInterval == 'week'}\">Week</a>\n" +
    "          <a href='' ng-click='switchToMonthMode()' ng-class=\"{'active' : view.timeInterval == 'month'}\" >Month</a>\n" +
    "        </span>\n" +
    "\n" +
    "        <span class='move-graph'>\n" +
    "          <a href='' ng-click='moveTimeInterval(-1)'><img ng-src=\"{{canMoveBackward ? '/images/icons/logging-left-enabled.png' : '/images/icons/logging-left-disabled.png'}}\"/></a>\n" +
    "          <span ng-class=\"{'week-text': view.timeInterval === 'week', 'month-text': view.timeInterval === 'month'}\">{{view.currentInterval}}</span>\n" +
    "          <a href='' ng-click='moveTimeInterval(1)'><img ng-src=\"{{canMoveForward ? '/images/icons/logging-right-enabled.png' : '/images/icons/logging-right-disabled.png'}}\" /></a>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div google-chart chart=\"deviceData.chartObj\" style=\"{{config.chartCssStyle}}\"></div>\n" +
    "\n" +
    "      <div class='fitbit-value-wrapper'>\n" +
    "        <span class='fitbit-value'>\n" +
    "          <img class='image' src='/images/fitbit/steps.png' /><span class='value'>{{deviceData.stepsTaken || 0 | number}}</span>\n" +
    "          <span class='action'> steps taken</span>\n" +
    "        </span>\n" +
    "\n" +
    "        <span class='fitbit-value middle'>\n" +
    "          <img class='image' src='/images/fitbit/calories.png' /><span class='value'>{{deviceData.caloriesBurned || 0 | number}}</span>\n" +
    "          <span class='action'> calories burned</span>\n" +
    "        </span>\n" +
    "\n" +
    "        <span class='fitbit-value'>\n" +
    "          <img class='image' src='/images/fitbit/activity-level.png' /><span class='value'>{{deviceData.veryActiveMinutes || 0 | number}}</span>\n" +
    "          <span class='action'> active minutes</span>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/devices/garmin_connection_error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/garmin_connection_error.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div class=\"device-connected-container\">\n" +
    "    <div class='center font-bold font-lg font-uppercase'>Connection Unsuccessful</div>\n" +
    "	  	<p class=\"center\" style=\"padding: 0 25px;\">Connecting to your Garmin was unsuccessful. Please try again.</p>\n" +
    "      <div ng-switch=\"error_code\">\n" +
    "      <p ng-switch-when=\"5C0P3\">\n" +
    "        Try this: return to the <a href=\"#/settings/personal\">profile</a> page and click Connect Your Device/App, when prompted check all the boxes to ensure your data is shared with your <em>{{ promotion.program_name }}</em> account, then click Allow.\n" +
    "      </p>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("/scripts/devices/google_health_connect.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/google_health_connect.html",
    "<div ng-click=\"closeThisDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "\n" +
    "<!-- All copy comes from the 'google_health' content category, key 'marketplace_description':\n" +
    "     image1 = logo, title_html = heading, content_html = body, summary_html = terms line, description_html = button label. -->\n" +
    "<div class=\"center google-health-connect\">\n" +
    "	<div class=\"google-health-connect-image\" ng-if=\"content.ghDescription.image1 && content.ghDescription.image1.url\">\n" +
    "		<img hes-image=\"{{content.ghDescription.image1.url}}\" use-domain=\"true\" no-theme alt=\"{{plainText(content.ghDescription.title)}}\" />\n" +
    "	</div>\n" +
    "\n" +
    "	<div class=\"center font-bold font-lg google-health-connect-title\" ng-if=\"content.ghDescription.title_html\" ng-bind-html=\"content.ghDescription.title_html\"></div>\n" +
    "\n" +
    "	<div class=\"google-health-connect-content\" ng-bind-html=\"content.ghDescription.content_html\"></div>\n" +
    "\n" +
    "	<div class=\"font-sm google-health-connect-terms\" ng-if=\"content.ghDescription.summary_html\" ng-bind-html=\"content.ghDescription.summary_html\"></div>\n" +
    "\n" +
    "	<button class=\"google-health-connect-button\" ng-class=\"{disabled: connecting}\" ng-disabled=\"connecting\" ng-click=\"$ctrl.googleHealthRedirect()\" aria-label=\"Connect Google Health\" ng-bind-html=\"content.ghDescription.description_html || 'Continue'\"></button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/devices/google_health_connection_error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/google_health_connection_error.html",
    "<div class=\"center font-bold font-lg font-uppercase\">Connection Unsuccessful</div>\n" +
    "\n" +
    "<div markdown-div ng-model=\"connection_failed.content_html\"></div>\n" +
    "");
}]);

angular.module("/scripts/devices/google_health_connection_success.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/google_health_connection_success.html",
    "<div class=\"center font-bold font-lg font-uppercase\">Connection Successful</div>\n" +
    "\n" +
    "<div markdown-div ng-model=\"connected_information.content_html\"></div>\n" +
    "<div markdown-div ng-model=\"connected_information.summary_html\"></div>\n" +
    "");
}]);

angular.module("/scripts/devices/googlefit_connection_error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/googlefit_connection_error.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div class=\"device-connected-container\">\n" +
    "  <div class=\"center font-bold font-lg\">Connection Unsuccessful</div>\n" +
    "  <div>\n" +
    "    <p>Your device or app didn’t sync. To try again or pick a different option, click \"Connect Device/App\".</p>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/devices/health_connect_popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/health_connect_popup.html",
    "<div>\n" +
    "  <h2 ng-bind-html='content.hc.sync.title'></h2>\n" +
    "  <p ng-bind-html='content.hc.sync.content'></p>\n" +
    "  <div>\n" +
    "    <a tabindex=\"0\" ng-href='{{content.hc.android_app_link.title}}' target='_blank'>\n" +
    "      <img style=\"width:150px;\" alt=\"\" hes-image='{{content.hc.android_app_link.image1.url}}' no-theme use-domain=\"true\"></img>\n" +
    "    </a>\n" +
    "  </div>\n" +
    "  <div class=\"text-right\">\n" +
    "    <button ng-click=\"closeThisDialog()\">OK</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/devices/marketplace/marketplace.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/devices/marketplace/marketplace.html",
    "<div class='device-settings'>\n" +
    "	<div class='center loading-marketplace' ng-show='$ctrl.market.loading'>\n" +
    "		<div hes-loading-gif loading='$ctrl.market.loading'></div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if=\"!$ctrl.market.user.isAnyDeviceConnected() && !$ctrl.market.loading\" \n" +
    "		class=\"loading-marketplace\" \n" +
    "		layout=\"row\" \n" +
    "		layout-wrap\n" +
    "		layout-align=\"space-between center\">\n" +
    "		\n" +
    "		<!-- Fitbit -->\n" +
    "		<div class=\"device-box\" \n" +
    "			flex-xs=\"100\"\n" +
    "			flex-sm=\"100\"\n" +
    "			ng-if=\"$ctrl.market.site.flags.is_fitbit_enabled\"\n" +
    "			layout=\"row\"\n" +
    "			layout-align=\"start center\">\n" +
    "			<img hes-image=\"/fitbit/marketplace_icon.png\" alt='Fitbit logo' / >\n" +
    "			<div class=\"actions\" flex=\"grow\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "				<div class='option-title'>Fitbit</div>\n" +
    "				<button class=\"secondary\" aria-label=\"Connect Fitbit\" \n" +
    "					ng-hide='$ctrl.market.user.isFitbitConnected()' \n" +
    "					ng-click='$ctrl.fitbitRedirect()'>\n" +
    "						Connect\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Garmin -->\n" +
    "		<div class=\"device-box\" \n" +
    "			flex-xs=\"100\"\n" +
    "			flex-sm=\"100\"\n" +
    "			ng-if=\"$ctrl.market.site.flags.is_garmin_enabled\"\n" +
    "			layout=\"row\"\n" +
    "			layout-align=\"start center\">\n" +
    "			<img hes-image=\"/fitbit/garmin_icon.png\" alt='Garmin logo' / >\n" +
    "			<div class=\"actions\" flex=\"grow\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "				<div class='option-title'>Garmin</div>\n" +
    "				<button class=\"secondary\" aria-label=\"Connect Garmin\" \n" +
    "					ng-hide='$ctrl.market.user.isGarminConnected()' \n" +
    "					ng-click='$ctrl.garminRedirect()'>\n" +
    "						Connect\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Google Health -->\n" +
    "		<div class=\"device-box\"\n" +
    "			flex-xs=\"100\"\n" +
    "			flex-sm=\"100\"\n" +
    "			ng-if=\"$ctrl.market.site.flags.is_google_health_enabled\"\n" +
    "			layout=\"row\"\n" +
    "			layout-align=\"start center\">\n" +
    "			<img ng-if=\"content.gh.image1.url\" ng-src=\"{{content.gh.image1.url}}\" alt=\"{{content.gh.title || 'Google Health'}} logo\" />\n" +
    "			<div class=\"actions\" flex=\"grow\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "				<div class=\"option-title\">{{content.gh.title || 'Google Health'}}</div>\n" +
    "				<button class=\"secondary\" aria-label=\"Connect Google Health\"\n" +
    "					ng-hide=\"$ctrl.market.user.isGoogleHealthConnected()\"\n" +
    "					ng-click=\"$ctrl.openGoogleHealthDialog()\">\n" +
    "						Connect\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Apple Health -->\n" +
    "		<div class=\"device-box\" \n" +
    "			flex-xs=\"100\"\n" +
    "			flex-sm=\"100\"\n" +
    "			ng-if=\"$ctrl.market.site.flags.is_healthkit_enabled\"\n" +
    "			layout=\"row\"\n" +
    "			layout-align=\"start center\">\n" +
    "			<img hes-image=\"{{content.hk.icon.image1.url}}\" alt='{{content.hk.icon.title}} logo' / >\n" +
    "			<div class=\"actions\" flex=\"grow\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "				<div class='option-title'>{{content.hk.icon.title}}</div>\n" +
    "				<button class=\"secondary\" aria-label=\"Connect {{content.hk.icon.title}}\" \n" +
    "					ng-hide='$ctrl.market.user.isAppleHealthConnected()' \n" +
    "					ng-click='$ctrl.connectAppleHealth()'>\n" +
    "						Info\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Health Connect -->\n" +
    "		<div class=\"device-box\" \n" +
    "			flex-xs=\"100\"\n" +
    "			flex-sm=\"100\"\n" +
    "			ng-if=\"$ctrl.market.site.flags.is_health_connect_enabled\"\n" +
    "			layout=\"row\"\n" +
    "			layout-align=\"start center\">\n" +
    "			<img hes-image=\"{{content.hc.icon.image1.url}}\" alt='{{content.hc.icon.title}} logo' / >\n" +
    "			<div class=\"actions\" flex=\"grow\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "				<div class='option-title'>{{content.hc.icon.title}}</div>\n" +
    "				<button class=\"secondary\" aria-label=\"Connect {{content.hc.icon.title}}\" \n" +
    "					ng-hide='$ctrl.market.user.isHealthConnectConnected()' \n" +
    "					ng-click='$ctrl.connectHealthConnect()'>\n" +
    "						Info\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Validic -->\n" +
    "		<div class=\"device-box\" \n" +
    "			flex-xs=\"100\"\n" +
    "			flex-sm=\"100\"\n" +
    "			ng-class=\"{'connected': $ctrl.isValidicAppConnected(option.name)}\" \n" +
    "			ng-repeat='option in $ctrl.market.options' \n" +
    "			ng-if=\"($ctrl.market.user.isValidicConnected() && $ctrl.isValidicAppConnected(option.name)) || (!$ctrl.market.user.isAnyDeviceConnected() && $ctrl.market.site.flags.is_validic_enabled)\"\n" +
    "			layout=\"row\"\n" +
    "			layout-align=\"start center\">\n" +
    "				<img hes-image='{{option.image_path}}' alt='{{option.name}} logo' />\n" +
    "				<div class=\"actions\" flex=\"grow\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "					<div class='option-title' ng-bind-html='option.name'></div>\n" +
    "					<button class=\"secondary\" aria-label=\"Connect {{option.name}}\" \n" +
    "						ng-hide='$ctrl.isValidicAppConnected(option.name)' \n" +
    "						ng-click='$ctrl.validicRedirect(option.url)'>\n" +
    "							Connect\n" +
    "					</button>\n" +
    "				</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div ng-if=\"$ctrl.market.user.isAnyDeviceConnected() && !$ctrl.market.loading\" \n" +
    "		class=\"device-connected\"\n" +
    "		layout=\"row\"\n" +
    "		layout-align=\"center center\">\n" +
    "		<div>\n" +
    "			<div class=\"choice-box\">\n" +
    "				<img ng-if=\"$ctrl.market.user.isFitbitConnected()\" \n" +
    "					hes-image=\"/fitbit/marketplace_icon.png\" alt='Fitbit logo' / >\n" +
    "				<img ng-if=\"$ctrl.market.user.isGarminConnected()\" \n" +
    "					hes-image=\"/fitbit/garmin_icon.png\" alt='Garmin logo' / >\n" +
    "				<img ng-if=\"$ctrl.market.user.isAppleHealthConnected()\"\n" +
    "					hes-image=\"{{content.hk.icon.image1.url}}\" alt='{{content.hk.icon.title}} logo' />\n" +
    "				<img ng-if=\"$ctrl.market.user.isHealthConnectConnected()\"\n" +
    "					hes-image=\"{{content.hc.icon.image1.url}}\" alt='{{content.hc.icon.title}} logo' />\n" +
    "				<img ng-if=\"$ctrl.market.user.isGoogleHealthConnected() && content.gh.image1.url\"\n" +
    "					ng-src=\"{{content.gh.image1.url}}\" alt=\"{{content.gh.title || 'Google Health'}} logo\" />\n" +
    "				<img ng-repeat='option in $ctrl.market.options'\n" +
    "					ng-if=\"$ctrl.market.user.isValidicConnected() && $ctrl.isValidicAppConnected(option.name)\"\n" +
    "					hes-image='{{option.image_path}}' alt='{{option.name}} logo' />	\n" +
    "				<div>\n" +
    "					<p>Your {{$ctrl.market.user.formattedActiveDevice()}}<span ng-show='$ctrl.market.user.isFitbitConnected()'> tracker</span><span ng-show='$ctrl.market.user.isAppleHealthConnected() || $ctrl.market.user.isHealthConnectConnected() || $ctrl.market.user.isGoogleHealthConnected()'> app</span> is now connected to <em>{{$ctrl.market.site.name}}</em>!</p>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<button class=\"link-look\" \n" +
    "				aria-label=\"Disconnect Device\" \n" +
    "				ng-click='$ctrl.tryDisconnect($ctrl.market.user.active_device)'>\n" +
    "					Disconnect\n" +
    "			</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/dialogs/confirmationDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/dialogs/confirmationDialog.html",
    "<div>\n" +
    "  <h2>\n" +
    "    <span class=\"dialog-title\" markdown-div ng-model=\"confirmation.title\" no-paragraph></span>\n" +
    "  </h2>\n" +
    "  <div class='dialog-text' markdown-div ng-model=\"confirmation.message\">\n" +
    "  </div>\n" +
    "  <div class='dialog-buttons'>\n" +
    "    <button class=\"link-look\" ng-click='closeThisDialog()'>{{confirmation.cancelText}}</button>\n" +
    "    <button class=\"done\" ng-click='confirm()'>{{confirmation.confirmText}}</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/dialogs/confirmationReverseDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/dialogs/confirmationReverseDialog.html",
    "<div>\n" +
    "  <h2>\n" +
    "    <span class=\"dialog-title\">{{confirmation.title}}</span>\n" +
    "  </h2>\n" +
    "  <div markdown-div ng-model=\"confirmation.message\" class=\"dialog-text\"></div>\n" +
    "  <div class='dialog-buttons'>\n" +
    "    <button class=\"cancel\" ng-click='confirm()'>{{confirmation.cancelText}}</button>\n" +
    "    <button class=\"done\" ng-click='deviceUserCheck(); closeThisDialog()'>{{confirmation.confirmText}}</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/dialogs/confirmationUnsavedDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/dialogs/confirmationUnsavedDialog.html",
    "<div>\n" +
    "  <h2>\n" +
    "    <span class=\"dialog-title\" markdown-div ng-model=\"confirmation.title\" no-paragraph></span>\n" +
    "  </h2>\n" +
    "  <div class='dialog-text' markdown-div ng-model=\"confirmation.message\">\n" +
    "  </div>\n" +
    "  <div class='dialog-buttons'>\n" +
    "    <button class=\"secondary\" ng-click='closeThisDialog()'>{{confirmation.cancelText}}</button>\n" +
    "    <button class=\"done\" ng-click='confirm()'>{{confirmation.confirmText}}</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/dialogs/email.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/dialogs/email.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div>\n" +
    "  <h2>\n" +
    "    <div class=\"dialog-title\" no-paragraph>\n" +
    "      Email {{emailSettings.email.recipient.profile.full_name}}\n" +
    "    </div>\n" +
    "  </h2>\n" +
    "  <form ng-if=\"!emailSettings.sent\" hes-validator>\n" +
    "    <div class=\"row\">\n" +
    "      <span class=\"double\">\n" +
    "        <textarea hes-invisible-label placeholder=\"Message\" class=\"margin-lg-top\" ng-model='emailSettings.email.message'></textarea>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "    <div class=\"row\" error-banner priority-level=3></div>\n" +
    "    <div class='button-container'>\n" +
    "      <div hes-loading-gif loading=\"emailSettings.disabled\" loading-title=\"Sending...\" delay=\"100\"></div>\n" +
    "      <button ng-click='sendEmail()' ng-disabled=\"emailSettings.disabled\">Send</button>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "  <span ng-if=\"emailSettings.sent\">\n" +
    "    <p>\n" +
    "      Your message has been sent.\n" +
    "    </p>\n" +
    "    <div class='button-container'>\n" +
    "      <button ng-click='closeThisDialog()'>OK</button>\n" +
    "    </div>\n" +
    "  </span>\n" +
    "</div>");
}]);

angular.module("/scripts/dialogs/informationDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/dialogs/informationDialog.html",
    "<div role=\"article\">\n" +
    "  <h2> \n" +
    "    <span class=\"dialog-title\" markdown-div ng-model=\"information.title\" no-paragraph></span>\n" +
    "  </h2>\n" +
    "  <div class='font-md' markdown-div ng-model=\"information.message\" leave-orphans>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/dialogs/sendSmsDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/dialogs/sendSmsDialog.html",
    "<div class=\"sms-dialog\">\n" +
    "  <h2>\n" +
    "    <span\n" +
    "      class=\"dialog-title\"\n" +
    "      markdown-div\n" +
    "      ng-model=\"confirmation.title\"\n" +
    "      no-paragraph\n" +
    "    ></span>\n" +
    "  </h2>\n" +
    "\n" +
    "  <div\n" +
    "    class=\"speech-bubble\"\n" +
    "    markdown-div\n" +
    "    ng-model=\"confirmation.data.message\"\n" +
    "  ></div>\n" +
    "\n" +
    "  <div class=\"dialog-text\" markdown-div ng-model=\"confirmation.message\"></div>\n" +
    "  <div>\n" +
    "    <details>\n" +
    "      <summary>Recipients</summary>\n" +
    "      <div class=\"tableFixHead\">\n" +
    "        <table>\n" +
    "          <thead>\n" +
    "            <tr>\n" +
    "              <th>\n" +
    "                Phone Number<br />\n" +
    "                <input\n" +
    "                  type=\"text\"\n" +
    "                  ng-model=\"confirmation.search\"\n" +
    "                  placeholder=\"Search for number..\"\n" +
    "                />\n" +
    "              </th>\n" +
    "            </tr>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "            <tr\n" +
    "              ng-repeat=\"x in confirmation.data.recipients | filter:confirmation.search track by $index \"\n" +
    "            >\n" +
    "              <td>{{ x }}</td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "    </details>\n" +
    "  </div>\n" +
    "  <div ng-if=\"confirmation.data.total_failed > 0\">\n" +
    "    <details>\n" +
    "      <summary>\n" +
    "        Failed Recipients: {{confirmation.data.total_failed}}\n" +
    "        <span class=\"failed\">!</span>\n" +
    "      </summary>\n" +
    "      <div class=\"tableFixHead\">\n" +
    "        <table>\n" +
    "          <thead>\n" +
    "            <tr>\n" +
    "              <th>\n" +
    "                Non Valid Numbers<br />\n" +
    "                <input\n" +
    "                  type=\"text\"\n" +
    "                  ng-model=\"confirmation.searchFailed\"\n" +
    "                  placeholder=\"Search for number..\"\n" +
    "                />\n" +
    "              </th>\n" +
    "            </tr>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "            <tr\n" +
    "              ng-repeat=\"x in confirmation.data.failed_recipients | filter:confirmation.searchFailed track by $index \"\n" +
    "            >\n" +
    "              <td>{{ x }}</td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "    </details>\n" +
    "  </div>\n" +
    "  <div class=\"dialog-buttons\">\n" +
    "    <button class=\"link-look\" ng-click=\"closeThisDialog()\">\n" +
    "      {{confirmation.cancelText}}\n" +
    "    </button>\n" +
    "    <button class=\"done\" ng-click=\"confirm()\">\n" +
    "      {{confirmation.confirmText}}\n" +
    "    </button>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/dialogs/uploading.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/dialogs/uploading.html",
    "<div class=\"center\">\n" +
    "  <div hes-loading-gif loading=\"uploading\"></div>\n" +
    "  {{message}}\n" +
    "</div>");
}]);

angular.module("/scripts/eligibility/confirmDeleteElig.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/confirmDeleteElig.html",
    "<p>Are you sure you want to delete \"{{data.eligToDelete.identifier}}\"?</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm(data.eligToDelete)\">Confirm</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/eligibility/confirmDeleteEligFile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/confirmDeleteEligFile.html",
    "<p>Are you sure you want to delete \"{{data.activeEligibilityFile.filename}}\"?</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm(data.activeEligibilityFile)\">Confirm</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/eligibility/confirmResetElig.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/confirmResetElig.html",
    "<p>Are you sure you want to delete \"{{data.eligToReset.identifier}}\"?</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm(data.eligToReset)\">Confirm</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/eligibility/eligLabelHover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/eligLabelHover.html",
    "<span hes-external-links>\n" +
    "  <span ng-model=\"eligibilityHelpMessage.content_html\" markdown></span>\n" +
    "</span>");
}]);

angular.module("/scripts/eligibility/eligibilities.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/eligibilities.html",
    "<div class=\"col3\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div class=\"standard-header\">Verification Customization</div>\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "      <br/>\n" +
    "      <a class='action-link go-right' ui-sref=\"go.u.site.eligibilityfiles\">Upload Eligibility File</a>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "      <a ui-sref=\"go.u.site.eligibility.create({eligId: 'new'})\">Add Eligibility</a>\n" +
    "    </div>\n" +
    "    <div hes-table tbl-data=\"data.tblData\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/eligibility/eligibility.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/eligibility.html",
    "<div class=\"full-page\">\n" +
    "  <div>\n" +
    "    <h4>{{view.isEdit ? 'Edit Eligibility' : 'New Eligibility'}}</h4>\n" +
    "    \n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "      <a class='action-link go-right' ui-sref=\"go.u.site.eligibilities\">View Eligibilities</a>\n" +
    "    </div>\n" +
    "    <form class=\"hes\" name='organizationForm' ng-submit='save()'>\n" +
    "      <fieldset>\n" +
    "        <div class=\"row\">\n" +
    "          <span>\n" +
    "            <label for='name'>ID</label>\n" +
    "            <input id='name' type='text' ng-model='editEligibility.name' required />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='name'>Email</label>\n" +
    "            <input id='name' type='text' ng-model='editEligibility.email' required />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class='row'>\n" +
    "          <span>\n" +
    "            <label for='name'>First Name</label>\n" +
    "            <input id='name' type='text' ng-model='editEligibility.first_name' required />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='name'>Last Name</label>\n" +
    "            <input id='name' type='text' ng-model='editEligibility.last_name' required />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        <!-- TODO: Add Custom Fields somehow -->\n" +
    "        <!-- <div class='row'></div> -->\n" +
    "      </fieldset>\n" +
    "      <div class='bottom-row-rel center'>\n" +
    "        <button ng-disabled=\"settings.saving\" ng-class=\"{disabled: settings.isSaving}\" type='submit'>{{view.isEdit ? 'Save' : 'Create'}}</button>\n" +
    "        <div class='save-feedback' ng-show=\"settings.showSaving\">\n" +
    "          Saving...\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/eligibility/eligibilityCreateEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/eligibilityCreateEdit.html",
    "<div class=\"col3\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div class=\"standard-header\">{{(view.isEdit ? 'Edit ' : 'Create ') + 'Eligibility'}}</div>\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "      <a class='action-link go-right' ui-sref=\"go.u.site.eligibilities\">Back to Eligibilities</a>\n" +
    "    </div>\n" +
    "    <form name='hes' class=\"hes\" name=\"eligForm\" ng-submit='save()'>\n" +
    "      <fieldset>\n" +
    "        <div class=\"row\">\n" +
    "          <span >\n" +
    "            <label for='identifier'>Identifier</label>\n" +
    "            <input id='identifier' type='text' class=\"width-auto\" required ng-model='editEligibility.identifier' />\n" +
    "          </span>\n" +
    "          <span class=\"\">\n" +
    "            <label for='email'>Email</label>\n" +
    "            <input id='email' type='text' class=\"width-auto\" ng-model='editEligibility.email' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <span >\n" +
    "            <label for='first_name'>First Name</label>\n" +
    "            <input id='first_name' type='text' class=\"width-auto\"  ng-model='editEligibility.first_name' />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='last_name'>Last Name</label>\n" +
    "            <input id='last_name' type='text' class=\"width-auto\" ng-model='editEligibility.last_name' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <span>\n" +
    "            <label for='birth_date'>Birth Date</label>\n" +
    "            <input id='birth_date' type='text' class=\"width-auto\" ng-model='editEligibility.birth_date' />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='location'>Location</label>\n" +
    "            <input id='location' type='text' class=\"width-auto\" ng-model='editEligibility.string_1' disabled/>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- WUSTL-only roster extras (employee id, dept code, mailing address) -->\n" +
    "        <div class=\"row\" ng-if=\"dbSite.isWUSTL()\">\n" +
    "          <span>\n" +
    "            <label for='alt_id'>Employee ID</label>\n" +
    "            <input id='alt_id' type='text' class=\"width-auto\" ng-model='editEligibility.alt_id' />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='structure_level_10'>Structure Level 10</label>\n" +
    "            <input id='structure_level_10' type='text' class=\"width-auto\" ng-model='editEligibility.structure_level_10' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"dbSite.isWUSTL()\">\n" +
    "          <span>\n" +
    "            <label for='line1'>Address Line 1</label>\n" +
    "            <input id='line1' type='text' class=\"width-auto\" ng-model='editEligibility.line1' />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='line2'>Address Line 2</label>\n" +
    "            <input id='line2' type='text' class=\"width-auto\" ng-model='editEligibility.line2' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"dbSite.isWUSTL()\">\n" +
    "          <span>\n" +
    "            <label for='city'>City</label>\n" +
    "            <input id='city' type='text' class=\"width-auto\" ng-model='editEligibility.city' />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='state_province'>State/Province</label>\n" +
    "            <input id='state_province' type='text' class=\"width-auto\" ng-model='editEligibility.state_province' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"dbSite.isWUSTL()\">\n" +
    "          <span>\n" +
    "            <label for='postal_code'>Postal Code</label>\n" +
    "            <input id='postal_code' type='text' class=\"width-auto\" ng-model='editEligibility.postal_code' />\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label for='country'>Country</label>\n" +
    "            <input id='country' type='text' class=\"width-auto\" ng-model='editEligibility.country' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "      </fieldset>\n" +
    "\n" +
    "      <div class='text-right center'>\n" +
    "        <div error-banner priority=1></div>\n" +
    "        <button ng-disabled=\"settings.saving\" ng-class=\"{disabled: settings.isSaving}\" type='submit'>{{view.isEdit ? 'Save' : 'Create'}}</button>\n" +
    "        <div class='save-feedback' ng-show=\"settings.showSaving\">Saving...</div>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/eligibility/eligibilityFile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/eligibility/eligibilityFile.html",
    "<div class=\"col3\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div class=\"standard-header\">Eligibility Files</div>\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "      <a class='action-link go-right' ui-sref=\"go.u.site.eligibilities\">View Eligibilities</a>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Eligibility Files -->\n" +
    "    <span hes-file-upload complete='uploadDone' ng-model='eligibilityFile.filename' label='Upload File' allow-any-size allow-any-type is-secure></span>\n" +
    "    <div error-banner priority=1></div>\n" +
    "    <div hes-table tbl-data=\"data.tblData\" loading=\"settings.loading\" custom-no-data-msg=\"No files uploaded.\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/entries-chart/entries-chart.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries-chart/entries-chart.template.html",
    "<div style=\"overflow-x:auto; overflow-y:hidden;\">\n" +
    "  <div class='chart-top' flex layout='row' layout-align='space-between center'>\n" +
    "    <div>\n" +
    "      <h2 class='homepage-title'>My Progress</h2>\n" +
    "      <div>\n" +
    "        <a class='homepage-link max-cont' ui-sref='go.u.personal.entries({year: data.year})'>Log Activity</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    \n" +
    "    <div>\n" +
    "      <div class=\"group-options\" flex layout='row' layout-align='space-between center'>\n" +
    "        <a ng-repeat=\"option in data.group_options\"\n" +
    "           ng-class=\"{'selected': data.selected_group == option}\"\n" +
    "          ng-click=\"updateChart(option)\"\n" +
    "          class=\"group-options\">\n" +
    "          {{ option }}\n" +
    "        </a>\n" +
    "        <select ng-class=\"{'pointer': data.values.length > 1 }\"\n" +
    "                ng-disabled=\"data.values.length < 2\"\n" +
    "                ng-change='updateChart()'\n" +
    "                ng-model='data.selected_value'\n" +
    "                ng-options='v as v.humanized for v in data.values'>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "      <div style=\"text-align:right; margin-right:5px;\">\n" +
    "        <strong><span style=\"font-size:18pt;\">{{ data.total_steps | numberFormatter }}</span> Steps</strong>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if='data.is_loading'>loading</div>\n" +
    "    <div id='canvas-wrapper' style='background-color:#ffffff;position:relative;min-width:660px;'>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/entries/banners/coming_soon.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/banners/coming_soon.html",
    "<div ng-init=\"block = data.current_billboard.blocks[0]\"\n" +
    "     block-attributes=\"block.config_json\"\n" +
    "     key=\"image_backgroud\"\n" +
    "     background-image\n" +
    "     style=\"position: relative;\">\n" +
    "\n" +
    "  <div class=\"logging-bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div style=\"\n" +
    "         display:flex;\n" +
    "         justify-content:space-between;\n" +
    "         align-items: center;\n" +
    "         min-height:80px;\n" +
    "         z-index:2;\">\n" +
    "  \n" +
    "    <div style=\"width:25%; z-index:2;\">\n" +
    "      <img style=\"max-width: 200px; margin-left:20px; z-index:2;\" block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "  \n" +
    "    <span class=\"hide-on-mobile\" style=\"text-align:center; z-index:2; width: 60%;\">\n" +
    "      <div class=\"shadow\" style=\"color:white; font-weight:bold; font-size: 24px;\" block-attributes=\"block.config_json\" key=\"header_main\" text></div>\n" +
    "      <div class=\"shadow\" style=\"color:white;\" ng-bind-html=\"data.logging_content.summary\"></div>\n" +
    "    </span>\n" +
    "    \n" +
    "    \n" +
    "    <div style=\"width:25%;\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/entries/banners/enter_logging.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/banners/enter_logging.html",
    "<div ng-init=\"block = data.current_billboard.blocks[0]\"\n" +
    "     block-attributes=\"block.config_json\"\n" +
    "     key=\"image_backgroud\"\n" +
    "     background-image\n" +
    "     style=\"position: relative;\">\n" +
    "\n" +
    "  <div class=\"logging-bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div style=\"\n" +
    "         display:flex;\n" +
    "         justify-content:space-between;\n" +
    "         align-items: start;\n" +
    "         min-height:250px;\n" +
    "         z-index:2;\n" +
    "         padding-top:20px;\">\n" +
    "  \n" +
    "    <div style=\"width:25%; z-index:2;\">\n" +
    "      <img class=\"hide-on-mobile\" style=\"max-width: 200px; margin-left:20px; z-index:2;\" block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "  \n" +
    "    <span  style=\"text-align:center; z-index:2;margin-top: 20px;width:60%;\">\n" +
    "      <button style=\"margin-right:20px;margin-top:50px;\" ng-click=\"goToProgram(data.current_program.id)\">Enter</button>\n" +
    "      <div class=\"shadow\" style=\"color:white;margin-top:40px;\" ng-bind-html=\"data.logging_content.summary\"></div>\n" +
    "    </span>\n" +
    "\n" +
    "    <div style=\"width:25%;\"></div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/entries/banners/enter_no_logging.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/banners/enter_no_logging.html",
    "<div ng-init=\"block = data.current_billboard.blocks[0]\"\n" +
    "     block-attributes=\"block.config_json\"\n" +
    "     key=\"image_backgroud\"\n" +
    "     background-image\n" +
    "     style=\"position: relative;\">\n" +
    "\n" +
    "  <div class=\"logging-bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div style=\"\n" +
    "         display:flex;\n" +
    "         justify-content:space-between;\n" +
    "         align-items: center;\n" +
    "         min-height:80px;\n" +
    "         z-index:2;\">\n" +
    "  \n" +
    "    <div style=\"width:25%; z-index:2;\">\n" +
    "      <img style=\"max-width: 200px; margin-left:20px; z-index:2;\" block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "  \n" +
    "    <span class=\"hide-on-mobile\" style=\"text-align:center; z-index:2;width:60%;\">\n" +
    "      <div class=\"shadow\" style=\"color:white; font-weight:bold; font-size: 24px;\" block-attributes=\"block.config_json\" key=\"header_main\" text></div>\n" +
    "      <div class=\"shadow\" style=\"color:white;\" ng-bind-html=\"data.logging_content.summary\"></div>\n" +
    "    </span>\n" +
    "    \n" +
    "    \n" +
    "    <button style=\"margin-right:20px;\" ng-click=\"goToProgram(data.current_program.id)\">Enter</button>\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/entries/banners/logging_ended.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/banners/logging_ended.html",
    "");
}]);

angular.module("/scripts/entries/banners/opt_in_logging.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/banners/opt_in_logging.html",
    "<div ng-init=\"block = data.current_billboard.blocks[0]\"\n" +
    "  block-attributes=\"block.config_json\"\n" +
    "  key=\"image_backgroud\"\n" +
    "  background-image\n" +
    "  class=\"logging-optin\">\n" +
    "\n" +
    "  <div class=\"logging-bg-image-overlay\" block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div class=\"logging-optin__wrapper\">\n" +
    "\n" +
    "    <img class=\"hide-on-mobile logging-optin__logo\" block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "\n" +
    "\n" +
    "    <section class=\"logging-optin__container\">\n" +
    "      <div>\n" +
    "        <h3 class=\"shadow\"  block-attributes=\"block.config_json\" key=\"header_main\" text></h3>\n" +
    "        <p class=\"shadow\" ng-bind-html=\"data.logging_content.summary\"></p>\n" +
    "      </div>\n" +
    "      <div>\n" +
    "        <button style=\"margin-right:20px;margin-top:20px;\" ng-click=\"goToProgram(data.current_program.id)\">Opt In</button>\n" +
    "      </div>\n" +
    "    </section>\n" +
    "\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/entries/banners/opt_in_no_logging.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/banners/opt_in_no_logging.html",
    "<div ng-init=\"block = data.current_billboard.blocks[0]\"\n" +
    "     block-attributes=\"block.config_json\"\n" +
    "     key=\"image_backgroud\"\n" +
    "     background-image\n" +
    "     style=\"position: relative;\">\n" +
    "\n" +
    "  <div class=\"logging-bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div style=\"\n" +
    "         display:flex;\n" +
    "         justify-content:space-between;\n" +
    "         align-items: center;\n" +
    "         min-height:80px;\n" +
    "         z-index:2;\">\n" +
    "  \n" +
    "    <div style=\"width:25%; z-index:2;\">\n" +
    "      <img style=\"max-width: 200px; margin-left:20px; z-index:2;\" block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "  \n" +
    "    <span class=\"hide-on-mobile\" style=\"text-align:center; z-index:2;width:60%;\">\n" +
    "      <div class=\"shadow\" style=\"color:white; font-weight:bold; font-size: 24px;\" block-attributes=\"block.config_json\" key=\"header_main\" text></div>\n" +
    "      <div style=\"color:white;white-space: pre-wrap;padding-left: 1.5em;\" ng-bind-html=\"data.logging_content.summary\"></div>\n" +
    "    </span>\n" +
    "    \n" +
    "    \n" +
    "    <button style=\"margin-right:20px;\" ng-click=\"goToProgram(data.current_program.id)\">Opt In</button>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/entries/banners/registration_closed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/banners/registration_closed.html",
    "<div ng-init=\"block = data.current_billboard.blocks[0]\"\n" +
    "     block-attributes=\"block.config_json\"\n" +
    "     key=\"image_backgroud\"\n" +
    "     background-image\n" +
    "     style=\"position: relative;\">\n" +
    "\n" +
    "  <div class=\"logging-bg-image-overlay\"  block-attributes=\"block.config_json\" key=\"overlay_backgroud\" overlay-color></div>\n" +
    "\n" +
    "  <div style=\"\n" +
    "         display:flex;\n" +
    "         justify-content:space-between;\n" +
    "         align-items: start;\n" +
    "         min-height:250px;\n" +
    "         z-index:2;\n" +
    "         padding-top:20px;\">\n" +
    "  \n" +
    "    <div style=\"width:25%; z-index:2;\">\n" +
    "      <img class=\"hide-on-mobile\" style=\"max-width: 200px; margin-left:20px; z-index:2; max-height: 100px;\" block-attributes=\"block.config_json\" key=\"image_app_logo\" image></img>\n" +
    "    </div>\n" +
    "\n" +
    "    <span  style=\"text-align:center; z-index:2;margin-top: 65px; width:60%;\">\n" +
    "      <div class=\"shadow\" style=\"color:white; font-weight:bold; font-size: 24px;\" block-attributes=\"block.config_json\" key=\"content_main\" text></div>\n" +
    "      <div class=\"shadow\" style=\"color:white;margin-top:10px;\" ng-bind-html=\"data.logging_content.summary\"></div>\n" +
    "    </span>\n" +
    "\n" +
    "    <div style=\"width:25%;\"></div>\n" +
    "\n" +
    "  </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/entries/views/entries.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/entries.html",
    "<div ng-controller=\"EntryEditController\"\n" +
    "  class=\"log-progress\"\n" +
    "  ng-class=\"{'masked': data.edit_entry.origin.is_editing}\">\n" +
    "\n" +
    "  <h1 class=\"visuallyhidden\">Log progress for {{ ::$state.params.year }}</h1>\n" +
    "\n" +
    "  <logging-banner application-state=\"user.application_state\"></logging-banner>\n" +
    "\n" +
    "  <h6 ng-if=\"!data.entry_weeks\">Loading Entries..</h6>\n" +
    "\n" +
    "  <div class=\"weeks\">\n" +
    "    <div class=\"week\" ng-repeat=\"week in data.entry_weeks track by week.key\"\n" +
    "      ng-class=\"{'is-showing': week.is_showing, \n" +
    "        'is-campaign': week.program,\n" +
    "        'is-disabled': data.edit_entry.origin.is_editing}\"\n" +
    "      ng-hide=\"$first && !!week.program && week.is_current\">\n" +
    "\n" +
    "      <div class=\"week-entry-row-layout top\" layout=\"row\" layout-align=\"start center\"\n" +
    "        ng-class=\"{'pointer': !week.program, 'default-cursor': week.program}\"\n" +
    "        tabindex=\"{{ !week.program ? '0' : '' }}\"\n" +
    "        ng-click=\"toggleWeek(week)\"\n" +
    "        ng-keypress=\"ariaClick($event)\"\n" +
    "        aria-label=\"{{ week.is_showing ? 'hide' : 'show' }} {{ ::week.datesHumanized($state.params.year) }}\"\n" +
    "        aria-expanded=\"{{ week.is_showing }}\"\n" +
    "        role=\"button\">\n" +
    "\n" +
    "        <!-- Closed -->\n" +
    "        <span class=\"column-1 closed-date\" ng-if=\"!week.is_showing\" flex=\"{{!week.program ? 'grow' : 'noshrink'}}\">\n" +
    "          <span class=\"arrow\"\n" +
    "            ng-class=\"{'noshow': week.program}\"\n" +
    "            hes-icon\n" +
    "            icon-name=\"standard:arrow\"></span>\n" +
    "          {{ ::week.datesHumanized($state.params.year) }}\n" +
    "        </span>\n" +
    "        <span class=\"program-name\" ng-if=\"!!week.program && !isMobile()\">\n" +
    "          <em>{{ ::week.program.name}}</em>\n" +
    "        </span>\n" +
    "        <span class=\"column-4 program-opt sm md\" ng-if=\"week.program\" flex=\"noshrink\">\n" +
    "          <a ng-if=\"::hasUserOptedInToProgram(week.program) && !isMobile()\" ng-click=\"downloadHistory(week.program)\">Download Report</a>\n" +
    "          <span class=\"optin-msg\" ng-if=\"!hasUserOptedInToProgram(week.program)\">You didn't opt in</span>\n" +
    "        </span>\n" +
    "        <span class=\"column-4 header\"\n" +
    "          ng-if=\"!week.program && !week.is_showing\">{{ formattedTotalSteps(week.totalSteps()) }}</span>\n" +
    "\n" +
    "        <!-- Open -->\n" +
    "        <span class=\"header data sm md\" ng-if=\"week.is_showing\">\n" +
    "          <span class=\"arrow-down margin-5-left\"\n" +
    "            hes-icon\n" +
    "            icon-name=\"standard:arrow\"></span>\n" +
    "          DATE\n" +
    "        </span>\n" +
    "        <span class=\"column-1 header width-60\" ng-if=\"week.is_showing\">\n" +
    "          <span class=\"arrow down xs\"\n" +
    "            hes-icon\n" +
    "            icon-name=\"standard:arrow\"></span>\n" +
    "            STEPS &nbsp;&nbsp;<a ng-if=\"site.hasDevicesEnabled() && !user.isAnyDeviceConnected()\" ui-sref=\"go.u.settings.tracking\">Connect Device</a>\n" +
    "        </span>\n" +
    "        <span class=\"column-2 header width-20\" ng-if=\"week.is_showing\" flex=\"noshrink\">TOTAL</span>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- start of entry rows -->\n" +
    "      <div class=\"entries\"\n" +
    "        ng-if=\"week.is_showing\"\n" +
    "        ng-class=\"{'showing': week.is_showing}\">\n" +
    "\n" +
    "        <div ng-class=\"{'edit-entry': entry.is_editing, 'sm md': !isMobile(), 'xs': isMobile()}\"\n" +
    "          ng-repeat=\"entry in week.entries track by entry.recorded_on\"\n" +
    "          ng-cloak\n" +
    "          md-hes-popover\n" +
    "          class=\"relative\"\n" +
    "          target-class=\"{{isMobile() ? '.xs' : '.sm'}} .calculated\"\n" +
    "          show-popover=\"{{entry.showWhySteps}}\"\n" +
    "          template=\"{{view.whyStepsTemplate}}\">\n" +
    "          <div ng-include=\"entryTemplate(entry)\"></div>\n" +
    "        </div>\n" +
    "\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>");
}]);

angular.module("/scripts/entries/views/entry-edit-desktop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/entry-edit-desktop.html",
    "<!-- DESKTOP VIEW -->\n" +
    "<form class=\"week-entry-row-layout edit-entry sm md\"\n" +
    "  ng-class=\"{'is-recorded': data.edit_entry.is_recorded}\"\n" +
    "  name=\"entry_form\"\n" +
    "  layout=\"row\"\n" +
    "  layout-align=\"start top\"\n" +
    "  focus-trap=\"entry.is_editing\"\n" +
    "  ng-submit=\"saveEntry(entry, data.edit_entry.override)\">\n" +
    "  <div class=\"record\" flex-gt-xs=\"noshrink\">\n" +
    "    <div>\n" +
    "      {{ ::data.edit_entry.humanize() }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"activities\" flex-layout=\"column\">\n" +
    "    <div class=\"column-2 steps\" ng-class=\"{ 'flex-order--1' : !user.isAnyDeviceConnected() }\">\n" +
    "\n" +
    "      <!-- When logging manually -->\n" +
    "      <div ng-if=\"shouldStepsLookLikeActivity(entry)\" class=\"activity-steps\">\n" +
    "        <div class=\"minutes-remove\" ng-class=\"{ 'closed': areStepsClosed() }\">\n" +
    "          <button class=\"icon-btn dark-gray\"\n" +
    "            type=\"button\"\n" +
    "            ng-click=\"changeToButton({clear_steps:true})\"\n" +
    "            aria-label=\"remove {{ entry_activity.name || 'new' }} activity\">\n" +
    "            <span hes-icon icon-name=\"standard:close-x\"></span>\n" +
    "          </button>\n" +
    "        </div>\n" +
    "        <div class=\"row-full-width\">\n" +
    "          <a class=\"steps-link\" ng-class=\"{ 'closed': areStepsClosed() }\"\n" +
    "            ng-click=\"changeToInput()\">\n" +
    "            {{ areStepsClosed() ? 'Manual Steps' : 'Steps' }}\n" +
    "          </a>\n" +
    "        </div>\n" +
    "        <div class=\"steps-minutes-input\" ng-class=\"{'last':$last, 'closed': areStepsClosed() }\" flex=\"noshrink\">\n" +
    "          <input name=\"value\"\n" +
    "            ng-required=\"!areStepsClosed()\"\n" +
    "            id=\"ea_{{entry_activity.$$hashKey}}\"\n" +
    "            ng-model=\"data.edit_entry.exercise_steps\"\n" +
    "            ng-class=\"{'modify': !!entry.id}\"\n" +
    "            placeholder='0'\n" +
    "            min=\"0\"\n" +
    "            type='number'\n" +
    "            pattern='\\d*'\n" +
    "            hes-integer-input\n" +
    "            digit-limit=5\n" +
    "            aria-label=\"input number of steps\"\n" +
    "            ng-change=\"view.displaySave = true\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- When device connected -->\n" +
    "      <div ng-if=\"!shouldStepsLookLikeActivity(entry)\" class=\"flex-row\">\n" +
    "        <span>{{ areStepsFromDevice(entry) ? 'Device ' : '' }}Steps</span>\n" +
    "        <div class=\"relative\">\n" +
    "          <button type=\"button\" class=\"link-look\"\n" +
    "            ng-if=\"(!areStepsFromDevice(entry) && user.isAnyDeviceConnected() && user.active_device != 'APPLE') || (user.isAnyDeviceConnected() && user.active_device != 'APPLE' && !!data.edit_entry.override)\"\n" +
    "            ng-click=\"useDeviceData(user, entry)\">\n" +
    "            Sync\n" +
    "          </button>\n" +
    "          <button type=\"button\" \n" +
    "            class=\"link-look\"\n" +
    "            ng-if=\"areStepsFromDevice(entry) && !data.edit_entry.override\"\n" +
    "            ng-click=\"overwrite($event)\">\n" +
    "            Overwrite\n" +
    "          </button>\n" +
    "          <input name=\"exercise_steps\"\n" +
    "            type=\"number\"\n" +
    "            ng-if=\"!areStepsFromDevice(entry) || data.edit_entry.override\"\n" +
    "            ng-model=\"data.edit_entry.exercise_steps\"\n" +
    "            ng-class=\"{'modify': !!entry.id}\"\n" +
    "            placeholder='0'\n" +
    "            min=\"0\"\n" +
    "            type='number'\n" +
    "            pattern='\\d*'\n" +
    "            hes-integer-input\n" +
    "            digit-limit=5\n" +
    "            aria-label=\"input number of steps\"\n" +
    "            ng-change=\"view.displaySave = true\">\n" +
    "          </input>\n" +
    "          <span class=\"device-steps\" ng-if=\"areStepsFromDevice(entry) && !data.edit_entry.override\">{{ (!data.edit_entry.exercise_steps ? 0 : data.edit_entry.exercise_steps) | number }}</span>\n" +
    "          <div class=\"micro\" ng-show=\"!!data.entry_message\" aria-live=\"polite\">{{ data.entry_message }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"column-3 minutes\">\n" +
    "      <div layout=\"row\" layout-align=\"start center\" class=\"entry-activity-row\"\n" +
    "        ng-repeat=\"entry_activity in entry.entry_exercise_activities\">\n" +
    "\n" +
    "        <div class=\"minutes-remove\" ng-if=\"entry_activity.exercise_activity_id\">\n" +
    "          <button type=\"button\" class=\"icon-btn dark-gray\"\n" +
    "            ng-click=\"removeActivity(entry_activity)\"\n" +
    "            aria-label=\"remove {{ entry_activity.name || 'new' }} activity\">\n" +
    "            <span hes-icon icon-name=\"standard:close-x\"></span>\n" +
    "          </button>\n" +
    "        </div>\n" +
    "        <div class=\"row-full-width\">\n" +
    "          <select name=\"exercise_activity_id\"\n" +
    "            ng-model=\"entry_activity.exercise_activity_id\"\n" +
    "            ng-class=\"{'long': !entry_activity.exercise_activity_id}\"\n" +
    "            ng-change=\"onSelect()\">\n" +
    "            <option value=\"\">Choose an activity</option>\n" +
    "            <optgroup label=\"{{ ::name }}\" ng-repeat=\"(name, activities) in ::data.activities\">\n" +
    "              <option ng-value=\"activity.id\"\n" +
    "                ng-selected=\"{{ entry_activity.exercise_activity_id == activity.id }}\"\n" +
    "                ng-repeat=\"activity in ::activities\"\n" +
    "                aria-label=\"select activity\"\n" +
    "                ng-if=\"showOption(data.edit_entry, entry_activity.exercise_activity_id, activity.id)\"\n" +
    "                ng-bind-html=\"activity.name\">\n" +
    "              </option>\n" +
    "            </optgroup>\n" +
    "          </select>\n" +
    "        </div>\n" +
    "        <div class=\"minutes-input\" ng-class=\"{'last':$last}\" ng-if=\"entry_activity.exercise_activity_id\" flex=\"noshrink\">\n" +
    "          <input name=\"value\"\n" +
    "            aria-label=\"Minutes amount\"\n" +
    "            ng-required=\"entry_activity.exercise_activity_id !== ''\"\n" +
    "            id=\"ea_{{entry_activity.$$hashKey}}\"\n" +
    "            type='number'\n" +
    "            pattern='\\d*'\n" +
    "            hes-integer-input\n" +
    "            digit-limit=3\n" +
    "            min=\"0\"\n" +
    "            ng-model='entry_activity.value'\n" +
    "            placeholder='minutes' />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"save\"\n" +
    "    ng-class=\"{'show-save': view.displaySave && !view.isSaving}\">\n" +
    "    <div class=\"entry__buttons\">\n" +
    "      <button type=\"submit\"\n" +
    "        ng-class=\"{'secondary': !view.displaySave}\"\n" +
    "        ng-disabled=\"!view.displaySave || view.isSaving\"\n" +
    "        aria-label=\"save entry\"\n" +
    "        class=\"entry__save\">\n" +
    "        Save\n" +
    "      </button>\n" +
    "      <button style=\"margin:10px 0px;\" type=\"button\" class=\"link-look\"\n" +
    "        ng-init=\"bindForm(entry_form)\"\n" +
    "        ng-click=\"checkIfUnsavedCancel(entry)\"\n" +
    "        aria-label=\"cancel edit entry\"\n" +
    "        ng-hide=\"view.isSaving\">\n" +
    "        Cancel\n" +
    "      </button>\n" +
    "      <span ng-show=\"!!view.isSaving\">Saving...</span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>");
}]);

angular.module("/scripts/entries/views/entry-edit-mobile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/entry-edit-mobile.html",
    "<!-- Mobile View -->\n" +
    "<form class=\"week-entry-row-layout edit-entry xs\"\n" +
    "  ng-class=\"{'is-recorded': data.edit_entry.is_recorded}\"\n" +
    "  name=\"entry_form\"\n" +
    "  layout=\"row\"\n" +
    "  layout-align=\"start top\"\n" +
    "  focus-trap=\"entry.is_editing\"\n" +
    "  ng-submit=\"saveEntry(entry, data.edit_entry.override)\">\n" +
    "  <div class=\"column-1 record\" flex-gt-xs=\"noshrink\">\n" +
    "    <div>\n" +
    "      {{ ::data.edit_entry.humanize() }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"column-2 steps\" ng-class=\"{ 'flex-order--1' : !user.isAnyDeviceConnected() }\" flex-gt-xs=\"noshrink\">\n" +
    "\n" +
    "    <!-- When logging manually XS -->\n" +
    "    <div ng-if=\"shouldStepsLookLikeActivity(entry)\" class=\"activity-steps\">\n" +
    "      <div class=\"minutes-remove\" ng-class=\"{ 'closed': areStepsClosed() }\">\n" +
    "        <button class=\"icon-btn dark-gray\"\n" +
    "          type=\"button\"\n" +
    "          ng-click=\"changeToButton({clear_steps:true})\"\n" +
    "          aria-label=\"remove {{ entry_activity.name || 'new' }} activity\">\n" +
    "          <span hes-icon icon-name=\"standard:close-x\"></span>\n" +
    "        </button>\n" +
    "      </div>\n" +
    "      <div class=\"row-full-width\">\n" +
    "        <a class=\"steps-link\" ng-class=\"{ 'closed': areStepsClosed() }\"\n" +
    "          ng-click=\"changeToInput()\">\n" +
    "          {{ areStepsClosed() ? 'Manual Steps' : 'Steps' }}\n" +
    "        </a>\n" +
    "      </div>\n" +
    "      <div class=\"steps-minutes-input\" ng-class=\"{'last':$last, 'closed': areStepsClosed() }\" flex=\"noshrink\">\n" +
    "        <input name=\"value\"\n" +
    "          ng-required=\"!areStepsClosed()\"\n" +
    "          id=\"ea_{{::entry_activity.$$hashKey}}\"\n" +
    "          ng-model=\"data.edit_entry.exercise_steps\"\n" +
    "          ng-class=\"{'modify': !!entry.id}\"\n" +
    "          placeholder='0'\n" +
    "          min=\"0\"\n" +
    "          type='number'\n" +
    "          pattern='\\d*'\n" +
    "          hes-integer-input\n" +
    "          digit-limit=5\n" +
    "          aria-label=\"input number of steps\"\n" +
    "          ng-change=\"view.displaySave = true\" />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!shouldStepsLookLikeActivity(entry)\" class=\"flex-row\">\n" +
    "      <span>{{ areStepsFromDevice(entry) ? 'Device ' : '' }}Steps</span>\n" +
    "      <div class=\"relative\">\n" +
    "        <button type=\"button\" class=\"link-look\"\n" +
    "          ng-if=\"(!areStepsFromDevice(entry) && user.isAnyDeviceConnected() && user.active_device != 'APPLE') || (user.isAnyDeviceConnected() && user.active_device != 'APPLE' && !!data.edit_entry.override)\"\n" +
    "          ng-click=\"useDeviceData(user, entry)\">\n" +
    "          Sync\n" +
    "        </button>\n" +
    "        <button type=\"button\"\n" +
    "          class=\"link-look\"\n" +
    "          ng-if=\"areStepsFromDevice(entry) && !data.edit_entry.override\"\n" +
    "          ng-click=\"overwrite($event)\">\n" +
    "          Overwrite\n" +
    "        </button>\n" +
    "        <input name=\"exercise_steps\"\n" +
    "          type=\"number\"\n" +
    "          ng-if=\"!areStepsFromDevice(entry) || data.edit_entry.override\"\n" +
    "          ng-model=\"data.edit_entry.exercise_steps\"\n" +
    "          ng-class=\"{'modify': !!entry.id}\"\n" +
    "          placeholder='0'\n" +
    "          min=\"0\"\n" +
    "          type='number'\n" +
    "          pattern='\\d*'\n" +
    "          hes-integer-input\n" +
    "          digit-limit=5\n" +
    "          aria-label=\"input number of steps\"\n" +
    "          ng-change=\"view.displaySave = true\">\n" +
    "        </input>\n" +
    "        <span class=\"device-steps\" ng-if=\"areStepsFromDevice(entry) && !data.edit_entry.override\">{{ (!data.edit_entry.exercise_steps ? 0 : data.edit_entry.exercise_steps) }}</span>\n" +
    "        <div class=\"micro\" ng-show=\"!!data.entry_message\" aria-live=\"polite\">{{ data.entry_message }}</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"column-3 minutes\">\n" +
    "    <div layout=\"row\" layout-align=\"start center\" class=\"entry-activity-row\"\n" +
    "      ng-repeat=\"entry_activity in entry.entry_exercise_activities\">\n" +
    "\n" +
    "      <div class=\"minutes-remove\" ng-if=\"entry_activity.exercise_activity_id\">\n" +
    "        <button type=\"button\" class=\"icon-btn dark-gray\"\n" +
    "          ng-click=\"removeActivity(entry_activity)\"\n" +
    "          aria-label=\"remove {{ entry_activity.name || 'new' }} activity\">\n" +
    "          <span hes-icon icon-name=\"standard:close-x\"></span>\n" +
    "        </button>\n" +
    "      </div>\n" +
    "      <div class=\"row-full-width\">\n" +
    "        <select name=\"exercise_activity_id\"\n" +
    "          ng-model=\"entry_activity.exercise_activity_id\"\n" +
    "          ng-class=\"{'long': !entry_activity.exercise_activity_id}\"\n" +
    "          ng-change=\"onSelect()\">\n" +
    "          <option value=\"\">Choose an activity</option>\n" +
    "          <optgroup label=\"{{ ::name }}\" ng-repeat=\"(name, activities) in ::data.activities\">\n" +
    "            <option ng-value=\"activity.id\"\n" +
    "              ng-selected=\"{{ entry_activity.exercise_activity_id == activity.id }}\"\n" +
    "              ng-repeat=\"activity in ::activities\"\n" +
    "              aria-label=\"select activity\"\n" +
    "              ng-if=\"showOption(data.edit_entry, entry_activity.exercise_activity_id, activity.id)\"\n" +
    "              ng-bind-html=\"activity.name\">\n" +
    "            </option>\n" +
    "          </optgroup>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "      <div class=\"minutes-input\" ng-class=\"{'last':$last}\" ng-if=\"entry_activity.exercise_activity_id\" flex=\"noshrink\">\n" +
    "        <input name=\"value\"\n" +
    "          aria-label=\"Minutes amount\"\n" +
    "          ng-required=\"entry_activity.exercise_activity_id !== ''\"\n" +
    "          id=\"ea_{{entry_activity.$$hashKey}}shrunk\"\n" +
    "          type='number'\n" +
    "          pattern='\\d*'\n" +
    "          hes-integer-input\n" +
    "          digit-limit=3\n" +
    "          min=\"0\"\n" +
    "          ng-model='entry_activity.value'\n" +
    "          placeholder='min' />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"totalsteps flex-order--1\"\n" +
    "    ng-class=\"{'show-save': view.displaySave && !view.isSaving}\">\n" +
    "    <div class=\"entry__buttons\">\n" +
    "      <button type=\"submit\"\n" +
    "        ng-class=\"{'secondary': !view.displaySave }\"\n" +
    "        ng-disabled=\"!view.displaySave || view.isSaving\"\n" +
    "        aria-label=\"save entry\"\n" +
    "        class=\"entry__save\">\n" +
    "        Save\n" +
    "      </button>\n" +
    "      <button style=\"margin:10px 0px;\" type=\"button\" class=\"link-look\"\n" +
    "        ng-init=\"bindForm(entry_form)\"\n" +
    "        ng-click=\"checkIfUnsavedCancel(entry)\"\n" +
    "        aria-label=\"cancel edit entry\"\n" +
    "        ng-hide=\"view.isSaving\">\n" +
    "        Cancel\n" +
    "      </button>\n" +
    "      <span ng-show=\"!!view.isSaving\">Saving...</span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("/scripts/entries/views/entry-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/entry-edit.html",
    "<div ng-if=\"isMobile() && entry.is_editing\"   ng-include=\"'/scripts/entries/views/entry-edit-mobile.html'\"></div>\n" +
    "<div ng-if=\"!isMobile() && entry.is_editing\"  ng-include=\"'/scripts/entries/views/entry-edit-desktop.html'\"></div>");
}]);

angular.module("/scripts/entries/views/entry-show-desktop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/entry-show-desktop.html",
    "<div class=\"week-entry-row-layout entry-show sm md\"\n" +
    "  ng-click=\"editEntry(entry)\"\n" +
    "  tabindex=\"-1\"\n" +
    "  ng-class=\"::{'is-recorded': !!entry.is_recorded,\n" +
    "              'is-disabled' : data.edit_entry.origin.is_editing}\">\n" +
    "\n" +
    "  <div class=\"column-1 record\" ng-class=\"::{ 'border': entry.is_recorded || areStepsFromDevice(entry) }\">\n" +
    "    {{ ::entry.humanize() }}\n" +
    "  </div>\n" +
    "  <div class=\"entry__row\" ng-if=\"::((entry.exercise_steps || entry.entry_exercise_activities.length > 0) || areStepsFromDevice(entry))\">\n" +
    "    <div class=\"steps\" ng-if=\"::user.isAnyDeviceConnected()\" flex=\"noshrink\"\n" +
    "      layout=\"row\"\n" +
    "      layout-align=\"space-between\">\n" +
    "      <div class=\"\">{{ ::(areStepsFromDevice(entry) ? 'Device ' : '') }}Steps</div>\n" +
    "      <div class=\"\">{{ ((!entry.exercise_steps ? 0 : entry.exercise_steps)) | numberFormatter }}</div>\n" +
    "    </div>\n" +
    "    <div class=\"minutes\" flex=\"grow\"\n" +
    "      layout=\"row\">\n" +
    "      <div ng-if=\"::(entry.entry_exercise_activities.length > 0)\" class=\"activities\"\n" +
    "        flex=\"grow\">\n" +
    "        <div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"activity in ::entry.entry_exercise_activities\">\n" +
    "          <div>{{ ::activity.name }}\n" +
    "            <span class=\"visuallyhidden\">\"{{ ::activity.steps_per_minute }} steps/min\"</span>\n" +
    "            <span class=\"\">({{ ::activity.value }} min)</span>\n" +
    "          </div>\n" +
    "          <div>\n" +
    "            <span class=\"calculated\" hes-popover content=\"{{ ::activity.steps_per_minute }} steps/min\">{{ ::activity.steps_calculated | numberFormatter }}</span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"steps\" ng-if=\"::(!user.isAnyDeviceConnected() && entry.exercise_steps)\" flex=\"noshrink\"\n" +
    "      layout=\"row\"\n" +
    "      layout-align=\"space-between\">\n" +
    "      <div class=\"\">{{ ::(areStepsFromDevice(entry) ? 'Device ' : '') }}Steps</div>\n" +
    "      <div class=\"\">{{ (!entry.exercise_steps ? 0 : entry.exercise_steps) | numberFormatter }}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"total-steps\" ng-class=\"{'border': entry.is_recorded || areStepsFromDevice(entry)}\">\n" +
    "    <div ng-if=\"(entry.is_recorded || areStepsFromDevice(entry))\">\n" +
    "      <b>{{ entry.total_steps | numberFormatter }}</b>\n" +
    "      <button class=\"link-look\"\n" +
    "        id=\"entry-{{::entry.recorded_on}}\"\n" +
    "        ng-click=\"editEntry(entry, data.edit_entry)\"\n" +
    "        ng-disabled=\"data.edit_entry.origin.is_editing\"\n" +
    "        aria-label=\"edit {{::entry.humanize()}}\">\n" +
    "        edit\n" +
    "      </button>\n" +
    "    </div>\n" +
    "    <button ng-if=\"::(!entry.is_recorded && !areStepsFromDevice(entry))\"\n" +
    "      id=\"entry-{{::entry.recorded_on}}\"\n" +
    "      ng-click=\"editEntry(entry, data.edit_entry)\"\n" +
    "      aria-label=\"log for {{ ::entry.humanize() }}\"\n" +
    "      ng-disabled=\"data.edit_entry.origin.is_editing\">\n" +
    "      Log\n" +
    "    </button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/entries/views/entry-show-mobile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/entry-show-mobile.html",
    "<div class=\"week-entry-row-layout entry-show xs\"\n" +
    "  ng-click=\"editEntry(entry)\"\n" +
    "  tabindex=\"-1\"\n" +
    "  layout=\"column\" layout-align=\"start top\"\n" +
    "  ng-class=\"::{'is-recorded': !!entry.is_recorded,\n" +
    "              'is-disabled' : data.edit_entry.origin.is_editing}\">\n" +
    "  <div layout=\"row\">\n" +
    "    <div class=\"column-1 record\" flex=\"{{ ::(entry.is_recorded ? 'noshrink' : 'grow')}}\">\n" +
    "      {{ ::entry.humanize() }}\n" +
    "    </div>\n" +
    "    <div class=\"column-2 total-steps\" flex=\"noshrink\">\n" +
    "      <div ng-if=\"(entry.is_recorded || areStepsFromDevice(entry))\">\n" +
    "        <b>{{ entry.total_steps | numberFormatter }}</b>\n" +
    "        <button class=\"link-look\"\n" +
    "          id=\"entry-{{::entry.recorded_on}}\"\n" +
    "          ng-click=\"editEntry(entry, data.edit_entry)\"\n" +
    "          ng-disabled=\"data.edit_entry.origin.is_editing\"\n" +
    "          aria-label=\"edit {{::entry.humanize()}}\">\n" +
    "          edit\n" +
    "        </button>\n" +
    "      </div>\n" +
    "      <button ng-if=\"::(!entry.is_recorded && !areStepsFromDevice(entry))\"\n" +
    "        id=\"entry-{{::entry.recorded_on}}\"\n" +
    "        ng-click=\"editEntry(entry, data.edit_entry)\"\n" +
    "        aria-label=\"log for {{ ::entry.humanize() }}\"\n" +
    "        ng-disabled=\"data.edit_entry.origin.is_editing\">\n" +
    "        Log\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"entry__row\" ng-if=\"::(entry.exercise_steps || entry.entry_exercise_activities.length > 0 || areStepsFromDevice(entry))\" layout=\"column\">\n" +
    "    <div class=\"steps\" ng-if=\"::user.isAnyDeviceConnected()\" flex=\"noshrink\"\n" +
    "      layout=\"row\"\n" +
    "      layout-align=\"space-between\">\n" +
    "      <div class=\"\">{{ (areStepsFromDevice(entry) ? 'Device ' : '') }}Steps</div>\n" +
    "      <div class=\"\">{{ ((!entry.exercise_steps ? 0 : entry.exercise_steps)) | numberFormatter }}</div>\n" +
    "    </div>\n" +
    "    <div class=\"minutes\" flex=\"grow\"\n" +
    "      layout=\"row\">\n" +
    "      <div ng-if=\"::(entry.entry_exercise_activities.length > 0 || areStepsFromDevice(entry))\" class=\"activities\"\n" +
    "        flex=\"grow\">\n" +
    "        <div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"activity in ::entry.entry_exercise_activities\">\n" +
    "          <div>{{ ::activity.name }}</div>\n" +
    "          <div>\n" +
    "            <span class=\"calculated\" hes-popover content=\"{{ ::activity.steps_per_minute }} steps/min\">{{ ::activity.steps_calculated | numberFormatter }}</span>\n" +
    "            <span class=\"visuallyhidden\">\"{{ ::activity.steps_per_minute }} steps/min\"</span>\n" +
    "            <span class=\"\">({{ ::activity.value }} min)</span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"steps\" ng-if=\"::(!user.isAnyDeviceConnected() && entry.exercise_steps)\" flex=\"noshrink\"\n" +
    "      layout=\"row\"\n" +
    "      layout-align=\"space-between\">\n" +
    "      <div class=\"\">{{ ::(areStepsFromDevice(entry) ? 'Device ' : '') }}Steps</div>\n" +
    "      <div class=\"\">{{ ::((!entry.exercise_steps ? 0 : entry.exercise_steps)) | numberFormatter }}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/entries/views/entry-show.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/entry-show.html",
    "<div ng-if=\"isMobile()  && !entry.is_editing\"   ng-include=\"'/scripts/entries/views/entry-show-mobile.html'\"></div>\n" +
    "<div ng-if=\"!isMobile() && !entry.is_editing\"  ng-include=\"'/scripts/entries/views/entry-show-desktop.html'\"></div>");
}]);

angular.module("/scripts/entries/views/why-steps.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/entries/views/why-steps.html",
    "<div ng-bind-html=\"explanations.why_steps.content_html\"></div>");
}]);

angular.module("/scripts/errors/errorBanner.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/errors/errorBanner.html",
    "<div class=\"error-banner-container no-print\">\n" +
    "  <div role=\"alert\" aria-live=\"polite\" class='error-banner' ng-class=\"{'active': errors.length}\">\n" +
    "    <div ng-repeat='error in errors' class='banner-error'>\n" +
    "      <span markdown no-paragraph ng-model=\"error\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/evaluations/evaluation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/evaluations/evaluation.html",
    "<div class='page-form' hes-validator>\n" +
    "	<div markdown ng-model=\"data.site_evaluation.message\"></div>\n" +
    "	<div flex='100' user-evaluation evaluation=\"data.evaluation\" site-evaluation='data.site_evaluation'></div>\n" +
    "	<div class='text-right'>\n" +
    "		<button aria-label=\"Submit\" hes-validate-click=\"submitEvaluation()\">Submit</button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/evaluations/siteEvaluation-createEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/evaluations/siteEvaluation-createEdit.html",
    "<div class='tile'>\n" +
    "  <ul role=\"tablist\" class=\"links\">\n" +
    "    <li role=\"tab\" ng-class=\"active\">\n" +
    "      <span><span ng-if='isNewSiteEvaluation()'>New</span> Site Evaluation</span>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "  \n" +
    "  <div class='frame page-form'>\n" +
    "\n" +
    "    <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "  \n" +
    "\n" +
    "    <div layout=\"row\" layout-wrap class='input-group'>\n" +
    "      <div flex='100'>\n" +
    "        <input name=\"is_initial\" type='checkbox' ng-model='siteEvaluation.is_initial_evaluation' />\n" +
    "        <label for=\"is_initial\" class='inline'>Is Initial Evaluation (Registration)</label><br />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div layout=\"row\" layout-wrap class='input-group' ng-if=\"!siteEvaluation.is_initial_evaluation\">\n" +
    "      <h4 flex='100' class=\"name\">Name<span class='asterisk'>*</span></h4>\n" +
    "      <div flex='100' flex-gt-xs='50'>\n" +
    "        <label class=\"screen-hidden\" for=\"name\">Name</label>\n" +
    "        <input type=\"text\" id=\"name\" name=\"name\" ng-model=\"siteEvaluation.name\" placeholder=\"Evaluation Name\" />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div layout=\"row\" layout-wrap class='input-group' ng-if=\"!siteEvaluation.is_initial_evaluation\">\n" +
    "      <div flex='100'>\n" +
    "        <input type='radio' name='eval_timing' on-click=\"selectEvalType(true)\" ng-model='config.is_days_from_start' ng-value='true'> Days From Start <br />\n" +
    "        <input type='radio' name='eval_timing' on-click=\"selectEvalType(false)\" ng-model='config.is_days_from_start' ng-value='false'> Start/End\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div layout=\"row\" layout-wrap class='input-group' ng-if='config.is_days_from_start && !siteEvaluation.is_initial_evaluation'>\n" +
    "      <h4 flex='100' class=\"name\">Days From Start<span class='asterisk'>*</span></h4>\n" +
    "      <div flex='100' flex-gt-xs='50'>\n" +
    "        <label class=\"screen-hidden\" for=\"site_evaluation_days_from_start\">Days From Start</label>\n" +
    "        <input type=\"text\" id=\"site_evaluation_days_from_start\" name=\"site_evaluation_days_from_start\" ng-model=\"siteEvaluation.days_from_start\" placeholder=\"Days From Start\" />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div layout=\"row\" layout-wrap class='input-group' ng-if='!config.is_days_from_start && !siteEvaluation.is_initial_evaluation'>\n" +
    "      <div flex='100' flex-gt-xs='50'>\n" +
    "        <h4 class=\"name\">Start<span class='asterisk'>*</span></h4>\n" +
    "        <label class=\"screen-hidden\" for=\"startDate\">Start</label>\n" +
    "        <input type='text' required name='startDate' id='startDate' ng-model='siteEvaluation.start_date' hes-date-select class=\"date\" date-format=\"dateFormat\"/>\n" +
    "      </div>\n" +
    "      <div flex='100' flex-gt-xs='50'>\n" +
    "        <h4 class=\"name\">End<span class='asterisk'>*</span></h4>\n" +
    "        <label class=\"screen-hidden\" for=\"endDate\">End</label>\n" +
    "        <input type='text' required name='endDate' id='endDate' ng-model='siteEvaluation.end_date' hes-date-select class=\"date\" date-format=\"dateFormat\"/>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!siteEvaluation.is_initial_evaluation\">\n" +
    "      <div layout=\"row\" layout-wrap class='input-group'>\n" +
    "        <h4 flex='100' class=\"name\">{{(siteEvaluation.is_initial_evaluation ? 'Registration ' : 'Evaluation ') + 'Message'}}<span class='asterisk'>*</span></h4>\n" +
    "        <div flex='100'>\n" +
    "          <label class=\"screen-hidden\" for=\"site_evaluation_days_from_start\">{{(siteEvaluation.is_initial_evaluation ? 'Registration ' : 'Evaluation ') + 'Message'}}</label>\n" +
    "          <textarea id=\"evaluation_message\" rows='2' ng-model=\"siteEvaluation.message\"></textarea>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    \n" +
    "    <div layout=\"row\" layout-wrap class='input-group'>\n" +
    "      <div flex='100'>\n" +
    "        <button class=\"secondary\" ng-click='addQuestion()'>Add Question</button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div layout=\"row\" layout-wrap class='input-group'>\n" +
    "      <div flex='100'>\n" +
    "        <table style=\"width:100%;\">\n" +
    "          <thead>\n" +
    "            <th>Type of Prompt</th>\n" +
    "            <th>Prompt</th>\n" +
    "            <th>Short Label</th>\n" +
    "            <th>Sequence</th>\n" +
    "            <th></th>\n" +
    "          </thead>\n" +
    "          <tbody>\n" +
    "            <tr ng-repeat=\"question in siteEvaluation.site_evaluation_questions\">\n" +
    "              <td>{{ question.type_of_prompt }}</td>\n" +
    "              <td>{{ question.prompt }}</td>\n" +
    "              <td>{{ question.short_label }}</td>\n" +
    "              <td>{{ question.sequence }}</td>\n" +
    "              <td style=\"text-align:right;\">\n" +
    "                <button class=\"secondary\" ng-click=\"editQuestionPopup(question, false)\">Edit</button>\n" +
    "                <a role=\"button\" ng-click=\"siteEvaluation.site_evaluation_questions.splice($index,1)\">Remove</a>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </tbody>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div layout=\"row\" layout-wrap class='input-group'>\n" +
    "      <div flex='100'>\n" +
    "      <button class='save-button' ng-click='submitSiteEvaluation()'>{{isNewSiteEvaluation() ? 'Create ' : 'Save '}}</button>\n" +
    "      <div ng-if=\"data.is_saving\">saving..</div>\n" +
    "      <a role=\"button\" ng-click='destroy(siteEvaluation)'>Destroy</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/evaluations/siteEvaluationQuestion-createEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/evaluations/siteEvaluationQuestion-createEdit.html",
    "<div>\n" +
    "	<!-- Title -->\n" +
    "	<div class='page-title'>\n" +
    "		<span class='content'>{{config.addEditQuestion.is_new ? \"New\" : \"Edit\"}} Question</span>\n" +
    "	</div>\n" +
    "\n" +
    "	<form name='newQuestionForm'>\n" +
    "		\n" +
    "		<div>\n" +
    "			<label for='sequence'>Sequence</label>\n" +
    "			<input tabindex='-1' type='text' name='sequence' ng-model='config.addEditQuestion.sequence' />\n" +
    "		</div>\n" +
    "\n" +
    "		<div>\n" +
    "			<label for='short_label'>Short Label</label>\n" +
    "			<input type='text' name='short_label' ng-model='config.addEditQuestion.short_label' />\n" +
    "		</div>\n" +
    "\n" +
    "		<div>\n" +
    "			<label for='prompt'>Prompt</label>\n" +
    "			<input type='text' name='prompt' ng-model='config.addEditQuestion.prompt' />\n" +
    "		</div>\n" +
    "\n" +
    "		<div>\n" +
    "			<label for='type_of_prompt'>Type of prompt</label>\n" +
    "			<select name='type_of_prompt' ng-model='config.addEditQuestion.type_of_prompt'>\n" +
    "				<option ng-repeat='option in config.options' value=\"{{option}}\">{{option}}</option>\n" +
    "			</select>\n" +
    "		</div>\n" +
    "\n" +
    "		<div ng-if=\"config.addEditQuestion.id\">\n" +
    "			Answer Column Name: <strong>{{ config.addEditQuestion.answer_column_name }}</strong>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- <div ng-if='config.addEditQuestion.type_of_prompt == \"TEXTAREA\"'>\n" +
    "			<label for='data_type'>Data Type</label>\n" +
    "			<select name='data_type'></select>\n" +
    "		</div> -->\n" +
    "\n" +
    "		<div ng-if='config.addEditQuestion.type_of_prompt == \"DROPDOWN\"'>\n" +
    "			<label for='options'>Options</label>\n" +
    "			<textarea name='options' ng-model='config.addEditQuestion.options' ng-change=\"turnOptionsIntoArray(config.addEditQuestion)\"></textarea>\n" +
    "		</div>\n" +
    "\n" +
    "		<div>\n" +
    "			<input type='checkbox' ng-model='config.addEditQuestion.is_active' name='is_active' />\n" +
    "			<span>Is Active</span>\n" +
    "			<br />\n" +
    "\n" +
    "			<input type='checkbox' ng-model='config.addEditQuestion.is_required' name='is_required' />\n" +
    "			<span>Is Required</span>\n" +
    "			<br />\n" +
    "\n" +
    "			<input type='checkbox' ng-model='config.addEditQuestion.show_in_profile' name='show_in_profile' />\n" +
    "			<span>Show In Profile</span>\n" +
    "			<br />\n" +
    "		</div>\n" +
    "\n" +
    "		<div style=\"margin-bottom: 12px;\">\n" +
    "			<div>Sample</div>\n" +
    "			<div ng-if='config.addEditQuestion.type_of_prompt == \"CHECKBOX\"'>\n" +
    "				<tr>\n" +
    "					<td>\n" +
    "						<input type='checkbox'/>\n" +
    "					</td>\n" +
    "					<td>\n" +
    "						<div markdown no-paragraph ng-model=\"config.addEditQuestion.prompt\"></div>\n" +
    "					</td>\n" +
    "				</tr>\n" +
    "			</div>\n" +
    "			<div ng-if='config.addEditQuestion.type_of_prompt == \"DROPDOWN\"'>\n" +
    "				<label>\n" +
    "					<span markdown no-paragraph ng-model=\"config.addEditQuestion.prompt\"></span>\n" +
    "				</label>\n" +
    "				<select>\n" +
    "					<option ng-repeat='option in editQuestionSampleData' value=\"{{option}}\">{{option}}</option>\n" +
    "				</select>\n" +
    "			</div>\n" +
    "			<div ng-if='config.addEditQuestion.type_of_prompt == \"TEXTAREA\"'>\n" +
    "				<label>\n" +
    "					<span markdown no-paragraph ng-model=\"config.addEditQuestion.prompt\"></span>\n" +
    "				</label>\n" +
    "				<textarea></textarea>\n" +
    "			</div>\n" +
    "			<div ng-if='config.addEditQuestion.type_of_prompt == \"TEXTBOX\"'>\n" +
    "				<label>\n" +
    "					<span markdown no-paragraph ng-model=\"config.addEditQuestion.prompt\"></span>\n" +
    "				</label>\n" +
    "				<input type='text'/>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<div class='save-button'>\n" +
    "			<div class='float-left error-container'>\n" +
    "				<div error-banner priority-level=0 class='float-left'></div>\n" +
    "			</div>\n" +
    "			<button type='submit' ng-disabled='config.saving' ng-click='saveQuestion(config.addEditQuestion)' aria-label=\"Save\">{{config.addEditQuestion.is_new == true ? \"Create\" : \"Save\"}}</button>\n" +
    "			<!-- <button class=\"secondary\" ng-click=\"closePopup(config.addEditQuestion)\">Add</button> -->\n" +
    "		</div>\n" +
    "	</form>\n" +
    "</div>");
}]);

angular.module("/scripts/evaluations/userEvaluation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/evaluations/userEvaluation.html",
    "<div class='question clearfix {{question.type_of_prompt}}' ng-repeat='question in siteEvaluation.site_evaluation_questions'>\n" +
    "  <label ng-if='question.type_of_prompt != \"CHECKBOX\" && question.type_of_prompt != \"HEADER\"' id=\"{{question.answer_column_name}}_label\" class='question-label' for='{{question.answer_column_name}}_input'><span markdown no-paragraph ng-model=\"question.prompt\"></span></label>\n" +
    "  <div ng-if='question.type_of_prompt === \"HEADER\"' class=\"section-label\" markdown-div no-paragraph ng-model=\"question.prompt\"></div>\n" +
    "\n" +
    "  <!-- Required -->\n" +
    "  <div ng-if='question.is_required' class='question-question'>\n" +
    "    <table ng-if='question.type_of_prompt == \"CHECKBOX\"'>\n" +
    "      <tr>\n" +
    "        <td class=\"col-checkbox\">\n" +
    "          <div hes-checkbox aria-describedBy=\"{{question.answer_column_name}}_label\" id=\"{{question.answer_column_name}}_check\" name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]' hes-required class='hes-checkbox margin-10-right inline' label-name='{{question.answer_column_name}}_label' type='checkbox' ng-true-value=\"{{question.data_type === 'string' ? 'Y' : 1}}\" ng-false-value=\"0\"></div>\n" +
    "        </td>\n" +
    "        <td class=\"col-checkbox-label\">\n" +
    "          <div>\n" +
    "            <div ng-if='question.type_of_prompt == \"CHECKBOX\"' id=\"{{question.answer_column_name}}_label\" name='{{question.answer_column_name}}_label' class='checkbox-label question-label' markdown no-paragraph ng-model=\"question.prompt\"></div>\n" +
    "          </div>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "    </table>\n" +
    "    <select class=\"\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"DROPDOWN\"' hes-required id=\"{{question.answer_column_name}}_input\" name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]'>\n" +
    "      <option value=''>Choose…</option>\n" +
    "      <option ng-repeat='option in question.options_array' value=\"{{option}}\">{{option}}</option>\n" +
    "    </select>\n" +
    "    <textarea id=\"{{question.answer_column_name}}_input\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"TEXTAREA\"' hes-required name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]'/></textarea>\n" +
    "    <input id=\"{{question.answer_column_name}}_input\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"TEXTBOX\"' hes-required name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]' />\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- Not Required -->\n" +
    "  <div ng-if='!question.is_required' class='question-question'>\n" +
    "    <table ng-if='question.type_of_prompt == \"CHECKBOX\"'>\n" +
    "      <tr>\n" +
    "        <td class=\"col-checkbox\">\n" +
    "          <div hes-checkbox aria-describedBy=\"{{question.answer_column_name}}_label\" type=\"checkbox\" id=\"{{question.answer_column_name}}_check\" name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]' class='hes-checkbox margin-10-right inline' label-name='{{question.answer_column_name}}_label' ng-true-value=\"{{question.data_type === 'string' ? 'Y' : 1}}\" ng-false-value=\"{{question.data_type === 'string' ? 'N' : 0}}\"></div>\n" +
    "        </td>\n" +
    "        <td class=\"col-checkbox-label\">\n" +
    "          <div>\n" +
    "            <div ng-if='question.type_of_prompt == \"CHECKBOX\"' id=\"{{question.answer_column_name}}_label\" name='{{question.answer_column_name}}_label' class='checkbox-label question-label' markdown no-paragraph ng-model=\"question.prompt\"></div>\n" +
    "          </div>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "    </table>\n" +
    "    <select class=\"\" ng-if='question.type_of_prompt == \"DROPDOWN\"' aria-describedBy=\"{{question.answer_column_name}}_label\" id=\"{{question.answer_column_name}}\" name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]'>\n" +
    "      <option value=''>Choose…</option>\n" +
    "      <option ng-repeat='option in question.options_array' value=\"{{option}}\">{{option}}</option>\n" +
    "    </select>\n" +
    "    <textarea ng-if='question.type_of_prompt == \"TEXTAREA\"' aria-describedBy=\"{{question.answer_column_name}}_label\" name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]'/></textarea>\n" +
    "    <input ng-if='question.type_of_prompt == \"TEXTBOX\"' aria-describedBy=\"{{question.answer_column_name}}_label\" name='{{question.answer_column_name}}_input' ng-model='evaluation[question.answer_column_name]' />\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/faqs/faqs.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/faqs/faqs.html",
    "<div class='faqs'>\n" +
    "  <div class=\"center\">\n" +
    "    <div hes-loading-gif loading='faqsConfig.loading'></div>\n" +
    "  </div>\n" +
    "\n" +
    "	<!-- <div class='faqs-index'>\n" +
    "		<div ng-repeat='item in faqs' ng-if=\"showFaq(item.key) && !faqsConfig.loading\">\n" +
    "			<a ng-click='goToItem(item.id)' ng-bind-html='item.title_html'></a>\n" +
    "		</div>\n" +
    "	</div> -->\n" +
    "\n" +
    "	<div class='faq' ng-repeat='item in faqs | orderBy: \"sequence\"' ng-if=\"showFaq(item.key) && !faqsConfig.loading\">\n" +
    "		<div id='faq_{{item.id}}' class='faq-title' ng-bind-html='item.title_html' hes-external-links></div>\n" +
    "		<div class='faq-content' ng-bind-html='item.content_html' hes-external-links></div>\n" +
    "\n" +
    "		<!-- <div>\n" +
    "			<a ng-click='backToTop()'>Back to top</a>\n" +
    "		</div> -->\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if='faqs.length === 0 && !faqsConfig.loading'>No FAQs.</div>\n" +
    "</div>");
}]);

angular.module("/scripts/feedback/feedback.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/feedback/feedback.html",
    "<div class='tile'>  \n" +
    "  <div class='frame page-form'>\n" +
    "    <span>\n" +
    "        <form name=\"feedback_form\" ng-submit='submitFeedback()'>\n" +
    "            <div>\n" +
    "              <p ng-bind-html=\"explanations.feedback_form.content\"></p>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- <div class='font-sm font-bold font-green'>Full name</div> -->\n" +
    "            <input type='text' required placeholder='Full name' ng-disabled=\"feedbackSent\" ng-model='feedbackUser.full_name' ng-class=\"{'invalid-field': firstNameRequired}\" />\n" +
    "            \n" +
    "            <!-- <div class='font-sm font-bold font-green'>Email</div> -->\n" +
    "            <input type='text' required placeholder='Email' ng-disabled=\"feedbackSent\" ng-model='feedbackUser.email' ng-class=\"{'invalid-field': emailRequired}\" />\n" +
    "            \n" +
    "            <!-- <div class='font-sm font-bold font-green'>Feedback</div> -->\n" +
    "            <textarea rows=\"5\" required placeholder='Feedback' ng-disabled=\"feedbackSent\" ng-model='feedback.feedback' ng-class=\"{'invalid-textarea': commentsRequired}\"></textarea><br />\n" +
    "\n" +
    "\n" +
    "            <button type='submit' ng-disabled='sendingFeedback || feedbackSent || !feedback_form.$valid'>Submit</button>\n" +
    "            <div ng-if=\"sendingFeedback\">Sending...</div>\n" +
    "            \n" +
    "            <div class='feedback-sent' ng-show='feedbackSent'>\n" +
    "                <p compile=\"explanations.feedback_sent.content\"></p>\n" +
    "            </div>\n" +
    "            \n" +
    "        </form>\n" +
    "    </span>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/footer/footer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/footer/footer.html",
    "<div>\n" +
    "    <div ng-if=\"!is_menu\" class='footer-wrapper'>\n" +
    "        <span class='links'>\n" +
    "            <ul>\n" +
    "                <li ng-repeat='link in footerLinks | filter : {hidden: false}'>\n" +
    "                  <a ng-if='link.linkPath' ui-sref=\"{{link.linkPath}}\" ng-bind-html='link.linkText'></a>\n" +
    "                  <a ng-if='link.linkMethod' href=\"#\" class=\"visited\"  ng-bind-html='link.linkText' ng-click='this[link.linkMethod]()' tabindex=\"0\" ng-keydown=\"ariaClick($event)\"></a>\n" +
    "                </li>\n" +
    "                <li ng-show=\"isCountdownPage()\">\n" +
    "                  <a ng-click='pilotPassword()' tabindex=\"0\" ng-keydown=\"ariaClick($event)\" aria-label=\"Pilot password\">Pilot Password</a>\n" +
    "                </li>\n" +
    "                <li ng-if=\"site.flags.show_high_contrast_link\">\n" +
    "                  <a high-contrast-toggle></a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </span>\n" +
    "\n" +
    "        <span class=\"copyright font-gray\" ng-show=\"!site.flags.white_label\">&copy; {{year}} Health Enhancement Systems</span>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "    <div ng-if=\"is_menu\" class=\"overflow-hidden\">\n" +
    "        <span class='links'>\n" +
    "            <ul>\n" +
    "                <li ng-repeat='link in footerLinks | filter : {hidden: false}'>\n" +
    "                  <a ng-if='link.linkPath' ui-sref=\"{{link.linkPath}}\" ng-bind-html='link.linkText'></a>\n" +
    "                  <a ng-if='link.linkMethod' href=\"#\" class=\"visited\" ng-bind-html='link.linkText' ng-click='this[link.linkMethod]()' tabindex=\"0\" ng-keydown=\"ariaClick($event)\"></a>\n" +
    "                </li>\n" +
    "                <li ng-if=\"site.flags.show_high_contrast_link\">\n" +
    "                    <a high-contrast-toggle></a>\n" +
    "                  </li>\n" +
    "            </ul>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/footer/footer_acme.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/footer/footer_acme.html",
    "<button class=\"btn btn-default pull-right\" ng-click=\"showAnvil=!showAnvil\">Anvil Drop</button>\n" +
    "<span class=\"anvil\" hes-slide-down=\"showAnvil\"></span>\n" +
    "<div class=\"header-banner\" ng-init=\"showAnvil=false\">\n" +
    "	<div class=\"header-container\">\n" +
    "		<span class=\"app-image\">\n" +
    "			<span>Application Image</span>\n" +
    "		</span>\n" +
    "		<div class=\"go-menu\">\n" +
    "			\n" +
    "			<span class=\"dropdown\">\n" +
    "				<a href class=\"dropdown-toggle\">Home</a>\n" +
    "				<ul class='dropdown-menu'>\n" +
    "					<li><a>Item1</a></li>\n" +
    "					<li><a>Item2</a></li>\n" +
    "					<li><a>Item3</a></li>\n" +
    "					<li><a>Item4</a></li>\n" +
    "				</ul>\n" +
    "			</span>\n" +
    "			<span class=\"dropdown\">\n" +
    "				<a href class=\"dropdown-toggle\">Profile</a>\n" +
    "				<ul class='dropdown-menu'>\n" +
    "					<li><a>Item1</a></li>\n" +
    "					<li><a>Item2</a></li>\n" +
    "					<li><a>Item3</a></li>\n" +
    "					<li><a>Item4</a></li>\n" +
    "				</ul>\n" +
    "			</span>\n" +
    "			<span class=\"dropdown\">\n" +
    "				<a href class=\"dropdown-toggle\">Community</a>\n" +
    "				<ul class='dropdown-menu'>\n" +
    "					<li><a>Item1</a></li>\n" +
    "					<li><a>Item2</a></li>\n" +
    "					<li><a>Item3</a></li>\n" +
    "					<li><a>Item4</a></li>\n" +
    "				</ul>\n" +
    "			</span>\n" +
    "			<span class=\"dropdown\">\n" +
    "				<a href class=\"dropdown-toggle\">Resources</a>\n" +
    "				<ul class='dropdown-menu'>\n" +
    "					<li><a>Item1</a></li>\n" +
    "					<li><a>Item2</a></li>\n" +
    "					<li><a>Item3</a></li>\n" +
    "					<li><a>Item4</a></li>\n" +
    "				</ul>\n" +
    "			</span>\n" +
    "		</div>\n" +
    "		<div class=\"user-actions\">\n" +
    "			<span href=''>Hello User!</span>\n" +
    "			<div class=\"actions\">\n" +
    "				<span class=\"email-icon\">Email</span>\n" +
    "				<span class=\"settings-icon\">Settings</span>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<span class=\"promo-image\">Promo Image</span>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/footer/mobile-overlay.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/footer/mobile-overlay.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div class='mobile-overlay'>\n" +
    "  <div class=\"xs mobile-overlay__logo\">\n" +
    "    <img alt=\"\" hes-image=\"{{setup.content.mobile_overlay.image2.url}}\"></img>\n" +
    "  </div>\n" +
    "  <div class='inline mobile-img sm md'>\n" +
    "    <img alt=\"\" hes-image='{{setup.content.mobile_overlay.image1.url}}' no-theme use-domain=\"true\"></img>\n" +
    "  </div>\n" +
    "  <div class='mobile-overlay__logo xs'>\n" +
    "      <img alt=\"\" hes-image='{{setup.content.mobile_overlay.image1.url}}' no-theme use-domain=\"true\"></img>\n" +
    "    </div>\n" +
    "  <div class='inline mobile-info'>\n" +
    "    <img alt=\"\" hes-image=\"{{setup.content.mobile_overlay.image2.url}}\" class=\"sm md\"></img>\n" +
    "    <div>\n" +
    "      <span ng-bind-html='setup.content.mobile_overlay.content_html'></span>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "      <a tabindex=\"0\" ng-href='{{setup.content.android_app_link.title}}' aria-label=\"Download from Google Play\" target='_blank'>\n" +
    "        <img alt=\"\" hes-image='{{setup.content.android_app_link.image1.url}}' no-theme use-domain=\"true\"></img>\n" +
    "      </a>\n" +
    "      <a tabindex=\"0\" ng-href='{{setup.content.ios_app_link.title}}' aria-label=\"Download from AppStore\" target='_blank'>\n" +
    "        <img alt=\"\" hes-image='{{setup.content.ios_app_link.image1.url}}' no-theme use-domain=\"true\"></img>\n" +
    "      </a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/friendships/_pager.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/friendships/_pager.template.html",
    "<div ng-if=\"pager && search.query == ''\" flex layout=\"row\" layout-align=\"space-between center\">\n" +
    "  <div>\n" +
    "    <div ng-if=\"!status.loading\">Page {{ pager.current_page }} of {{ pager.total_pages }}</div>\n" +
    "    <div ng-if=\"status.loading\">Loading page {{ status.loading_page }}</div>\n" +
    "  </div>\n" +
    "  \n" +
    "  <div ng-if=\"!status.loading\">\n" +
    "    <button class=\"secondary\" ng-if=\"pager.current_page > 1\" ng-click=\"pager.previousPage(pager.current_page-1)\">Previous Page</button>\n" +
    "    <button class=\"secondary\" ng-if=\"pager.current_page != pager.total_pages\"  ng-click=\"pager.nextPage(pager.current_page)\">Next Page</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/friendships/friends-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/friendships/friends-list.html",
    "<div class='friends'>\n" +
    "	<div class='search'>\n" +
    "		<div class='search-title'>Add {{ site.friend_label_plural }}</div>\n" +
    "		<input type='text' ng-model='search.query' placeholder=\"Invite by email or name\" ng-change='search.handlers.change(search.query)' />\n" +
    "		<button type=\"button\" ng-if=\"!!search.query\" class=\"link-look clear-btn\" ng-click=\"search.actions.clearSearch()\">Clear</button>\n" +
    "		<button class=\"icon-btn search-icon\" aria-label=\"Start searching\">\n" +
    "		  <span hes-icon icon-name=\"standard:search\"></span>\n" +
    "		</button>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Search Results -->\n" +
    "	<div ng-if='!search.status.loading'>\n" +
    "		<div ng-repeat=\"user in search.result.allSorted\">\n" +
    "			<div ng-if=\"!!user.relationsStatus\">\n" +
    "				<div hes-friendship friendship=\"user.relationsStatus.friendship\"></div>\n" +
    "			</div>\n" +
    "			<div ng-if=\"!user.relationsStatus\">\n" +
    "				<div hes-friendship friendship=\"user\"></div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-show='search.status.directEmailInvite'>\n" +
    "		<div>This person does not have an account yet. Do you want to invite {{ search.query }} to join <em>{{ site.name }}</em> and be your {{ site.getFriendsLabel() }}?</div>\n" +
    "		<br />\n" +
    "		<div class=\"text-right\">\n" +
    "		    <button ng-click=\"inviteByEmail(search.query)\" ng-show=\"!search.status.directEmailInvite.invited\">Invite</button>\n" +
    "		    <button ng-show=\"search.status.directEmailInvite.invited\" disabled=\"true\">Already Invited</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div ng-if='!search.status.loading && !!search.query && search.status.active && search.result.allSorted.length == 0 && !search.status.directEmailInvite'>\n" +
    "		<span>No results found.</span>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if='search.status.loading'>\n" +
    "		<div ng-repeat=\"i in [1, 2, 3]\">\n" +
    "			<div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/friendships/friendship-placeholder.html')\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- End Search Results -->\n" +
    "\n" +
    "	<div class=\"friends-divider\"></div>\n" +
    "\n" +
    "	<!-- Me -->\n" +
    "	<div ng-if='!status.loading' class='friends-me' layout=\"row\" layout-wrap>\n" +
    "		<div flex='100' flex-gt-sm='45'>\n" +
    "			<img alt=\"\" class='md-img' hes-image=\"{{ user.profile.image.url }}\" />\n" +
    "			<div class='name-location-block'>\n" +
    "				<div class='name-location'>\n" +
    "					<div class='name'>{{ user.profile.full_name }}</div>\n" +
    "					<div class='location' ng-if=\"site.flags.is_location_displayed\">{{ user.location.name }}</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"friends__stats\">\n" +
    "			<div ng-if=\"site.flags.is_logging_enabled\">\n" +
    "				<img alt=\"\" class='sm-img' hes-image=\"/stats/steps-icon.svg\" />\n" +
    "				<div class='friend-stats me'>\n" +
    "					<div class=\"steps-count steps-color\">{{ user.stats.total_steps | numberFormatter }}</div>\n" +
    "					<div class=\"font-semi-bold\">Steps in {{ site.years[0] }}</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<div>\n" +
    "				<img alt=\"\" class='sm-img' hes-image=\"/stats/challenges-icon.svg\" />\n" +
    "				<div class='friend-stats me'>\n" +
    "					<div class=\"challenges-count challenges-color\">{{ user.stats.total_completed_challenges }}</div>\n" +
    "					<div class=\"font-semi-bold\">Successful Challenges</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<!-- End Me -->\n" +
    "\n" +
    "	<div ng-include=\"'/scripts/friendships/_pager.template.html'\"></div>\n" +
    "	\n" +
    "	<div ng-if='!status.loading' ng-repeat=\"friend in data.friends | orderBy: filter.value\">\n" +
    "		<div hes-friendship friendship=\"friend\"></div>\n" +
    "	</div>\n" +
    "	\n" +
    "	</br></br>\n" +
    "\n" +
    "	<div ng-if=\"!status.loading\" ng-include=\"'/scripts/friendships/_pager.template.html'\"></div>\n" +
    "\n" +
    "	<div ng-if='status.loading'>\n" +
    "		<div ng-repeat=\"i in [1, 2, 3]\">\n" +
    "			<div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/friendships/friendship-placeholder.html')\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/friendships/friends-pending.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/friendships/friends-pending.html",
    "<div class='friends'>\n" +
    "	<!-- Received -->\n" +
    "	<div ng-if=\"data.incomingRequests.length > 0\">\n" +
    "		<div class=\"title first-title\">Incoming Requests</div>\n" +
    "		<div ng-repeat=\"request in data.incomingRequests\">\n" +
    "			<div hes-friendship friendship=\"request\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Sent -->\n" +
    "	<div ng-if=\"data.invitedEmails.length > 0 || data.sentRequests.length > 0\">\n" +
    "		<div class=\"title\" ng-class=\"{'first-title': data.incomingRequests.length == 0}\">Outgoing Requests</div>\n" +
    "		<div ng-repeat=\"request in data.sentRequests\">\n" +
    "			<div hes-friendship friendship=\"request\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- No Pending -->\n" +
    "	<div ng-if=\"data.incomingRequests.length == 0 && data.sentRequests.length == 0 && data.invitedEmails.length == 0 && !status.loading\">\n" +
    "		<div class='font-md' ng-bind-html=\"explanations.peers_no_pending.content\"></div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Loading Friendships -->\n" +
    "	<div ng-if=\"status.loading\">\n" +
    "		<div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/friendships/friendship-placeholder.html')\"></div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/friendships/friends-search.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/friendships/friends-search.html",
    "<div class='friends'>\n" +
    "	<div class='search'>\n" +
    "		<div class='search-title'>Invite by Name or Email</div>\n" +
    "		<!-- <hes-search-input on-search=\"search.handlers.change(search.query)\" \n" +
    "		  search-value=\"data.query\"\n" +
    "		  placeholder-text=\"Type to start searching...\"></hes-search-input> -->\n" +
    "		<input type='text' ng-model='search.query' placeholder=\"Search My {{ site.friend_label_plural }}...\" ng-change='search.handlers.change(search.query)' />\n" +
    "		<button type=\"button\" ng-if=\"!!search.query\" class=\"link-look clear-btn\" ng-click=\"search.actions.clearSearch()\">Clear</button>\n" +
    "		<button class=\"icon-btn search-icon\" aria-label=\"Start searching\">\n" +
    "		  <span hes-icon icon-name=\"standard:search\"></span>\n" +
    "		</button>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if='!search.status.loading'>\n" +
    "		<div ng-repeat=\"user in search.result.allSorted\">\n" +
    "			<div ng-if=\"!!user.relationsStatus\">\n" +
    "				<div hes-friendship friendship=\"user.relationsStatus.friendship\"></div>\n" +
    "			</div>\n" +
    "			<div ng-if=\"!user.relationsStatus\">\n" +
    "				<div hes-friendship friendship=\"user\"></div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-show='search.status.directEmailInvite'>\n" +
    "		<div>This person does not have an account yet. Want to invite {{ search.query }} to join <em>{{ site.name }}</em> and be your {{ site.getFriendsLabel() }}?</div>\n" +
    "		<br />\n" +
    "		<div class=\"text-right\">\n" +
    "		    <button ng-click=\"inviteByEmail(search.query)\" ng-show=\"!search.status.directEmailInvite.invited\">Invite</button>\n" +
    "		    <button ng-show=\"search.status.directEmailInvite.invited\" disabled=\"true\">Already Invited</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if='!search.status.loading && search.status.active && search.result.allSorted.length == 0 && !search.status.directEmailInvite'>\n" +
    "		<span>No results found.</span>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if='search.status.loading'>\n" +
    "		<div ng-repeat=\"i in [1, 2, 3]\">\n" +
    "			<div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/friendships/friendship-placeholder.html')\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/friendships/friendship-placeholder.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/friendships/friendship-placeholder.html",
    "<div class=\"friendship-placeholder\" ng-class=\"{'with-location' : site.flags.is_location_displayed}\">\n" +
    "	<div class=\"base\">\n" +
    "		<div class=\"right-of-img\"></div>\n" +
    "		<div class=\"above-text\"></div>\n" +
    "		<div class=\"right-of-text\"></div>\n" +
    "		<div class=\"right-of-text2\"></div>\n" +
    "		<div class=\"below-text\"></div>\n" +
    "		<div class=\"right-of-location\"></div>\n" +
    "		<div class=\"below-location\"></div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/friendships/friendship.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/friendships/friendship.html",
    "<!-- Friendship Row -->\n" +
    "<div class='friendship headline' layout=\"row\" layout-wrap ng-if='friendship.friendee_id'>\n" +
    "	<div flex='100' flex-gt-sm='35' class='friendship-left'>\n" +
    "		<img alt=\"\" class='md-img' hes-image=\"{{ friendship.friendee.profile.image.url }}\" />\n" +
    "		<div class='name-location-block'>\n" +
    "			<div class='name-location'>\n" +
    "				<div class='name'>{{ friendship.friendee.profile.full_name }}</div>\n" +
    "				<div class='location' ng-if=\"site.flags.is_location_displayed\">{{ friendship.friendee.location.name }}</div>\n" +
    "			</div>\n" +
    "			<div class=\"friend-actions\" ng-if='onFriendsList()'>\n" +
    "				<a role=\"button\" ng-click=\"sendEmail(friendship.friendee)\" aria-label=\"Send email to {{ friendship.friendee.profile.full_name }}\" tabindex=\"0\">Email</a>\n" +
    "				<a role=\"button\" aria-label=\"Remove {{ friendship.friendee.profile.full_name }} as a friend\" ng-click='removeFriend(friendship)' tabindex=\"0\">Remove {{ site.getFriendsLabel() }}</a>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	\n" +
    "	<div flex='100' flex-gt-sm='65' class='friendship-right'>\n" +
    "\n" +
    "		<!-- Already Friends -->\n" +
    "		<div ng-if=\"alreadyFriends() && !onFriendsList()\" class='float-right pending'>\n" +
    "			<span class='font-italic'>Already {{ site.friend_label_plural }}</span>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Has Incoming Request -->\n" +
    "		<div ng-if=\"isPendingIncoming()\" class='pending float-right hide-on-mobile'>\n" +
    "			<span class='font-italic'>Request received {{ friendship.updated_at | date:'EEE, MMM d' }}</span>\n" +
    "			<button aria-label=\"Decline {{ friendship.friendee.profile.full_name }}'s request\" class='link-look' ng-click=\"declineRequest(friendship)\">Decline</button>\n" +
    "			<button aria-label=\"Accept {{ friendship.friendee.profile.full_name }}'s request\" ng-click=\"acceptRequest(friendship)\">Accept</button>\n" +
    "		</div>\n" +
    "		<div ng-if=\"isPendingIncoming()\" class='mobile-only pending-mobile'>\n" +
    "			<div class='font-italic request-info' style='font-size:14px;'>Request received {{ friendship.updated_at | date:'EEE, MMM d' }}</div>\n" +
    "			<button aria-label=\"Decline {{ friendship.friendee.profile.full_name }}'s request\" class='link-look decline-btn' ng-click=\"declineRequest(friendship)\">Decline</button>\n" +
    "			<button aria-label=\"Accept {{ friendship.friendee.profile.full_name }}'s request\" class='accept-btn' ng-click=\"acceptRequest(friendship)\">Accept</button>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Has Outgoing Request -->\n" +
    "		<div ng-if=\"isPendingOutgoing()\" class='pending float-right hide-on-mobile'>\n" +
    "			<span class='font-italic'>Request sent {{ friendship.updated_at | date:'EEE, MMM d' }}</span>\n" +
    "			<button aria-label='Remove request' class='link-look' ng-click=\"removeRequest(friendship)\">Remove</button>\n" +
    "			<button ng-hide='friendship.resent' aria-label='Resend request to {{ friendship.friendee.profile.full_name }}' class='link-look' ng-click=\"resendRequest(friendship)\">Resend</button>\n" +
    "			<div class='sent-label' ng-show='friendship.resent'>Sent!</div>\n" +
    "		</div>\n" +
    "		<div ng-if=\"isPendingOutgoing()\" class='mobile-only pending-mobile'>\n" +
    "			<div class='font-italic request-info'>Request sent {{ friendship.updated_at | date:'EEE, MMM d' }}</div>\n" +
    "			<button aria-label='remove request' class='link-look remove-btn' ng-click=\"removeRequest(friendship)\">Remove</button>\n" +
    "			<button ng-hide='friendship.resent' aria-label='Resend request to {{ friendship.friendee.profile.full_name }}' class='link-look resend-btn' ng-click=\"resendRequest(friendship)\">Resend</button>\n" +
    "			<div class='sent-label resend-btn' ng-show='friendship.resent'>Sent!</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Non Search Friendship -->\n" +
    "		<div ng-if=\"alreadyFriends() && onFriendsList()\" class='friend-right'>\n" +
    "			<div class='float-left'>\n" +
    "				<div class='friend-stats' ng-if=\"site.flags.is_logging_enabled\">\n" +
    "					<div class=\"steps-count\">{{ friendship.friendee.total_steps | numberFormatter }}</div>\n" +
    "					<div class=\"font-semi-bold\">Steps</div>\n" +
    "				</div>\n" +
    "				<div class=\"friend-actions\" ng-if='onFriendsList()'>\n" +
    "					<a role=\"button\" ng-click=\"sendEmail(friendship.friendee)\" aria-label=\"Email\">Email</a>\n" +
    "					<a role=\"button\" aria-label=\"Remove {{ site.getFriendsLabel() }}\" ng-click='removeFriend(friendship)'>Remove {{ site.getFriendsLabel() }}</a>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<div class='float-right'>\n" +
    "				<div class='friend-stats'>\n" +
    "					<div class=\"challenges-count\">{{ friendship.friendee.total_completed_challenges }}</div>\n" +
    "					<div class=\"font-semi-bold\">Successful Challenges</div>\n" +
    "				</div>\n" +
    "				<div class=\"friend-actions\">\n" +
    "					<a role=\"button\" aria-label=\"Send a Challenge to {{ friendship.friendee.profile.full_name }}\" ng-click=\"sendChallenge(friendship.friendee)\" tabindex=\"0\">Send a Challenge</a>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Search Result / No Friendship created -->\n" +
    "<div class='friendship headline' layout=\"row\" layout-wrap ng-if='!friendship.friendee_id'>\n" +
    "	<div flex='100' flex-gt-sm='35' class='friendship-left'>\n" +
    "		<img ng-if=\"!friendship.friend_email\" alt=\"\" class='md-img' hes-image=\"{{ friendship.profile.image.url }}\" />\n" +
    "		<div class='name-location-block'>\n" +
    "			<div class='name-location' ng-if=\"!friendship.friend_email\">\n" +
    "				<div class='name'>{{ friendship.profile.full_name }}</div>\n" +
    "				<div class='location' ng-if=\"site.flags.is_location_displayed\">{{ friendship.location.name }}</div>\n" +
    "			</div>\n" +
    "			<div class='name-location' ng-if=\"friendship.friend_email\">\n" +
    "				<div class='name'>{{ friendship.friend_email }}</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	\n" +
    "	<div flex='100' flex-gt-sm='65' class='friendship-right padding-10-bottom' ng-if='!friendship.friend_email'>\n" +
    "		<button aria-label='send request to {{ friendship.profile.full_name }}' class='float-right wide-button' ng-click=\"sendRequest(friendship)\">Send {{ site.friend_label }} Request</button>\n" +
    "	</div>\n" +
    "\n" +
    "	<div flex='100' flex-gt-sm='65' class='friendship-right' ng-if='friendship.friend_email'>\n" +
    "		<div class='pending float-right hide-on-mobile'>\n" +
    "			<span class='font-italic'>Request sent {{ friendship.updated_at | date:'EEE, MMM d' }}</span>\n" +
    "			<button aria-label='remove request' class='link-look' ng-click=\"removeRequest(friendship)\">Remove</button>\n" +
    "			<button ng-hide='friendship.resent' aria-label='resend request to {{ friendship.profile.full_name }}' class='link-look' ng-click=\"resendRequest(friendship)\">Resend</button>\n" +
    "			<div class='sent-label' ng-show='friendship.resent'>Sent!</div>\n" +
    "		</div>\n" +
    "		<div class='pending center mobile-only'>\n" +
    "			<div class='font-italic'>Request sent {{ friendship.updated_at | date:'EEE, MMM d' }}</div>\n" +
    "			<button aria-label='remove request' class='link-look' ng-click=\"removeRequest(friendship)\">Remove</button>\n" +
    "			<button ng-hide='friendship.resent' aria-label='resend request to {{ friendship.profile.full_name }}' class='link-look' ng-click=\"resendRequest(friendship)\">Resend</button>\n" +
    "			<div class='sent-label' ng-show='friendship.resent'>Sent!</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/galleries/image_gallery.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/galleries/image_gallery.html",
    "<div class='image-gallery' ng-class=\"{'upload-only': uploadOnly}\">\n" +
    "	<!-- <a ng-click=\"uploadOnly = !uploadOnly\">Toggle Gallery</a> -->\n" +
    "	<div class='gallery-left'>\n" +
    "		<!-- Image Upload -->\n" +
    "		<div class=\"upload_div\">\n" +
    "			<span hes-file-upload start='uploadPhotoStart' complete='uploadPhotoFinished' ng-model='upload_file.photo' label='Choose File' label-class='upload-button wall' class='drag-here' use-url=\"{{options.uploadUrl}}\" no-resize='true' allow-drop=\"true\" allow-any-type allow-any-size></span>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Gallery Options -->\n" +
    "		<div class='gallery_options' ng-if=\"!uploadOnly\">\n" +
    "			<!-- Directories -->\n" +
    "			<div ng-show='!hide_directories' class='gallery_nav'>\n" +
    "				<div class='gallery-name'>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Search Bar -->\n" +
    "			<div ng-show='!hide_search' class='gallery_search'>\n" +
    "				<span><strong>Search:</strong></span>\n" +
    "				<input ng-model='setup.search_term' type='text' />\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Toggles -->\n" +
    "			<div>\n" +
    "				<input id='hidden_files' name='hidden_files' type='checkbox' />\n" +
    "				<label for='hidden_files'>Show hidden files</label>\n" +
    "			</div>\n" +
    "			<div>\n" +
    "				<input id='deleted_files' name='deleted_files' type='checkbox' ng-model='show_deleted_files' />\n" +
    "				<label for='deleted_files'>Show deleted files</label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div class='vertical_divider' ng-hide=\"no_upload || uploadOnly\"></div>\n" +
    "	<div class='gallery_selection' ng-if=\"!uploadOnly\">\n" +
    "\n" +
    "		<!-- Loading Gif -->\n" +
    "		<div class='center' ng-show='loading_gallery'>\n" +
    "			<div hes-loading-gif loading='loading_gallery'></div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Breadcrumbs -->\n" +
    "		<div class='breadcrumbs'>\n" +
    "			<span ng-class=\"{'bold': current_path.length == 0}\">\n" +
    "				<span ng-if='current_path.length == 0'>&rang; galleries</span>\n" +
    "				<span ng-if='current_path.length != 0'>&rang; <a ng-click='backFolder(\"galleries\")'>galleries</a></span>\n" +
    "			</span>\n" +
    "			<span ng-class=\"{'bold': $last}\" ng-if=\"current_path.length > 0\" ng-repeat=\"path in current_path\">\n" +
    "				<span ng-if='$last'> &rang; {{path}}</span>\n" +
    "				<span ng-if='!$last'> &rang; <a ng-click='backFolder(path)'>{{path}}</a></span>\n" +
    "			</span>\n" +
    "		</div>\n" +
    "\n" +
    "		<div class='gallery_list' ng-hide='loading_gallery'>\n" +
    "\n" +
    "			<!-- Deleted Files -->\n" +
    "			<fieldset ng-show='!selected_photo && !selected_deleted_photo && show_deleted_files'>\n" +
    "				<legend>Deleted Files</legend>\n" +
    "				<div ng-show='!selected_photo' ng-repeat='image in gallery.deleted_files | filter:setup.search_term'>\n" +
    "					<img alt=\"\" ng-if=\"isImage(getImageURL(image.http_path))\" class='image-result {{image_result_size}}' ng-class='{\"svg\" : isSVG(image.http_path)}' ng-src=\"{{getImageURL(image.http_path)}}\" ng-click=\"selectDeletedPhoto(image)\" />\n" +
    "					<span ng-if=\"!isImage(getImageURL(image.http_path))\" class='image-result {{image_result_size}} video' ng-click=\"selectPhoto(image)\">{{ fileNameWithoutPath(getImageURL(image.http_path)) }}</span>\n" +
    "				</div>\n" +
    "			</fieldset>\n" +
    "\n" +
    "			<!-- Folders in Gallery -->\n" +
    "			<div ng-show='!selected_photo && !selected_deleted_photo' ng-repeat='folder in gallery.folders | filter:setup.search_term'>\n" +
    "				<div class='folder-result {{image_result_size}}' ng-click=\"getFolder(folder.name)\">\n" +
    "					<img alt=\"\" class='image-result {{image_result_size}}' hes-image=\"/gallery/folder.png\" />\n" +
    "					<div class='center'>\n" +
    "						<span class='folder-name'>{{folder.name}}</span>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Images in Gallery -->\n" +
    "			<div ng-show='!selected_photo && !selected_deleted_photo' ng-repeat='image in gallery.files | filter:setup.search_term'>\n" +
    "				<img alt=\"\" ng-if=\"isImage(getImageURL(image.http_path))\" class='image-result {{image_result_size}}' ng-class='{\"svg\" : isSVG(image.http_path)}' ng-src=\"{{getImageURL(image.http_path)}}\" ng-click=\"selectPhoto(image)\" />\n" +
    "				<span ng-if=\"!isImage(getImageURL(image.http_path))\" class='image-result {{image_result_size}} video' ng-click=\"selectPhoto(image)\">{{ fileNameWithoutPath(getImageURL(image.http_path)) }}</span>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Hidden Images in Gallery -->\n" +
    "			<div ng-show='!selected_photo' ng-repeat='image in gallery.hidden_files | filter:setup.search_term'>\n" +
    "				<img alt=\"\" class='image-result {{image_result_size}}' ng-src=\"{{getImageURL(image.http_path)}}\" ng-click=\"selectPhoto(image)\" />\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Selected Photo -->\n" +
    "			<div ng-show=\"selected_photo\" class='center'>\n" +
    "				<div class='center'>\n" +
    "					<img alt=\"\" class='selected-photo' ng-src=\"{{getImageURL(selected_photo.http_path)}}\" />\n" +
    "				</div>\n" +
    "				<div ng-show=\"!hide_image_name\" class='photo-name center'>{{selected_photo.name}}</div>\n" +
    "				<div ng-hide='prompt_remove'>\n" +
    "					<!-- <span>{{label}} </span> -->\n" +
    "					<button ng-if=\"allow_remove\" class='secondary remove-button' ng-click=\"promptRemove()\">Delete from gallery</button>\n" +
    "					<button class=\"cancel\" ng-click=\"deselectPhoto()\">Select another</button>\n" +
    "					<button ng-click=\"confirm(selected_photo)\">Use</button>\n" +
    "				</div>\n" +
    "				<div ng-show='prompt_remove'>\n" +
    "					<span>Are you sure you want to remove this? </span>\n" +
    "					<button ng-click=\"confirmRemove(selected_photo)\">Yes</button>\n" +
    "					<button ng-click=\"deselectRemove()\">No</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Selected Deleted Photo -->\n" +
    "			<div ng-show=\"selected_deleted_photo\" class='center'>\n" +
    "				<div class='center'>\n" +
    "					<img alt=\"\" class='selected-photo' ng-src=\"{{getImageURL(selected_deleted_photo.http_path)}}\" />\n" +
    "				</div>\n" +
    "				<div class='photo-name center'>{{selected_deleted_photo.name}}</div>\n" +
    "				<div>\n" +
    "					<button ng-click=\"unDelete(selected_deleted_photo)\">Un-Delete</button>\n" +
    "					<button ng-click=\"deselectDeletedPhoto()\">Cancel</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/galleries/image_gallery_placeholder.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/galleries/image_gallery_placeholder.html",
    "<div>\n" +
    "  <img alt=\"\" ng-show='ngModel && isImage(getImageURL(ngModel))' class='gallery-image logo' hes-image=\"{{ getImageURL(ngModel) }}\" ng-click='openGallery()' />\n" +
    "  <div ng-show='ngModel && !isImage(getImageURL(ngModel))' class='gallery-image logo' ng-click='openGallery()'>{{ fileNameWithoutPath(getImageURL(ngModel)) }}</div>\n" +
    "  <div ng-show='!ngModel' ng-click='openGallery()'>\n" +
    "    <img alt=\"\" hes-image=\"{{getFileName()}}\" class=\"gallery-image logo center\"/><br/>\n" +
    "  </div>\n" +
    "  <a ng-if=\"!!ngModel\" class=\"secondary-link-color\" ng-click=\"removeImage()\">Remove Image</a>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/admin/goal-admin-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/admin/goal-admin-edit.html",
    "<div class=\"goals with-breadcrumbs\">\n" +
    "	<form ng-submit=\"saveGoal()\" hes-validator>\n" +
    "		<div class=\"goal-edit-box\">\n" +
    "			<div>\n" +
    "				<!-- Photo -->\n" +
    "				<label class=\"name\">Photo</label>\n" +
    "				<div>\n" +
    "					<!-- Image Upload -->\n" +
    "					<div class=\"upload_div\">\n" +
    "						<span \n" +
    "						hes-file-upload \n" +
    "						start='uploadPhotoStart' \n" +
    "						complete='uploadPhotoFinished' \n" +
    "						ng-model='data.editGoal.image' \n" +
    "						label='Choose File' \n" +
    "						label-class='upload-button' \n" +
    "						class='drag-here' \n" +
    "						use-url=\"{{options.uploadUrl}}\" \n" +
    "						no-resize='true' \n" +
    "						allow-drop=\"true\"\n" +
    "						aspect-ratio=\"2.2\"\n" +
    "						image-class=\"goal-photo goal-photo-holder\"\n" +
    "						thumbnail-url=\"data.editGoal.image.url\"\n" +
    "						place-holder=\"/goals/default-goal.jpg\"\n" +
    "						show-cropper></span>\n" +
    "					</div>\n" +
    "					<!-- <div>\n" +
    "						<a ng-click=\"openGallery()\" aria-label=\"or choose from our gallery\">or choose from our gallery</a>\n" +
    "					</div> -->\n" +
    "					<br />\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<div>\n" +
    "				<label>Title</label>\n" +
    "				<input ng-model='data.editGoal.title' hes-required />\n" +
    "			</div>\n" +
    "			\n" +
    "			<div style=\"margin-bottom: 12px;\">\n" +
    "				<textarea ng-show=\"!!settings.summaryMarkdown\" rows=\"3\" id=\"edit_content\" ng-model=\"data.editGoal.summary\"></textarea>\n" +
    "				<label>Short Summary&nbsp;\n" +
    "					<a ng-click=\"settings.summaryMarkdown = !settings.summaryMarkdown\">toggle markup</a>\n" +
    "				</label>\n" +
    "				<ng-quill-editor ng-model=\"data.editGoal.summary\" required>\n" +
    "					<ng-quill-toolbar>\n" +
    "					<div>\n" +
    "						<div class=\"ql-formats\">\n" +
    "						<button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "						<button class=\"ql-italic\"></button>\n" +
    "						<button class=\"ql-underline\"></button>\n" +
    "						<button class=\"ql-strike\"></button>\n" +
    "						</div>\n" +
    "						<div class=\"ql-formats\">\n" +
    "						<button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "						<button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "						</div>\n" +
    "						<div class=\"ql-formats\">\n" +
    "						<button class=\"ql-link\"></button>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					</ng-quill-toolbar>\n" +
    "				</ng-quill-editor>\n" +
    "			</div>\n" +
    "			\n" +
    "			<div style=\"margin-bottom: 12px;\">\n" +
    "				<textarea ng-show=\"!!settings.descriptionMarkdown\" rows=\"3\" id=\"edit_content\" ng-model=\"data.editGoal.description\" hes-required></textarea>\n" +
    "				<label>Description&nbsp;\n" +
    "					<a ng-click=\"settings.descriptionMarkdown = !settings.descriptionMarkdown\">toggle markup</a>\n" +
    "				</label>\n" +
    "					<ng-quill-editor ng-model=\"data.editGoal.description\" required>\n" +
    "						<ng-quill-toolbar>\n" +
    "						<div>\n" +
    "							<div class=\"ql-formats\">\n" +
    "							<button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "							<button class=\"ql-italic\"></button>\n" +
    "							<button class=\"ql-underline\"></button>\n" +
    "							<button class=\"ql-strike\"></button>\n" +
    "							</div>\n" +
    "							<div class=\"ql-formats\">\n" +
    "							<button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "							<button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "							</div>\n" +
    "							<div class=\"ql-formats\">\n" +
    "							<button class=\"ql-link\"></button>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						</ng-quill-toolbar>\n" +
    "					</ng-quill-editor>\n" +
    "			</div>\n" +
    "\n" +
    "			<div>\n" +
    "				<label>Category</label>\n" +
    "\n" +
    "			<select ng-if=\"!data.showNewCat\"  id='edit_category' type='text' ng-model='data.editGoal.category' ng-options=\"option for option in data.goalCats\"  hes-required></select>\n" +
    "			<a ng-if=\"!data.showNewCat\" class=\"action-link\" ng-click=\"showAddCat()\">Add New Category</a>\n" +
    "\n" +
    "			<input ng-if=\"data.showNewCat\" ng-model='data.newCat' maxlength=\"35\"/>\n" +
    "			<hes-characters-remaining style=\"margin-top:-5px;\" ng-if=\"data.showNewCat\"  containing-text='data.newCat' characters-allowed=\"35\"></hes-characters-remaining>\n" +
    "			<a ng-if=\"data.showNewCat\" class=\"action-link\" ng-click=\"addNewCat()\">Save</a>&nbsp;&nbsp;<a ng-if=\"data.showNewCat\" class=\"action-link\" ng-click=\"cancelAddCat()\">Cancel</a>\n" +
    "			<br>\n" +
    "				</div>\n" +
    "\n" +
    "				<div>\n" +
    "					<label>Starting Month</label>\n" +
    "					<select ng-options=\"item.value as item.month for item in data.months\" ng-model='data.editGoal.month_integer' hes-required></select>\n" +
    "				</div>\n" +
    "\n" +
    "				<div>\n" +
    "					<label>Ending Month</label>\n" +
    "					<select ng-options=\"item.value as item.month for item in data.months\" ng-model='data.editGoal.final_month_integer'>\n" +
    "				<option value=\"\">None</option>\n" +
    "			</select>\n" +
    "				</div>\n" +
    "\n" +
    "				<!-- <div>\n" +
    "					<div type=\"checkbox\" id=\"isDefault\" hes-checkbox class='hes-checkbox inline' label-name='isDefault' ng-model='data.editGoal.is_default'></div>\n" +
    "					<div class='checkbox-label inline' name='isDefault'>Is Default</div>\n" +
    "				</div> -->\n" +
    "		</div>\n" +
    "		\n" +
    "		<div class='button-row'>\n" +
    "			<button aria-label=\"Cancel\" ng-click=\"cancelEdit()\" class='link-look'>Cancel</button>\n" +
    "			<button aria-label=\"Create\" type='submit' hes-validate-click>{{data.editGoal.id ? \"Save\" : \"Create\"}}</button>\n" +
    "		</div>\n" +
    "	</form>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/admin/goals-list-admin.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/admin/goals-list-admin.html",
    "<a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "\n" +
    "<div class='padded-page'>\n" +
    "  <div class='padded-page'> \n" +
    "    <h4>All Goals</h4>\n" +
    "    <div class=\"promotions-content\">\n" +
    "      <a class=\"red-link-button\" ui-sref=\"go.u.site.goal_edit\">Create New Goal</a>\n" +
    "      <div hes-table tbl-data=\"data.tblElements\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/goal-create.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/goal-create.html",
    "<hes-breadcrumb crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "<div class=\"goals with-breadcrumbs\">\n" +
    "  <form hes-validator>\n" +
    "    <div>\n" +
    "      <!-- Photo -->\n" +
    "      <label class=\"name\">Photo</label>\n" +
    "      <div class=\"photo-actions\">\n" +
    "        <!-- Image Upload -->\n" +
    "        <div class=\"upload_div\">\n" +
    "          <span\n" +
    "            hes-file-upload\n" +
    "            start='uploadPhotoStart'\n" +
    "            complete='uploadPhotoFinished'\n" +
    "            ng-model='data.editGoal.image'\n" +
    "            label='Choose File'\n" +
    "            label-class='upload-button'\n" +
    "            class='drag-here'\n" +
    "            use-url=\"{{options.uploadUrl}}\"\n" +
    "            no-resize='true'\n" +
    "            allow-drop=\"true\"\n" +
    "            disable-popup=\"true\"\n" +
    "            aspect-ratio=\"2.2\"\n" +
    "            image-class=\"goal-photo goal-photo-holder\"\n" +
    "            thumbnail-url=\"data.editGoal.image.url\"\n" +
    "            place-holder=\"/goals/default-goal.jpg\"\n" +
    "            show-cropper></span>\n" +
    "        </div>\n" +
    "        <div class=\"margin-10-top\">\n" +
    "          <a ng-click=\"openGallery()\" aria-label=\"or choose from our gallery\" tabindex=\"0\">or choose from our gallery</a>\n" +
    "        </div>\n" +
    "        <br />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div>\n" +
    "      <label>Title</label>\n" +
    "      <input ng-model='data.editGoal.title' hes-required />\n" +
    "    </div>\n" +
    "\n" +
    "    <div style=\"margin-bottom: 12px;\">\n" +
    "      <label>Short Summary</label>\n" +
    "      <ng-quill-editor ng-model=\"data.editGoal.summary\" required>\n" +
    "        <ng-quill-toolbar>\n" +
    "          <div>\n" +
    "            <div class=\"ql-formats\">\n" +
    "              <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "              <button class=\"ql-italic\"></button>\n" +
    "              <button class=\"ql-underline\"></button>\n" +
    "              <button class=\"ql-strike\"></button>\n" +
    "            </div>\n" +
    "            <div class=\"ql-formats\">\n" +
    "              <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "              <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "            </div>\n" +
    "            <div class=\"ql-formats\">\n" +
    "              <button class=\"ql-link\"></button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </ng-quill-toolbar>\n" +
    "      </ng-quill-editor>\n" +
    "    </div>\n" +
    "\n" +
    "    <div style=\"margin-bottom: 12px;\">\n" +
    "      <label for=\"description\">Description</label>\n" +
    "      <div id=\"text-angular-required\" hes-required ng-model=\"data.editGoal.description\">\n" +
    "        <ng-quill-editor ng-model=\"data.editGoal.description\" required>\n" +
    "          <ng-quill-toolbar>\n" +
    "            <div>\n" +
    "              <div class=\"ql-formats\">\n" +
    "                <button class=\"ql-bold\" ng-attr-title=\"{{'Bold'}}\"></button>\n" +
    "                <button class=\"ql-italic\"></button>\n" +
    "                <button class=\"ql-underline\"></button>\n" +
    "                <button class=\"ql-strike\"></button>\n" +
    "              </div>\n" +
    "              <div class=\"ql-formats\">\n" +
    "                <button class=\"ql-list\" value=\"ordered\"></button>\n" +
    "                <button class=\"ql-list\" value=\"bullet\"></button>\n" +
    "              </div>\n" +
    "              <div class=\"ql-formats\">\n" +
    "                <button class=\"ql-link\"></button>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </ng-quill-toolbar>\n" +
    "        </ng-quill-editor>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"small-tip\">\n" +
    "      <span ng-bind-html=\"explanations.goal_tip.content\"></span>\n" +
    "    </div>\n" +
    "    <br />\n" +
    "    <div class='button-row'>\n" +
    "      <a ng-show='!!data.editGoal.user_id' aria-label=\"Cancel\" ui-sref=\"go.u.personal.goals.active\">Cancel</a>\n" +
    "      <a ng-show='!data.editGoal.user_id' aria-label=\"Cancel\" ui-sref=\"go.u.personal.goals.choose\">Cancel</a>\n" +
    "      <button aria-label=\"Create\" hes-validate-click=\"saveGoal()\" type='button'>{{data.editGoal.user_id ? \"Save\" : \"Create\"}}</button>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/goal-share-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/goal-share-popup.html",
    "<div>\n" +
    "	<h2 class=\"dialog-title\">Congratulations!</h2>\n" +
    "	<br />\n" +
    "	<img class='center' hes-image=\"/images/goals/completed-goal.svg\" />\n" +
    "	<br /><br />\n" +
    "	<div class='font-semi-bold center'>You completed {{ data.completed_goal.title }}.</div>\n" +
    "	<p>What an accomplishment! Don't stop there &mdash; share your success, then add another goal.</p>\n" +
    "	<div>\n" +
    "		<button aria-label=\"Share via Email\" ng-click='emailGoal(data.completed_goal)'>Share by Email</button>\n" +
    "		<button aria-label=\"Share on Wall\" ng-click='shareOnWall(data.completed_goal)'>Share on Wall</button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/goal-view-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/goal-view-popup.html",
    "<div class=\"goal-block popup\">\n" +
    "	<div class=\"goal my-goal goal-found\">\n" +
    "		<div>\n" +
    "			<img hes-image=\"{{ viewableGoal.image.url }}\" />\n" +
    "			<div class=\"goal-body\">\n" +
    "				<div class=\"category\">{{ viewableGoal.category }}</div>\n" +
    "				<div class=\"title\">{{ viewableGoal.title }}</div>\n" +
    "				<div class='description' hes-external-links ng-bind-html=\"viewableGoal.description\"></div>\n" +
    "			</div>\n" +
    "			<div class='goal-buttons'>\n" +
    "				<table ng-hide='settings.saving'>\n" +
    "					<tr>\n" +
    "						<td><button class=\"secondary\" aria-label=\"Complete\" ng-click=\"startDefaultGoal(viewableGoal)\" ng-disabled=\"data.active_user_goals.length >= 3\">Start Goal</button></td>\n" +
    "						<td><button class=\"secondary\" aria-label=\"Complete\" ng-click=\"createEditGoal(viewableGoal)\" ng-disabled=\"data.active_user_goals.length >= 3\">Customize</button></td>\n" +
    "					</tr>\n" +
    "				</table>\n" +
    "				<div ng-show='settings.saving'>\n" +
    "					<div hes-loading-gif loading='true'></div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/goal_gallery.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/goal_gallery.html",
    "<div>\n" +
    "  <h2 class=\"dialog-title\">Photo Gallery</h2>\n" +
    "\n" +
    "  <div ng-repeat=\"group in data.goal_groups\">\n" +
    "    <div class='title'>{{ group }}</div>\n" +
    "    <section class=\"goal__gallery\">\n" +
    "      <div class='photo' ng-repeat=\"photo in photosByGroup(group)\">\n" +
    "        <div class='goal__gallery-image' ng-click=\"chooseImageFromGallery(photo.image2)\">\n" +
    "          <img hes-image='{{photo.image2.url}}' />\n" +
    "          <div class='caption'>{{ photo.title }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </section>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/goals-active.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/goals-active.html",
    "<div class=\"goals\">\n" +
    "	<div class=\"explanation\" ng-bind-html=\"explanations.goal_active.content\"></div>\n" +
    "	<div class=\"goal-visibility\">\n" +
    "\n" +
    "		<div class=\"goal-block\">\n" +
    "			<div \n" +
    "				class=\"goal my-goal delay0\" \n" +
    "				ng-class=\"{'goal-found' : settings.data_fetched, 'goal-available' : !data.active_user_goals[0]}\">\n" +
    "\n" +
    "				<div ng-if=\"!!data.active_user_goals[0]\">\n" +
    "					<img hes-image=\"{{ data.active_user_goals[0].image.url }}\" />\n" +
    "					<div class=\"goal-body\">\n" +
    "						<div \n" +
    "							class=\"category\">Started on {{ data.active_user_goals[0].created_at | date: 'EEE, MMM d' }}</div>\n" +
    "						<div class=\"title\">{{ data.active_user_goals[0].title }}</div>\n" +
    "						<div \n" +
    "							class='description' \n" +
    "							hes-external-links \n" +
    "							ng-bind-html=\"data.active_user_goals[0].description\"></div>\n" +
    "					</div>\n" +
    "\n" +
    "					<div class='goal-buttons'>\n" +
    "						<table>\n" +
    "							<tr>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"complete\" \n" +
    "										aria-label=\"Complete\" \n" +
    "										ng-click=\"completeGoal(data.active_user_goals[0])\">Complete\n" +
    "									</button>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"icon-btn\" \n" +
    "								  		aria-label=\"Edit Goal\"\n" +
    "								  		ng-click=\"createEditGoal(data.active_user_goals[0])\">\n" +
    "										<span \n" +
    "											hes-icon \n" +
    "											icon-name=\"standard:edit\"\n" +
    "											icon-hover-name='standard:edit-hover' \n" +
    "											watch-parent=\"button\">\n" +
    "										</span>\n" +
    "									</button>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"icon-btn delete-btn\" \n" +
    "								  		aria-label=\"Delete Goal\"\n" +
    "								  		ng-click=\"deleteGoal(data.active_user_goals[0])\">\n" +
    "									  	<span \n" +
    "									  		hes-icon \n" +
    "									  		icon-name=\"standard:delete\"\n" +
    "									   		icon-hover-name='standard:delete-hover' \n" +
    "									   		watch-parent=\"button\">\n" +
    "									   	</span>\n" +
    "									</button>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</table>\n" +
    "					</div>\n" +
    "\n" +
    "				</div>\n" +
    "\n" +
    "				<div ng-if=\"!data.active_user_goals[0]\">\n" +
    "					<img hes-image=\"goals/default-goal.jpg\" />\n" +
    "					<div class=\"goal-body\">\n" +
    "						<div \n" +
    "							class=\"bookworm\"\n" +
    "							ng-class=\"{'fifty-worm': line == 4 }\"\n" +
    "							ng-repeat=\"line in [1,2,3,4]\">\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class='goal-buttons'>\n" +
    "						<button \n" +
    "							aria-label=\"Set a New Goal\" \n" +
    "							ui-sref=\"go.u.personal.goals.choose\" \n" +
    "							class='create-goal secondary'>Set a New Goal\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<div class=\"goal-block\">\n" +
    "			<div \n" +
    "				class=\"goal my-goal delay1\" \n" +
    "				ng-class=\"{'goal-found' : settings.data_fetched, 'goal-available' : !data.active_user_goals[1]}\">\n" +
    "\n" +
    "				<div ng-if=\"!!data.active_user_goals[1]\">\n" +
    "					<img hes-image=\"{{ data.active_user_goals[1].image.url }}\" />\n" +
    "					<div class=\"goal-body\">\n" +
    "						<div \n" +
    "							class=\"category\">Started on {{ data.active_user_goals[1].created_at | date: 'EEE, MMM d' }}\n" +
    "						</div>\n" +
    "						<div class=\"title\">{{ data.active_user_goals[1].title }}</div>\n" +
    "						<div \n" +
    "							class=\"description\" \n" +
    "							hes-external-links \n" +
    "							ng-bind-html=\"data.active_user_goals[1].description\">\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<div class='goal-buttons'>\n" +
    "						<table>\n" +
    "							<tr>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"complete\" \n" +
    "										aria-label=\"Complete\" \n" +
    "										ng-click=\"completeGoal(data.active_user_goals[1])\">Complete\n" +
    "									</button>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"icon-btn\" \n" +
    "								  		aria-label=\"Edit Goal\"\n" +
    "								  		ng-click=\"createEditGoal(data.active_user_goals[1])\">\n" +
    "									  	<span \n" +
    "									  		hes-icon \n" +
    "									  		icon-name=\"standard:edit\"\n" +
    "									   		icon-hover-name='standard:edit-hover' \n" +
    "									   		watch-parent=\"button\">\n" +
    "									   	</span>\n" +
    "									</button>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"icon-btn\" \n" +
    "								  		aria-label=\"Delete Goal\"\n" +
    "								  		ng-click=\"deleteGoal(data.active_user_goals[1])\">\n" +
    "								  		<span \n" +
    "								  			hes-icon \n" +
    "								  			icon-name=\"standard:delete\"\n" +
    "								   			icon-hover-name='standard:delete-hover' \n" +
    "								   			watch-parent=\"button\">\n" +
    "								   		</span>\n" +
    "									</button>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</table>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "\n" +
    "				<div ng-if=\"!data.active_user_goals[1]\">\n" +
    "					<img hes-image=\"goals/default-goal.jpg\" />\n" +
    "					<div class=\"goal-body\">\n" +
    "						<div \n" +
    "							class=\"bookworm\"\n" +
    "							ng-class=\"{'fifty-worm': line == 4 }\"\n" +
    "							ng-repeat=\"line in [1,2,3,4]\">\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class='goal-buttons'>\n" +
    "						<button \n" +
    "							aria-label=\"Set a New Goal\" \n" +
    "							ui-sref=\"go.u.personal.goals.choose\" \n" +
    "							class='create-goal secondary'>Set a New Goal\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "		</div>\n" +
    "\n" +
    "		<div class=\"goal-block\">\n" +
    "			<div \n" +
    "				class=\"goal my-goal delay2\" \n" +
    "				ng-class=\"{'goal-found' : settings.data_fetched, 'goal-available' : !data.active_user_goals[2]}\">\n" +
    "\n" +
    "				<div ng-if=\"!!data.active_user_goals[2]\">\n" +
    "					<img hes-image=\"{{ data.active_user_goals[2].image.url }}\" />\n" +
    "					<div class=\"goal-body\">\n" +
    "						<div \n" +
    "							class=\"category\">Started on {{ data.active_user_goals[2].created_at | date: 'EEE, MMM d' }}\n" +
    "						</div>\n" +
    "						<div class=\"title\">{{ data.active_user_goals[2].title }}</div>\n" +
    "						<div \n" +
    "							class=\"description\" \n" +
    "							hes-external-links \n" +
    "							ng-bind-html=\"data.active_user_goals[2].description\">\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<div class='goal-buttons'>\n" +
    "						<table>\n" +
    "							<tr>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"complete\" \n" +
    "										aria-label=\"Complete\" \n" +
    "										ng-click=\"completeGoal(data.active_user_goals[2])\">Complete\n" +
    "									</button>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"icon-btn\" \n" +
    "								  		aria-label=\"Edit Goal\"\n" +
    "								  		ng-click=\"createEditGoal(data.active_user_goals[2])\">\n" +
    "								  		<span \n" +
    "								  			hes-icon \n" +
    "								  			icon-name=\"standard:edit\"\n" +
    "								   			icon-hover-name='standard:edit-hover' \n" +
    "								   			watch-parent=\"button\">\n" +
    "								   		</span>\n" +
    "									</button>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<button \n" +
    "										class=\"icon-btn\" \n" +
    "								  		aria-label=\"Delete Goal\"\n" +
    "								  		ng-click=\"deleteGoal(data.active_user_goals[2])\">\n" +
    "								  		<span \n" +
    "								  			hes-icon \n" +
    "								  			icon-name=\"standard:delete\"\n" +
    "								   			icon-hover-name='standard:delete-hover' \n" +
    "								   			watch-parent=\"button\">\n" +
    "								   		</span>\n" +
    "									</button>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</table>\n" +
    "					</div>\n" +
    "\n" +
    "				</div>\n" +
    "\n" +
    "				<div ng-if=\"!data.active_user_goals[2]\">\n" +
    "					<img hes-image=\"goals/default-goal.jpg\" />\n" +
    "					<div class=\"goal-body\">\n" +
    "						<div \n" +
    "							class=\"bookworm\"\n" +
    "							ng-class=\"{'fifty-worm': line == 4 }\"\n" +
    "							ng-repeat=\"line in [1,2,3,4]\">\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class='goal-buttons'>\n" +
    "						<button \n" +
    "							aria-label=\"Set a New Goal\" \n" +
    "							ui-sref=\"go.u.personal.goals.choose\" \n" +
    "							class='create-goal secondary'>Set a New Goal\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/goals-choose.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/goals-choose.html",
    "<hes-breadcrumb crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "<div class='goals with-breadcrumbs'>\n" +
    "\n" +
    "	<div ng-bind-html=\"explanations.goal_choose.content\"></div>\n" +
    "\n" +
    "	<div class='group-title'>\n" +
    "		<span class=\"goal-filter\" ng-if=\"data.goal_groups.length > 1\">\n" +
    "			<select ng-options=\"group as group for group in data.goal_groups\" ng-model=\"data.current_filter\" ng-change=\"groupGoals(data.current_filter)\"></select>\n" +
    "		</span>\n" +
    "		<button class='design-goal-button secondary' ng-click=\"createEditGoal()\">Design a Goal</button>\n" +
    "	</div>\n" +
    "\n" +
    "	<span class=\"goal-block-list\">\n" +
    "    <div class='goal-block clickable' ng-repeat='goal in data.goals | filter:(data.current_filter !== settings.default_filter || undefined) && {category: data.current_filter}' tabindex=\"0\" aria-label=\"{{ goal.title}}\" aria-describedby=\"description-{{goal.id}}\" ng-click=\"viewGoal(goal)\">\n" +
    "			<div class=\"goal\">\n" +
    "				<div class=\"hidding-overflow\">\n" +
    "					<div class=\"corner-ribbon top-left black shadow\">{{ goal.is_featured ? \"New\" : goal.month }}</div>\n" +
    "					<img ng-if=\"goal.image.url\" hes-image=\"{{ goal.image.url }}\" />\n" +
    "				</div>\n" +
    "				<img ng-if=\"!goal.image.url\" hes-image=\"goals/default-goal.jpg\" />\n" +
    "				<!-- <img class=\"plus-goal\" hes-image=\"/images/placeholders/plus.png\" alt=\"select goal\"> -->\n" +
    "				<div class='goal-body'>\n" +
    "					<div class=\"category\">{{ goal.category }}</div>\n" +
    "					<div class='title'>{{ goal.title }}</div>\n" +
    "					<div class='description' hes-external-links ng-bind-html=\"goal.summary\" id=\"description-{{goal.id}}\"></div>\n" +
    "				</div>\n" +
    "				<div class='goal-buttons'>\n" +
    "					<button aria-label=\"View Goal\" class='create-goal secondary'>View Goal</button>\n" +
    "					<!-- <button aria-label=\"Select Goal\" class='create-goal secondary' ng-click=\"createEditGoal(goal)\">Select &amp; Edit</button> -->\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Custom Goal -->\n" +
    "		<!-- <div class='goal-block' ng-if=\"$index == 0\">\n" +
    "			<div class=\"goal\">\n" +
    "				<img hes-image=\"goals/default-goal.jpg\" />\n" +
    "				<div class='goal-body'>\n" +
    "					<div class=\"title category\">Create a Custom Goal</div>\n" +
    "					<div class='description'>Design your own, add an image, then write a description.</div>\n" +
    "				</div>\n" +
    "				<div class='goal-buttons'>\n" +
    "					<button aria-label=\"Create\" class='create-goal secondary' ng-click=\"createEditGoal()\">Create</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div> -->\n" +
    "\n" +
    "	</span>\n" +
    "</div>");
}]);

angular.module("/scripts/goals/goals-completed.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/goals/goals-completed.html",
    "<div class='goals'>\n" +
    "	<div class=\"goals__stats\">\n" +
    "		<p>\n" +
    "			<span hes-icon icon-name=\"standard:stats-goals\"></span>\n" +
    "		</p>\n" +
    "		<p>\n" +
    "			<span>\n" +
    "				<b class=\"bigger\">{{ data.completed_user_goals.length }}</b> Goal{{ data.completed_user_goals.length != 1 ? 's' : '' }}\n" +
    "			</span>\n" +
    "			<br>\n" +
    "			<span class=\"data-label\">Completed in {{ data.completed_user_goals[0].completed_at || currentDate | date : 'yyyy' }}</span>\n" +
    "		</p>\n" +
    "	</div>\n" +
    "	<div ng-repeat=\"group in data.completed_dates\">\n" +
    "		<div class='group-title'>\n" +
    "			<span>Completed in {{ group }}</span>\n" +
    "		</div>\n" +
    "		<div class='goal-block' ng-repeat='goal in completedByDate(group) | orderBy:\"-completed_at\"'>\n" +
    "			<div class=\"goal goal-completed\" tabindex=\"0\" aria-label=\"{{ goal.title }}\">\n" +
    "				<img ng-if=\"goal.image.url\" hes-image=\"{{ goal.image.url }}\" />\n" +
    "				<img ng-if=\"!goal.image.url\" hes-image=\"goals/default-goal.jpg\" />\n" +
    "				<div class='goal-body'>\n" +
    "          <div class=\"goal__meta\">\n" +
    "            <div class=\"sharing\" ng-cloak>\n" +
    "                <hes-share-dial type=\"Goal\" resource=\"goal\"></hes-share-dial>\n" +
    "            </div>\n" +
    "            <div class=\"color-gray\">\n" +
    "              <p>Started on {{ goal.created_at | date: 'EEE, MMM d'}}</p>\n" +
    "              <p>Completed on {{ goal.completed_at | date: 'EEE, MMM d'}}</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class='title'>{{ goal.title }}</div>\n" +
    "					<div class='description' hes-external-links ng-bind-html=\"(goal.summary | limitTo: 200) + (goal.summary.length > 200 ? '...' : '')\" \n" +
    "            id=\"description-{{goal.id}}\"></div>\n" +
    "				</div>\n" +
    "				<div class=\"history-actions\">\n" +
    "            <button aria-label=\"View Goal\" ng-click=\"viewGoal(goal)\" class='create-goal secondary'>View Goal</button>\n" +
    "            <button aria-label=\"Run again this goal\" class='secondary' ng-click=\"startDefaultGoal(goal)\" ng-disabled=\"!showRunAgain(goal)\">Run Again</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div ng-show='data.completed_dates.length == 0'>\n" +
    "		<div class='left'>\n" +
    "			<div ng-bind-html=\"explanations.goal_completed.content\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/header/header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/header/header.html",
    "<div class=\"header-container\">\n" +
    "  <div layout=\"row\" layout-align=\"start center\">\n" +
    "    <div \n" +
    "      class=\"app-logo\" \n" +
    "      flex=\"noshrink\"\n" +
    "      layout=\"row\" \n" +
    "      layout-align=\"start center\">\n" +
    "      <a ng-if=\"site.id !== 5\" ui-sref=\"go.u.home\">\n" +
    "        <img ng-src=\"{{site.logo.url}}\" alt=\"app logo\" aria-label=\"Logo\" role=\"image\"></img>\n" +
    "      </a>\n" +
    "      <a ng-if=\"site.id == 5\" ui-sref=\"go.u.sites\">\n" +
    "        <img ng-src=\"{{site.logo.url}}\" alt=\"app logo\" aria-label=\"Logo\" role=\"image\"></img>\n" +
    "      </a>\n" +
    "      <span hide-sm hide-xs class=\"promo-logo\" ng-if=\"user.location.logo.url || branding.secondary_logo\">\n" +
    "        <img ng-src=\"{{branding.secondary_logo.image1.url || user.location.logo.url}}\" alt=\"secondary logo\" aria-label=\"Secondary Logo\" role=\"image\"></img>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "    <hes-mega-menu ng-if=\"!!user\"></hes-mega-menu>\n" +
    "    <hes-user-menu ng-if=\"!!user\"></hes-user-menu>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/header/megaMenu/megaMenu.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/header/megaMenu/megaMenu.html",
    "<div layout=\"row\" layout-align=\"start end\" class=\"mega-menu__header\">\n" +
    "  <div class=\"home-menu\"  hide-sm hide-xs>\n" +
    "    <a class=\"icon-btn-item\" ui-sref=\"{{ (site.id == 5 ? 'go.u.sites' : 'go.u.home') }}\" ng-class=\"{'active': isHomePage()}\">\n" +
    "        Home\n" +
    "      </a>\n" +
    "  </div>\n" +
    "  <div class=\"home-menu\" ng-if=\"site.flags.is_aktivetrak\" hide-sm hide-xs>\n" +
    "    <a class=\"icon-btn-item\" ui-sref=\"go.u.personal.entries({year: site.years[0]})\" ng-class=\"{'active':  $state.current.name == 'go.u.personal.entries'}\">\n" +
    "        Log Activity\n" +
    "      </a>\n" +
    "  </div>\n" +
    "  <div ng-show=\"!site.flags.is_aktivetrak && ((site.flags.is_launchpad_plus && site.features_on) || site.isDefault())\" class=\"mega-menu\">\n" +
    "    <button class=\"icon-btn menu\"\n" +
    "      id=\"megaMenuButton\"\n" +
    "      ng-if=\"user\"\n" +
    "      aria-selected=\"{{is_mega_menu_open}}\"\n" +
    "      aria-label=\"toggle main menu\"\n" +
    "      ng-class=\"{'open': is_mega_menu_open}\"\n" +
    "      aria-haspopup=\"true\">\n" +
    "      <span class=\"unread\" ng-if=\"showDot({link: 'main-menu'})\"></span>\n" +
    "      <span>Menu</span>\n" +
    "      <span class=\"arrow\" ng-class=\"{'up': is_mega_menu_open}\" hes-icon icon-name=\"standard:arrow\"></span>\n" +
    "    </button>\n" +
    "\n" +
    "    <navigation ng-class=\"{'open': is_mega_menu_open}\">\n" +
    "      <div class=\"link-wrapper\">\n" +
    "        <div class=\"navigation-menu\"\n" +
    "          ng-controller='NavigationCtrl'\n" +
    "          layout=\"row\"\n" +
    "          layout-align=\"center start\"\n" +
    "          layout-xs=\"column\"\n" +
    "          layout-sm=\"column\">\n" +
    "\n" +
    "          <!-- home link -->\n" +
    "          <span hide-gt-sm class=\"links\">\n" +
    "            <ul class=\"links\"\n" +
    "              aria-label=\"home\">\n" +
    "              <li>\n" +
    "                <a tabindex=\"0\" ui-sref=\"go.u.home\">Home</a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </span>\n" +
    "\n" +
    "          <!-- main navigation link -->\n" +
    "          <span ng-repeat=\"group in navigation.menus()\" class=\"links\">\n" +
    "            <ul class=\"links\"\n" +
    "              aria-label=\"{{ group.name }}\"\n" +
    "              layout-column>\n" +
    "              <li flex-100\n" +
    "                ng-repeat=\"menu in group.menus()\"\n" +
    "                ng-class=\"{'current-tab' : menu.isCurrent}\">\n" +
    "                <a ui-sref=\"{{ menu.link }}({{ menu.params }})\"\n" +
    "                  ui-sref-opts=\"{{menu.linkOpts}}\"\n" +
    "                  class=\"{{ menu.className }}\"\n" +
    "                  tabindex=\"0\">\n" +
    "                  <span ng-if=\"menu.iconName\" hes-icon icon-name=\"{{menu.iconName}}\"></span>\n" +
    "                  {{ menu.name }}\n" +
    "                  <span class=\"unread\" ng-if=\"showDot(menu)\"></span>\n" +
    "                </a>\n" +
    "              </li>\n" +
    "              <li flex-100 ng-if=\"site.flags.is_feedback_enabled && $last\">\n" +
    "                <a class=\"feedback-link\" ui-sref=\"go.give.feedback\">\n" +
    "                  Provide Feedback\n" +
    "                </a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "            <div ng-if=\"!$last\" class=\"divider\"></div>\n" +
    "          </span>\n" +
    "\n" +
    "          <!-- user-menu links -->\n" +
    "          <span hide-gt-sm class=\"links mega-menu__user-links\">\n" +
    "            <ul class=\"links\"\n" +
    "              aria-label=\"user menu\"\n" +
    "              layout-column>\n" +
    "              <li flex-100 ng-if=\"data.count.evaluations\">\n" +
    "                <a tabindex=\"0\" ui-sref=\"go.u.evaluations.current\">\n" +
    "                  <span hes-icon icon-name='standard:evaluation' icon-hover-name='standard:evaluation-hover' watch-parent=\"a\"></span>&nbsp;Evaluation\n" +
    "                  <!-- <span class=\"count\">({{ data.count.evaluations }})</span> -->\n" +
    "                </a>\n" +
    "              </li>\n" +
    "              <li flex-100>\n" +
    "                <a tabindex=\"0\" ui-sref=\"go.u.settings.main\">\n" +
    "                  <span hes-icon icon-name='standard:settings' icon-hover-name='standard:settings-hover' watch-parent=\"a\"></span>&nbsp;Settings\n" +
    "                </a>\n" +
    "              </li>\n" +
    "              <li flex-100>\n" +
    "                <a tabindex=\"0\" class=\"lastitem\" ui-sref=\"go.logout\">\n" +
    "                  <span hes-icon icon-name='standard:logout' icon-hover-name='standard:logout-hover' watch-parent=\"a\"></span>&nbsp;Logout\n" +
    "                </a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </span>\n" +
    "\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div go-footer is-menu class=\"footer is-menu\"></div>\n" +
    "    </navigation>\n" +
    "  </div>\n" +
    "\n" +
    "  <div ng-show=\"((site.flags.is_launchpad_plus && site.features_on) || site.isDefault()) || site.flags.is_aktivetrak\" class=\"mega-menu xs mobile-menu\">\n" +
    "    <button class=\"icon-btn menu\"\n" +
    "      ng-if=\"user\"\n" +
    "      ng-click=\"toggleMobileMenu()\"\n" +
    "      aria-selected=\"{{is_mega_menu_open}}\"\n" +
    "      aria-label=\"{{is_mega_menu_open ? 'Close menu' : 'Open menu'}}\"\n" +
    "      ng-class=\"{'open': is_mega_menu_open}\"\n" +
    "      aria-haspopup=\"true\">\n" +
    "      <span class=\"unread\" ng-if=\"showDot({link: 'main-menu'})\"></span>\n" +
    "      <span>{{is_mega_menu_open ? 'Close' : 'Menu'}}</span>\n" +
    "      <span class=\"arrow\" ng-class=\"{'up': is_mega_menu_open}\" hes-icon icon-name=\"standard:{{ is_mega_menu_open ? 'close-x' : 'arrow' }}\"></span>\n" +
    "    </button>\n" +
    "\n" +
    "    <navigation ng-class=\"{'open': is_mega_menu_open}\">\n" +
    "      <div class=\"mobile-menu__link-wrapper\">\n" +
    "        <div class=\"navigation-menu\"\n" +
    "          ng-controller='NavigationCtrl'\n" +
    "          layout=\"row\"\n" +
    "          layout-align=\"center start\"\n" +
    "          layout-xs=\"column\"\n" +
    "          layout-sm=\"column\">\n" +
    "\n" +
    "          <!-- home link -->\n" +
    "          <span hide-gt-sm class=\"links\">\n" +
    "            <ul class=\"links\"\n" +
    "              aria-label=\"home\">\n" +
    "              <li class=\"no-border\">\n" +
    "                <a tabindex=\"0\" ui-sref=\"go.u.home\">Home</a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </span>\n" +
    "\n" +
    "          <!-- main navigation link -->\n" +
    "          <span ng-repeat=\"group in navigation.menus()\" class=\"links\">\n" +
    "            <ul class=\"links\"\n" +
    "              aria-label=\"{{ group.name }}\"\n" +
    "              layout-column>\n" +
    "              <li flex-100\n" +
    "                ng-repeat=\"menu in group.menus()\"\n" +
    "                ng-class=\"{'current-tab' : menu.isCurrent}\">\n" +
    "                <span class=\"unread\" ng-if=\"showDot(menu)\"></span>\n" +
    "                <a ui-sref=\"{{ menu.link }}({{ menu.params }})\"\n" +
    "                  class=\"{{ menu.className }}\"\n" +
    "                  tabindex=\"0\">\n" +
    "                  <span ng-if=\"menu.iconName\" hes-icon icon-name=\"{{menu.iconName}}\"></span>\n" +
    "                  {{ menu.name }}\n" +
    "                </a>\n" +
    "              </li>\n" +
    "              <li flex-100 ng-if=\"site.flags.is_feedback_enabled && $last\">\n" +
    "                <a class=\"feedback-link\" ui-sref=\"go.give.feedback\">\n" +
    "                  Provide Feedback\n" +
    "                </a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "            <div ng-if=\"!$last\" class=\"divider\"></div>\n" +
    "          </span>\n" +
    "\n" +
    "          <!-- user-menu links -->\n" +
    "          <section hide-gt-sm class=\"links mega-menu__user-links\">\n" +
    "            <figure class=\"user-picture\">\n" +
    "              <img alt=\"Profile picture\"\n" +
    "                hes-image=\"{{user.profile.image.url}}\" is-user />\n" +
    "            </figure>\n" +
    "            <ul class=\"links user-links\"\n" +
    "              aria-label=\"user menu\"\n" +
    "              layout-column>\n" +
    "              <li flex-100 ng-if=\"data.count.evaluations\">\n" +
    "                <a tabindex=\"0\" ui-sref=\"go.u.evaluations.current\">\n" +
    "                  <span hes-icon icon-name='standard:evaluation' icon-hover-name='standard:evaluation-hover' watch-parent=\"a\"></span>&nbsp;Evaluation\n" +
    "                </a>\n" +
    "              </li>\n" +
    "              <li class=\"no-border\" flex-100>\n" +
    "                <a tabindex=\"0\" ui-sref=\"go.u.settings.main\">\n" +
    "                  <span hes-icon icon-name='standard:settings' icon-hover-name='standard:settings-hover' watch-parent=\"a\"></span>&nbsp;Settings\n" +
    "                </a>\n" +
    "              </li>\n" +
    "              <li flex-100  ng-if=\"(user.role == 'Coordinator' || user.role == 'Location Coordinator') && !isMobile()\">\n" +
    "                <a tabindex=\"0\" ui-sref=\"go.u.coordinator.helm\">\n" +
    "                  <span hes-icon icon-name='standard:evaluation' icon-hover-name='standard:evaluation-hover' watch-parent=\"a\"></span>&nbsp;Dashboard\n" +
    "                </a>\n" +
    "              </li>\n" +
    "              <li flex-100>\n" +
    "                <a tabindex=\"0\" class=\"lastitem\" ui-sref=\"go.logout\">\n" +
    "                  <span hes-icon icon-name='standard:logout' icon-hover-name='standard:logout-hover' watch-parent=\"a\"></span>&nbsp;Logout\n" +
    "                </a>\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </section>\n" +
    "          <ul class=\"links last-menu\">\n" +
    "            <li flex-100 ng-repeat='link in footerLinks | filter : {hidden: false}'>\n" +
    "              <a ng-if='link.linkPath' ui-sref=\"{{link.linkPath}}\" ng-bind-html='link.linkText'></a>\n" +
    "              <a ng-if='link.linkMethod' href=\"#\" class=\"visited\" ng-bind-html='link.linkText' ng-click='this[link.linkMethod]()' tabindex=\"0\" ng-keydown=\"ariaClick($event)\"></a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              <a high-contrast-toggle></a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "        \n" +
    "        <div ng-if=\"user.location.logo.url || branding.secondary_logo\">\n" +
    "          <img ng-src=\"{{branding.secondary_logo.image1.url || user.location.logo.url}}\" alt=\"secondary logo\" aria-label=\"Secondary Logo\" role=\"image\"></img>\n" +
    "        </div>\n" +
    "        \n" +
    "      </div>\n" +
    "    </navigation>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/header/user-menu/user-menu.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/header/user-menu/user-menu.html",
    "  <div class=\"user-menu\"  ng-class=\"{'sticky': ((!site.flags.is_launchpad_plus && !site.flags.is_aktivetrak) || !site.features_on) }\" hide-sm hide-xs>\n" +
    "    <button \n" +
    "      class=\"icon-btn menu\" \n" +
    "      ng-click=\"view.userMenuService.toggle()\"\n" +
    "      aria-label=\"toggle user menu\"\n" +
    "      aria-selected=\"{{view.userMenuService.isOpen}}\"\n" +
    "      ng-class=\"{'open' : view.userMenuService.isOpen}\">\n" +
    "      <span class=\"user-name\">{{user.getTruncatedName()}}</span>\n" +
    "      <span class=\"arrow\" ng-class=\"{'up': is_mega_menu_open}\" hes-icon icon-name=\"standard:arrow\"></span>\n" +
    "      <img \n" +
    "        alt=\"\" \n" +
    "        class=\"md-img image-circle\" \n" +
    "        hes-image=\"{{user.profile.image.url}}\" \n" +
    "        is-user/>\n" +
    "    </button>\n" +
    "    <navigation ng-class=\"{'open': view.userMenuService.isOpen}\">\n" +
    "      <ul ng-if=\"user.pending_evaluation_ids.length\">\n" +
    "        <li>\n" +
    "          <a ui-sref=\"go.u.evaluations.current\"> \n" +
    "            <span hes-icon icon-name='standard:evaluation' icon-hover-name='standard:evaluation-hover' watch-parent=\"a\"></span>Evaluation \n" +
    "          </a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "      <div ng-include=\"'/scripts/header/user-menu/userMenuItemsList.html'\"></div>\n" +
    "    </navigation>\n" +
    "</div>");
}]);

angular.module("/scripts/header/user-menu/userMenuItemsList.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/header/user-menu/userMenuItemsList.html",
    "<ul class=\"menu-items\">\n" +
    "\n" +
    "	<li ng-if=\"user.isLocationCoordinatorOrAbove() && !isMobile()\">\n" +
    "		<a ui-sref=\"go.u.coordinator.helm\">\n" +
    "			<span hes-icon icon-name='standard:evaluation' \n" +
    "			icon-hover-name='standard:evaluation-hover' watch-parent=\"a\">\n" +
    "			</span>Dashboard\n" +
    "		</a>\n" +
    "	</li>\n" +
    "	\n" +
    "	<li>\n" +
    "		<a ui-sref=\"go.u.settings.main\">\n" +
    "			<span hes-icon icon-name='standard:settings' \n" +
    "			icon-hover-name='standard:settings-hover' watch-parent=\"a\">\n" +
    "			</span>Settings\n" +
    "		</a>\n" +
    "	</li>\n" +
    "\n" +
    "	<li>\n" +
    "		<a class=\"lastitem\" ui-sref=\"go.logout\">\n" +
    "			<span hes-icon icon-name='standard:logout' \n" +
    "				icon-hover-name='standard:logout-hover' watch-parent=\"a\">\n" +
    "			</span>Logout\n" +
    "		</a>\n" +
    "	</li>\n" +
    "</ul>");
}]);

angular.module("/scripts/header/welcomeHeader.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/header/welcomeHeader.html",
    "<div>\n" +
    "  <button class=\"hide-on-mobile-inline\" ng-click=\"goTo('go.login')\" ng-if=\"showLogin()\">LOG IN</button>\n" +
    "  <button class=\"hide-on-mobile-inline\" ng-click=\"goTo('go.register')\">REGISTER</button>\n" +
    "  <button ng-click=\"skipIntro()\" ng-if='showSkipIntro' class=\"hide-on-mobile-inline green go-right\">SKIP INTRO</button>\n" +
    "</div>");
}]);

angular.module("/scripts/hes/hesImgCropper.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/hes/hesImgCropper.html",
    "<div>\n" +
    "  <div class=\"image-cropper\" ng-show=\"ngModel && !loading && !cropping && !hasBeenCropped\" ng-class=\"\">\n" +
    "    <div class=\"cropping-overlay\" ng-show=\"cropping\"></div>\n" +
    "  </div>\n" +
    "  <div class=\"center save-padding\" ng-show=\"ngModel && !loading && !cropping\">\n" +
    "    <div class=\"save-buttons-wrapper\">\n" +
    "      <button ng-hide='cropping' class=\"done\" type=\"button\" ng-click=\"cropPhoto()\">{{ saveButtonLabel || 'Save' }}</button>\n" +
    "      <button ng-show='cropping' class=\"done\" disabled='disabled' type=\"button\">Saving</button>\n" +
    "      <button ng-if=\"showCancel()\" class=\"cancel\" type=\"button\" ng-click=\"doCancel()\">cancel</button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"center save-padding\">\n" +
    "    <div hes-loading-gif loading=\"cropping\" loading-title=\"Cropping...\" delay=\"100\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/hes/loadingGif.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/hes/loadingGif.html",
    "<div id=\"loading-gif-animation\">\n" +
    "  <img id=\"spin-wheel\" hes-image='icons/spinner.png' />\n" +
    "  <!-- <svg id=\"spin-wheel\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 188.25 175.69\">\n" +
    "    <defs>\n" +
    "      <style>.cls-1{fill:#d8d8d8;}.cls-2{fill:#262626;}</style>\n" +
    "    </defs>\n" +
    "    <title>spinny-wheel2</title>\n" +
    "    <path id=\"grey-circle\" class=\"cls-1\" d=\"M512,471.85A87.85,87.85,0,1,1,599.85,384,87.95,87.95,0,0,1,512,471.85Zm0-157.69A69.85,69.85,0,1,0,581.85,384,69.93,69.93,0,0,0,512,314.15Z\" transform=\"translate(-417.88 -296.15)\"/>\n" +
    "    <path id=\"green-chunk\" class=\"cls-2\" d=\"M512,296.15l0,18A69.87,69.87,0,0,1,572.45,349L588,340A87.9,87.9,0,0,0,512,296.15Z\" transform=\"translate(-417.88 -296.15)\"/>\n" +
    "  </svg> -->\n" +
    "</div>");
}]);

angular.module("/scripts/hes/main_layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/hes/main_layout.html",
    "<span>\n" +
    "  <header class=\"no-print\" ng-include=\"hesTemplateService.getTemplateUrl('/scripts/header/header.html')\"></header>\n" +
    "  <div class='app-content'>\n" +
    "    <div class=\"page\" ui-view role='main'>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</span>\n" +
    "");
}]);

angular.module("/scripts/highContrast/highContrast.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/highContrast/highContrast.html",
    "<a href=\"#\"\n" +
    "   class=\"visited\"\n" +
    "   ng-click=\"toggleContrast(!toggle.isHighContrast, $event)\"\n" +
    "   aria-pressed=\"{{!!toggle.isHighContrast}}\"\n" +
    "   aria-label=\"{{(!toggle.isHighContrast ? 'enable' : 'disable') + ' high contrast'}}\">\n" +
    "  <span hes-icon icon-name='standard:high-contrast' class=\"no-margin\" icon-hover-name='standard:high-contrast-hover' watch-parent=\"a\"></span>&nbsp;{{(toggle.isHighContrast ? 'Reset ' : 'High ') }} Contrast\n" +
    "</a>");
}]);

angular.module("/scripts/home/_billboards.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/_billboards.html",
    "<span ng-if=\"site.flags.is_launchpad_plus && (!user.application_state.logging_state || user.application_state.logging_state.indexOf('opt_in') == -1)\">\n" +
    "\n" +
    "  <div class=\"banner pointer\" ng-if=\"data.showEvaluationBanner\" billboard-agent billboard-id=\"site.evaluation_billboard_id\" user=\"user\" current-program=\"currentProgram\"></div>\n" +
    "  <div class=\"banner\" ng-if=\"!data.showEvaluationBanner && data.banners[data.banner_options.current] && user.flags.is_banner_expanded\" ng-include=\"'/scripts/home/banner.html'\"></div>\n" +
    "\n" +
    "  <span ng-if=\"data.banners.length > 0\">\n" +
    "    <span ng-if=\"!user.flags.is_banner_expanded\" ng-click=\"user.updateFlags({is_banner_expanded:true})\" class=\"toggle-banner\" hes-icon icon-name=\"standard:maximize-icon\"></span>\n" +
    "    <span ng-if=\"user.flags.is_banner_expanded\" ng-click=\"user.updateFlags({is_banner_expanded:false})\" class=\"toggle-banner\" hes-icon icon-name=\"standard:minimize-icon\"></span>\n" +
    "  </span>\n" +
    "\n" +
    "</span>\n" +
    "\n" +
    "<div class=\"billboard-wrapper\" ng-if=\"data.active_billboard_id\" billboard-agent billboard-id=\"data.active_billboard_id\" user=\"user\" current-program=\"currentProgram\"></div>");
}]);

angular.module("/scripts/home/_home_normal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/_home_normal.html",
    "<div class=\"homepage\">\n" +
    "\n" +
    "  <div ng-include=\"'/scripts/home/_billboards.html'\"></div>\n" +
    "\n" +
    "  <div style=\"padding:0px;\" ng-show=\"site.programs.past.length > 0 && (!user.application_state.logging_state || user.application_state.logging_state.indexOf('opt_in') == -1)\" class=\"stats\" ng-controller=\"StatsController\">\n" +
    "    <div class=\"stats-container\" style=\"margin-top: 10px;\">\n" +
    "\n" +
    "      <div class=\"stats-header\" flex layout=\"row\" layout-align=\"space-between center\">\n" +
    "        <h2>Campaign History</h2>\n" +
    "        <select ng-model=\"data.selected_year\" ng-options=\"year as year for year in site.years\" ng-if=\"site.years.length > 1\" ng-change=\"fetchData(data.selected_year)\"></select>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"campaign-data\" ng-if=\"site.programs.past.length > 0\">\n" +
    "        <div class=\"stats__item\"\n" +
    "          ng-repeat=\"campaign in site.programs.past\"\n" +
    "          ng-class=\"{'dashed': (isCurrent(campaign) && !hasUserOptedInToProgram(campaign)) || \n" +
    "                               (!isCurrent(campaign) && !hasUserOptedInToProgram(campaign))\n" +
    "        }\">\n" +
    "          <div class=\"campaign-data__image-wrapper\">\n" +
    "            <img ng-src=\"{{campaign.logo.url}}\" alt=\"{{campaign.name}}\"></img>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"dates\">{{ formattedDate(campaign.effective_date_start)  }} - {{ formattedDate(campaign.effective_date_end) }}</div>\n" +
    "          <span ng-if=\"isCurrent(campaign)\">\n" +
    "            <button aria-label=\"Enter {{ campaign.name }}\" ng-if=\"hasUserOptedInToProgram(campaign)\" ng-click=\"goToProgram(campaign.id)\">Enter</button>\n" +
    "            <button aria-label=\"Opt in to {{ campaign.name }}\" ng-if=\"!hasUserOptedInToProgram(campaign)\" ng-click=\"goToProgram(campaign.id)\">Opt In</button>\n" +
    "          </span>\n" +
    "          <span ng-if=\"!isCurrent(campaign)\">\n" +
    "            <button aria-label=\"Download report for {{ campaign.name }}\" class=\"secondary\" ng-if=\"hasUserOptedInToProgram(campaign) && !isMobile()\" ng-click=\"downloadHistory(campaign)\">Download Report</button>\n" +
    "            <div tabindex=\"0\" aria-label=\"You did not opt in to {{ campaign.name }}\" ng-if=\"!hasUserOptedInToProgram(campaign)\">You missed opting in to this one.</div>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"campaign-data\" ng-if=\"!site.programs.past.length\">\n" +
    "        <p>No campaigns for {{ data.selected_year }}.</p>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/home/_home_plus.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/_home_plus.html",
    "<div class=\"homepage\">\n" +
    "\n" +
    "  <div ng-include=\"'/scripts/home/_billboards.html'\"></div>\n" +
    "\n" +
    "  <span ng-if=\"(!user.application_state.logging_state || user.application_state.logging_state.indexOf('opt_in') == -1)\"\n" +
    "        ng-controller=\"TilesController\">\n" +
    "    <span class=\"dragula-wrapper\" dragula=\"'bag'\" dragula-model=\"tiles\">\n" +
    "      <span class=\"dragula\"\n" +
    "            ng-repeat=\"tile in tiles track by $index\">\n" +
    "\n" +
    "        <div class=\"dragula-tile\">\n" +
    "          <div ng-if=\"tiles.length > 1\" class=\"handle\">\n" +
    "            <span class=\"handle-up\" tabindex=\"0\" ng-if=\"!$first\" ng-click=\"move(tile,'up')\"></span>\n" +
    "            <span class=\"handle-down\" tabindex=\"0\" ng-if=\"!$last\" ng-click=\"move(tile,'down')\"></span>\n" +
    "          </div>\n" +
    "\n" +
    "          <span ng-include=\"templateMap[tile]\"></span>\n" +
    "        </div>\n" +
    "\n" +
    "      </span>\n" +
    "    </span>\n" +
    "  </span>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/home/banner.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/banner.html",
    "<div hes-external-links>\n" +
    "  <span ng-if=\"data.banners.length > 1\" class='previous' ng-click=\"page('back',$event)\">\n" +
    "    <span hes-icon icon-name=\"standard:page-back\" icon-hover-name=\"standard:page-back-hover\"></span>\n" +
    "  </span>\n" +
    "  <a class=\"no-underline\" ng-class=\"{'pointer': data.banners[data.banner_options.current].link && data.banners[data.banner_options.current].link != '' }\"\n" +
    "     ng-href=\"{{data.banners[data.banner_options.current].link  }}\"\n" +
    "     aria-label=\"{{ data.banners[data.banner_options.current].name }}\">\n" +
    "    <!-- <img ng-src=\"{{ data.banners[data.banner_options.current].image.url }}\"></img> -->\n" +
    "    <div billboard-agent billboard-id=\"data.banners[data.banner_options.current].banner_billboard_id\" billboard-obj=\"data.banners[data.banner_options.current].banner_billboard\" user=\"user\" current-program=\"currentProgram\"></div>\n" +
    "  </a>\n" +
    "  <span ng-if=\"data.banners.length > 1\" class=\"next\" ng-click=\"page('next',$event)\">\n" +
    "    <span hes-icon icon-name=\"standard:page-forward\" icon-hover-name=\"standard:page-forward-hover\"></span>\n" +
    "  </span>\n" +
    "</div>");
}]);

angular.module("/scripts/home/home.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/home.html",
    "<overlay></overlay>\n" +
    "<div ng-if=\"(site.flags.is_launchpad_plus && site.features_on) || site.flags.is_aktivetrak\"\n" +
    "     ng-include=\"hesTemplateService.getTemplateUrl('/scripts/home/_home_plus.html')\"\n" +
    "     ng-controller=\"HomePlusController\">\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"(!site.flags.is_launchpad_plus || !site.features_on) && !site.flags.is_aktivetrak\"\n" +
    "     ng-include=\"hesTemplateService.getTemplateUrl('/scripts/home/_home_normal.html')\"\n" +
    "     ng-controller=\"HomeNormalController\">\n" +
    "</div>");
}]);

angular.module("/scripts/home/homepageTile/challenges.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/homepageTile/challenges.html",
    "<section\n" +
    "  class=\"panel\" data-key=\"challenges\">\n" +
    "  <header>\n" +
    "    <h2 class=\"homepage-title\">{{ site.friend_label }} Challenges</h2>\n" +
    "    <span><a ui-sref=\"go.u.usermenu.challenges.active\" class=\"homepage-link\">View My Challenges</a></span>\n" +
    "  </header>\n" +
    "\n" +
    "  <div class=\"panel__tiles\">\n" +
    "    <div class=\"panel__tile\" ng-repeat=\"challenge in data.user_challenges\" aria-label=\"{{ challenge.challenge.name }}\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\">\n" +
    "      <figure class=\"image-wrapper tooltip-below\">\n" +
    "        <a ui-sref=\"go.u.usermenu.challenges.active\" tabindex=\"-1\">\n" +
    "          <img src=\"{{ challenge.challenge.image.url }}\" alt=\"{{ challenge.challenge.name }}\">\n" +
    "        </a>\n" +
    "        <figcaption class=\"tooltip\">{{ challenge.challenge.name }}</figcaption>\n" +
    "      </figure>\n" +
    "      <div class='challenge_timer absolute-index tooltip-sibling' ng-if=\"challenge.expires_at\">\n" +
    "        <challenge-timer no-countdown=\"true\" ng-if=\"challenge.expires_at\" challenge=challenge seconds=false></challenge-timer>\n" +
    "      </div>\n" +
    "      <challenge-timer no-icon=\"true\" ng-if=\"challenge.expires_at\" class=\"tooltip\" challenge=challenge seconds=false></challenge-timer>\n" +
    "    </div>\n" +
    "    <div class=\"panel__tile\" ng-repeat=\"x in [].constructor(5 - data.user_challenges.length) track by $index\" aria-label=\"Add new challenge\" tabindex=\"0\">\n" +
    "      <a ui-sref=\"go.u.usermenu.challenges.select_challenge\" class=\"panel__icon-container tooltip-below\">\n" +
    "        <span hes-icon icon-name='standard:challenge-icon'></span>\n" +
    "        <img class=\"plus-icon absolute-center\" hes-image=\"/images/placeholders/plus.png\" alt=\"Add new challenge\">\n" +
    "        <span class=\"tooltip tooltip-center\">Challenge a {{ site.friend_label }}</span>\n" +
    "      </a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</section>");
}]);

angular.module("/scripts/home/homepageTile/chart.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/homepageTile/chart.html",
    "<section class=\"panel panel-chart\" data-key=\"logging_graph\">\n" +
    "  <entries-chart></entries-chart>\n" +
    "</section>");
}]);

angular.module("/scripts/home/homepageTile/goals.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/homepageTile/goals.html",
    "<section\n" +
    "  class=\"panel\" data-key=\"goals\">\n" +
    "  <header>\n" +
    "    <h2 class=\"homepage-title\">Goals</h2>\n" +
    "    <span><a ui-sref=\"go.u.personal.goals.active\" class=\"homepage-link\">View My Goals</a></span>\n" +
    "  </header>\n" +
    "\n" +
    "  <div class=\"panel__tiles wide\">\n" +
    "    <div class=\"panel__tile\" ng-repeat=\"goal in data.goals\" aria-label=\"{{ goal.title }}\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\">\n" +
    "      <figure class=\"image-wrapper tooltip-below\">\n" +
    "        <a ui-sref=\"go.u.personal.goals.active\" tabindex=\"-1\">\n" +
    "          <img src=\"{{ goal.image.url }}\" alt=\"{{ goal.title }}\">\n" +
    "        </a>\n" +
    "        <figcaption class=\"tooltip\">{{ goal.title }}</figcaption>\n" +
    "      </figure>\n" +
    "    </div>\n" +
    "    <div class=\"panel__tile\" ng-repeat=\"x in [].constructor(3 - data.goals.length) track by $index\" aria-label=\"Add new goal\" tabindex=\"0\">\n" +
    "      <a ui-sref=\"go.u.personal.goals.choose\" class=\"panel__icon-container tooltip-inside\">\n" +
    "        <span hes-icon icon-name='standard:stats-goals'></span>\n" +
    "        <img class=\"plus-icon absolute-center\" hes-image=\"/images/placeholders/plus.png\" alt=\"Add new goal\">\n" +
    "        <span class=\"tooltip tooltip-center\">Set a new Goal</span>\n" +
    "      </a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</section>");
}]);

angular.module("/scripts/home/homepageTile/recipes.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/homepageTile/recipes.html",
    "<section class=\"panel panel-flex\" data-key=\"recipes\">\n" +
    "    <div class=\"panel__thumbnail\">\n" +
    "      <img hes-image=\"{{ data.daily_recipe.image_url }}\" alt=\"{{ data.daily_recipe.title }}\">\n" +
    "    </div>\n" +
    "    <article>\n" +
    "      <h2 class=\"homepage-title\">Today's Recipe</h2>\n" +
    "      <a ui-sref=\"go.u.content.recipes.today\" class=\"homepage-link panel-content-title\" ng-bind-html=\"data.daily_recipe.title\"></a>\n" +
    "      <span class=\"panel-content-description\" ng-bind-html=\"data.daily_recipe.description\"></span>\n" +
    "    </article>\n" +
    "  </section>");
}]);

angular.module("/scripts/home/homepageTile/tips.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/homepageTile/tips.html",
    "<section class=\"panel panel-flex\" data-key=\"tips\">\n" +
    "    <div class=\"panel__thumbnail\">\n" +
    "      <img hes-image=\"{{ data.daily_tip.image1.url }}\" alt=\"{{ data.daily_tip.title }}\">\n" +
    "    </div>\n" +
    "    <article>\n" +
    "      <h2 class=\"homepage-title\">Today's Tip</h2>\n" +
    "      <a ui-sref=\"go.u.content.tips.today\" class=\"homepage-link panel-content-title\" ng-bind-html=\"data.daily_tip.title\"></a>\n" +
    "     <!-- <span class=\"panel-content-description\" ng-bind-html=\"data.daily_tip.content_html\"></span> -->\n" +
    "     <span class=\"sm md\" ng-bind-html=\"truncate(data.daily_tip.content_html, 100)\"></span>\n" +
    "      <span class=\"two-lines-only xs\" ng-bind-html=\"truncate(data.daily_tip.content_html, 40)\"></span>\n" +
    "    </article>\n" +
    "  </section>");
}]);

angular.module("/scripts/home/homepageTile/wall.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/homepageTile/wall.html",
    "<section class=\"panel panel-flex {{ posts.moderator.photo.url ? '' : 'wider' }}\" data-key=\"wall\">\n" +
    "    <div class=\"panel__thumbnail\" ng-if=\"\">\n" +
    "      <img hes-image=\"{{ posts.moderator.photo.url }}\" alt=\"{{ posts.moderator.content }}\">\n" +
    "    </div>\n" +
    "    <article>\n" +
    "      <h2 class=\"homepage-title\">Wall</h2>\n" +
    "      <a ui-sref=\"go.u.content.wall.all\" class=\"homepage-link\">{{ posts.new || 'No' }} new {{ posts.new == 1 ? 'post' : 'posts' }} today</a>\n" +
    "      <span class=\"panel-content-description\"><span class=\"font-semi-bold\" ng-if=\"posts.moderator\">Wall Moderator: </span>{{ posts.moderator.content }}</span>\n" +
    "    </article>\n" +
    "  </section>");
}]);

angular.module("/scripts/home/video-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/home/video-popup.html",
    "<div class=\"ngDialog-title\" ng-bind-html=\"currentProgram.name\"></div>\n" +
    "<video id=\"participant_video\" ng-src=\"{{trustSrc(currentProgram.video.video_url)}}\" type='video/mp4' width='100%' controls autoplay ng-ended=\"closeThisDialog()\">\n" +
    "Your browser does not support the video tag.\n" +
    "</video>");
}]);

angular.module("/scripts/icons/iconTemplate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/icons/iconTemplate.html",
    "<md-icon md-svg-icon=\"{{iconName}}\" alt=\"\"></md-icon>");
}]);

angular.module("/scripts/idleTimeout/idleTimeout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/idleTimeout/idleTimeout.html",
    "<div ng-controller='IdleTimeoutController'>\n" +
    "	<div class=\"dialog-title\">\n" +
    "		Your session is about to expire!\n" +
    "	</div>\n" +
    "	<div class='dialog-text'>\n" +
    "		<div class='timeout-countdown'>\n" +
    "		<span>You will be logged out in\n" +
    "			<span class='countdown-number'>\n" +
    "				<span>{{minutes}} minute(s) </span>\n" +
    "				<span>{{seconds}} second(s).</span>\n" +
    "			</span>\n" +
    "		</span>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class='dialog-buttons'>\n" +
    "		<button class=\"cancel\" ng-click='timeoutGo()'>Logout</button>\n" +
    "		<button class=\"done\" ng-click='timeoutStay()'>Stay</button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/imageViewer/imageViewer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/imageViewer/imageViewer.html",
    "<img alt=\"\" hes-image='{{config.imageUrl}}' no-theme\n" +
    "  ng-click=\"openImageViewer()\"\n" +
    "  aria-label=\"{{ config.screenReader }}\"\n" +
    "  aria-hidden=\"true\"\n" +
    "  class=\"{{config.imageClass}}\"\n" +
    "  ng-class=\"{'clickable': !disablePopup}\"\n" +
    "  tabindex=\"{{ disablePopup ? -1 : 0 }}\"\n" +
    "  role=\"image\" />\n" +
    "");
}]);

angular.module("/scripts/imageViewer/imageViewerDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/imageViewer/imageViewerDialog.html",
    "<md-dialog aria-label=\"image viewer\" class=\"image-viewer\">\n" +
    "  <button class=\"icon-btn\" ng-click=\"close()\" md-autofocus aria-label=\"Close this view\">\n" +
    "    <span hes-icon icon-name='standard:close-x'>Close</span>\n" +
    "  </button>\n" +
    "  <md-dialog-content>\n" +
    "    <img src=\"{{view.imageUrl}}\" alt=\"\">\n" +
    "  </md-dialog-content>\n" +
    "</md-dialog>");
}]);

angular.module("/scripts/loadMoreButton/loadMoreButton.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/loadMoreButton/loadMoreButton.html",
    "<button class=\"load-more\" \n" +
    "  ng-click=\"handleClick()\">Load More\n" +
    "</button>");
}]);

angular.module("/scripts/location/confirmDeleteLocation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/location/confirmDeleteLocation.html",
    "<p>Are you sure you want to delete Location: \"{{confirmation.location.name}}\"?</p>\n" +
    "<p ng-if=\"confirmation.location.locations && confirmation.location.locations.length > 0\">WARNING: This will also remove all of it's sub locations!!</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm(confirmation.location)\">Confirm</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/location/locationCreateEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/location/locationCreateEdit.html",
    "<div class=\"padded-page\">\n" +
    "  <h4>{{(!data.editLocation.isNew() ? 'Edit ' : 'Create ') + 'Location'}}</h4>\n" +
    "  <form name='hes' name=\"eligForm\" ng-submit='saveLocation()'>\n" +
    "    <fieldset>   \n" +
    "      <div class=\"row\"> \n" +
    "        <span class=\"\">\n" +
    "          <label for='identifier'>Name</label>\n" +
    "          <input id='identifier' type='text' required ng-model='data.editLocation.name' />\n" +
    "        </span>\n" +
    "        <span class=\"\">\n" +
    "          <label for='banner_billboard'>Hero</label>\n" +
    "          <select id=\"banner_billboard\" ng-model=\"data.editLocation.billboard_id\">\n" +
    "            <option value=\"\">None</option>\n" +
    "            <option ng-selected=\"{{ b.id == data.editLocation.billboard_id }}\" ng-value=\"b.id\" ng-repeat=\"b in data.billboards | filter:{ billboard_type: 'placeholder' }\">{{ b.name }}</option>\n" +
    "          </select>\n" +
    "            or <a ng-click=\"editBillboard(data.editLocation.billboard_id,'placeholder')\">{{ data.editLocation.billboard_id ? \"edit\" : \"new\" }} Hero</a>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "        <!-- Logo -->\n" +
    "        <label for=\"logo\">Logo</label>\n" +
    "        <input hes-file-upload\n" +
    "               ng-model='data.editLocation.logo'\n" +
    "               start=\"_.noop\"\n" +
    "               complete=\"_.noop\"\n" +
    "               thumbnail-url=\"data.editLocation.logo.url\">\n" +
    "        </input>\n" +
    "      </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <div class='bottom-row-rel center'>\n" +
    "      <button ng-disabled=\"settings.saving\" ng-class=\"{disabled: settings.isSaving}\" type='submit'>{{!data.editLocation.isNew() ? 'Save' : 'Create'}}</button>\n" +
    "      <div class='save-feedback' ng-show=\"settings.showSaving\">Saving...</div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/location/locations.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/location/locations.html",
    "<script type=\"text/ng-template\" id=\"nodes_renderer.html\">\n" +
    "  <div ui-tree-handle ng-click=\"expandCollapse(this)\">\n" +
    "    <!----><span data-nodrag ng-show=\"location.locations && location.locations.length > 0\"><a ng-click=\"expandCollapse(this)\">{{collapsed ? 'open' : 'close'}}</a></span>\n" +
    "    <span>&nbsp;&nbsp;{{location.name}}</span>\n" +
    "    <span class=\"go-right\">\n" +
    "      <span data-nodrag><a ng-click=\"editLocation(location)\">edit</a></span>&nbsp;&nbsp;&nbsp;\n" +
    "      <span data-nodrag><a ng-click=\"addLocation(location.id)\">add</a></span>&nbsp;&nbsp;&nbsp;\n" +
    "      <span data-nodrag><a ng-click=\"confirmRemoveLocation(location)\">remove</a></span>\n" +
    "      <!-- <span class=\"\">\n" +
    "       <label for='logo'>Logo</label>\n" +
    "       <div hes-image-gallery allow-remove='true' label=\"Use as logo?\" ng-model='location.logo' image-result-size=\"sm\" folder-location=\"/locations\"></div>\n" +
    "     </span> -->\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <ol ui-tree-nodes=\"\" ng-model=\"location.locations\" ng-show=\"!collapsed\">\n" +
    "    <li ng-repeat=\"location in location.locations\" ui-tree-node ng-include=\"'nodes_renderer.html'\">\n" +
    "    </li>\n" +
    "  </ol>\n" +
    "</script>\n" +
    "\n" +
    "<div class=\"col3\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "    </div>\n" +
    "    <h4>Locations</h4>\n" +
    "    <div><strong>Hierarchy:</strong>{{dbSite.location_labels.join('|')}}</div>\n" +
    "    <br/>\n" +
    "    <div>\n" +
    "      <span hes-file-upload complete=\"onUploadCompleted\" ng-model='upload.file' label='Upload File' alias=\"locations_file\" use-url=\"{{settings.uploadEndpoint}}\" allow-any-size allow-csv-type no-resize=\"true\"></span>\n" +
    "      <!-- <span hes-file-upload complete=\"onUploadCompleted\" ng-model='upload.file' label='Upload File' alias=\"locations_file\" allow-any-size allow-any-type no-resize=\"true\"></span> -->\n" +
    "    </div>\n" +
    "    <br/>\n" +
    "    <br/>\n" +
    "    <div>\n" +
    "      <span><a ng-click=\"addLocation(null)\" class=\"action-link\">Add Top Level Location</a></span>\n" +
    "    </div>\n" +
    "    <br/>\n" +
    "    <div class=\"hes-tree\">\n" +
    "      <div ui-tree=\"tree.options\">\n" +
    "        <ol ui-tree-nodes=\"\" ng-model=\"data.locations\" id=\"tree-root\" >\n" +
    "          <li ng-repeat=\"location in data.locations\" ui-tree-node ng-include=\"'nodes_renderer.html'\" collapsed=\"!view.openedNodes[location.id]\"></li>\n" +
    "        </ol>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/location/prompt_location/promptLocationDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/location/prompt_location/promptLocationDialog.html",
    "\n" +
    "<h2 ng-if='!displayChildLocations()' class='left-neg-1'> Confirm your {{site.getLocationLabel(0)}}</h2>\n" +
    "<h2 ng-if='displayChildLocations()'  class='left-neg-1'> Confirm your {{site.getLocationLabel(0)}} and {{site.getLocationLabel(1)}}</h2>\n" +
    "\n" +
    "<div hes-validator class=\"margin-10-top\">\n" +
    "    <div class='flex-row'>\n" +
    "      <div>\n" +
    "        <label>{{site.getLocationLabel(0)}}</label>\n" +
    "        <select id=\"location\" class='ie8_select_full_width' ng-model='settingsUser.parentLocation' ng-options='location as location.name for location in data.parentLocations' ng-change=\"locationChanged('parent')\" hes-required>\n" +
    "          <option value=''>-- Choose --</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "      <div >\n" +
    "        <label ng-if='displayChildLocations()'>{{site.getLocationLabel(1)}}</label>\n" +
    "        <select id=\"location_2\" class='ie8_select_full_width' ng-if='displayChildLocations()' ng-model='settingsUser.childLocation' ng-options='location as location.name for location in settingsUser.parentLocation.locations' hes-required>\n" +
    "          <option value=''>-- Choose --</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"center text-right margin-md-top\">\n" +
    "        <span hes-loading-gif loading=\"savingUser\"></span>\n" +
    "        <span ng-show=\"saved\" class='font-md font-primary-color'>Saved!</span>\n" +
    "        <button class=\"margin-md-left\"  class='big' ng-class='{disabled: savingUser}' ng-disabled='savingUser' hes-validate-click=\"updateUserInfo()\">{{confirmation.confirmText}}</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("/scripts/login/login.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/login/login.html",
    "<div class='login' ng-class=\"{'login--hes-platform': settings.hesPlatform}\">\n" +
    "	<!-- Program logo -->\n" +
    "	<div class=\"login-logo\" style=\"margin: 15px 0px;\">\n" +
    "		<img class=\"md-img-rect\" ng-if='settings.programLogo' hes-image='{{settings.programLogo.url}}' alt='{{settings.programName}}'/>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Title -->\n" +
    "	<h2 class=\"login-title center\">Log In</h2>\n" +
    "\n" +
    "	<form name='loginForm' ng-submit='login()'>\n" +
    "		<div>\n" +
    "			<label for=\"email\">Email</label>\n" +
    "			<input type='email' id=\"email\" ng-model='loginUser.email' />\n" +
    "			<label for=\"password\">Password</label>\n" +
    "			<input id='password-input' class=\"space-under\" ng-model='loginUser.password' type='password' />\n" +
    "		</div>\n" +
    "		<div class='keep-logged'>\n" +
    "			<div class='checkbox-row'>\n" +
    "				<div class='in-check'>\n" +
    "					<div\n" +
    "						type=\"checkbox\"\n" +
    "						id=\"showPassword\"\n" +
    "						hes-checkbox\n" +
    "						class='hes-checkbox snug'\n" +
    "						ng-model='showPassword'\n" +
    "						ng-click=\"showPasswordChanged()\"\n" +
    "						label-name='showPasswordBox'\n" +
    "						aria-label=\"Show Password\"\n" +
    "						aria-labelledby=\"showPasswordLabel\"\n" +
    "						aria-checked=\"{{showPassword}}\"\n" +
    "						tabindex=\"0\">\n" +
    "					</div>\n" +
    "					<div name='showPasswordBox' id='showPasswordLabel'>\n" +
    "						Show Password\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<a tabindex='0' ng-click='startForgottenPassword()' ng-keydown=\"ariaClick($event)\">Forgot Password?</a>\n" +
    "			</div>\n" +
    "			<div class=\"in-check\">\n" +
    "				<div\n" +
    "					type=\"checkbox\"\n" +
    "					ng-show=\"site.flags.is_stay_logged_in_displayed\"\n" +
    "					aria-label=\"Remember Me\"\n" +
    "					aria-checked=\"{{stay_logged_in == 1}}\"\n" +
    "					id=\"agreementCheck\"\n" +
    "					hes-checkbox\n" +
    "					class='hes-checkbox snug'\n" +
    "					label-name='stayLoggedIn'\n" +
    "					ng-model='stay_logged_in'>\n" +
    "				</div>\n" +
    "				<div name='stayLoggedIn' ng-show=\"site.flags.is_stay_logged_in_displayed\">\n" +
    "					Remember Me\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class='login-button' ng-class=\"{'extra-padding': !site.flags.is_stay_logged_in_displayed}\">\n" +
    "			<div class='float-left login-error-container margin-15-bottom' ng-hide=\"displayForgottenPassword\">\n" +
    "				<div error-banner priority-level=0 class='float-left'></div>\n" +
    "			</div>\n" +
    "			<button type='submit' ng-disabled='loggingIn' aria-label=\"Log In\">Log In</button>\n" +
    "		</div>\n" +
    "	</form>\n" +
    "\n" +
    "	<!-- Register link for mobile (hesPlatform) -->\n" +
    "	<div ng-if=\"settings.hesPlatform\" class=\"login-register-link\">\n" +
    "		Don't have an account? <a ui-sref=\"go.register\">Register here</a>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/login/logout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/login/logout.html",
    "<div class=\"padded-page extra-padding\">\n" +
    "  <span ng-if=\"showSSOLogout\">\n" +
    "    <span ng-model=\"showSSOLogout\" markdown>You have been successfully logged out click <a ng-click=\"closeWindow()\">here</a> to close the window.</span>\n" +
    "  </span>\n" +
    "</div>");
}]);

angular.module("/scripts/mdHesPopover/md-hes-popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/mdHesPopover/md-hes-popover.html",
    "<div ng-include=\"popupTemplate\">\n" +
    "</div>\n" +
    "<div layout=\"row\" layout-align='end end'>\n" +
    "  <button class=\"link-look secondary-theme-link\" ng-click=\"closePopover()\">Got It</button>\n" +
    "</div>");
}]);

angular.module("/scripts/messages/confirmRemoveMember.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/messages/confirmRemoveMember.html",
    "<p>Are you sure you want to remove {{data.conversationMember.full_name}} from the conversation?</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm()\">Remove</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/messages/conversation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/messages/conversation.html",
    "<div ui-view></div>\n" +
    "<div ng-if=\"$state.current.name === 'go.u.usermenu.conversation'\">\n" +
    "	<hes-breadcrumb crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "	<a class=\"edit-conversation\" ui-sref=\"go.u.usermenu.conversation.edit({conversationId: data.conversation.id})\">\n" +
    "		<span hes-icon icon-name='standard:settings' icon-hover-name='standard:settings-hover' watch-parent=\"a\"></span>\n" +
    "	</a>\n" +
    "	<div class='conversation-block'>\n" +
    "		<div class=\"conversation\" scroll-bottom=\"data.conversation.current_messages\">\n" +
    "			<div class='message-wrapper'>\n" +
    "\n" +
    "				<div class='messages scrollbar'>\n" +
    "					<!-- Load more -->\n" +
    "					<div ng-if=\"data.conversation.has_more_messages\" class='load-more clickable center' ng-click=\"loadAllMessages()\">\n" +
    "						<span class='font-md font-uppercase'>load previous</span>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Conversation -->\n" +
    "					<div id='message_{{message.id}}' class='message' ng-repeat='message in (current_messages = (data.conversation.current_messages | filter:showMessage))'>\n" +
    "\n" +
    "						<div ng-if='message.action === \"message\"'>\n" +
    "							<!-- Profile Photo -->\n" +
    "							<div class='profile-photo'>\n" +
    "								<img image-class='sm-img' hes-image='{{ message.user_image }}'>\n" +
    "							</div>\n" +
    "\n" +
    "							<!-- Message -->\n" +
    "							<div class='message-content-wrapper'>\n" +
    "								<div class='message-header'>\n" +
    "									<span class='name'>{{ message.user_name }}</span>\n" +
    "									<span ng-if=\"$index == 0 || !isSameTime(message, current_messages[$index - 1])\" class='datetime hide-on-mobile'>{{ message.created_at | date:\"MMM dd, hh:mm a\" }}</span>\n" +
    "								</div>\n" +
    "								<div class='message-text'>\n" +
    "									<!-- Photo -->\n" +
    "									<div class='photo' ng-if='hasPhoto(message)' ng-model=\"message\" hes-image-rotate>\n" +
    "										<a ng-href='{{message.image.url}}' data-lightbox='message-image{{message.id}}'>\n" +
    "											<img hes-image='{{message.image.url}}' imageonload=\"scrollToBottom()\"/>\n" +
    "										</a>\n" +
    "									</div>\n" +
    "									<div>{{ message.content }}</div>\n" +
    "								</div>\n" +
    "\n" +
    "							</div>\n" +
    "						</div>\n" +
    "\n" +
    "						<div ng-if='message.action !== \"message\"'>\n" +
    "							<div class='center'>\n" +
    "								<span>{{ message.content }}</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- Form -->\n" +
    "		<div class='reply-form'>\n" +
    "			<div class='message-photo-upload'>\n" +
    "				<span\n" +
    "				  hes-file-upload \n" +
    "				  complete='postMessage()'\n" +
    "				  failure=''\n" +
    "				  ng-model='data.newMessageImage' \n" +
    "				  class='button-style icon-btn' \n" +
    "				  resize-width=\"1920\" \n" +
    "				  resize-height=\"1080\"\n" +
    "				  template=\"/scripts/upload/fileUploadPhoto.html\"></span>\n" +
    "			</div>\n" +
    "			<textarea class='message' growing-input height-offset='0' min-height='35' ng-keypress=\"checkForSend($event)\" placeholder='Add to the conversation...' ng-model=\"data.newMessageContent\" ng-disabled=\"data.conversation.removed\"></textarea>\n" +
    "			<div class=\"inline\">\n" +
    "				<div class=\"clickable-arrow for-messages\"\n" +
    "						 ng-class=\"{'is_active': data.newMessageContent && data.newMessageContent != '' && !view.isSending && !data.conversation.removed}\"\n" +
    "						 ng-click='postMessage()'>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<div class='buttons'>\n" +
    "				<!-- Upload Status -->\n" +
    "				<span class='uploaded-url' ng-show='uploading'>Uploading...</span>\n" +
    "				<span class='uploaded-url' ng-show='imageUploaded'>Your photo has been uploaded.</span>\n" +
    "				<span class=\"alert alert-danger\" ng-show=\"msgConfig.postNeedsContent\">Oops... you need to add your message first.</span>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/messages/conversationSettings.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/messages/conversationSettings.html",
    "<hes-breadcrumb crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "<div class=\"conversations_settings\" layout=\"row\" layout-wrap>\n" +
    "	<!-- Add Dropdown -->\n" +
    "	<div flex=\"100\" flex-gt-sm=\"50\">\n" +
    "		<div class='conversation-notification-switch'>\n" +
    "			<label class=\"switch\">\n" +
    "			  <input type=\"checkbox\" ng-model=\"data.conversation.muted\" ng-true-value=\"false\" ng-false-value=\"true\">\n" +
    "			  <span class=\"slider\"></span>\n" +
    "			</label>\n" +
    "			<span>Notifications: {{ data.conversation.muted ? \"Off\" : \"On\" }}</span>\n" +
    "		</div>\n" +
    "		<div class=\"member-count\">{{ data.conversation.members.length }} <span ng-pluralize count='data.conversation.members.length' when=\"{'one': 'person', 'other': 'people'}\"></span></div>\n" +
    "		<span ng-if=\"friendList().length > 0 && !data.conversation.isTeam()\">\n" +
    "			<select\n" +
    "				class='margin-10-left full-width input-look'\n" +
    "				ng-model=\"data.conversationMember\"\n" +
    "				ng-options='friend as friend.full_name for friend in friendList()'\n" +
    "				ng-change='addConversationMember(data.conversationMember)'>\n" +
    "				<option selected value=''>-- Add a Friend --</option>\n" +
    "			</select>\n" +
    "			<span class='symbol-button add attached-left click-through'></span>\n" +
    "		</span>\n" +
    "\n" +
    "		<div ng-if=\"friendList().length === 0 && !data.conversation.isTeam()\">\n" +
    "			<a ui-sref='go.u.personal.friends.search'>Invite {{ site.friend_label_plural }}</a>&nbsp;<span>to add people to the conversation.</span>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Members List -->\n" +
    "	<div flex=\"100\" flex-gt-sm=\"50\">\n" +
    "		<div class='conversation-member' ng-repeat=\"member in data.conversation.members\" ng-if=\"member.user_id != user.id\">\n" +
    "			<img hes-image=\"{{ member.image }}\" alt='{{ member.full_name }} Image' / >\n" +
    "			<div class='name'>{{ member.full_name }}</div>\n" +
    "			<button aria-label=\"Remove\" ng-click=\"removeConversationMember(member)\">Remove</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Update Buttons -->\n" +
    "	<div flex=\"100\" ng-if=\"!data.conversation.is_new\">\n" +
    "		<div class='buttons'>\n" +
    "			<button aria-label=\"Cancel\" class='link-look' ui-sref=\"go.u.usermenu.conversation({conversationId: data.conversation.id})\">Cancel</button>\n" +
    "			<button aria-label=\"Update Settings\" ng-click=\"updateConversation()\">Update Settings</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Form -->\n" +
    "	<div class='reply-form' ng-if=\"data.conversation.is_new\" flex=\"100\">\n" +
    "		<div class='message-photo-upload'>\n" +
    "			<span\n" +
    "			  hes-file-upload \n" +
    "			  complete='postMessage()'\n" +
    "			  failure=''\n" +
    "			  ng-model='data.newMessageImage' \n" +
    "			  class='button-style icon-btn' \n" +
    "			  resize-width=\"1920\" \n" +
    "			  resize-height=\"1080\"\n" +
    "			  template=\"/scripts/upload/fileUploadPhoto.html\"></span>\n" +
    "		</div>\n" +
    "		<textarea class='message' growing-input height-offset='0' min-height='35' ng-keypress=\"checkForSend($event)\" placeholder='Start a conversation...' ng-model=\"data.newMessageContent\"></textarea>\n" +
    "		<div class=\"inline\">\n" +
    "			<div class=\"clickable-arrow for-messages\"\n" +
    "					 ng-class=\"{'is_active': data.newMessageContent && data.newMessageContent != '' && !view.isSending && !data.conversation.removed}\"\n" +
    "					 ng-click='postMessage()'>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class='buttons'>\n" +
    "			<!-- Upload Status -->\n" +
    "			<span class='uploaded-url' ng-show='uploading'>Uploading...</span>\n" +
    "			<span class='uploaded-url' ng-show='imageUploaded'>Your photo has been uploaded.</span>\n" +
    "			<span class=\"alert alert-danger\" ng-show=\"msgConfig.postNeedsContent\">Oops... you need to add your message first.</span>\n" +
    "		</div>\n" +
    "\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/messages/conversationsList.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/messages/conversationsList.html",
    "<div class=\"conversations_list\" layout=\"row\" layout-wrap>\n" +
    "	<!-- New Conversation -->\n" +
    "	<div flex=\"100\" flex-gt-sm=\"50\">\n" +
    "		<div class='conversation-option'>\n" +
    "			<img hes-image=\"/images/placeholders/new-conversation.png\" alt='New Conversation' / >\n" +
    "			<div class='convo-title'>New Conversation</div>\n" +
    "			<button aria-label=\"Start\" ui-sref=\"go.u.usermenu.conversation_create\">Start</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- Conversation List -->\n" +
    "	<div flex=\"100\" flex-gt-sm=\"50\" ng-repeat=\"conversation in data.conversations | filter: conversationHasMoreThanOneMember\">\n" +
    "		<div class='conversation-option'>\n" +
    "			<img ng-if=\"conversation.getMembersExclude(user.id).length <= 1 || conversation.isTeam()\"\n" +
    "			 hes-image=\"{{ conversation.conversation_image || conversation.getMembersExclude(user.id)[0].image }}\" alt='New Conversation' / >\n" +
    "			 <div class='member-circle-square' ng-if=\"conversation.getMembersExclude(user.id).length > 1 && !conversation.isTeam()\"><div class='member-count'>{{ conversation.getMembersExclude(user.id).length }}</div></div>\n" +
    "			<div class='convo-title'>\n" +
    "				<span class=\"name recipient-name\" ng-if='conversation.isTeam()'>Team Chat</span>\n" +
    "				<span class=\"name recipient-name\" ng-if='!conversation.isTeam()'>{{ conversation.conversation_name }}</span>\n" +
    "			</div>\n" +
    "			<button aria-label=\"View\" ui-sref=\"go.u.usermenu.conversation({conversationId: conversation.id})\">View</button>\n" +
    "			<span class='unread-dot' ng-if=\"conversation.unseen\"></span>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/notifications/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/notifications/alert.html",
    "<div class='notification-alert' tabindex=\"-1\">\n" +
    "	<table ng-click=\"goToNotificationLink(alert)\" tabindex=\"-1\">\n" +
    "		<tr>\n" +
    "			<td>\n" +
    "				<img alt=\"\" ng-show='alert.type == \"wall_post\"' class='notification-icon image-circle' hes-image='{{alert.from.image.url}}' />\n" +
    "				<img alt=\"\" ng-show='alert.type == \"message\"' class='notification-icon image-circle' hes-image='{{alert.user_image}}' />\n" +
    "				<img alt=\"\" ng-show='alert.type == \"friend\"' class='notification-icon image-circle' hes-image='{{alert.from.image.url}}' />\n" +
    "				<img alt=\"\" ng-show='alert.type == \"coordinator\"' class='notification-icon image-circle' hes-image='{{alert.from.image.url}}' />\n" +
    "				<img alt=\"\" ng-show='alert.type == \"challenge\"' class='notification-icon image-circle' use-domain='true' no-theme='true' hes-image='{{alert.from.image.url}}' />\n" +
    "				<img alt=\"\" ng-show='alert.type == \"badge\"' class='notification-icon' use-domain='true' no-theme='true'  hes-image='{{ alert.image }}' />\n" +
    "			</td>\n" +
    "			<td class=\"alert-content\">\n" +
    "				<div class='font-bold' ng-show=\"alert.is_message\">{{alert.title}}</div>\n" +
    "				<div ng-class='{\"message\" : $scope.alert.type == \"message\"}'>\n" +
    "					<div markdown no-paragraph ng-model='alert.message'></div>\n" +
    "				</div>\n" +
    "			</td>\n" +
    "			<!-- <td>\n" +
    "				<span hes-icon icon-name=\"standard:arrow\"></span>\n" +
    "			</td> -->\n" +
    "		</tr>\n" +
    "	</table>\n" +
    "	<div class='alert-close alert-tab' ng-click=\"hideAlert()\" tabindex=\"{{ isAlertShown() ? 0 : -1 }}\">\n" +
    "		<span hes-icon icon-name=\"standard:close-x\"></span>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/notifications/notifications.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/notifications/notifications.html",
    "<h1 class=\"visuallyhidden\">Notifications</h1>\n" +
    "\n" +
    "\n" +
    "<div ng-if=\"data.is_loading\"\n" +
    "     class=\"notification\">\n" +
    "\n" +
    "  <div class=\"message\" aria-label=\"Loading notifications\">Loading notifications..</div>\n" +
    "\n" +
    "</div>\n" +
    "\n" +
    "\n" +
    "<div ng-if=\"data.notifications.length == 0\"\n" +
    "     class=\"notification static\"\n" +
    "     aria-label=\"No notifications\"\n" +
    "     tabindex=\"0\">\n" +
    "\n" +
    "  <div class=\"message\">No unread notifications</div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"notification\"\n" +
    "     ng-repeat=\"notification in data.notifications\"\n" +
    "     ng-class=\"{'haslink': notification.link}\"\n" +
    "     ng-click=\"notification.link ? notification.goToLink() : ''\"\n" +
    "     tabindex=\"0\"\n" +
    "     aria-label=\"{{ notification.message }}\"\n" +
    "     aria-describedby=\"{{notification.id}}\">\n" +
    "\n" +
    "  <div class=\"message p-inline\" ng-bind-html=\"notification.message\"></div>\n" +
    "  <div class=\"timespan\" id=\"{{notification.id}}\">{{ notification.read ? notification.fromCreatedOn() : notification.fromUpdatedOn() }}</div>\n" +
    "  <button class=\"icon-btn\" ng-if=\"!notification.read\" ng-click=\"clear($event, notification)\" class>\n" +
    "    <span hes-icon class=\"clear-icon\"\n" +
    "    icon-name=\"standard:x-clear\"\n" +
    "    icon-hover-name=\"standard:x-clear-hover\"\n" +
    "    watch-parent=\"button\"></span>\n" +
    "  </button>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/password/forgotten_password.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/password/forgotten_password.html",
    "<div>\n" +
    "	<h2 class=\"login-title center\" ng-hide='submittedForgottenPassword'>Forgot Password</h2>\n" +
    "	<form ng-submit='submitForgottenPassword()' ng-hide='submittedForgottenPassword'>\n" +
    "		<p>Enter your email address and we&rsquo;ll help you reset your password.</p>\n" +
    "		<label for=\"email\">Email Address</label>\n" +
    "		<input type='text' id=\"email\" name=\"email\" ng-model='passwordUser.email' required />\n" +
    "\n" +
    "		<div \n" +
    "			id=\"email-invalid-format\" \n" +
    "			class=\"ng-animate-disabled hes-invalid-msg password margin-10-bottom\"\n" +
    "			ng-if=\"email_invalid\" \n" +
    "			aria-hidden=\"false\">\n" +
    "			<div style='float: left; width: 25px;'>\n" +
    "				<img class=\"invalid-image\" src=\"/images/default/icons/error.png\">\n" +
    "			</div>\n" +
    "			<div style='width: 300px; margin-left: 4px;'>\n" +
    "				<div ng-bind-html='emailInvalidMessage' aria-live=\"polite\"></div>\n" +
    "			</div>\n" +
    "	  	</div>\n" +
    "\n" +
    "		<div error-banner priority-level=0 class='login-error margin-10-bottom' ng-show=\"login_error\"></div>\n" +
    "		\n" +
    "		<p>Forgot your email address? <a ng-click=\"contactUs();\" tabindex=\"0\" role=\"button\">Contact Us</a></p>\n" +
    "\n" +
    "		<div class='password-buttons'>\n" +
    "			<button aria-label='Send' type='submit' ng-disabled='submitted'>Send</button>\n" +
    "			<button aria-label=\"Cancel\" class='link-look' ng-click='cancelForgottenPassword()'>Cancel</button>\n" +
    "		</div>\n" +
    "	</form>\n" +
    "\n" +
    "	<!-- Forgot Password has been submitted -->\n" +
    "	<div ng-show='submittedForgottenPassword'>\n" +
    "		<h2 class=\"login-title center\" ng-bind-html=\"settings.sentEmailMessage.title_html\"></h2>\n" +
    "		<p class='password-message' ng-bind-html=\"settings.sentEmailContent\"></p>\n" +
    "\n" +
    "		<div class='password-buttons'>\n" +
    "			<button aria-label=\"Close\" ng-click='cancelForgottenPassword()'>Close</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/password/pilot_password.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/password/pilot_password.html",
    "<div class=\"pilot-password-wrapper\" ng-show=\"!settings.loading\">\n" +
    "	<div class=\"pilot-password\">\n" +
    "		<div><label>Enter the pilot password to continue.</label></div>\n" +
    "			<input type='password' ng-model=\"data.pilotPassword\" ng-keydown=\"ariaClickEnter($event)\"/> \n" +
    "			<button ng-click=\"verifyPilotPassword()\">CONTINUE</button>\n" +
    "			<div class='error-msg'>\n" +
    "				<label ng-show='data.incorrectPassword'>Incorrect Pilot Password.</label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/password/reset_password.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/password/reset_password.html",
    "  <h2 class=\"login-title center\" ng-if='canResetPassword && !resetSuccess'>Choose a New Password</h2>\n" +
    "  <h2 class=\"login-title center\" ng-if='resetSuccess' ng-bind-html=\"settings.passwordResetSuccessMessage.title_html\"></h2>\n" +
    "  <h2 class=\"login-title center\" ng-if='!canResetPassword && !settings.loading' ng-bind-html=\"settings.passwordResetExpiredMessage.title_html\"></h2>\n" +
    "  <div layout=\"row\" layout-wrap>\n" +
    "    <div ng-if='canResetPassword && !resetSuccess' flex='100' flex-gt-xs='100'>\n" +
    "      <p>Please enter and confirm a new password for the account <b>{{passwordUser.email}}</b>.</p>\n" +
    "      <div class=\"password-req-message\" ng-bind-html=\"site.password_help_message_list\"></div>\n" +
    "      <form ng-submit='comparePasswords(passwordUser.passwordConfirmation); createNewPassword()' hes-validator>\n" +
    "  \n" +
    "        <div class='row'>\n" +
    "          <label for=\"password\">Password</label>\n" +
    "          <input type='password' id='password' ng-model='passwordUser.password' hes-required class='width-full shopwd passwords' set-z-index='10000'/>\n" +
    "          <div \n" +
    "            id=\"password-invalid-format\" \n" +
    "            class=\"ng-animate-disabled hes-invalid-msg password margin-10-bottom\"\n" +
    "            ng-if=\"password_invalid_format\" \n" +
    "            aria-hidden=\"false\">\n" +
    "            <img class=\"invalid-image\" src=\"/images/default/icons/error.png\" style=\"float: left;\">\n" +
    "            <div ng-bind-html='settings.requirementErrorMessage.content' aria-live=\"polite\"></div>\n" +
    "          </div>\n" +
    "          <div class='in-check show-reset-password'>\n" +
    "            <div \n" +
    "              type=\"checkbox\"\n" +
    "              id=\"showPassword\"\n" +
    "              hes-checkbox \n" +
    "              class='hes-checkbox snug'\n" +
    "              ng-model='showPassword'\n" +
    "              ng-click=\"showPasswordChanged()\"\n" +
    "              aria-label=\"Show Password\"\n" +
    "              label-name='showPasswordBox'\n" +
    "              aria-labelledby=\"showPasswordLabel\"\n" +
    "              aria-checked=\"false\"\n" +
    "              label-name='showPassword'\n" +
    "              tabindex=\"0\">\n" +
    "            </div>\n" +
    "            <div class='checkbox-label sm-label sm-single-line inline' name='showPasswordBox' id='showPasswordLabel'>\n" +
    "              Show Password\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class='row' style=\"margin-top: 18px;\">\n" +
    "          <label for=\"password2\">Retype Password</label>\n" +
    "          <input type='password' id='password2' class='width-full passwords' ng-model='passwordUser.passwordConfirmation' hes-required set-z-index='10000'/>\n" +
    "          <div \n" +
    "            id=\"password-invalid\" \n" +
    "            class=\"ng-animate-disabled hes-invalid-msg password margin-10-bottom\"\n" +
    "            ng-if=\"password_invalid\" \n" +
    "            aria-hidden=\"false\">\n" +
    "            <img class=\"invalid-image\" src=\"/images/default/icons/error.png\" style=\"float: left;\">\n" +
    "            <div aria-live=\"polite\">Passwords do not match</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "  \n" +
    "        <div class='button-container margin-40-top'>\n" +
    "          <button type='submit' ng-disabled='resettingPassword'>Save</button>\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Cannot Reset -->\n" +
    "    <div class=\"center\" ng-if='!canResetPassword'>\n" +
    "      <div ng-bind='settings.passwordResetExpiredMessage.content'></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Reset Successful -->\n" +
    "    <div ng-if=\"resetSuccess\">\n" +
    "      <div class=\"center\" ng-bind-html=\"settings.passwordResetSuccessMessageContent\"></div> \n" +
    "      <div class=\"button-container margin-40-top\">\n" +
    "        <button ng-click=\"closeThisDialog()\">Close</button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "");
}]);

angular.module("/scripts/password/reset_password_confirmation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/password/reset_password_confirmation.html",
    "<!-- <div>\n" +
    "	<h2 class=\"login-title center\" ng-bind-html=\"settings.passwordResetSuccessMessage.title_html\"></h2>\n" +
    "	<div class=\"center\" ng-bind-html=\"settings.passwordResetSuccessMessage.content_html\"></div> \n" +
    "	<div class=\"button-container margin-40-top\">\n" +
    "		<button ng-click = \"closeThisDialog()\">Close</button>\n" +
    "	</div>\n" +
    "</div> -->");
}]);

angular.module("/scripts/photoUpload/customPhotoUpload.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/photoUpload/customPhotoUpload.html",
    "<div autofocus=\"true\" ng-click=\"closeDialog()\" class=\"ngdialog-close cancel\" tabindex=\"0\" ng-keydown=\"ariaClick($event)\" role=\"button\" aria-label=\"Close Dialog\"></div>\n" +
    "<div>\n" +
    "  <div class=\"dialog-title\">Photo Upload</div>\n" +
    "  <div class='center image-upload-popup'>\n" +
    "    <span ng-show='!config.uploadedPhoto && !config.uploadingPhoto' hes-file-upload start='uploadPhotoStart' complete='uploadPhotoFinished' ng-model='config.uploadedPhoto' label='Choose File' label-class='upload-button wall' class='drag-here choose-file' resize-width=\"{{config.resize.width}}\" resize-height=\"{{config.resize.height}}\" allow-drop=\"true\"></span>\n" +
    "\n" +
    "    <div ng-hide=\"config.photoSaving || config.uploadingPhoto\" hes-img-cropper save-button-label='{{config.saveButtonLabel}}' class='cropper' uncropped-photo='thisvariable' ng-model='config.uploadedPhoto' thumbnail-url='thumbnail' options=\"config\" on-crop='setPhoto()' cropping=\"config.croppingPhoto\" crop-style=\"config.cropStyle\"></div>\n" +
    "    <div class=\"padding-7\" hes-loading-gif loading='config.uploadingPhoto' loading-title=\"Uploading...\" delay=\"300\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/photoUpload/photoUpload.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/photoUpload/photoUpload.html",
    "<div>\n" +
    "  <h2>\n" +
    "  	<div class=\"dialog-title\">Photo Upload</div>\n" +
    "  </h2>\n" +
    "  <div class='center image-upload-popup'>\n" +
    "    <span ng-show='!config.uploadedPhoto && !config.uploadingPhoto' hes-file-upload start='uploadPhotoStart' complete='uploadPhotoFinished' ng-model='config.uploadedPhoto' label='Choose File' label-class='upload-button wall' class='drag-here choose-file' resize-width=\"{{config.resize.width}}\" resize-height=\"{{config.resize.height}}\" allow-drop=\"true\"></span>\n" +
    "\n" +
    "    <div ng-hide=\"config.photoSaving || config.uploadingPhoto\" hes-img-cropper save-button-label='{{config.saveButtonLabel}}' class='cropper' uncropped-photo='thisvariable' ng-model='config.uploadedPhoto' thumbnail-url='thumbnail' options=\"{boxWidth: 300, boxHeight: 300}\" on-crop='setPhoto()' aspect-ratio=\"{{config.aspectRatio}}\" cropping=\"config.croppingPhoto\"></div>\n" +
    "    <div class=\"padding-7\" hes-loading-gif loading='config.uploadingPhoto' loading-title=\"Uploading...\" delay=\"300\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/privacy/privacy.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/privacy/privacy.html",
    "<div class=\"privacy-wrapper\">\n" +
    "	\n" +
    "	<div required-term-prompts='privacy'></div>\n" +
    "	\n" +
    "	<div class=\"center\">\n" +
    "		<div hes-loading-gif loading='privacyConfig.loading'></div>\n" +
    "	</div>\n" +
    "	\n" +
    "	<div ng-repeat='item in privacy' ng-if=\"!privacyConfig.loading\">\n" +
    "		<h2>{{ strip_tags(item.title_html) }}</h2>\n" +
    "		<div class='privacy-content' ng-bind-html='item.content_html' hes-external-links></div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if='privacy.length === 0 && !privacyConfig.loading'>No Privacy.</div>\n" +
    "</div>");
}]);

angular.module("/scripts/profile/profileUpload.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/profile/profileUpload.html",
    "<div class=\"main-page\">\n" +
    "  <div class=\"photo-container\">\n" +
    "    <h4 class='font-green'>Upload your Profile Picture</h4>\n" +
    "    <p>Add your favorite selfie that will appear on Wall posts, Leaderboards, and Team page.</i></p>\n" +
    "    <div class=\"crop-photo-container\" ng-show=\"photoNotCropped\">\n" +
    "      <span id=\"uploadImage show-upload-image\">\n" +
    "        <div class='hes-img-cropper' uncropped-photo='photoNotCropped' ng-model='profilePhoto' thumbnail-url='thumbnail' options=\"{boxWidth: 300, boxHeight: 300}\" aspect-ratio='1' on-crop='saveProfilePhoto()'></div>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "    <div class='photo-wrapper'>\n" +
    "      <div class='profile-photo' ng-hide='config.uploaded'>\n" +
    "        <img hes-milestone='user.milestone_id' badges='promotion.badges' image-class='lg-img' hes-image='{{user.profile.image.url}}'>\n" +
    "      </div>\n" +
    "\n" +
    "      <h5 class=\"center\" go-fade-in-out on-switch='config.uploadingPhoto' s-options=\"config.inOutOptions\">Uploading...</h5>\n" +
    "\n" +
    "      <div ng-show=\"profilePhoto\" class=\"crop-container\" ng-hide='!config.uploaded'>\n" +
    "        <img class=\"profile-photo-preview\" />\n" +
    "        <img class=\"profile-photo-preview-mask\" src='images/elements/blue-circle-mask.png' />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"alert alert-danger\" ng-show=\"settingsConfig.photoSaveError\">{{settingsConfig.photoSaveMsg}}</div>\n" +
    "      <div class=\"alert alert-success center\" ng-show=\"settingsConfig.photoSaved\">Profile Image Updated!</div>\n" +
    "      <div class=\"choose-photo-container\" ng-hide=\"photoNotCropped\">\n" +
    "        <div hes-file-upload ng-model='profilePhoto' label='{{hasDefaultImage() ? \"CHOOSE\" : \"CHANGE\"}}' start='uploadPhotoStart()' complete='uploadPhotoFinished()'></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"photo-bottom-actions\">\n" +
    "   <a ng-if=\"!photoNotCropped && !config.photoSaving && !config.uploadingPhoto && !config.uploaded\" class=\"back-link\" ui-sref=\"go.u.prestart\">Back</a>\n" +
    "   <button ng-click=\"cancelSave()\" ng-if=\"photoNotCropped\">Cancel</button>\n" +
    "   <h5 ng-if=\"config.photoSaved\">Saved Photo</h5>\n" +
    "   <h5 go-fade-in-out on-switch='config.photoSaving'>Saving Photo...</h5>\n" +
    " </div>\n" +
    "</div>");
}]);

angular.module("/scripts/programs/logging_content/preview_logging_content.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/programs/logging_content/preview_logging_content.template.html",
    "<div class=\"page-tile lg\">\n" +
    "  <div class=\"standard-header\">Preview Logging States</div>\n" +
    "  <div>\n" +
    "    <a class=\"back-link\" ui-sref=\"go.u.site.program({siteId: $state.params.siteId, programId: $state.params.programId})\">Back to Program</a>\n" +
    "  </div>\n" +
    "\n" +
    "  <select ng-model=\"data.app_state\"\n" +
    "          ng-options=\"app_state as app_state.logging_state for app_state in data.applications_states\">\n" +
    "  </select>\n" +
    "\n" +
    "  <logging-banner ng-if=\"data.program\"\n" +
    "                  program=\"data.program\"\n" +
    "                  application-state=\"data.app_state\">\n" +
    "  </logging-banner>\n" +
    "\n" +
    "  <div ng-if=\"dbSite\"\n" +
    "       ng-include=\"'/scripts/content/contentAddEdit.html'\"\n" +
    "       ng-controller=\"ContentAddEditController\">\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/programs/programCreateEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/programs/programCreateEdit.html",
    "<div class=\"page-tile lg\">\n" +
    "  <div class=\"standard-header\">{{editProgram.is ? 'Create Program' : 'Edit ' + data.editMap.name + ' Program'}}\n" +
    "  </div>\n" +
    "  <div>\n" +
    "    <a class=\"back-link\" ui-sref=\"go.u.site({siteId: dbSite.id})\">Back to Site</a>\n" +
    "  </div>\n" +
    "  <div class=\"center\">\n" +
    "    <div hes-loading-gif loading='settings.loading'></div>\n" +
    "  </div>\n" +
    "  <form class=\"hes\" ng-submit='save()' ng-if=\"!settings.loading\">\n" +
    "    <div class=\"padding-md\" ng-if=\"!editProgram.isNew()\">\n" +
    "      <div class=\"font-red\">Promotion SSO Redirect: {{'https://' + dbSite.urls.split('\\n')[0] + '/welcome/login?programId=' + editProgram.id}}</div><br/>\n" +
    "      <div style=\"color:red\" ng-if=\"editProgram.id && !editProgram.reporting_promotion\">Reporting promotion does not exist! Please create the folowing promotion:<br/>{{dbSite.reporting_promotion}}.{{editProgram.promotion.domain_name}}</div>\n" +
    "    </div>\n" +
    "    <fieldset>\n" +
    "      <legend>Setup</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for='app'>App Name: {{editProgram.promotion.app_name}}</label>\n" +
    "          <select ng-change=\"loadBillboards()\" id='app' type='text' required ng-model='editProgram.promotion' ng-options=\"p as p.subdomain group by p.app_name for p in data.promotions | orderBy:['app_name','subdomain']\">\n" +
    "            <option value=\"\">-- Choose --</option>\n" +
    "            <option value=\"-1\">-- Coming Soon Placeholder --</option>\n" +
    "          </select>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label>Display Name</label>\n" +
    "          <input class=\"width-auto\" id=\"name\" required type=\"text\" ng-model=\"editProgram.name\"/>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='enabled'>Enabled</label>\n" +
    "          <input class=\"width-auto\" id='enabled' type='checkbox' ng-model='editProgram.enabled' />\n" +
    "        </span>\n" +
    "        <!-- <span>\n" +
    "          <label class=\"checkbox-label\" for='onging'>Is Ongoing?</label>\n" +
    "          <input class=\"width-auto\" id='onging' type='checkbox' ng-model='editProgram.ongoing' />\n" +
    "        </span> -->\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for='effective_start'>Effective Start Date</label>\n" +
    "          <input class=\"width-auto\" required id='effective_start' type='text' hes-date-select date-format=\"dateFormat\" ng-model='editProgram.effective_date_start' />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for='effective_end'>Effective End Date</label>\n" +
    "          <input class=\"width-auto\" required id='effective_end' type='text' hes-date-select date-format=\"dateFormat\" ng-model='editProgram.effective_date_end' />\n" +
    "        </span>\n" +
    "        <label ng-if=\"!editProgram.isNew()\">Loggable dates in program: ({{ timeframe('logging') }})</label>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <!-- <span>\n" +
    "          <label for='enter_button'>Enter Button Text (for ongoing programs only)</label>\n" +
    "          <input class=\"width-auto\" id=\"enter_button\" required type=\"text\" ng-model=\"editProgram.enter_button_copy\"/>\n" +
    "        </span> -->\n" +
    "        <span ng-if=\"dbSite.isLocationDisplayed()\">\n" +
    "          <label for='location'>Locations</label>\n" +
    "          <div ng-repeat='location_id in data.programLocationsIDs'>\n" +
    "            <div>\n" +
    "              {{ getLocationName(location_id) }} <a ng-click=\"deleteLocation(location_id)\">delete</a>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <a ng-hide=\"view.addingLocation\" ng-click=\"view.addingLocation = true\">Add Location</a>&nbsp;|&nbsp;<a ng-click=\"pushLocation(null)\">Add All</a>\n" +
    "          <select ng-show='view.addingLocation' id='location' type='text' ng-change='pushLocation(data.locationBuffer)' ng-model='data.locationBuffer' ng-options=\"location.id as location.name group by getLocationName(location.parent_location_id) for location in data.locations | filter:shouldShow\">\n" +
    "          </select>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <!-- <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for='coordinator_report_promotion_id'>Report Promotion <em>{{editProgram.promotion.app_name}}</em></label>\n" +
    "          <select id='coordinator_report_promotion_id' type='text' ng-model='editProgram.coordinator_reports_promotion_id' ng-options=\"p.promotion_id as p.subdomain for p in data.promotions | filter: {app_name: editProgram.promotion.app_name} | orderBy:['subdomain']\">\n" +
    "            <option value=\"\">-- Choose --</option>\n" +
    "          </select>\n" +
    "        </span>\n" +
    "      </div> -->\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <fieldset ng-if=\"editProgram.id\">\n" +
    "      <legend>Billboards</legend>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          \n" +
    "          <label for=\"coming_soon_billboard\">Coming Soon ({{ timeframe('coming_soon') }})</label>\n" +
    "          <select id=\"coming_soon_billboard\" ng-model=\"editProgram.coming_soon_billboard_id\" ng-options=\"b.id as b.name for b in data.billboards | filter:{ billboard_type: 'coming_soon', app_domain: editProgram.getAppDomain()  }\"></select>\n" +
    "            or <a ng-click=\"editBillboard(editProgram.coming_soon_billboard_id,'coming_soon')\">{{ editProgram.coming_soon_billboard_id ? \"edit\" : \"new\" }} billboard</a>\n" +
    "          \n" +
    "          <label for=\"opt_in_billboard\">Opt In ({{ timeframe('opt_in') }})</label>\n" +
    "          <select id=\"opt_in_billboard\" ng-model=\"editProgram.opt_in_billboard_id\" ng-options=\"b.id as b.name for b in data.billboards | filter:{ billboard_type: 'opt_in', app_domain: editProgram.getAppDomain() }\"></select>\n" +
    "            or <a ng-click=\"editBillboard(editProgram.opt_in_billboard_id,'opt_in')\">{{ editProgram.opt_in_billboard_id ? \"edit\" : \"new\" }} billboard</a>\n" +
    "\n" +
    "          <label for=\"enter_billboard\">Enter ({{ timeframe('enter') }})</label>\n" +
    "          <select id=\"enter_billboard\" ng-model=\"editProgram.enter_billboard_id\" ng-options=\"b.id as b.name for b in data.billboards | filter:{ billboard_type: 'enter', app_domain: editProgram.getAppDomain()  }\"></select>\n" +
    "            or <a ng-click=\"editBillboard(editProgram.enter_billboard_id, 'enter')\">{{ editProgram.enter_billboard_id ? \"edit\" : \"new\" }} billboard</a>\n" +
    "\n" +
    "            <label for=\"enter_billboard\">Registration Closed ({{ timeframe('registration_closed') }})</label>\n" +
    "            <select id=\"enter_billboard\" ng-model=\"editProgram.registration_closed_billboard_id\" ng-options=\"b.id as b.name for b in data.billboards | filter:{ billboard_type: 'registration_closed', app_domain: editProgram.getAppDomain()  }\"></select>\n" +
    "              or <a ng-click=\"editBillboard(editProgram.registration_closed_billboard_id, 'registration_closed')\">{{ editProgram.registration_closed_billboard_id ? \"edit\" : \"new\" }} billboard</a>\n" +
    "\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <a ui-sref=\"go.u.preview_logging_states({siteId:dbSite.id, programId:editProgram.id})\">Preview Logging Content</a>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "    </fieldset>\n" +
    "\n" +
    "\n" +
    "    <fieldset>\n" +
    "      <legend>Images</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <span class=\"\">\n" +
    "          <label for=\"logo\">Logo</label>\n" +
    "          <input hes-file-upload\n" +
    "                 ng-model='editProgram.logo'\n" +
    "                 start=\"_.noop\"\n" +
    "                 complete=\"_.noop\"\n" +
    "                 thumbnail-url=\"editProgram.logo.url\">\n" +
    "          </input>\n" +
    "          <em>use size that will be used in emails: width 200px</em>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "\n" +
    "\n" +
    "    <div class=\"center text-right\">\n" +
    "      <div error-banner priority-level=1></div>\n" +
    "      <a ng-show=\"editProgram\" class='back-link' ui-sref=\"go.u.site({siteId: $state.params.siteId})\">Cancel</a>\n" +
    "      <button type=\"submit\">Save</button>\n" +
    "      <span ng-if=\"settings.saving\">Saving..</span>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/recipes/recipes-layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/recipes/recipes-layout.html",
    "<div>\n" +
    "  <!-- <h1 class=\"visuallyhidden\">{{$state.current.title}}</h1> -->\n" +
    "  <div ui-view></div>\n" +
    "</div>");
}]);

angular.module("/scripts/recipes/views/recipe.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/recipes/views/recipe.html",
    "<hes-breadcrumb class=\"resource\" ng-if=\"settings.showBreadcrumb\" crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "<div ng-if=\"!show_broken_recipe\" class=\"recipe content-item\">\n" +
    "  <div flex layout-xs=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\" \n" +
    "    class=\"headline\">\n" +
    "    <div class=\"content-item__header\">\n" +
    "      <div class=\"picture-frame\">\n" +
    "        <img alt=\"\" class=\"resource-image\" hes-image=\"{{recipe.image_url}}\" \n" +
    "          no-theme />\n" +
    "      </div>\n" +
    "      <div class=\"content-item__meta xs\">\n" +
    "        <h2 tabindex=\"-1\">\n" +
    "          <span markdown no-paragraph ng-model=\"recipe.title\"></span>\n" +
    "        </h2>\n" +
    "        <div flex class=\"health-categories secondary-text\">\n" +
    "          {{::recipe.getHealthCategories()}}\n" +
    "        </div>  \n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div flex class=\"intro\">\n" +
    "      <div flex class=\"sm md\">\n" +
    "        <h2 tabindex=\"-1\">\n" +
    "          <span markdown no-paragraph ng-model=\"recipe.title\"></span>\n" +
    "        </h2>\n" +
    "      </div>\n" +
    "      <div flex layout-gt-sm=\"row\" class=\"actions\" layout-align=\"start center\" ng-show=\"user\">\n" +
    "        <div class=\"favorite\">\n" +
    "          <div plus-one\n" +
    "              toggle-var='{{recipe.favorited}}'\n" +
    "              image-span=\"<span hes-icon icon-name='standard:favorite-filled'>\n" +
    "              </span>\">\n" +
    "            <button class=\"icon-btn favorite\" aria-label=\"Favorite Recipe\"\n" +
    "                ng-class=\"{'active': user && recipe.favorited}\"\n" +
    "                ng-click=\"recipe.toggleFavorite()\"\n" +
    "                ng-mouseenter=\"recipe.hover = true\"\n" +
    "                ng-mouseleave=\"recipe.hover = false\"\n" +
    "                aria-pressed=\"{{!!recipe.favorited}}\">\n" +
    "              <md-tooltip md-direction=\"bottom\">Favorite</md-tooltip>\n" +
    "              <span hes-icon \n" +
    "                icon-name=\"standard:favorite{{!!recipe.favorited || recipe.hover ? '-filled' : ''}}\">\n" +
    "              </span>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"sharing\" ng-cloak>\n" +
    "          <hes-share-dial type=\"Recipe\" resource=\"recipe\"></hes-share-dial>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div flex layout-gt-sm=\"row\" class=\"actions rating\">\n" +
    "        <div class=\"recipe-rating\" flex=\"none\">\n" +
    "          <div>\n" +
    "            <div hes-star-rating size=\"5\" \n" +
    "              change-handler=\"saveRating(recipe, rating)\"\n" +
    "              clear-handler=\"recipe.unRate()\"\n" +
    "              user-rating=\"recipe.userRating\"\n" +
    "              average=\"recipe.rating\"\n" +
    "              do-popover=\"true\"\n" +
    "              popover-text=\"ratingText\"\n" +
    "              user=\"user\"></div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"comments-preview no-print\" layout-align=\"start center\">\n" +
    "          <div>\n" +
    "            <button ng-if=\"settings.recipeWall.posts.length != 1\" class=\"link-look\" ng-click=\"scrollToComments()\">\n" +
    "              {{settings.recipeWall.posts.length}} comments\n" +
    "            </button>\n" +
    "            <button ng-if=\"settings.recipeWall.posts.length == 1\" class=\"link-look\" ng-click=\"scrollToComments()\">\n" +
    "              {{settings.recipeWall.posts.length}} comment\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div flex class=\"health-categories secondary-text md sm\">\n" +
    "        {{::recipe.getHealthCategories()}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <div flex layout=\"row\" layout=\"left\">\n" +
    "    <div flex-gt-xs=\"20\" class=\"about-icons\">\n" +
    "      <ul>\n" +
    "        <li>\n" +
    "          <span hes-icon icon-name=\"recipe:course\" alt=\"\"></span>\n" +
    "          <div class=\"label tall\">{{::recipe.getCourse()}}</div>\n" +
    "        </li>\n" +
    "        <li ng-show=\"!!recipe.getDifficulty()\">\n" +
    "          <span hes-icon icon-name=\"recipe:difficulty\" alt=\"\"></span>\n" +
    "          <div class=\"label\">{{::recipe.getDifficulty()}}</div>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <span hes-icon icon-name=\"recipe:servings\" alt=\"\"></span>\n" +
    "          <div class=\"label\">{{recipe.servings}} <span ng-pluralize count='recipe.servings' when=\"{'one': 'Serving', 'other': 'Servings'}\"></span></div>\n" +
    "        </li>\n" +
    "        <li ng-show=\"recipe.active_time\">\n" +
    "          <span hes-icon icon-name=\"recipe:prep\" alt=\"\"></span>\n" +
    "          <div class=\"label\">{{gsubMetrics(recipe.active_time)}} Prep</div>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "          <span hes-icon icon-name=\"recipe:total-time\" alt=\"\"></span>\n" +
    "          <div class=\"label tall\">Ready In {{gsubMetrics(recipe.total_time)}}</div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <div flex class=\"instructions\">\n" +
    "      <div hes-external-links markdown ng-model=\"recipe.description\"></div>\n" +
    "      <h3>Ingredients</h3>\n" +
    "      <ul class=\"ingredients\">\n" +
    "        <li ng-repeat=\"ingr in recipe.ingredients\">\n" +
    "          <div markdown no-paragraph ng-model='ingr.quantity'\n" +
    "            hes-external-links></div>\n" +
    "          <div markdown no-paragraph ng-model='ingr.unit' \n" +
    "            hes-external-links></div>\n" +
    "          <div markdown no-paragraph ng-model='ingr.item'\n" +
    "            hes-external-links></div>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "      <h3>Preparation</h3>\n" +
    "      <ol class=\"preparation\">\n" +
    "        <li ng-repeat=\"step in recipe.recipe_steps\"\n" +
    "          class=\"margin-7-bottom\">\n" +
    "          <div markdown ng-model=\"step.description\" no-paragraph></div>\n" +
    "        </li>\n" +
    "      </ol>\n" +
    "      <div ng-if='recipe.recipe_tip'>\n" +
    "        <h3>Tips & Notes</h3>\n" +
    "        <div markdown\n" +
    "          ng-model='recipe.recipe_tip'\n" +
    "          hes-external-links></div>\n" +
    "      </div>\n" +
    "      <div ng-if='recipe.serving_size'>\n" +
    "        <h3>Serving Size</h3>\n" +
    "        <div markdown\n" +
    "          ng-model='recipe.serving_size'\n" +
    "          hes-external-links></div>\n" +
    "      </div>\n" +
    "      <h3>Nutrition</h3>\n" +
    "      <div markdown ng-model=\"recipe.nutrition_information\" ></div>\n" +
    "      <div class=\"copyright secondary-text\" markdown-div  \n" +
    "        ng-model=\"recipe.copyright_text_url\" no-paragraph>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div layout=\"row\">\n" +
    "    <hes-resource-comments ng-if=\"recipe\" id=\"recipe_comments\" flex-offset-gt-xs=\"20\" flex \n" +
    "      ng-if=\"user\" wallable=\"recipe\" wall=\"settings.recipeWall\"\n" +
    "      resource-name=\"recipe\"></hes-resource-comments>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ng-if=\"show_broken_recipe\" class=\"recipe content-item\">\n" +
    "  <div style=\"width:100%;height:200px;\" hes-icon\n" +
    "    icon-name=\"standard:recipe-error\">\n" +
    "  </div>\n" +
    "  <h2 style=\"margin-top:20px;\" class=\"text-center\">Recipe does not exist</h2>\n" +
    "</div>");
}]);

angular.module("/scripts/recipes/views/recipes.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/recipes/views/recipes.html",
    "<div class=\"recipes\">\n" +
    "  <h2 \"visuallyhidden\" tabindex=\"-1\"></h2>\n" +
    "  <div class=\"all\">\n" +
    "    <div layout=\"column\" class=\"filter\">\n" +
    "      <md-radio-group md-no-ink ng-model=\"data.selectedFilter\" class=\"resource-filters\" tabindex=\"-1\">\n" +
    "        <md-radio-button tabindex=\"0\" ng-repeat=\"filter in ::data.allFilters\"\n" +
    "          ng-value=\"filter.key\"\n" +
    "          ng-keydown=\"ariaClick($event)\"\n" +
    "          aria-label=\"{{filter.display}}\">\n" +
    "          {{filter.display}}\n" +
    "        </md-radio-button>\n" +
    "      </md-radio-group>\n" +
    "      <div>\n" +
    "        <hes-search-input on-search=\"applySearch(value)\" \n" +
    "          search-value=\"data.search\"\n" +
    "          placeholder-text=\"Search by name, ingredient, or keyword...\"></hes-search-input>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"resource-list\" ng-if=\"data.filteredItems.length === 0\">\n" +
    "      <md-divider></md-divider>\n" +
    "      <div class=\"item\">\n" +
    "        <div class=\"image-frame\">\n" +
    "          <img alt=\"\" class=\"preview-image\" hes-image=\"/images/placeholders/recipe-placeholder.jpg\" />\n" +
    "        </div>\n" +
    "        <div ng-if=\"data.selectedFilter === 'favorites' && !data.hasFavorites\" flex class=\"preview\">\n" +
    "          <div flex class=\"title\">You have no Favorites yet.</div>\n" +
    "          <div flex  class=\"summary\">Select the heart icon (<span hes-icon \n" +
    "                icon-name=\"standard:favorite\" aria-hidden=\"true\">\n" +
    "              </span>) on your favorite recipes to save them here.</div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"data.selectedFilter === 'favorites' && data.hasFavorites\" flex class=\"preview\">\n" +
    "          <!-- <div flex class=\"title\">Oops, try again.</div> -->\n" +
    "          <div flex  class=\"summary\" ng-bind-html=\"searchEmptyMessage()\"></div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"data.selectedFilter !== 'favorites'\" flex class=\"preview\">\n" +
    "          <!-- <div flex class=\"title\">Oops, try again.</div> -->\n" +
    "          <div flex  class=\"summary\" ng-bind-html=\"searchEmptyMessage()\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <md-divider></md-divider>\n" +
    "    </div>\n" +
    "    <div class=\"resource-list\">\n" +
    "      <span class=\"visuallyhidden\" aria-live=\"polite\">{{searchFilterMessage()}}</span>\n" +
    "      <a id=\"{{recipe.id}}\" ng-repeat=\"recipe in (data.filteredItems = (allRecipes | recipeCategoryFilter:data.selectedFilter\n" +
    "        | recipeSearchFilter:data.appliedSearch | orderBy: 'title') | limitTo: data.limit)\"\n" +
    "         ui-sref=\"go.u.content.recipes.single({id: recipe.id})\" aria-label=\"{{recipe.title}}\"\n" +
    "         hes-focus set-focus=\"{{data.scrollTo == recipe.id}}\">\n" +
    "        <md-divider></md-divider>\n" +
    "        <div class=\"item\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-align=\"start start\">\n" +
    "          <div class=\"image-frame\">\n" +
    "            <img alt=\"\" class=\"preview-image\" hes-image=\"{{recipe.image_url}}\" />\n" +
    "          </div>\n" +
    "          <div flex class=\"preview\">\n" +
    "            <div flex class=\"title\" markdown-div no-paragraph ng-model='::recipe.title'></div>\n" +
    "            <div flex ng-init=\"recipe.getSummary()\" class=\"summary\" markdown-div ng-model=\"::recipe._summary\"></div>\n" +
    "            <div flex class=\"secondary-text\">{{::recipe.getHealthCategories()}}</div>\n" +
    "          </div>\n" +
    "          <div class=\"arrow\" hide-xs flex=\"10\">\n" +
    "            <span hes-icon icon-name=\"standard:arrow\"></span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <md-divider ng-if=\"$last\"></md-divider>\n" +
    "      </a>\n" +
    "      <hes-load-more-button on-click=\"showMore()\" \n" +
    "        ng-if=\"data.filteredItems.length && data.filteredItems.length > data.limit\">\n" +
    "      </hes-load-more-button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/registration/eligibilityCheck.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/registration/eligibilityCheck.html",
    "<div>\n" +
    "  <div class='page-title'>\n" +
    "    <div class=\"dialog-title\" markdown-div no-paragraph ng-model=\"eligLabelMessage.title\"></div>\n" +
    "  </div>\n" +
    "\n" +
    "  <form name=\"eligForm\" ng-submit=\"confirmIdentifier()\">\n" +
    "    <div>\n" +
    "      <div>\n" +
    "        <label ng-show='displayBirthDate()'>Date of Birth</label>\n" +
    "        <div class='elig-dob'>\n" +
    "          <div ng-if='displayBirthDate()'>\n" +
    "            <select class=\"sm\" ng-model=\"data.birthMonth\" ng-options=\"m.value as m.month for m in yearOptions.months\">\n" +
    "              <option value=''>Month</option>\n" +
    "            </select>\n" +
    "            <select class=\"sm middle\" ng-model=\"data.birthDay\" ng-options=\"m.value as m.day for m in yearOptions.days\">\n" +
    "              <option value=''>Day</option>\n" +
    "            </select>\n" +
    "            <select class=\"sm\" ng-model=\"data.birthYear\" ng-options=\"m.value as m.year for m in yearOptions.years\">\n" +
    "              <option value=''>Year</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <label><div ng-bind-html=\"eligLabelMessage.content_html\" hes-external-links></div></label>\n" +
    "        <span markdown ng-model=\"eligLabelMessage.summary_html\" no-paragraph></span>\n" +
    "        <div class='identifier-wrapper'>\n" +
    "          <input class=\"lg\" id='identifier' ng-class=\"{'right': displayBirthDate()}\" ng-model='data.identifier' /><br />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class='button-wrapper'>\n" +
    "      <button aria-label=\"Next\" type=\"submit\">Next</button>\n" +
    "      <span class='cancel-button' ng-click='goToWelcome()'>Cancel</span>\n" +
    "      <div class='extra-padding' error-banner priority-level=0></div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/registration/indv_leaderboard_info.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/registration/indv_leaderboard_info.html",
    "<div>\n" +
    "	<h4>Individual Leaderboard</h4>\n" +
    "	<div class='font-sm font-gray'>Your inches of snow will be ranked against other participants who opt in.</div>\n" +
    "	<br />\n" +
    "	<div class='font-sm font-gray'><span class='font-bold'>Note: </span>If you change your mind, uncheck the box under Settings.</div>\n" +
    "	<br />\n" +
    "</div>");
}]);

angular.module("/scripts/registration/participant_confidentiality.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/registration/participant_confidentiality.html",
    "<div>\n" +
    "	<div class='font-sm font-gray'>We're committed to safeguarding confidentiality. Personal information is stored under strict security measures as outlined in our <a href='#/privacy' target='_blank'>Privacy Statement.</a> Your participation data will be:</div>\n" +
    "\n" +
    "	<ul class='font-sm font-gray'>\n" +
    "		<li>Compiled with other participants’ data</li>\n" +
    "		<li>Displayed in your organization's coordinator reports.</li>\n" +
    "	</ul>\n" +
    "</div>");
}]);

angular.module("/scripts/registration/readMoreHover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/registration/readMoreHover.html",
    "<span hes-external-links>\n" +
    "  <span ng-model=\"messages.agreeReadMore.content_html\" markdown></span>\n" +
    "</span>");
}]);

angular.module("/scripts/registration/registration.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/registration/registration.html",
    "<div class='tile'>\n" +
    "  <div class=\"page-top\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "    <div>Registration</div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <!-- Closed -->\n" +
    "  <div class=\"frame registration\" ng-if=\"registrationFrozen && !settings.loading\">\n" +
    "    <span markdown ng-model=\"messages.closed\"></span>\n" +
    "  </div>\n" +
    "\n" +
    "  <!-- Open -->\n" +
    "  <div class=\"frame registration\" ng-if=\"!registrationFrozen && !settings.loading\">\n" +
    "    <div class='registration-message' markdown ng-model='messages.welcomeToSite.content'></div>\n" +
    "\n" +
    "    <div hes-validator>\n" +
    "      <div>\n" +
    "        <!-- Name -->\n" +
    "        <div layout=\"row\" layout-wrap class='input-group'>\n" +
    "          <label flex='100' class=\"name\">Name\n" +
    "            <!-- <span class='asterisk'>*</span> -->\n" +
    "          </label>\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <label class=\"screen-hidden\" for=\"first_name\">First Name</label>\n" +
    "            <input type=\"text\" id=\"first_name\" name=\"first_name\" ng-model=\"newUser.profile.first_name\" placeholder=\"First Name\" hes-required />\n" +
    "          </div>\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <label class=\"screen-hidden\" for=\"last_name\">Last Name</label>\n" +
    "            <input type=\"text\" class=\"right\" id=\"last_name\" name=\"last_name\" ng-model=\"newUser.profile.last_name\" placeholder=\"Last Name\" hes-required />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Email -->\n" +
    "        <div layout=\"row\" layout-wrap class='input-group'>\n" +
    "          <label flex='100' class=\"name\">Email Address\n" +
    "            <!-- <span class='asterisk'>*</span> -->\n" +
    "          </label>\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <label class=\"screen-hidden\" for=\"email\">Email Address</label>\n" +
    "            <span ng-model=\"newUser.email\" hes-required>\n" +
    "              <input type=\"email\" id=\"email\" name=\"email\" ng-model=\"newUser.email\"\n" +
    "                hes-popover html-content=\"{{messages.emailErrorMessage}}\" tip-joint=\"bottom\" target-joint=\"top\" event=\"null\" custom-show=\"{{email_duplicate}}\" hide-event=\"null\" border-color=\"red\" placeholder=\"Email Address\" ng-blur=\"checkEmailFormat(newUser.email)\" />\n" +
    "            </span>\n" +
    "          </div flex='100' flex-gt-xs='50'>\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <label class=\"screen-hidden\" for=\"email2\">Retype Email Address</label>\n" +
    "            <span ng-model=\"retype.email\" hes-required>\n" +
    "              <input type=\"email\" id=\"email2\" name=\"email2\" ng-model=\"retype.email\" class=\"right\" hes-popover content=\"Emails do not match\" tip-joint=\"bottom\" target-joint=\"top\" event=\"null\" custom-show=\"{{email_invalid}}\" hide-event=\"null\" border-color=\"red\" placeholder=\"Retype Email Address\" />\n" +
    "            </span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Password -->\n" +
    "        <div ng-if=\"!site.is_sso_enabled\" layout=\"row\" layout-wrap class=\"input-group\">\n" +
    "          <div flex='100'>\n" +
    "            <label class=\"name\">Password\n" +
    "              <!-- <span class='asterisk'>*</span> -->\n" +
    "            </label>\n" +
    "            <div class=\"padding-10-bottom\" ng-bind-html='site.password_help_message'></div>\n" +
    "          </div>\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <label class=\"screen-hidden\" for=\"password\">Password</label>\n" +
    "            <span>\n" +
    "              <span ng-model=\"newUser.password\" hes-required>\n" +
    "                <input type=\"password\" id=\"password\" name=\"password\" ng-model=\"newUser.password\" placeholder=\"{{ site.is_sso_enabled ? 'Mobile' : '' }}Password\" hes-popover content=\"{{ site.password_help_message }}\" tip-joint=\"bottom\" target-joint=\"top\" custom-show=\"{{password_invalid_format}}\" event=\"null\" hide-event=\"null\" border-color=\"red\" />\n" +
    "              </span>\n" +
    "            </span>\n" +
    "          </div>\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <label class=\"screen-hidden\" for=\"password2\">Retype Password</label>\n" +
    "            <span>\n" +
    "              <span ng-model=\"retype.password\" hes-required>\n" +
    "                <input type=\"password\" id=\"password2\" name=\"password2\" class=\"right\" hes-popover content=\"Passwords do not match\" tip-joint=\"bottom\" target-joint=\"top\"\n" +
    "                  event=\"null\" custom-show=\"{{password_invalid}}\" hide-event=\"null\" border-color=\"red\" ng-model=\"retype.password\" placeholder=\"Retype{{ site.is_sso_enabled ? ' Mobile' : '' }} Password\" />\n" +
    "              </span>\n" +
    "            </span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Photo -->\n" +
    "        <div layout=\"row\" layout-wrap class=\"input-group\">\n" +
    "\n" +
    "          <div flex='100' flex-gt-xs='50' class=\"mobile-photo\">\n" +
    "            <label class=\"name\" tabindex=\"0\">Profile Photo</label>\n" +
    "            <div>\n" +
    "              <!-- Image Upload -->\n" +
    "              <div class=\"upload_div\">\n" +
    "                <span\n" +
    "                  hes-file-upload\n" +
    "                  start='uploadPhotoStart'\n" +
    "                  complete='uploadPhotoFinished'\n" +
    "                  ng-model='newUser.profile.image'\n" +
    "                  label='Choose File'\n" +
    "                  label-class='upload-button'\n" +
    "                  class='drag-here'\n" +
    "                  use-url=\"{{options.uploadUrl}}\"\n" +
    "                  no-resize='true'\n" +
    "                  allow-drop=\"true\"\n" +
    "                  on-cancel=\"resetUserImage()\"\n" +
    "                  image-class=\"user-photo md-img\"\n" +
    "                  screen-reader-label=\"Profile Photo\"\n" +
    "                  thumbnail-url=\"newUser.profile.image\"\n" +
    "                  place-holder=\"/users/default.png\"\n" +
    "                  show-cropper></span>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "\n" +
    "          <!-- Profile -->\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <div ng-if=\"site.flags.is_gender_displayed\">\n" +
    "              <label class=\"name\">Gender\n" +
    "                <!-- <span class='asterisk'>*</span> -->\n" +
    "              </label>\n" +
    "              <select id=\"gender\" ng-model=\"newUser.profile.gender\" hes-required name=\"Gender\">\n" +
    "                <option value=\"\">-- Gender --</option>\n" +
    "                <option value=\"F\">Female</option>\n" +
    "                <option value=\"M\">Male</option>\n" +
    "                <option value=\"N\">Non-Binary</option>\n" +
    "                <option value=\"P\">Prefer not to answer</option>\n" +
    "              </select>\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"site.flags.allow_set_location\">\n" +
    "              <label class='name'>{{site.getLocationLabel(0)}}\n" +
    "                <!-- <span class='asterisk'>*</span> -->\n" +
    "              </label>\n" +
    "              <label class='screen-hidden' for=\"location\">{{site.getLocationLabel(0)}}</label>\n" +
    "              <div>\n" +
    "                <select id=\"location\" class='ie8_select_full_width' ng-model='newUser.parentLocation' ng-options='location as location.name for location in data.parentLocations' ng-change=\"locationChanged('parent')\" hes-required>\n" +
    "                  <option value=''>-- Choose --</option>\n" +
    "                </select>\n" +
    "\n" +
    "                <div class='name' ng-if='displayChildLocations()'>{{site.getLocationLabel(1)}}</div>\n" +
    "                <label class='screen-hidden' ng-if='displayChildLocations()' for=\"location_2\">{{site.getLocationLabel(1)}}</label>\n" +
    "                <select id=\"location_2\" class='ie8_select_full_width' ng-if='displayChildLocations()' ng-model='newUser.childLocation' ng-options='location as location.name for location in newUser.parentLocation.locations' hes-required>\n" +
    "                  <option value=''>-- Choose --</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "\n" +
    "          <!-- Shipping Address -->\n" +
    "          <div flex='100'>\n" +
    "            <div ng-if=\"site.flags.is_address_displayed\">\n" +
    "              <div class=\"name address-label\" markdown-div ng-model='messages.addressLabel' no-paragraph></div>\n" +
    "              <div>\n" +
    "                <div markdown-div ng-model='messages.address_content'></div>\n" +
    "                <label class=\"screen-hidden\" for=\"line1\">Address line 1</label>\n" +
    "                <input type=\"text\" id=\"line1\" name=\"line1\" ng-model=\"newUser.profile.line1\" placeholder=\"Address line 1\" hes-required />\n" +
    "              </div>\n" +
    "              <div>\n" +
    "                <label class=\"screen-hidden\" for=\"line2\">Address line 2</label>\n" +
    "                <input type=\"text\" class=\"right\" id=\"line2\" name=\"line2\" ng-model=\"newUser.profile.line2\" placeholder=\"Address line 2\" />\n" +
    "              </div>\n" +
    "              <div class=\"flex-row\">\n" +
    "                <div flex-gt-xs='45'>\n" +
    "                  <label class=\"screen-hidden\" for=\"city\">City</label>\n" +
    "                  <input type=\"text\" class=\"left\" id=\"city\" name=\"city\" ng-model=\"newUser.profile.city\" placeholder=\"City\" hes-required />\n" +
    "                </div>\n" +
    "                <div flex-gt-xs='30'>\n" +
    "                  <label class=\"screen-hidden\" for=\"state_province\">State/Province</label>\n" +
    "                  <select hes-invisible-label=\"State or Province\" class=\"state_province\" id='state_province' ng-model='newUser.profile.state_province' ng-options='state.abbreviation as state.stateName for state in stateChoices' hes-required>\n" +
    "                    <option value=''>-- State/Province --</option>\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "                <div flex-gt-xs='20'>\n" +
    "                  <label class=\"screen-hidden\" for=\"city\">Postal code</label>\n" +
    "                  <input type=\"text\" class=\"left\" id=\"postal_code\" name=\"postal_code\" ng-model=\"newUser.profile.postal_code\" placeholder=\"Postal code\" hes-required />\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "\n" +
    "          <!-- Evaluation -->\n" +
    "          <div flex='100' ng-if='!!newUser.evaluation' layout=\"row\" layout-wrap class=\"input-group\">\n" +
    "            <div flex-gt-xs='50' user-evaluation evaluation=\"newUser.evaluation\" site-evaluation='data.site_evaluation'></div>\n" +
    "          </div>\n" +
    "\n" +
    "          <!-- SMS Profile -->\n" +
    "          <div flex='100' flex-gt-xs='100' layout-wrap class=\"sms\" ng-if=\"site.flags.is_sms_enabled\">\n" +
    "            <div>\n" +
    "              <table >\n" +
    "                <tr>\n" +
    "                  <td>\n" +
    "                    <div type=\"checkbox\" id=\"smsCheck\" aria-describedBy=\"smsCheckLabel\" hes-checkbox aria-checked=\"{{ agreedSms == true }}\" class='hes-checkbox inline margin-15-bottom' label-name='smsCheck' ng-model='newUser.allows_sms'></div>\n" +
    "                  </td>\n" +
    "                  <td>\n" +
    "                    <div name='smsCheck' class=\"checkbox-label margin-n-20-bottom\"><span id=\"smsCheckLabel\"><span id=\"smsAgreement\" markdown ng-model='messages.smsAgreement.content'></span></span>\n" +
    "                  </td>\n" +
    "                </tr>\n" +
    "              </table>\n" +
    "              <table ng-if=\"newUser.allows_sms\">\n" +
    "                <td>\n" +
    "                  <div\n" +
    "                      hes-popover\n" +
    "                      content='Invalid Phone Number' tip-joint='bottom' target-joint='top' event='null'\n" +
    "                      tip-joint='bottom' target-joint='top' event='null'\n" +
    "                      custom-show='{{phone_invalid}}' hide-event='null' border-color='red'>\n" +
    "                  </div>\n" +
    "                  <div>\n" +
    "                    <input type=\"tel\" id=\"phone\" ng-model=\"newUser.profile.phone\" name=\"tel\" class=\"phone\" aria-describedBy=\"phone input\" ng-change=\"setPhone()\" intl-tel-input/>\n" +
    "                  </div>\n" +
    "                </td>\n" +
    "                <td>\n" +
    "                  <select ng-model=\"newUser.profile.time_zone\" ng-init=\"newUser.profile.time_zone = site.time_zone\" ng-options=\"zone as zone for zone in timeZones\" aria-describedBy=\"time zone select\"  class=\"time-zone\">\n" +
    "                  </select>\n" +
    "                </td>\n" +
    "              </table>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <!-- Mobile Password -->\n" +
    "          <div ng-if=\"site.is_sso_enabled && site.flags.is_mobile_enabled\" id=\"mobile-password-box\" layout=\"row\" layout-wrap class=\"input-group\">\n" +
    "            <div flex='100'>\n" +
    "              <label class=\"name\">Mobile App Setup\n" +
    "                <!-- <span class='asterisk'>*</span> -->\n" +
    "              </label>\n" +
    "              <div class=\"password-msg\" markdown-div ng-model=\"messages.mobilePasswordMsg\"></div>\n" +
    "            </div>\n" +
    "            <div flex='100' flex-gt-xs='50'>\n" +
    "              <label for=\"password\">Mobile Password</label>\n" +
    "              <span>\n" +
    "                <span ng-model=\"newUser.password\">\n" +
    "                  <input type=\"password\" id=\"password\" name=\"password\" ng-model=\"newUser.password\" placeholder=\"{{ site.is_sso_enabled ? 'Mobile' : '' }} Password\" hes-popover content=\"{{ site.password_help_message }}\" tip-joint=\"bottom\" target-joint=\"top\" custom-show=\"{{password_invalid_format}}\" event=\"null\" hide-event=\"null\" border-color=\"red\" />\n" +
    "                </span>\n" +
    "              </span>\n" +
    "            </div>\n" +
    "            <div flex='100' flex-gt-xs='50'>\n" +
    "              <label for=\"password2\">Retype Mobile Password</label>\n" +
    "              <span>\n" +
    "                <span ng-model=\"retype.password\">\n" +
    "                  <input type=\"password\" id=\"password2\" name=\"password2\" class=\"right\" hes-popover content=\"Passwords do not match\" tip-joint=\"bottom\" target-joint=\"top\"\n" +
    "                    event=\"null\" custom-show=\"{{password_invalid}}\" hide-event=\"null\" border-color=\"red\" ng-model=\"retype.password\" placeholder=\"Retype{{ site.is_sso_enabled ? ' Mobile' : '' }} Password\" />\n" +
    "                </span>\n" +
    "              </span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <!-- Terms & Conditions -->\n" +
    "          <!-- Second confidentiality - custom field -->\n" +
    "          <div layout=\"row\" flex='100' layout-wrap class=\"input-group\">\n" +
    "            <div>\n" +
    "              <table ng-if=\"site.flags.show_opt_custom_in_participation_link\">\n" +
    "                <tr>\n" +
    "                  <td>\n" +
    "                    <div type=\"checkbox\" id=\"agreementCheck3\" aria-describedBy=\"agreementCheckLabel3\" aria-checked=\"{{ agreedTerms == 1 }}\" hes-checkbox class='hes-checkbox inline' label-name='agreementCheck3' ng-model='agreedTerms' hes-required></div>\n" +
    "                  </td>\n" +
    "                  <td>\n" +
    "                    <div name='agreementCheck3' class=\"checkbox-label\">\n" +
    "                      <span id=\"agreementCheckLabel3\" markdown ng-model='messages.customConfidentiality2.content'>\n" +
    "                      </span>\n" +
    "                    </div>\n" +
    "                  </td>\n" +
    "                </tr>\n" +
    "              </table>\n" +
    "\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div layout=\"row\" flex='100' layout-wrap class=\"input-group\">\n" +
    "            <div>\n" +
    "              <table ng-if=\"!site.flags.show_opt_in_participation_link\">\n" +
    "                <tr>\n" +
    "                  <td>\n" +
    "                    <div type=\"checkbox\" id=\"agreementCheck\" aria-describedBy=\"agreementCheckLabel\" aria-checked=\"{{ agreedTerms == 1 }}\" hes-checkbox class='hes-checkbox inline margin-12-bottom' label-name='agreementCheck' ng-model='agreedTerms' hes-required></div>\n" +
    "                  </td>\n" +
    "                  <td>\n" +
    "                    <div name='agreementCheck' class=\"checkbox-label\"><span id=\"agreementCheckLabel\">I agree to have my <em class=\"site-name\">{{site.name}}</em> data compiled and displayed in secure reports as described in the participant confidentiality document.</span>\n" +
    "                      <span hes-popover popover-class=\"read-more\" class=\"hes-popover underline-dotted tip-open-on-focus\"\n" +
    "                        template=\"/scripts/registration/readMoreHover.html\" tabindex=\"0\"\n" +
    "                        aria-label=\"{{messages.agreeReadMore.content}}\"\n" +
    "                        ng-keydown=\"ariaClickLinkInside($event)\">Read More</span></div>\n" +
    "                  </td>\n" +
    "                </tr>\n" +
    "              </table>\n" +
    "\n" +
    "              <table ng-if=\"site.flags.show_opt_in_participation_link\">\n" +
    "                <tr>\n" +
    "                  <td>\n" +
    "                    <div type=\"checkbox\" id=\"agreementCheck2\" aria-describedBy=\"agreementCheckLabel2\" aria-checked=\"{{ agreedTerms == 1 }}\" hes-checkbox class='hes-checkbox inline' label-name='agreementCheck2' ng-model='agreedTerms' hes-required></div>\n" +
    "                  </td>\n" +
    "                  <td>\n" +
    "                    <div name='agreementCheck2' class=\"checkbox-label\">\n" +
    "                      <span id=\"agreementCheckLabel2\" markdown ng-model='messages.customConfidentiality.content'>\n" +
    "                      </span>\n" +
    "                    </div>\n" +
    "                  </td>\n" +
    "                </tr>\n" +
    "              </table>\n" +
    "\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <!-- Register Button -->\n" +
    "          <div layout=\"row\" flex='100' layout-wrap class=\"input-group\">\n" +
    "            <div flex='100' class=\"button-container\">\n" +
    "              <span hes-loading-gif loading=\"creating\" delay=\"1\"></span>\n" +
    "              <span ng-show=\"creating\" class=\"font-md font-primary-color\">Joining...</span>\n" +
    "              <button id=\"register\" ng-class=\"{disabled: creating}\" ng-disabled=\"creating\" hes-validate-click=\"register()\">Join Now</button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <!-- API Errors -->\n" +
    "          <div ng-if=\"data.errors.length\" layout=\"row\" flex='100' layout-wrap class=\"input-group\">\n" +
    "            <div flex='100' class=\"button-container\">\n" +
    "              <div style=\"color:red;\" ng-repeat=\"error in data.errors\">\n" +
    "                {{ error }}\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>");
}]);

angular.module("/scripts/reports/confirm_delete_report.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/reports/confirm_delete_report.html",
    "<p>Are you sure you want to delete \"{{reportToDelete.name}}\"?</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm()\">Confirm</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/reports/createSaveAsDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/reports/createSaveAsDialog.html",
    "<div>\n" +
    "  <div class=\"dialog-title\">Save As...</div>\n" +
    "  <form class=\"hes\">\n" +
    "    <div class=\"row\">\n" +
    "      <span class=\"double\">\n" +
    "        <label for='name'>New Report Name</label>\n" +
    "        <input id=\"name\" name=\"name\" type='text' ng-model='newReport.name' placeholder='Report Name' />\n" +
    "      </span>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"user.isMaster()\">\n" +
    "      <span class=\"double\">\n" +
    "        <input id=\"is_custom\" name=\"is_custom\" type='checkbox' ng-model='newReport.as_custom' placeholder='Report Name' />\n" +
    "        <label for=\"is_custom\">Make Custom Report</label>\n" +
    "        <i>Uncheck to make available for all promotions</i>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "  <div class='button-container'>\n" +
    "    <button class=\"cancel\" ng-click='closeThisDialog()'>Cancel</button>\n" +
    "    <button class=\"done\" ng-click='confirm()'>Create</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/reports/limit-50k-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/reports/limit-50k-dialog.html",
    "<p>Reports are limited to 50,000 rows of data; the report you’re trying to run exceeds this amount. Please contact your HES HES Account Manager for further assistance.</p>\n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"closeThisDialog()\">Close</button> \n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/reports/masterDashboardReports.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/reports/masterDashboardReports.html",
    "<div class=\"tile\">\n" +
    "  <div class=\"frame\">\n" +
    "    <div class=\"standard-header\">Reporting</div>\n" +
    "    <div class=\"pane\" ng-include=\"'/scripts/reports/reports.html'\"></div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/reports/reports.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/reports/reports.html",
    "<div class=\"dashboard-reporting\">\n" +
    "	<div class='split-pane one-third quarter-border float-right'>\n" +
    "		<div class=\"report-selector\">\n" +
    "\n" +
    "			<!-- Sites -->\n" +
    "			<div ng-if='user.isMaster()'>\n" +
    "				<div class=\"font-sub-header margin-7-bottom\">Site</div>\n" +
    "\n" +
    "				<select ng-model='reportSite.id' ng-options=\"s.id as s.name for s in sites | orderBy:'name'\" ng-change='switchSites()'>\n" +
    "					<option value=''>-- Choose Site --</option>\n" +
    "				</select>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Default Reports -->\n" +
    "			<div class=\"font-sub-header margin-7-bottom\">Reports</div>\n" +
    "			<button class=\"margin-0-left\" ng-click='resetReportPage()'>New Report</button><span class=\"font-bold font-mid-grey\">&nbsp;&nbsp;or&nbsp;&nbsp;</span>\n" +
    "\n" +
    "			<select class=\"margin-7-top width-full\" ng-model=\"data.selectedReport\" ng-options=\"opt as opt.name group by opt.group for opt in allReports\" ng-change=\"showReport(data.selectedReport)\">\n" +
    "				<option value=''>-- Choose Report --</option>\n" +
    "			</select>\n" +
    "\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div class=\"margin-10-left\">\n" +
    "		<div class=\"center\">\n" +
    "			<div hes-loading-gif loading='settings.loading'></div>\n" +
    "		</div>\n" +
    "		<div class='reports-content' ng-if=\"!settings.loading\">\n" +
    "			<div>\n" +
    "				<h2>{{!!currentReport.id ? currentReport.name : 'Create Report'}}</h2>\n" +
    "\n" +
    "				<span ng-if='user.isMaster() && currentReport.isNew()'>\n" +
    "					<span class='separator'>|</span>\n" +
    "					<a href='javascript:;' ng-click='switchToSQLLayout()' ng-show='displaySimpleLayout'>Use SQL Layout</a>\n" +
    "					<a href='javascript:;' ng-click='switchToSimpleLayout()' ng-show='displaySQLLayout'>Use Simple Layout</a>\n" +
    "				</span>\n" +
    "			</div>\n" +
    "\n" +
    "			<div>\n" +
    "				<!-- Name -->\n" +
    "				<div class='section' ng-show=\"canSaveReport(currentReport)\">\n" +
    "					<fieldset>\n" +
    "						<input type='text' ng-model='currentReport.name' placeholder='Report Name' />\n" +
    "						<a href='javascript:;' class='delete' ng-if='canDeleteReport(currentReport)' ng-click='deleteReport(currentReport)'>Delete</a>\n" +
    "					</fieldset>\n" +
    "				</div>\n" +
    "\n" +
    "				<!-- Fields -->\n" +
    "				<div class='section' ng-show='displaySimpleLayout'>\n" +
    "					<div class=\"font-sub-header margin-7-bottom\">Fields</div>\n" +
    "\n" +
    "					<!-- fields hidden on the back end stay in the model as raw ids; don't render a row for them -->\n" +
    "					<div ng-repeat='field in currentReport.fields track by $index' ng-show='!isHiddenField(field)'>\n" +
    "						<select class='report-field' ng-model='currentReport.fields[$index]' ng-options=\"reportField as reportField.display_name group by reportField.category for reportField in selectableReportFields | orderBy:['selectSequence', 'category', 'display_name']\">\n" +
    "							<!-- <option value=\"\">-- Choose Field --</option> -->\n" +
    "						</select>\n" +
    "\n" +
    "						<span class=\"clickable font-lg font-dark-grey-hover\" ng-click='removeField($index)'>x</span>\n" +
    "					</div>\n" +
    "\n" +
    "					<a href='javascript:;' ng-click='addField()'>add field</a>\n" +
    "				</div>\n" +
    "\n" +
    "				<div ng-show='user.isMaster() && displaySQLLayout && !currentReport.from_model'>\n" +
    "					<div class=\"font-sub-header margin-7-bottom\"><span class='hes-popover' content='{{sqlOptions}}'>SQL</span></div>\n" +
    "\n" +
    "					<textarea ng-model='currentReport.sql'></textarea>\n" +
    "				</div>\n" +
    "\n" +
    "				<!-- Filters -->\n" +
    "				<div class='section'>\n" +
    "\n" +
    "					<!-- Dates -->\n" +
    "					<div class=\"font-sub-header margin-7-bottom\" ng-if=\"displaySQLLayout && !currentReport.from_model\">Effective Dates</div>\n" +
    "\n" +
    "					<fieldset ng-if=\"displaySQLLayout && !currentReport.from_model\">\n" +
    "						<input type='text' ng-model='reportFilter.reported_on_min' hes-date-select date-format='dateFormat' min-date='reportSite.starts_on' placeholder='Start Date' />\n" +
    "						<input type='text' ng-model='reportFilter.reported_on_max' hes-date-select date-format='dateFormat' placeholder='End Date' />\n" +
    "					</fieldset>\n" +
    "				</div>\n" +
    "				<!-- Locations -->\n" +
    "				<div class=\"section\">\n" +
    "					<div class=\"font-sub-header margin-7-bottom\" ng-show='site.is_location_displayed'>Location</div>\n" +
    "					<!-- Preselected Location -->\n" +
    "					<div class='location-name' ng-show='user.isLocationCoordinator()'>{{selectedLocation.name}}</div>\n" +
    "					<!-- Loading Locations -->\n" +
    "					<div ng-show='loadingLocations && (user.isRegionCoordinator() || user.isLocationCoordinator())'>\n" +
    "						<div class='inline loading-div'>\n" +
    "							<div hes-loading-gif loading='loadingLocations'></div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Region -->\n" +
    "					<div class='filter-item' ng-show='site.isLocationDisplayed() && user.isCoordinatorOrAbove()'>\n" +
    "						<div class=\"font-sub-header margin-7-bottom\">{{(reportSite||site).getLocationLabel(0)}}</div>\n" +
    "\n" +
    "						<select class='ie8_select_full_width' ng-model='selectRegion.level1' id=\"region\" ng-options='region as region.name for region in data.locations'>\n" +
    "							<option value=''>-- All --</option>\n" +
    "						</select>\n" +
    "						<br />\n" +
    "						<div class=\"font-sub-header margin-7-bottom\" ng-if='selectRegion.level1 && selectRegion.level1.locations.length > 0'>{{(reportSite||site).getLocationLabel(1)}}</div>\n" +
    "						<select class='ie8_select_full_width' ng-if='selectRegion.level1 && selectRegion.level1.locations.length > 0' id='location' ng-model='selectRegion.level2' ng-options='location.name for location in selectRegion.level1.locations'>\n" +
    "							<option value=''>-- All --</option>\n" +
    "						</select>\n" +
    "						<br />\n" +
    "						<div class=\"font-sub-header margin-7-bottom\" ng-if='selectRegion.level2 && selectRegion.level2.locations.length > 0'>{{(reportSite||site).getLocationLabel(2)}}</div>\n" +
    "						<select class='ie8_select_full_width' ng-if='selectRegion.level2 && selectRegion.level2.locations.length > 0' id='location' ng-model='selectRegion.level3' ng-options='location.name for location in selectRegion.level2.locations' ng-init=\"selectRegion.level3 = selectRegion.level2.locations[0]\"></select>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<!-- User Input Filters -->\n" +
    "				<div class=\"section\" ng-show='displaySimpleLayout'>\n" +
    "					<div >\n" +
    "						<div class=\"font-sub-header margin-7-bottom\">Filters</div>\n" +
    "\n" +
    "						<table ng-if=\"currentReport.filters.length > 0\" class='container margin-10-top filter-container padding-7-bottom' >\n" +
    "							<tr>\n" +
    "								<th>Field</th>\n" +
    "								<th>Criteria</th>\n" +
    "								<th>Value</th>\n" +
    "							</tr>\n" +
    "							<!-- ng-if, not ng-show: the row's ng-init would reset hidden filter values if it compiled -->\n" +
    "						<tr ng-repeat='filter in currentReport.filters' ng-if='!isHiddenField(filter.field)'>\n" +
    "								<td>\n" +
    "									<select ng-model='currentReport.filters[$index].field' ng-options=\"reportField as reportField.display_name group by reportField.category for reportField in selectableReportFields | filter: {filterable: true} | orderBy: 'display_name'\">\n" +
    "										<option value=''>-- Choose --</option>\n" +
    "									</select>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<select style=\"width:110px;\" ng-model='currentReport.filters[$index].sign' ng-options='sign.value as sign.text for sign in filterCriteria'>\n" +
    "										<option value=''>-- Choose --</option>\n" +
    "									</select>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input style=\"width:85%;\" ng-if='filter.sign !== \"between\"' type='text' ng-model='filter.value' ng-init=\"filter.value = ''\" placeholder='Value' />\n" +
    "									<fieldset ng-if=\"filter.sign === 'between' && isDateField(filter.field)\" ng-init=\"setBetweenValues(filter, true)\"><span class=\"font-mid-grey margin-7-right\">to</span>\n" +
    "										<input  class=\"sm\" type='text' ng-model='filter.value[0]' hes-date-select date-format='dateFormat' min-date='reportSite.registration_starts_on' placeholder='Start Date' />\n" +
    "										<input  class=\"sm\" type='text' ng-model='filter.value[1]' hes-date-select date-format='dateFormat' placeholder='End Date' />\n" +
    "									</fieldset>\n" +
    "									<fieldset ng-if=\"filter.sign === 'between' && !isDateField(filter.field)\" ng-init=\"setBetweenValues(filter, false)\">\n" +
    "										<input class=\"sm\" type='text' ng-model='filter.value[0]' placeholder='Value' /><span class=\"font-mid-grey margin-7-right\">to</span>\n" +
    "										<input class=\"sm\" type='text' ng-model='filter.value[1]' placeholder='Value' />\n" +
    "									</fieldset>\n" +
    "									<span class=\"clickable font-lg font-dark-grey-hover\" ng-click='removeFilter($index)'>x</span>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</table>\n" +
    "						<a ng-show=\"canAddFilter()\" href='javascript:;' ng-click='addFilter()'>add filter</a>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div>\n" +
    "		<!-- Report Actions -->\n" +
    "		<div class='center margin-7-bottom-top' ng-if=\"!settings.loading\" ng-class=\"{ 'margin-40': currentReport.from_model }\">\n" +
    "			<button ng-click='runReport()' ng-show='(currentReport.isSimple() && currentReport.fields.length > 0) || currentReport.isSQL()'>Run</button>\n" +
    "\n" +
    "			<button ng-click='saveReport()' ng-show='canSaveReport(currentReport) && !currentReport.from_model'>Save</button>\n" +
    "\n" +
    "			<button ng-click='promptCreateReport()' ng-show='!currentReport.from_model && !currentReport.isNew() && (user.isCoordinatorOrAbove() || user.isRegionCoordinator())'>Save As...</button>\n" +
    "			<button ng-click='exportReport()' ng-show='reportData.rows'>Export</button>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Running/Saving -->\n" +
    "		<div class='report-running' ng-show='settings.reportRunning || settings.reportSaving'>\n" +
    "			<div class='inline loading-div'>\n" +
    "				<div hes-loading-gif loading='settings.reportRunning || settings.reportSaving'></div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Errors -->\n" +
    "		<p class='message error' ng-show='reportError'>Sorry, there was an error running this report.</p>\n" +
    "		<p class='message error' ng-show='reportSaveError'>Sorry, there was an error saving this report.</p>\n" +
    "\n" +
    "		<!-- No Data -->\n" +
    "		<p class='message error' ng-show='noRowsReturned && !reportPristine'>Sorry, no data available.</p>\n" +
    "\n" +
    "		<!-- Smart Table -->\n" +
    "		<div ng-if=\"reportData.rows.length > 0\" hes-table tbl-data=\"reportData\" report-name=\"currentReport.name\" external-calls=\"exportCall\"></div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/resources/views/resourcePreview.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/resources/views/resourcePreview.html",
    "<div class=\"content-preview\">\n" +
    "    <div class='title' ng-bind-html='content.group'></div>\n" +
    "    <a href=\"{{content.summary}}\" target=\"_blank\">\n" +
    "        <div class='title' ng-if=\"content.title_html !== ''\" ng-bind-html='content.title_html' hes-external-links></div>\n" +
    "    </a>\n" +
    "    <div class='image' ng-if=\"content.image\"><img ng-src=\"{{content.image.url}}\"/></div>\n" +
    "    <div class='' ng-if=\"content.content_html !== ''\" ng-bind-html='content.content_html' hes-external-links></div>\n" +
    "</div>");
}]);

angular.module("/scripts/resources/views/resources.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/resources/views/resources.html",
    "<div hes-external-links class=\"resource-list\">\n" +
    "  \n" +
    "  <div class=\"group\"\n" +
    "       ng-repeat=\"(group, resources) in data.grouped_contents\">\n" +
    "    <h2 class=\"group-label\">{{ group }}</h2>\n" +
    "\n" +
    "    <a href=\"{{resource.summary}}\" id=\"{{resource.id}}\" ng-repeat=\"resource in resources\" aria-label=\"{{resource.title}}\">\n" +
    "      <md-divider></md-divider>\n" +
    "      <div class=\"item\">\n" +
    "        <div class=\"image-frame\">\n" +
    "          <img alt=\"\" class=\"preview-image\" hes-image=\"{{::resource.image1.url}}\" use-domain=\"true\" no-theme/>\n" +
    "        </div>\n" +
    "        <div flex class=\"preview\">\n" +
    "          <div flex class=\"secondary-text\">{{resource.date | date: \"EEE, MMM d\"}}</div>\n" +
    "          <div flex class=\"title\" markdown-div no-paragraph ng-model='::resource.title'></div>\n" +
    "          <div  flex class=\"summary\" markdown-div ng-model=\"::resource.content_html\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"external-link\">\n" +
    "          <span hes-icon icon-name=\"standard:icon-external-link\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <md-divider ng-if=\"$last\"></md-divider>\n" +
    "    </a>\n" +
    "    \n" +
    "  </div>\n" +
    "  \n" +
    "  \n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/searchInput/searchInput.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/searchInput/searchInput.html",
    "<form name=\"search\" ng-submit=\"$ctrl.onEnter()\">\n" +
    "  <input type=\"text\" placeholder=\"{{$ctrl.placeholderText}}\" class=\"search\" ng-model=\"$ctrl.searchValue\"/>\n" +
    "  <button type=\"button\" ng-if=\"!!$ctrl.searchValue\" class=\"link-look clear-btn\" ng-click=\"$ctrl.clearSearch()\">Clear</button>\n" +
    "  <button class=\"icon-btn search-icon\" aria-label=\"Start searching\">\n" +
    "    <span hes-icon icon-name=\"standard:search\"></span>\n" +
    "  </button>\n" +
    "</form>");
}]);

angular.module("/scripts/settings/dashboard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/settings/dashboard.html",
    "<div class='settings-content dashboard'>\n" +
    "\n" +
    "	<form hes-validator class=\"hes\">\n" +
    "\n" +
    "		<fieldset>\n" +
    "			<legend>User Settings</legend>\n" +
    "			<div class=\"row\">\n" +
    "				<span>\n" +
    "					<label>First name</label>\n" +
    "					<input type='text' ng-model='dashboardSettingsUser.profile.first_name' hes-required />	\n" +
    "				</span>\n" +
    "				<span>\n" +
    "					<label>Last name</label>\n" +
    "					<input type='text' ng-model='dashboardSettingsUser.profile.last_name' hes-required />\n" +
    "				</span>\n" +
    "			</div>\n" +
    "			<div class=\"row\">\n" +
    "				<span>\n" +
    "					<label>Email</label>\n" +
    "					<input type='email' ng-model='dashboardSettingsUser.placeholderEmail' ng-change='checkUniqueEmail()' hes-required />	\n" +
    "				</span>\n" +
    "			</div>\n" +
    "\n" +
    "			<div class=\"row\">\n" +
    "				<span>\n" +
    "					<label>Role</label>\n" +
    "					<select ng-model='dashboardUser.role' ng-options='option as option for option in roleChoices'>\n" +
    "						<option value=''>-- Choose --</option>\n" +
    "					</select>\n" +
    "				</span>\n" +
    "			</div>\n" +
    "\n" +
    "			<div class=\"row\">\n" +
    "      	<span>\n" +
    "        	<label class=\"checkbox-label inline\">Has Seen Why Steps\n" +
    "          	<input id=\"has_seen_why_steps\" type=\"checkbox\" ng-model=\"dashboardSettingsUser.flags.has_seen_why_steps\"/>\n" +
    "        	</label>\n" +
    "      	</span>\n" +
    "    	</div>\n" +
    "\n" +
    "			<!-- Location -->\n" +
    "			<div class=\"row\">\n" +
    "				<span ng-if='dashboardUserSite.flags.is_location_displayed'>\n" +
    "					<label>{{dashboardUserSite.getLocationLabel(0)}}</label>\n" +
    "					<select class='ie8_select_full_width' ng-model='dashboardSettingsUser.parentLocation' ng-options='location as location.name for location in data.parentLocations' ng-change=\"locationChanged('parent')\" hes-required>\n" +
    "						<option value=''>-- Choose --</option>\n" +
    "					</select>\n" +
    "				</span>\n" +
    "				<span>\n" +
    "					<label ng-if='displayChildLocations()'>{{dashboardUserSite.getLocationLabel(1)}}</label>\n" +
    "					<select class='ie8_select_full_width' ng-if='displayChildLocations()' ng-model='dashboardSettingsUser.childLocation' ng-options='location as location.name for location in dashboardSettingsUser.parentLocation.locations'>\n" +
    "						<option value=''>-- Choose --</option>\n" +
    "					</select>\n" +
    "				</span>\n" +
    "			</div>\n" +
    "\n" +
    "			<div class=\"row\"\n" +
    "			     ng-include=\"hesTemplateService.getTemplateUrl('/scripts/devices/device_information.html')\"\n" +
    "					 ng-controller=\"DeviceInformationController\">\n" +
    "			</div>\n" +
    "		</fieldset>\n" +
    "\n" +
    "\n" +
    "		<!-- Save -->\n" +
    "		<div class='save-button'>\n" +
    "			<button hes-validate-click='updateUserInfo()' ng-disabled='savingUser'>SAVE</button>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Saving -->\n" +
    "		<div class='saving' ng-show='savingUser'>\n" +
    "			<div hes-loading-gif loading='savingUser'></div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Saved -->\n" +
    "		<div class='center' style='margin-top: 15px;' ng-show='saved'>\n" +
    "			<div class='font-sm font-gray'>Saved!</div>\n" +
    "		</div>\n" +
    "	</form>\n" +
    "</div>");
}]);

angular.module("/scripts/settings/message-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/settings/message-popup.html",
    "<div>\n" +
    "	<div class='center black-text'>\n" +
    "		Pardon the interruption. Please take a moment to confirm your work location. If you have elected to participate in the Reward and Recognition program, be sure your home address is correct. Click SAVE to continue using Go KP.\n" +
    "	</div>\n" +
    "	<br />\n" +
    "	<div class='center'>\n" +
    "		<button ng-click='closePopup()'>Got it!</button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/settings/settings-email.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/settings/settings-email.html",
    "<div class='settings' ng-if='!settings.loading' hes-validator>\n" +
    "\n" +
    "  <div flex layout=\"column\" layout-gt-xs=\"row\" layout-wrap>\n" +
    "    <!-- Email Options -->\n" +
    "    <div flex='100' flex-gt-xs='50' class='settings-column'>\n" +
    "      <div ng-if=\"!site.flags.disable_daily_emails\">\n" +
    "        <label id=\"title\">Daily Tip Frequency</label>\n" +
    "        <select ng-model='settingsUser.subscription.email_daily' ng-change=\"subChangeHandler()\" aria-labelledby=\"title\">\n" +
    "          <option ng-repeat=\"freq in ['None', 'Monday - Friday', 'Monday Only']\"\n" +
    "            ng-value=\"$index\">\n" +
    "            {{ freq }}\n" +
    "          </option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "      <div>\n" +
    "        <label>I want to receive...</label>\n" +
    "\n" +
    "        <table ng-if=\"site.flags.is_wall_enabled\">\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div role=\"checkbox\" id=\"emailCheck1\"\n" +
    "                hes-checkbox class='hes-checkbox inline'\n" +
    "                label-name='emailCheck1'\n" +
    "                ng-change=\"subChangeHandler()\"\n" +
    "                ng-model='settingsUser.subscription.email_wall_posts'\n" +
    "                aria-checked=\"true\"\n" +
    "                tabindex=\"0\"\n" +
    "                aria-labelledby=\"label1\"></div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div name='emailCheck1' id=\"label1\" class='checkbox-label'>Wall Emails</div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "\n" +
    "        <table ng-if=\"site.flags.is_peers_enabled\">\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div role=\"checkbox\" id=\"emailCheck2\"\n" +
    "                hes-checkbox class='hes-checkbox inline'\n" +
    "                label-name='emailCheck2'\n" +
    "                ng-change=\"subChangeHandler()\"\n" +
    "                ng-model='settingsUser.subscription.email_friend_requests'\n" +
    "                aria-checked=\"true\"\n" +
    "                tabindex=\"0\"\n" +
    "                aria-labelledby=\"label2\"></div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div name='emailCheck2' id=\"label2\" class='checkbox-label'>{{site.getFriendsLabel(false)}} Emails</div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "\n" +
    "        <!-- <table ng-if=\"site.flags.is_badges_enabled\">\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div type=\"checkbox\" id=\"emailCheck3\"\n" +
    "                hes-checkbox class='hes-checkbox inline'\n" +
    "                label-name='emailCheck3'\n" +
    "                ng-change=\"subChangeHandler()\"\n" +
    "                ng-model='settingsUser.subscription.email_badges'\n" +
    "                aria-checked=\"true\"\n" +
    "                tabindex=\"0\"\n" +
    "                aria-labelledby=\"label3\"></div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div name='emailCheck3' id=\"label3\" class='checkbox-label'>Badge Emails</div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table> -->\n" +
    "\n" +
    "        <table ng-if=\"site.flags.is_challenges_enabled\">\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div type=\"checkbox\" id=\"emailCheck4\"\n" +
    "                hes-checkbox class='hes-checkbox inline'\n" +
    "                label-name='emailCheck4'\n" +
    "                ng-change=\"subChangeHandler()\"\n" +
    "                ng-model='settingsUser.subscription.email_challenges'\n" +
    "                aria-checked=\"true\"\n" +
    "                tabindex=\"0\"\n" +
    "                aria-labelledby=\"label4\"></div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div name='emailCheck4' id=\"label4\" class='checkbox-label'>Challenge Emails</div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "\n" +
    "\n" +
    "        <table>\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div type=\"checkbox\" id=\"emailCheck5\"\n" +
    "                hes-checkbox class='hes-checkbox inline'\n" +
    "                label-name='emailCheck4'\n" +
    "                ng-change=\"subChangeHandler()\"\n" +
    "                ng-model='settingsUser.subscription.email_site'\n" +
    "                aria-checked=\"true\"\n" +
    "                tabindex=\"0\"\n" +
    "                aria-labelledby=\"label4\"></div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div name='emailCheck5' id=\"label5\" class='checkbox-label'><em>{{ site.name }}</em> Announcements</div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Unsubscribe -->\n" +
    "    <div flex='100' flex-gt-xs='50' class='settings-column margin-10-top'>\n" +
    "      <label>Unsubscribe</label>\n" +
    "      <table>\n" +
    "        <tr>\n" +
    "          <td>\n" +
    "            <div type=\"checkbox\" id=\"emailUnsubscribe\"\n" +
    "              hes-checkbox class='hes-checkbox inline'\n" +
    "              label-name='emailUnsubscribe'\n" +
    "              ng-change=\"unsubFromAllChangeHandler()\"\n" +
    "              ng-model='settingsUser.subscription.email_unsubscribe_all'\n" +
    "              aria-checked=\"false\"\n" +
    "              tabindex=\"0\"\n" +
    "              aria-labelledby=\"label5\"></div>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <div name='emailUnsubscribe' class='checkbox-label' id=\"label5\">Unsubscribe from all emails</div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "      </table>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Save -->\n" +
    "    <div flex=\"100\" class=\"text-right settings-column button-container\">\n" +
    "      <span hes-loading-gif loading=\"savingUser\"></span>\n" +
    "      <span ng-show=\"saved\" class='font-md font-primary-color'>Saved!</span>\n" +
    "      <button aria-label=\"Save Changes\" class=\"margin-md-left\" id='create_account_button' class='big' ng-class='{disabled: savingUser}' ng-disabled='savingUser' hes-validate-click='updateUserInfo()'>Save Changes</button>\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/settings/settings-tracking.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/settings/settings-tracking.html",
    "<div class=\"settings-devices choose-log\">\n" +
    "  <div ng-if=\"!user.hasChosenLogging() && !ChooseLogCtrl.view.selectDevice\" \n" +
    "    markdown-div \n" +
    "    ng-model=\"::ChooseLogCtrl.view.settingsContent.content_html\">\n" +
    "  </div>\n" +
    "  \n" +
    "  <hes-choose-logging \n" +
    "    ng-if=\"!ChooseLogCtrl.view.selectDevice && (!user.hasChosenLogging() || user.isLoggingManually())\" \n" +
    "    user=\"user\" \n" +
    "    site=\"site\" \n" +
    "    on-select-device=\"ChooseLogCtrl.showSelectDevice()\">\n" +
    "  </hes-choose-logging>\n" +
    "\n" +
    "  <hes-breadcrumb ng-if=\"ChooseLogCtrl.view.selectDevice\" \n" +
    "    crumbs=\"ChooseLogCtrl.view.crumbs\">\n" +
    "  </hes-breadcrumb>\n" +
    "  <hes-marketplace ng-if=\"user.isAnyDeviceConnected() || ChooseLogCtrl.view.selectDevice\">\n" +
    "  </hes-marketplace>\n" +
    "</div>");
}]);

angular.module("/scripts/settings/settings.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/settings/settings.html",
    "<form autocomplete=\"off\" name='settingsForm'>\n" +
    "  <input type=\"text\" style=\"display:none\">\n" +
    "  <input type=\"password\" style=\"display:none\">\n" +
    "  <div class='settings' ng-if='!settings.loading' hes-validator>\n" +
    "    <div flex layout=\"column\" layout-gt-xs=\"row\" layout-wrap>\n" +
    "\n" +
    "      <!-- Info -->\n" +
    "      <div flex='100' flex-gt-xs='50' class='settings-column'>\n" +
    "        <div>\n" +
    "          <label>Name</label>\n" +
    "          <label class='screen-hidden' for=\"first_name\">First Name</label>\n" +
    "          <input type='text' id='first_name' name='first_name'\n" +
    "            ng-model='settingsUser.profile.first_name' placeholder='First Name' hes-required /><br>\n" +
    "          <label class='screen-hidden' for=\"last_name\">Last Name</label>\n" +
    "          <input type='text' id='last_name' name='last_name' ng-model='settingsUser.profile.last_name'\n" +
    "            placeholder='Last Name' hes-required />\n" +
    "        </div>\n" +
    "\n" +
    "        <div>\n" +
    "          <label for=\"email\">Email Address</label>\n" +
    "          <span ng-model=\"settingsUser.placeholderEmail\" hes-required>\n" +
    "            <input type='email' id='email' name='email' hes-popover\n" +
    "              content='Email already taken' tip-joint='bottom' target-joint='top' event='null'\n" +
    "              custom-show='{{emailAlreadyTaken}}' hide-event='null' border-color='red'\n" +
    "              ng-model='settingsUser.placeholderEmail' placeholder='Email Address'\n" +
    "              ng-change='checkUniqueEmail()' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if='!!site.is_sso_enabled' class=\"margin-10-top\">\n" +
    "          <!-- Mobile Title -->\n" +
    "          <div ng-if=\"!!mobilePasswordInstruction.title && !data.changing_password\">\n" +
    "            <label ng-if=\"!!mobilePasswordInstruction.title\">{{mobilePasswordInstruction.title}}</label>\n" +
    "          </div>\n" +
    "          <div ng-if=\"!mobilePasswordInstruction.title && !data.changing_password\">\n" +
    "            <label>Mobile Password</label>\n" +
    "          </div>\n" +
    "          <!-- Mobile Content -->\n" +
    "          <div ng-if=\"!!mobilePasswordInstruction.content && !data.changing_password\">\n" +
    "            <div class=\"padding-10-bottom\" ng-bind-html='mobilePasswordInstruction.content_html'></div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"!data.changing_password\" class='changing-password'>\n" +
    "            <a class=\"secondary\" ng-click='changePassword(true)'>Change {{ site.is_sso_enabled ? 'Mobile' : '' }} Password</a>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"data.changing_password\" class='changing-password'>\n" +
    "          <label for=\"password\">New {{ site.is_sso_enabled ? 'Mobile' : '' }} Password</label>\n" +
    "          <input type='password' id='password' name='password' hes-popover\n" +
    "            ng-model='settingsUser.placeholderPassword' placeholder=\"New{{ site.is_sso_enabled ? ' Mobile' : '' }} Password\"\n" +
    "            content='{{ site.password_help_message }}'\n" +
    "            tip-joint='bottom' target-joint='top' custom-show='{{password_invalid_format}}'\n" +
    "            event='null' hide-event='null' border-color='red' /><br>\n" +
    "          <label for=\"password2\">Confirm New {{site.is_sso_enabled ? 'Mobile' : '' }} Password</label>\n" +
    "          <input type='password' id='password2' name='password2' hes-popover\n" +
    "            content='Passwords do not match' tip-joint='bottom' target-joint='top' event='null'\n" +
    "            custom-show='{{password_invalid}}' hide-event='null' border-color='red'\n" +
    "            ng-model='settingsUser.placeholderRetypePassword' placeholder=\"Confirm New{{ site.is_sso_enabled ? ' Mobile' : '' }} Password\" />\n" +
    "            <div>\n" +
    "              <div ng-if=\"!!site.password_help_message_list\">\n" +
    "                <div class=\"padding-10-bottom\" ng-bind-html=\"site.password_help_message_list\"></div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          <!-- <a class=\"secondary\" ng-click='changePassword(false)'>Cancel</a> -->\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"site.flags.allow_set_location\">\n" +
    "          <label>{{site.getLocationLabel(0)}}</label>\n" +
    "          <div>\n" +
    "            <select id=\"location\" class='ie8_select_full_width' ng-model='settingsUser.parentLocation' ng-options='location as location.name for location in data.parentLocations' ng-change=\"locationChanged('parent')\" hes-required>\n" +
    "              <option value=''>-- Choose --</option>\n" +
    "            </select>\n" +
    "\n" +
    "            <label ng-if='displayChildLocations()'>{{site.getLocationLabel(1)}}</label>\n" +
    "            <select id=\"location_2\" class='ie8_select_full_width' ng-if='displayChildLocations()' ng-model='settingsUser.childLocation' ng-options='location as location.name for location in settingsUser.parentLocation.locations' hes-required>\n" +
    "              <option value=''>-- Choose --</option>\n" +
    "            </select>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"site.flags.is_aktivetrak\">\n" +
    "          <table>\n" +
    "            <tr>\n" +
    "              <td>\n" +
    "                <div type=\"checkbox\" id=\"emailUnsubscribe\"\n" +
    "                  hes-checkbox class='hes-checkbox inline'\n" +
    "                  label-name='emailUnsubscribe'\n" +
    "                  ng-change=\"unsubFromAllChangeHandler()\"\n" +
    "                  ng-model='settingsUser.subscription.email_unsubscribe_all'\n" +
    "                  aria-checked=\"false\"\n" +
    "                  tabindex=\"0\"\n" +
    "                  aria-labelledby=\"label5\"></div>\n" +
    "              </td>\n" +
    "              <td>\n" +
    "                <div name='emailUnsubscribe' class='checkbox-label' id=\"label5\">Unsubscribe from emails</div>\n" +
    "              </td>\n" +
    "            </tr>\n" +
    "          </table>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "\n" +
    "      <!-- Photo -->\n" +
    "      <div flex='100' flex-gt-xs='50' class='settings-column'>\n" +
    "        <label>Photo</label>\n" +
    "        <div class='user-photo'>\n" +
    "          <div class=\"choose-photo-container\" ng-hide=\"photoNotCropped\">\n" +
    "            <div hes-file-upload\n" +
    "              ng-model='settingsUser.profile.image'\n" +
    "              label='{{hasDefaultImage() ? \"Choose\" : \"Upload\"}}'\n" +
    "              start='uploadPhotoStart()'\n" +
    "              complete='saveUserImage(imageUrl)'\n" +
    "              cancel='cancelPhotoCrop()'\n" +
    "              image-class=\"md-lg-img\"\n" +
    "              allow-drop=\"true\"\n" +
    "              thumbnail-url=\"user.profile.image.url\"\n" +
    "              hide-pre-crop=\"true\"\n" +
    "              show-cropper></div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div flex='100' flex-gt-xs='100' class='settings-column sms' ng-if=\"site.flags.is_sms_enabled\">\n" +
    "          <table >\n" +
    "              <tr>\n" +
    "                <td colspan=\"2\">\n" +
    "                  <label>SMS Messaging</label>\n" +
    "                </td>\n" +
    "              </tr>\n" +
    "              <tr>\n" +
    "              <td>\n" +
    "                  <div type=\"checkbox\" id=\"smsCheck\" aria-describedBy=\"smsCheckLabel\" hes-checkbox  class='hes-checkbox inline margin-n-3-bottom' label-name='smsCheck' ng-model='settingsUser.allows_sms'></div>\n" +
    "              </td>\n" +
    "              <td>\n" +
    "                  <div name='smsCheck' class=\"checkbox-label margin-n-20-bottom\"><span id=\"smsCheckLabel\"><span id=\"smsAgreement\" markdown ng-model='smsAgreement.content'></span></span>\n" +
    "              </td>\n" +
    "              </tr>\n" +
    "          </table>\n" +
    "          <table ng-if=\"settingsUser.allows_sms\">\n" +
    "              <td>\n" +
    "                <div\n" +
    "                    hes-popover\n" +
    "                    content='Invalid Phone Number' tip-joint='bottom' target-joint='top' event='null'\n" +
    "                    tip-joint='bottom' target-joint='top' event='null'\n" +
    "                    custom-show='{{phone_invalid}}' hide-event='null' border-color='red'>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                  <input type=\"tel\" ng-model=\"settingsUser.profile.phone\" name=\"tel\" class=\"phone\" aria-describedBy=\"phone input\" ng-change=\"setPhone()\" intl-tel-input/>\n" +
    "                </div>\n" +
    "              </td>\n" +
    "              <td>\n" +
    "                  <select ng-model=\"settingsUser.profile.time_zone\" ng-options=\"zone as zone for zone in timeZones\" ng-init=\"settingsUser.profile.time_zone = settingsUser.profile.time_zone != null ? settingsUser.profile.time_zone : site.time_zone\" aria-describedBy=\"time zone select\" class=\"time-zone\">\n" +
    "                  </select>\n" +
    "              </td>\n" +
    "          </table>\n" +
    "      </div>\n" +
    "\n" +
    "      <div flex='100' class='settings-column'>\n" +
    "\n" +
    "        <div ng-if=\"settingsUser.profile_prompts\">\n" +
    "          <div ng-repeat=\"(name, questions) in settingsUser.profile_prompts | groupBy: 'evaluation_name'\">\n" +
    "            <div ng-repeat=\"question in questions\">\n" +
    "              <label ng-if='question.type_of_prompt != \"CHECKBOX\" && question.type_of_prompt != \"HEADER\"' id=\"{{question.answer_column_name}}_label\" class='question-label' for='{{question.answer_column_name}}_input'><span markdown no-paragraph ng-model=\"question.prompt\"></span></label>\n" +
    "              <!-- required -->\n" +
    "              <div ng-if='question.is_required'>\n" +
    "                <table ng-if='question.type_of_prompt == \"CHECKBOX\"'>\n" +
    "                  <tr>\n" +
    "                    <td class=\"col-checkbox\">\n" +
    "                      <div hes-checkbox aria-describedBy=\"{{question.answer_column_name}}_label\" id=\"{{question.answer_column_name}}_check\" name='{{question.answer_column_name}}_input' ng-model='question.answer' hes-required class='hes-checkbox margin-10-right inline' label-name='{{question.answer_column_name}}_label' type='checkbox' ng-true-value=\"{{question.data_type === 'string' ? 'Y' : 1}}\" ng-false-value=\"0\"></div>\n" +
    "                    </td>\n" +
    "                    <td class=\"col-checkbox-label\">\n" +
    "                      <div>\n" +
    "                        <div ng-if='question.type_of_prompt == \"CHECKBOX\"' id=\"{{question.answer_column_name}}_label\" name='{{question.answer_column_name}}_label' class='checkbox-label question-label' markdown no-paragraph ng-model='question.prompt'></div>\n" +
    "                      </div>\n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                </table>\n" +
    "                <select class=\"\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"DROPDOWN\"' hes-required id=\"{{question.answer_column_name}}_input\" name='{{question.answer_column_name}}_input' ng-model='question.answer'>\n" +
    "                  <option value=''>Choose…</option>\n" +
    "                  <option ng-repeat='option in question.options_array' value=\"{{option}}\">{{option}}</option>\n" +
    "                </select>\n" +
    "                <textarea id=\"{{question.answer_column_name}}_input\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"TEXTAREA\"' hes-required name='{{question.answer_column_name}}_input' ng-model='question.answer'/></textarea>\n" +
    "                <input id=\"{{question.answer_column_name}}_input\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"TEXTBOX\"' hes-required name='{{question.answer_column_name}}_input' ng-model='question.answer' />\n" +
    "              </div>\n" +
    "              <!-- not required -->\n" +
    "              <div ng-if='!question.is_required'>\n" +
    "                <table ng-if='question.type_of_prompt == \"CHECKBOX\"'>\n" +
    "                  <tr>\n" +
    "                    <td class=\"col-checkbox\">\n" +
    "                      <div hes-checkbox aria-describedBy=\"{{question.answer_column_name}}_label\" id=\"{{question.answer_column_name}}_check\" name='{{question.answer_column_name}}_input' ng-model='question.answer' class='hes-checkbox margin-10-right inline' label-name='{{question.answer_column_name}}_label' type='checkbox' ng-true-value=\"{{question.data_type === 'string' ? 'Y' : 1}}\" ng-false-value=\"0\"></div>\n" +
    "                    </td>\n" +
    "                    <td class=\"col-checkbox-label\">\n" +
    "                      <div>\n" +
    "                        <div ng-if='question.type_of_prompt == \"CHECKBOX\"' id=\"{{question.answer_column_name}}_label\" name='{{question.answer_column_name}}_label' class='checkbox-label question-label' markdown no-paragraph ng-model='question.prompt'></div>\n" +
    "                      </div>\n" +
    "                    </td>\n" +
    "                  </tr>\n" +
    "                </table>\n" +
    "                <select class=\"\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"DROPDOWN\"' id=\"{{question.answer_column_name}}_input\" name='{{question.answer_column_name}}_input' ng-model='question.answer'>\n" +
    "                  <option value=''>Choose…</option>\n" +
    "                  <option ng-repeat='option in question.options_array' value=\"{{option}}\">{{option}}</option>\n" +
    "                </select>\n" +
    "                <textarea id=\"{{question.answer_column_name}}_input\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"TEXTAREA\"' name='{{question.answer_column_name}}_input' ng-model='question.answer'/></textarea>\n" +
    "                <input id=\"{{question.answer_column_name}}_input\" aria-describedBy=\"{{question.answer_column_name}}_label\" ng-if='question.type_of_prompt == \"TEXTBOX\"' name='{{question.answer_column_name}}_input' ng-model='question.answer' />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- Shipping Address -->\n" +
    "      <div flex='100' class='settings-column'>\n" +
    "\n" +
    "        <div ng-if=\"site.flags.is_address_displayed\">\n" +
    "          <div class=\"name address-label\" markdown-div ng-model='data.addressLabel' no-paragraph></div>\n" +
    "          <div>\n" +
    "            <div markdown-div ng-model='data.addressContent'></div>\n" +
    "            <label class=\"screen-hidden\" for=\"line1\">Address line 1</label>\n" +
    "            <input type=\"text\" id=\"line1\" name=\"line1\" ng-model=\"settingsUser.profile.line1\" placeholder=\"Address line 1\" hes-required />\n" +
    "          </div>\n" +
    "          <div>\n" +
    "            <label class=\"screen-hidden\" for=\"line2\">Address line 2</label>\n" +
    "            <input type=\"text\" class=\"right\" id=\"line2\" name=\"line2\" ng-model=\"settingsUser.profile.line2\" placeholder=\"Address line 2\" />\n" +
    "          </div>\n" +
    "          <div class=\"flex-row\">\n" +
    "            <div flex-gt-xs='45'>\n" +
    "              <label class=\"screen-hidden\" for=\"city\">City</label>\n" +
    "              <input type=\"text\" class=\"left\" id=\"city\" name=\"city\" ng-model=\"settingsUser.profile.city\" placeholder=\"City\" hes-required />\n" +
    "            </div>\n" +
    "            <div flex-gt-xs='30'>\n" +
    "              <label class=\"screen-hidden\" for=\"state_province\">State/Province</label>\n" +
    "              <select hes-invisible-label=\"State or Province\" class=\"state_province\" id='state_province' ng-model='settingsUser.profile.state_province' ng-options='state.abbreviation as state.stateName for state in stateChoices' hes-required >\n" +
    "                  <option value=''>-- State/Province --</option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "            <div flex-gt-xs='20'>\n" +
    "              <label class=\"screen-hidden\" for=\"city\">Postal code</label>\n" +
    "              <input type=\"text\" class=\"left\" id=\"postal_code\" name=\"postal_code\" ng-model=\"settingsUser.profile.postal_code\" placeholder=\"Postal code\" hes-required />\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"button-container text-right settings-column\" ng-show=\"!!isFormDirty()\">\n" +
    "        <span hes-timed-message display-for=\"2000\" class=\"font-md\" show=\"saved\">Saved!</span>\n" +
    "        <button class=\"cancel\" ng-hide='settings.savingUser || !isFormDirty()' ng-click=\"resetPage()\">Cancel</button>\n" +
    "        <button class=\"button-secondary\" hes-validate-click=\"updateUserInfo()\" ng-class='{disabled: !isFormDirty()}' ng-disabled='settings.savingUser || !isFormDirty()'>{{settings.savingUser ? 'Saving' : 'Save'}}</button>\n" +
    "      </div>\n" +
    "      <div class=\"padding-5-top\" error-banner priority-level=1></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("/scripts/shareResource/email/emailResource.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/shareResource/email/emailResource.html",
    "<div>\n" +
    "  <h2 class=\"dialog-title\">Email</h2>\n" +
    "  <form name=\"emailForm\" ng-submit=\"emailResource()\" ng-controller=\"EmailResourceCtrl\">\n" +
    "    <div class=\"full-width-form\">\n" +
    "      <p id=\"email-info\"\n" +
    "        class=\"dialog-info\">Enter a friend’s email or multiple addresses (separated by commas), then add a custom message.</p>\n" +
    "      <input name=\"emails\" id=\"emails\" ng-model=\"emails\" aria-label=\"emails\"\n" +
    "        aria-describedby=\"email-info\" class=\"dialog-field\" resource-emails\n" +
    "        placeholder=\"Email\" hes-autofocus required autocomplete=\"off\">\n" +
    "      <textarea aria-label=\"message\" class=\"dialog-field\" id=\"message\"\n" +
    "        ng-model=\"message\" placeholder=\"Message\"></textarea>\n" +
    "      <div class=\"dialog-buttons text-right\">\n" +
    "        <ng-messages for=\"emailForm.emails.$error\" role=\"alert\">\n" +
    "          <span ng-message=\"emails\">Please enter an email or emails separated by commas</span>\n" +
    "          <span ng-message=\"properEmails\">Email must include @ symbol</span>\n" +
    "          <span ng-message=\"fail\">An error has occured. Please try again</span>\n" +
    "        </ng-messages>\n" +
    "        <button type=\"submit\" class=\"dialog-button\"\n" +
    "          ng-disabled=\"isSending || sentSuccessfully\"\n" +
    "          ng-class=\"{disabled: isSending || sentSuccessfully}\">Send</button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/shareResource/shareDial.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/shareResource/shareDial.html",
    "<md-fab-speed-dial md-open=\"$ctrl.settings.shareOpen\" md-direction=\"right\" class=\"share-dial no-print md-fling\">\n" +
    "  <md-fab-trigger>\n" +
    "    <button class=\"icon-btn trigger-btn\" aria-label=\"share menu\"\n" +
    "      ng-click=\"$ctrl.postToWall()\">\n" +
    "      <md-tooltip md-direction=\"bottom\">Share</md-tooltip>\n" +
    "      <span hes-icon icon-name=\"share:sharing\"></span>\n" +
    "    </button>\n" +
    "  </md-fab-trigger>\n" +
    "  <md-fab-actions>\n" +
    "    <button class=\"icon-btn\" tabindex=\"{{!$ctrl.settings.shareOpen ? -1 : 0}}\"\n" +
    "      ng-click=\"$ctrl.shareToWall()\">\n" +
    "      <md-tooltip md-direction=\"bottom\">Share to Wall</md-tooltip>\n" +
    "      <span hes-icon icon-name=\"share:to-wall\"></span>\n" +
    "    </button>\n" +
    "    <button class=\"icon-btn\" tabindex=\"{{!$ctrl.settings.shareOpen ? -1 : 0}}\"\n" +
    "      ng-click=\"$ctrl.openEmailDialog()\">\n" +
    "      <md-tooltip md-direction=\"bottom\">Email</md-tooltip>\n" +
    "      <span hes-icon icon-name=\"share:email\"></span>\n" +
    "    </button>\n" +
    "    <button class=\"icon-btn\" tabindex=\"{{!$ctrl.settings.shareOpen ? -1 : 0}}\"\n" +
    "      ng-click=\"$ctrl.print()\" ng-hide=\"$ctrl.type == 'Goal'\">\n" +
    "      <md-tooltip md-direction=\"bottom\">Print</md-tooltip>\n" +
    "      <span hes-icon icon-name=\"share:print\"></span>\n" +
    "    </button>\n" +
    "  </md-fab-actions>\n" +
    "</md-fab-speed-dial>");
}]);

angular.module("/scripts/shareResource/shareToWall/shareToWall.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/shareResource/shareToWall/shareToWall.html",
    "<div>\n" +
    "  <h2 class=\"dialog-title\">Share to the Wall</h2>\n" +
    "  <div class=\"create-resource-post\" ng-if=\"!view.hasSent\">\n" +
    "    <hes-shared-post postable-id=\"{{view.resource.id}}\" postable-type=\"{{view.type}}\">\n" +
    "    </hes-shared-post>\n" +
    "    <hes-create-post wallable=\"site\" on-create=\"postCreated()\" hide-photo=\"true\"\n" +
    "      hide-tag=\"true\" place-holder-message=\"Enter a comment before posting to the wall...\"\n" +
    "      postable-id=\"{{view.resource.id}}\" postable-type=\"{{view.type}}\">\n" +
    "    </hes-create-post>\n" +
    "  </div>\n" +
    "  <div ng-show=\"view.hasSent\">\n" +
    "    <p ng-if=\"view.type != 'Goal'\" aria-live=\"polite\">{{view.hasSent ? 'Your ' + view.type + ' has been shared on the wall.' : ''}}</p>\n" +
    "    <p ng-if=\"view.type == 'Goal'\" aria-live=\"polite\">{{view.hasSent ? 'Your goal has been posted. Keep up the great work!' : ''}}</p>\n" +
    "    <div class='dialog-buttons'>\n" +
    "      <button class=\"done\" ng-click='closeThisDialog()'>OK</button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/site_map/site_map.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/site_map/site_map.html",
    "<div class=\"site_map\">\n" +
    "  <div>\n" +
    "    <div class=\"nav-group joined-group\"\n" +
    "      ng-repeat=\"group in navigation.active_menus\"\n" +
    "      ng-if=\"group.joinedGroup == 1 && !group.siteMapHidden\">\n" +
    "\n" +
    "      <h1>{{ group.name }}</h1>\n" +
    "\n" +
    "      <span ng-repeat=\"link in group.menus()\" ng-if=\"!link.siteMapHidden\">\n" +
    "        <h3 tabindex=\"0\">{{ link.name }}</h3>\n" +
    "\n" +
    "        <span ng-if=\"link.menus().length == 0\">\n" +
    "          <a class=\"nav-link\" ui-sref=\"{{link.link}}({{link.params}})\">\n" +
    "            {{ link.name }}\n" +
    "          </a>\n" +
    "        </span>\n" +
    "\n" +
    "        <span ng-if=\"link.menus().length > 0\">\n" +
    "          <a ng-if='sub_link.name != \"FAQs\"' class=\"nav-link\" ng-repeat=\"sub_link in link.menus()\"\n" +
    "            ui-sref=\"{{sub_link.link}}({{sub_link.params}})\">\n" +
    "            {{ sub_link.name }}\n" +
    "          </a>\n" +
    "          <a ng-if='sub_link.name == \"FAQs\"' class=\"nav-link\" ng-repeat=\"sub_link in link.menus()\"\n" +
    "            ui-sref=\"{{sub_link.link}}({{sub_link.params}})\"\n" +
    "            aria-label=\"\">\n" +
    "            {{ sub_link.name }}\n" +
    "          </a>\n" +
    "        </span>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div>\n" +
    "    <div class=\"nav-group joined-group\"\n" +
    "      ng-repeat=\"group in navigation.active_menus\"\n" +
    "      ng-if=\"group.joinedGroup == 2 && !group.siteMapHidden\">\n" +
    "\n" +
    "      <h1>{{ group.name }}</h1>\n" +
    "\n" +
    "      <span ng-repeat=\"link in group.menus()\">\n" +
    "        <h3 tabindex=\"0\">{{ link.name }}</h3>\n" +
    "\n" +
    "        <span ng-if=\"link.menus().length == 0\">\n" +
    "          <a class=\"nav-link\" ui-sref=\"{{link.link}}({{link.params}})\">\n" +
    "            {{ link.name }}\n" +
    "          </a>\n" +
    "        </span>\n" +
    "\n" +
    "        <span ng-if=\"link.menus().length > 0\">\n" +
    "          <a class=\"nav-link\" ng-repeat=\"sub_link in link.menus()\"\n" +
    "            ui-sref=\"{{sub_link.link}}({{sub_link.params}})\">\n" +
    "            {{ sub_link.name }}\n" +
    "          </a>\n" +
    "        </span>\n" +
    "      </span>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div>\n" +
    "      <div class=\"nav-group joined-group\"\n" +
    "        ng-repeat=\"group in navigation.active_menus\"\n" +
    "        ng-if=\"group.joinedGroup == 3 && !group.siteMapHidden\">\n" +
    "  \n" +
    "        <h1>{{ group.name }}</h1>\n" +
    "  \n" +
    "        <span ng-repeat=\"link in group.menus()\">\n" +
    "          <h3 tabindex=\"0\">{{ link.name }}</h3>\n" +
    "  \n" +
    "          <span ng-if=\"link.menus().length == 0\">\n" +
    "            <a class=\"nav-link\" ui-sref=\"{{link.link}}({{link.params}})\">\n" +
    "              {{ link.name }}\n" +
    "            </a>\n" +
    "          </span>\n" +
    "  \n" +
    "          <span ng-if=\"link.menus().length > 0\">\n" +
    "            <a class=\"nav-link\" ng-repeat=\"sub_link in link.menus()\"\n" +
    "              ui-sref=\"{{sub_link.link}}({{sub_link.params}})\">\n" +
    "              {{ sub_link.name }}\n" +
    "            </a>\n" +
    "          </span>\n" +
    "        </span>\n" +
    "  \n" +
    "      </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("/scripts/sites/activity/activitiesList.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/activity/activitiesList.html",
    "<div class=\"center\">\n" +
    "  <div class=\"col-2 text-left\">\n" +
    "    <div ui-view></div>\n" +
    "    <div class=\"page-tile lg\" ng-if=\"$state.current.name === 'go.u.site.activities'\">\n" +
    "      <div class=\"standard-header\">Activities\n" +
    "        <div class=\"navigate-action\">\n" +
    "          <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\">Back To Site</a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"tile-inner\">\n" +
    "        <div ng-show=\"!settings.loading\">\n" +
    "          <a class='font-bold float-right' ui-sref='go.u.site.activities.edit({activityId: \"new\"})'>Add New Activity</a>\n" +
    "        </div>\n" +
    "        <table class=\"hes margin-20-left\">\n" +
    "          <tr ng-repeat=\"activity in data.activities\">\n" +
    "            <td>{{$index+1}}.</td>\n" +
    "            <td class=\"padding-5\">{{activity.name}}</td>\n" +
    "            <td><a ui-sref=\"go.u.site.activities.edit({activityId:activity.id})\">Edit</a>&nbsp;&nbsp;<a ng-click=\"confirmRemoveActivity(activity)\">Remove</a>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "        <p ng-if=\"data.activities.length === 0\">No Activities!</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/sites/activity/activityEditor.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/activity/activityEditor.html",
    "<div class=\"center\">\n" +
    "  <div class=\"col-2 text-left\"> \n" +
    "    <div class=\"page-tile lg\">\n" +
    "      <div class=\"standard-header\">{{data._editActivity.isNew() ? 'Create New Activity' : 'Edit ' + data._editActivity.name}}\n" +
    "        <div class=\"navigate-action\">\n" +
    "          <a class='back-link' ui-sref=\"go.u.site.activities({siteId: $state.params.siteId})\">Back To Activities List</a>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"tile-inner\">\n" +
    "        <form class=\"hes\" name=\"forms.activityEdit\" hes-validator>\n" +
    "          <div class=\"row\">\n" +
    "            <span>\n" +
    "              <label for=\"name\">Name</label>\n" +
    "              <input tab-index='0' type=\"text\" id=\"name\" name=\"name\" ng-model=\"data._editActivity.name\" hes-required/>\n" +
    "            </span>\n" +
    "            <span>\n" +
    "              <label for=\"steps_per_minute\">Steps per Minute</label>\n" +
    "              <input tab-index='0' type=\"text\" id=\"steps_per_minute\" name=\"steps_per_minute\" ng-model=\"data._editActivity.steps_per_minute\" />\n" +
    "            </span>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"button-container\">\n" +
    "            <button ng-show=\"forms.activityEdit.$dirty && !settings.saving\" class=\"cancel\" ng-click=\"cancelEdit()\">cancel</button>\n" +
    "            <button ng-click=\"saveActivity()\" ng-disabled=\"!forms.activityEdit.$dirty || settings.saving\">{{settings.saving ? 'Saving' : 'Save'}}</button>\n" +
    "          </div>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/sites/banners/banners.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/banners/banners.html",
    "<div class=\"coordinator\">\n" +
    "  <div class=\"standard-header\">\n" +
    "    <div class=\"navigate-action\">\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\">Back To Site</a>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  \n" +
    "  <div class=\"padded-page\">\n" +
    "    <h2>Banners</h2>\n" +
    "    \n" +
    "    <div class=\"banner-info\">\n" +
    "      It's recommended the banner image dimensions are 970x80 px.\n" +
    "    </div>\n" +
    "\n" +
    "    <button class=\"secondary\" ng-click=\"new()\">New Banner</button>\n" +
    "\n" +
    "    <form>\n" +
    "      <div class=\"banner-edit\"\n" +
    "          ng-repeat=\"banner in data.banners\">\n" +
    "        \n" +
    "        <div layout=\"row\" layout-wrap class='input-group' layout-align=\"space-between\">\n" +
    "          <div flex='100' flex-gt-xs='40'>\n" +
    "            <label>Name</label>\n" +
    "            <input type=\"text\" ng-model=\"banner.name\"></input>\n" +
    "          </div>\n" +
    "          \n" +
    "          <div flex='100' flex-gt-xs='50' ng-hide=\"banner.isNew()\">\n" +
    "            <label>Link</label>\n" +
    "            <textarea type=\"text\" ng-model=\"banner.link\"></textarea>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div layout=\"row\" layout-wrap class='input-group' ng-hide=\"banner.isNew()\">\n" +
    "          <div flex='100' flex-gt-xs='50'>\n" +
    "            <label>Viewable As</label>\n" +
    "            <!-- <select type=\"text\" ng-model=\"banner.location_id\" ng-options=\"l.id as l.label for l in data.locations\"></select> -->\n" +
    "            \n" +
    "            <select ng-model=\"banner.location_id\">\n" +
    "              <option value=\"\">Global</option>\n" +
    "              <optgroup label=\"{{ label }}\" ng-repeat=\"(label, locations) in data.locations\">\n" +
    "                <option ng-value=\"location.id\"\n" +
    "                        ng-selected=\"{{ banner.location_id == location.id }}\"\n" +
    "                        ng-repeat=\"location in locations\"\n" +
    "                        ng-bind-html=\"location.label\">\n" +
    "                </option>\n" +
    "              </optgroup>\n" +
    "            </select>\n" +
    "            \n" +
    "          </div>\n" +
    "          <div flex='100' flex-gt-xs='50' ng-hide=\"banner.isNew()\">\n" +
    "            <label>Hidden?</label>\n" +
    "            <input type=\"checkbox\" ng-model=\"banner.is_hidden\"></input>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        \n" +
    "        <div layout=\"row\" layout-wrap class='input-group' ng-hide=\"banner.isNew()\">\n" +
    "          <span>\n" +
    "            <a ng-click=\"editBillboard(banner.banner_billboard_id,'banner', banner.name)\">Edit Image</a>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "        \n" +
    "        <div layout=\"row\" layout-align=\"end center\">\n" +
    "          <a ng-disabled=\"banner.status == 'Saving'\" flex=\"10\" role=\"button\" ng-if=\"!banner.id\"  ng-click=\"data.banners.splice($index,1)\">Cancel</a>\n" +
    "          <button ng-disabled=\"banner.status == 'Saving'\" ng-click=\"save(banner)\">{{banner.isNew() ? 'Create' : 'Save'}}</button>\n" +
    "        </div>\n" +
    "        <div layout=\"row\" layout-align=\"end center\">\n" +
    "          {{ banner.status }}\n" +
    "        </div>\n" +
    "        <a ng-disabled=\"banner.status == 'Saving'\" role=\"button\" ng-if=\"banner.id\"  ng-click=\"delete(banner)\">Delete Banner</a>\n" +
    "      </div>\n" +
    "      \n" +
    "    </form>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/sites/coordinatorsBox/coordinatorsBox.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/coordinatorsBox/coordinatorsBox.html",
    "<div class=\"page-tile lg\">\n" +
    "  <div class=\"page-title\">\n" +
    "    <div class=\"content\">Manage Coordinators</div>\n" +
    "  </div>\n" +
    "  <div>\n" +
    "    <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "  </div>\n" +
    "  <div class=\"tab-pane\">\n" +
    "    <div class=\"pane\">\n" +
    "      <div class=\"split-pane\">\n" +
    "        <form class=\"hes\" name=\"eligForm\" ng-submit='addCoordinator(coordinatorsBox.coordinatorEmail)'>\n" +
    "          <fieldset>\n" +
    "            <div class=\"row\">\n" +
    "              <input type=\"text\" id=\"email\" ng-model=\"coordinatorsBox.coordinatorEmail\" placeholder=\"Type in Coordinator Email\"/>\n" +
    "              <button type='submit'>add</button>\n" +
    "            </div>\n" +
    "          </fieldset>\n" +
    "        </form>\n" +
    "      </div>\n" +
    "      <div class=\"split-pane one-third\">\n" +
    "        <h5>Coordinators</h5>\n" +
    "        <div class=\"delete-list\">\n" +
    "          <ul>\n" +
    "            <li ng-repeat=\"email in coordinatorsBox.coordinators\">{{email}}<a class=\"delete\" ng-click=\"removeCoordinator(email)\">X</a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"center text-right\">\n" +
    "        <span ng-show=\"settings.saved\" class='font-md font-primary-color'>Saved!</span>\n" +
    "        <button type='submit' ng-click=\"save()\" ng-disabled=\"settings.isSaving\" ng-class=\"{disabled: settings.isSaving}\">save</button>\n" +
    "        <div class='save-feedback' ng-show=\"settings.isSaving\">Saving...</div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/sites/eopReporting/eopReporting.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/eopReporting/eopReporting.html",
    "<div class=\"col3\">\n" +
    "  <div class=\"page-tile lg context-white\">\n" +
    "    <div class='standard-header'>{{dbSite.name + ' End of Program'}}\n" +
    "      <div class=\"navigate-action\">\n" +
    "        <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\">Back To Site</a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"padding-10\">\n" +
    "      <div ng-if='dbSite.flags.is_location_displayed' class=\"margin-20-top prompts\">\n" +
    "        <table class=\"inputs columns-2\">\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div class=\"\">\n" +
    "                <div class='font-bold font-md margin-3-bottom'>{{dbSite.getLocationLabel(0)}}</div>\n" +
    "                <div class=\"question-question\">\n" +
    "                  <select id='location' ng-model='view.parentLocation' ng-options='location as location.name for location in dbSite.nested_locations' ng-change=\"getEopHTML()\">\n" +
    "                    <option value=''>-- Choose --</option>\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div class=\"\" ng-if='!!view.parentLocation && !!view.parentLocation.locations.length'>\n" +
    "                <div class='padding-10-left font-bold font-md margin-3-bottom'>{{dbSite.getLocationLabel(1)}}</div>\n" +
    "                <div class=\"question-question\">\n" +
    "                  <select id=\"location_2\" ng-model='view.childLocation' ng-options='location as location.name for location in view.parentLocation.locations' ng-change=\"getEopHTML()\">\n" +
    "                    <option value=''>-- Choose --</option>\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "      </div>\n" +
    "\n" +
    "      <span class=\"margin-10-bottom-top\">\n" +
    "        <a class=\"secondary-link-color\" ng-click='getEopHTML()'>Refresh</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a class=\"secondary-link-color\" ng-click=\"reset()\">Reset</a>\n" +
    "      </span>\n" +
    "      <div class='loading' ng-show='view.loading'>\n" +
    "        <div hes-loading-gif loading='view.loading' delay=300></div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div ng-bind-html='data.html'></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/sites/site-createEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/site-createEdit.html",
    "<div class=\"page-tile lg\">\n" +
    "  <form class=\"hes\" name=\"siteForm\" ng-submit=\"save()\">\n" +
    "\n" +
    "    <!-- Basic Information -->\n" +
    "    <fieldset>\n" +
    "      <legend>Basic Information</legend>\n" +
    "      <!-- <div class=\"row\">\n" +
    "        <span>\n" +
    "          \n" +
    "          <label for=\"theme\">Theme</label>\n" +
    "          <select name=\"theme\" ng-model=\"editSite.theme\" id=\"theme\" ng-options=\"theme.key as theme.value for theme in themes\">\n" +
    "            <option value=\"\">--select theme--</option>\n" +
    "          </select>\n" +
    "        </span>\n" +
    "      </div> -->\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <!-- Program Name -->\n" +
    "          <label for=\"site_name\">Site Name</label>\n" +
    "          <input id=\"site_name\" type=\"text\" required ng-model=\"editSite.name\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <!-- Subdomain -->\n" +
    "          <label for=\"subdomain\">URLs</label>\n" +
    "          <div style=\"color:red;\" ng-if=\"!areUrlsValid()\">\n" +
    "            The last URL can not contain an asterick \"*\".<br/> \n" +
    "            This is considered the \"default url\" and is used as the URL in emails and in SAML requests.\n" +
    "          </div>\n" +
    "          <textarea id=\"subdomain\" required ng-model=\"editSite.urls\" /></textarea>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"from_address\">From Address</label>\n" +
    "          <input id=\"from_address\" type=\"text\" ng-model=\"editSite.from_address\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"from_name\">From Name</label>\n" +
    "          <input id=\"from_name\" type=\"text\" ng-model=\"editSite.from_name\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <!-- Max Participants -->\n" +
    "          <label for=\"max_participants\">Max Participants</label>\n" +
    "          <input id=\"max_participants\" type=\"text\" ng-model=\"editSite.max_participants\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <!-- Logo -->\n" +
    "          <label for=\"logo\">Logo</label>\n" +
    "          <input hes-file-upload\n" +
    "            ng-model='editSite.logo'\n" +
    "            start=\"_.noop\"\n" +
    "            complete=\"_.noop\"\n" +
    "            thumbnail-url=\"editSite.logo.url\">\n" +
    "          </input>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"location_labels\">Placeholder Hero Image</label>\n" +
    "          <select id=\"placeholder_billboard\" ng-model=\"editSite.placeholder_billboard_id\" ng-options=\"b.id as b.name for b in data.billboards | filter:{ billboard_type: 'placeholder' }\"></select>\n" +
    "          or <a ng-click=\"editBillboard(editSite.placeholder_billboard_id,'placeholder')\">{{ editSite.placeholder_billboard_id ? \"edit\" : \"new\" }} billboard</a>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"location_labels\">Evaluation Banner</label>\n" +
    "          <select id=\"placeholder_billboard\" ng-model=\"editSite.evaluation_billboard_id\" ng-options=\"b.id as b.name for b in data.banner_billboards | filter:{ billboard_type: 'banner' }\"></select>\n" +
    "          or <a ng-click=\"editBillboard(editSite.evaluation_billboard_id,'banner')\">{{ editSite.evaluation_billboard_id ? \"edit\" : \"new\" }} billboard</a>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <!-- Location Labels -->\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"location_labels\">Location Label</label>\n" +
    "          <input id=\"location_labels\" type=\"text\" ng-model=\"editSite.location_labels\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"global_program_group\">Global Program Group</label>\n" +
    "          <input id=\"global_program_group\" type=\"text\" ng-model=\"editSite.global_program_group\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <!-- Friends Labels -->\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"location_labels\">Friend Label</label>\n" +
    "          <input id=\"location_labels\" type=\"text\" ng-model=\"editSite.friend_label\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"global_program_group\">Friend Label Plural</label>\n" +
    "          <input id=\"global_program_group\" type=\"text\" ng-model=\"editSite.friend_label_plural\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <!-- SSO Labels -->\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"sso_label\">SSO Label</label>\n" +
    "          <input id=\"sso_label\" type=\"text\" ng-model=\"editSite.sso_label\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"sso_label\">Reporting Promotion Subdomain</label>\n" +
    "          <input id=\"sso_label\" type=\"text\" ng-model=\"editSite.reporting_promotion\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <!-- Pilot Password -->\n" +
    "          <label for=\"pilot_password\">Pilot Password</label>\n" +
    "          <input id=\"pilot_password\" type=\"text\" ng-model=\"editSite.pilot_password\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <!-- Dates -->\n" +
    "    <fieldset>\n" +
    "      <legend>Site Dates</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <!-- Launches On -->\n" +
    "          <label for=\"launch_on\">Launch On</label>\n" +
    "          <input id=\"launch_on\" type=\"text\" date-format=\"dateFormat\" hes-date-select\n" +
    "            date-change=\"selectStartDates(date)\" required ng-model=\"editSite.launch_on\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <!-- Disabled On -->\n" +
    "          <label for=\"is_disabled_on\">Inactive After Date</label>\n" +
    "          <input id=\"is_disabled_on\" type=\"text\" hes-date-select date-format=\"dateFormat\"\n" +
    "            ng-model=\"editSite.disable_after\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"registration_starts_on\">Registration Starts On</label>\n" +
    "          <input id=\"registration_starts_on\" type=\"text\" hes-date-select date-format=\"dateFormat\" required\n" +
    "            ng-model=\"editSite.registration_starts_on\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"registration_ends_on\">Registration Ends After</label>\n" +
    "          <input id=\"registration_ends_on\" type=\"text\" hes-date-select date-format=\"dateFormat\" required\n" +
    "            ng-model=\"editSite.registration_ends_after\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"time_zone\">Default Time-Zone</label>\n" +
    "          <select id=\"time_zone\" ng-model=\"editSite.time_zone\" ng-options=\"zone as zone for zone in timeZones\"></select>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "    \n" +
    "    <!-- Password -->\n" +
    "    <fieldset>\n" +
    "      <legend>Password Options</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"password_min_length\">Password Min Length</label>\n" +
    "          <input type=\"number\" name=\"password_min_length\" ng-model=\"editSite.password_min_length\" required/>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"password_max_length\">Password Max Length</label>\n" +
    "          <input type=\"number\" name=\"password_max_length\" ng-model=\"editSite.password_max_length\" required/>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"password_min_letters\">Password Min Letters</label>\n" +
    "          <input type=\"number\" name=\"password_min_letters\" ng-model=\"editSite.password_min_letters\" required/>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for=\"password_min_numbers\">Password Min Numbers</label>\n" +
    "          <input type=\"number\" name=\"password_min_numbers\" ng-model=\"editSite.password_min_numbers\" required/>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"password_min_symbols\">Password Min Symbols</label>\n" +
    "          <input type=\"number\" name=\"password_min_symbols\" ng-model=\"editSite.password_min_symbols\" required/>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <!-- Flags -->\n" +
    "    <fieldset>\n" +
    "      \n" +
    "      <legend>Flags</legend>\n" +
    "      <!-- Registration Frozen/Location -->\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"is_location_displayed\">Location Displayed?</label>\n" +
    "          <input id=\"is_location_displayed\" ng-click=\"locationDisplayedChangeHandler()\" type=\"checkbox\" ng-model=\"editSite.flags.is_location_displayed\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"show_opt_in_participation_link\">Show Opt-in for Participation?</label>\n" +
    "          <input id=\"show_opt_in_participation_link\" type=\"checkbox\" ng-model=\"editSite.flags.show_opt_in_participation_link\" />\n" +
    "        </span>\n" +
    "        \n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"allow_set_location\"\n" +
    "            ng-class=\"{disabled: !editSite.flags.is_location_displayed}\">\n" +
    "            Allow Set Location?</label>\n" +
    "          <input id=\"allow_set_location\" type=\"checkbox\"\n" +
    "            ng-disabled=\"!editSite.flags.is_location_displayed\"\n" +
    "            ng-model=\"editSite.flags.allow_set_location\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"is_timeout_enabled\">20 Minute Timeout Enabled?</label>\n" +
    "          <input id=\"is_timeout_enabled\" type=\"checkbox\" ng-model=\"editSite.flags.is_timeout_enabled\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"force_set_location\" ng-class=\"{disabled: !editSite.flags.allow_set_location}\">\n" +
    "            Force Set Location?</label>\n" +
    "          <input id=\"force_set_location\" type=\"checkbox\" ng-disabled=\"!editSite.flags.allow_set_location\" ng-model=\"editSite.flags.force_set_location\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"required_birth_date\">Require Birth Date with Verification?</label>\n" +
    "          <input id=\"required_birth_date\" type=\"checkbox\"\n" +
    "            ng-model=\"editSite.flags.is_birth_date_eligibility_displayed\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"show_keep_me_logged_in\">Show Keep Me Logged In?</label>\n" +
    "          <input id=\"show_keep_me_logged_in\" type=\"checkbox\"\n" +
    "            ng-model=\"editSite.flags.is_stay_logged_in_displayed\"\n" +
    "            ng-change=\"keepMeLoggedInChangeHandler()\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"white_label\">White Label Site?</label>\n" +
    "          <input id=\"white_label\" type=\"checkbox\" ng-model=\"editSite.flags.white_label\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label inline\">Show High Contrast Link?\n" +
    "            <input id=\"show_high_contrast_link\" type=\"checkbox\" ng-model=\"editSite.flags.show_high_contrast_link\" />\n" +
    "          </label>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"default_keep_me_logged_in\"\n" +
    "            ng-class=\"{disabled: !editSite.flags.is_stay_logged_in_displayed}\">\n" +
    "            Keep Me Logged In Checked By Default?</label>\n" +
    "          <input id=\"default_keep_me_logged_in\" type=\"checkbox\"\n" +
    "            ng-disabled=\"!editSite.flags.is_stay_logged_in_displayed\"\n" +
    "            ng-model=\"editSite.flags.default_logged_in_checked\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "          <span>\n" +
    "            <label class=\"checkbox-label inline\">Address Displayed?\n" +
    "              <input id=\"is_address_displayed\" type=\"checkbox\" ng-model=\"editSite.flags.is_address_displayed\" />\n" +
    "            </label>\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label class=\"checkbox-label inline\">Is WUSTL?\n" +
    "              <input id=\"is_wustl\" type=\"checkbox\" ng-model=\"editSite.flags.is_wustl\" />\n" +
    "            </label>\n" +
    "          </span>\n" +
    "          <span>\n" +
    "            <label class=\"checkbox-label\" for='disable_daily_emails'>Disable Daily Emails?</label>\n" +
    "            <input id='disable_daily_emails' type='checkbox' ng-model='editSite.flags.disable_daily_emails' />\n" +
    "          </span>\n" +
    "        </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='default_only_monday_email'>Only Monday Emails by Default?</label>\n" +
    "          <input id='default_only_monday_email' type='checkbox' ng-model='editSite.flags.default_only_monday_email' />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"is_mobile_enabled\">\n" +
    "            Mobile App Enabled?</label>\n" +
    "          <input id=\"is_mobile_enabled\" type=\"checkbox\" ng-model=\"editSite.flags.is_mobile_enabled\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label inline\">Include HES Users?\n" +
    "            <input id=\"include_hes_users\" type=\"checkbox\" ng-model=\"editSite.flags.include_hes_users\" />\n" +
    "          </label>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='default_only_monday_email'>Only Monday Emails by Default?</label>\n" +
    "          <input id='default_only_monday_email' type='checkbox' ng-model='editSite.flags.default_only_monday_email' />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"requires_eligibility\">Require Verification?</label>\n" +
    "          <input id=\"requires_eligibility\" type=\"checkbox\" ng-model=\"editSite.flags.is_eligibility_displayed\" />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for=\"feedback\">Feedback Enabled?</label>\n" +
    "          <input id=\"feedback\" type=\"checkbox\" ng-model=\"editSite.flags.is_feedback_enabled\" />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <input id='is_automatic_wall_post_enabled' type='checkbox' ng-model='editSite.flags.is_automatic_wall_post_enabled' />\n" +
    "          <label class=\"checkbox-label\" for='is_automatic_wall_post_enabled'>Is Automatic Wall Post Enabled?</label>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <input id='skips_wall_moderator_posts' type='checkbox' ng-model='editSite.flags.skips_wall_moderator_posts' />\n" +
    "          <label class=\"checkbox-label\" for='skips_wall_moderator_posts'>Skips Wall Moderator Posts?</label>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label inline\">Display Gender at Registration?\n" +
    "            <input id=\"is_gender_displayed\" type=\"checkbox\" ng-model=\"editSite.flags.is_gender_displayed\" />\n" +
    "          </label>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <fieldset>\n" +
    "      <legend>Site Features</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label inline\">Elevate?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags.is_launchpad_plus\" ng-change=\"updateFeatureFlags(editSite, {is_plus: editSite.flags.is_launchpad_plus})\"></input>\n" +
    "          </label>\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label inline\">Independent Tracker?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags.is_aktivetrak\" ng-change=\"updateFeatureFlags(editSite, {is_aktivetrak: editSite.flags.is_aktivetrak})\"></input>\n" +
    "          </label>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label inline\">Launchpad?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags.is_launchpad\" ng-change=\"updateFeatureFlags(editSite, {is_launchpad: editSite.flags.is_launchpad})\"></input>\n" +
    "          </label>\n" +
    "        </span>\n" +
    "        <span></span>\n" +
    "      </div>\n" +
    "      <hr>\n" +
    "      <div class=\"row\" ng-repeat=\"chunk in data.chunked_flags\">\n" +
    "        <span ng-repeat=\"flag in chunk\" ng-switch on=\"flag\">\n" +
    "          <label ng-switch-when=\"is_challenges_enabled\" class=\"checkbox-label inline\">Peer Challenges Enabled?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags[flag]\"></input>\n" +
    "          </label>\n" +
    "          <label ng-switch-when=\"is_sms_enabled\" class=\"checkbox-label inline\">SMS Enabled?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags[flag]\"></input>\n" +
    "          </label>\n" +
    "          <label ng-switch-when=\"prompt_location_confirm_before_opt_in\" class=\"checkbox-label inline\">Prompt Location?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags[flag]\"></input>\n" +
    "          </label>\n" +
    "          <label ng-switch-when=\"launch_with_features_on\" class=\"checkbox-label inline\">No First Program Required\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags[flag]\" ng-disabled=\"!editSite.flags['is_launchpad_plus']\"></input>\n" +
    "            <md-tooltip ng-if=\"!editSite.flags['is_launchpad_plus']\" md-direction=\"bottom\">Only available for Elevate sites</md-tooltip>\n" +
    "          </label>\n" +
    "          <label ng-switch-when=\"is_email_to_non_campaign_participants_enabled\" class=\"checkbox-label inline\">Daily Email To Non-Campaign Users Enabled?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.is_email_to_non_campaign_participants_enabled\"></input>\n" +
    "          </label>\n" +
    "          <label ng-switch-default class=\"checkbox-label inline\">{{ humanize(stripIs(flag)) }}?\n" +
    "            <input type=\"checkbox\" ng-model=\"editSite.flags[flag]\"></input>\n" +
    "          </label>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <fieldset>\n" +
    "      <legend>Challenges</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label for=\"user_challenge_days\">Number of Challenge Days</label>\n" +
    "          <input type=\"number\" name=\"user_challenge_days\" id=\"user_challenge_days\" ng-model=\"editSite.user_challenge_days\" required />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <fieldset>\n" +
    "      <legend>Devices</legend>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='is_fitbit_enabled'>Is Fitbit Enabled?</label>\n" +
    "          <input id='is_fitbit_enabled' type='checkbox' ng-model='editSite.flags.is_fitbit_enabled' />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='is_healthkit_enabled'>Is Apple Health Enabled?</label>\n" +
    "          <input id='is_healthkit_enabled' type='checkbox' ng-model='editSite.flags.is_healthkit_enabled' />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='is_health_connect_enabled'>Is Health Connect Enabled?</label>\n" +
    "          <input id='is_health_connect_enabled' type='checkbox' ng-model='editSite.flags.is_health_connect_enabled' />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='is_garmin_enabled'>Is Garmin Enabled?</label>\n" +
    "          <input id='is_garmin_enabled' type='checkbox' ng-model='editSite.flags.is_garmin_enabled' />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <span>\n" +
    "          <label class=\"checkbox-label\" for='is_google_health_enabled'>Is Google Health Enabled?</label>\n" +
    "          <input id='is_google_health_enabled' type='checkbox' ng-model='editSite.flags.is_google_health_enabled' />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <!-- Save -->\n" +
    "    <div class=\"center text-right\">\n" +
    "      <div error-banner priority-level=1></div>\n" +
    "      <a class=\"back-link\" ui-sref=\"go.u.site({siteId: editSite.id})\" ng-if=\"view.isEdit\"\n" +
    "        ui-sref-opts=\"{reload: true}\">back</a>\n" +
    "      <button ng-disabled=\"settings.saving\" ng-class=\"{disabled: settings.isSaving}\" type=\"submit\">{{view.isEdit ?\n" +
    "      'Save' : 'Create'}}\n" +
    "      </button>\n" +
    "      <div class=\"save-feedback\" ng-show=\"settings.saving\">Saving...</div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/sites/site.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/site.html",
    "<div class=\"padded-page\">\n" +
    "  <div ui-view></div>\n" +
    "  <div class=\"promotions-content\" ng-if=\"$state.current.name === 'go.u.site'\">\n" +
    "    <div class=\"header1\">\n" +
    "      <h4>{{dbSite.name}}</h4>\n" +
    "    </div>\n" +
    "    <div class=\"promotion-row\">\n" +
    "      <div class=\"promo-container\">\n" +
    "        <span></span>\n" +
    "        <img\n" +
    "          hes-image=\"{{dbSite.logo.url}}\"\n" +
    "          class=\"right promo-logo\"\n" +
    "          alt=\"No Logo\"\n" +
    "          no-theme\n" +
    "          use-domain=\"true\"\n" +
    "        />\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"promotion-dates\">\n" +
    "      <div class=\"promotion-date\">\n" +
    "        <h4>Launch</h4>\n" +
    "\n" +
    "        {{dbSite.launch_on | date:'EEE, MMM d, yyyy'}}\n" +
    "      </div>\n" +
    "      <div class=\"promotion-date\">\n" +
    "        <h4>Registration</h4>\n" +
    "\n" +
    "        {{dbSite.registration_starts_on | date:'EEE, MMM d, yyyy'}}\n" +
    "        <br />\n" +
    "        to\n" +
    "        <br />\n" +
    "        {{dbSite.registration_ends_after | date:'EEE, MMM d, yyyy'}}\n" +
    "      </div>\n" +
    "      <div class=\"promotion-date\">\n" +
    "        <h4>Disabled</h4>\n" +
    "\n" +
    "        {{dbSite.disable_after | date:'EEE, MMM d, yyyy'}}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"clearfix\"></div>\n" +
    "\n" +
    "    <div class=\"promotion-row\">\n" +
    "      <div class=\"promotion-box dynamic\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Set Up</h4>\n" +
    "          <a ui-sref=\"go.u.site.edit({siteId: dbSite.id})\">edit</a>\n" +
    "        </div>\n" +
    "        <div class=\"box-body\">\n" +
    "          <div>\n" +
    "            <strong>Name:</strong> {{dbSite.name}}\n" +
    "            <br />\n" +
    "            <strong>URLs:</strong>\n" +
    "            <span ng-repeat=\"url in dbSite.getSiteUrls()\">\n" +
    "              <span class=\"font-md\">{{url}}</span>\n" +
    "              <br />\n" +
    "            </span>\n" +
    "            <strong>Registered Users:</strong>\n" +
    "            <a ui-sref=\"go.u.site.users({siteId: dbSite.id})\">{{dbSite.total_participants || 0}}</a>\n" +
    "            &nbsp;<span ng-if=\"!!dbSite.max_participants\" style=\"color: red;\">(of {{formatNumberWithCommas(dbSite.max_participants)}})</span>\n" +
    "            <br />\n" +
    "            <strong>Pilot Password:</strong> {{dbSite.pilot_password}}\n" +
    "            <br />\n" +
    "            <strong>Location Label:</strong> {{dbSite.location_labels[0]}}\n" +
    "            <br />\n" +
    "            <span ng-if=\"dbSite.flags.is_launchpad_plus\">\n" +
    "              <strong>Elevate: </strong>\n" +
    "              <span ng-if=\"dbSite.features_on\">Features On</span>\n" +
    "              <span ng-if=\"!dbSite.features_on\">Features Off</span>\n" +
    "              <br />\n" +
    "              <div ng-if=\"!dbSite.flags.launch_with_features_on\">\n" +
    "                <span> - </span> \n" +
    "                <span ng-if=\"dbSite.before_first_program\">Before First Program</span>\n" +
    "                <span ng-if=\"dbSite.in_first_program\">In First Program</span>\n" +
    "                <span ng-if=\"dbSite.after_first_program\">After First Program</span>\n" +
    "                <span> - </span> \n" +
    "              </div>\n" +
    "              <br />\n" +
    "            </span>\n" +
    "            <a ui-sref=\"go.u.site.ssoDetails\">SSO Details</a>\n" +
    "            <br /><br />\n" +
    "            <!-- <a ui-sref=\"go.u.site.users({siteId: dbSite.id})\">Users</a>\n" +
    "            <br /><br/> -->\n" +
    "            <strong>End Of Program:</strong>\n" +
    "            <a ui-sref=\"go.u.site.eop\" target=\"_blank\">view</a> <br /><br />\n" +
    "            <a ui-sref=\"go.u.site.custom-emails.send\">Send Custom Email</a>\n" +
    "            <br /><br />\n" +
    "            <a ui-sref=\"go.u.site.queued_emails\">Queued emails</a>\n" +
    "            <br /><br />\n" +
    "            <span ng-if=\"dbSite.flags.is_sms_enabled\">\n" +
    "              <a ui-sref=\"go.u.site.sms.queued\">SMS</a>\n" +
    "              <br /><br />\n" +
    "            </span>\n" +
    "            <button class=\"secondary\" ng-click=\"clearCache()\">\n" +
    "              Clear Cache\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"promotion-box dynamic\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Customization</h4>\n" +
    "        </div>\n" +
    "        <div class=\"box-body\">\n" +
    "          <h5>Customization</h5>\n" +
    "          <ul>\n" +
    "            <li>\n" +
    "              Cobranding:  <a ui-sref=\"go.u.site.content.editadd({category: 'branding'})\" >edit</a>\n" +
    "            </li>\n" +
    "            <li>Color(s):  <a ui-sref=\"go.u.site.theme-edit\">edit</a></li>\n" +
    "            <li>\n" +
    "              Elevate FAQs:  <a  ui-sref=\"go.u.site.content.editadd({category: 'faqs'})\"  >edit</a  >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Emails:  <a  ui-sref=\"go.u.site.content.editadd({category: 'emails'})\"  >edit</a  >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Launchpad FAQs:  <a  ui-sref=\"go.u.site.content.editadd({category: 'normal_faqs'})\"  >edit</a  >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Opt in Program Overlay:  <a  ui-sref=\"go.u.site.content.editadd({category: 'optin_program_overlay'})\"  >edit</a  >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Registration:  <a  ui-sref=\"go.u.site.content.editadd({category: 'registration'})\"  >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Resources:  <a ui-sref=\"go.u.site.content.editadd({category: 'resources'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Welcome Links:  <a ui-sref=\"go.u.site.content.welcome({category: 'welcome'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Welcome Site Logo:  <a ui-sref=\"go.u.site.content.welcome({category: 'welcome_logo'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Welcome to Elevate Overlay:  <a ui-sref=\"go.u.site.content.editadd({category: 'welcome_elevate'})\" >edit</a >\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "          <h5>Content</h5>\n" +
    "          <ul>\n" +
    "            <li>\n" +
    "              Contact:  <a ui-sref=\"go.u.site.content.editadd({category: 'contact'})\"  >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Countdown:  <a  ui-sref=\"go.u.site.content.editadd({category: 'countdown'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Email Templates:  <a ui-sref=\"go.u.site.custom-emails.template-editor\">edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Explanations:  <a ui-sref=\"go.u.site.content.editadd({category: 'explanations'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Marketplace:  <a ui-sref=\"go.u.site.content.editadd({category: 'marketplace'})\">edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Mobile Overlay:  <a ui-sref=\"go.u.site.content.editadd({category: 'mobile_overlay'})\">edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Mobile Password Instructions:  <a ui-sref=\"go.u.site.content.editadd({category: 'mobile_password_instructions'})\">edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Mobile:  <a ui-sref=\"go.u.site.content.editadd({category: 'mobile'})\" >edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Monthly Notifications:  <a ui-sref=\"go.u.site.content.editadd({category: 'monthly_notifications'})\" >edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Privacy:  <a  ui-sref=\"go.u.site.content.editadd({category: 'privacy'})\"  >edit</a >\n" +
    "            </li>\n" +
    "            <li>Settings:  <a ui-sref=\"go.u.site.content.editadd({category: 'settings'})\" >edit</a\n" +
    "              >\n" +
    "            </li>\n" +
    "            <li>Health Connect:  <a ui-sref=\"go.u.site.content.editadd({category: 'health_connect'})\" >edit</a\n" +
    "              >\n" +
    "            </li>\n" +
    "            <li>Google Health:  <a ui-sref=\"go.u.site.content.editadd({category: 'google_health'})\" >edit</a\n" +
    "              >\n" +
    "            </li>\n" +
    "            <li>Health Kit:  <a ui-sref=\"go.u.site.content.editadd({category: 'health_kit'})\" >edit</a\n" +
    "              >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              SMS Templates:  <a ui-sref=\"go.u.site.content.editadd({category: 'sms_templates'})\" ng-if=\"dbSite.flags.is_sms_enabled\" >edit</a\n" +
    "              >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Terms of Use:  <a ui-sref=\"go.u.site.content.editadd({category: 'terms'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Unsubscribe Email:  <a ui-sref=\"go.u.site.content.editadd({category: 'unsubscribe'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Reset Password:  <a ui-sref=\"go.u.site.content.editadd({category: 'reset_password'})\">edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Wall Posts:  <a ui-sref=\"go.u.site.content.editadd({category: 'auto_moderator'})\">edit</a>\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "          <h5>Elevate Features</h5>\n" +
    "          <ul>\n" +
    "            <li>\n" +
    "              Auto Generated Emails:  <a ui-sref=\"go.u.site.content.editadd({category: 'auto_generated_emails'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Choose Device Content:  <a ui-sref=\"go.u.site.content.editadd({category: 'choose_device'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Each Application Email Banners:  <a ui-sref=\"go.u.site.content.editadd({category: 'app_email_banners'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Feature Descriptions:  <a ui-sref=\"go.u.site.content.editadd({category: 'feature_descriptions'})\" >edit</a\n" +
    "              >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Goal Images:  <a ui-sref=\"go.u.site.content.editadd({category: 'goal_images'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Location Resources:  <a ui-sref=\"go.u.site.content.editadd({category: 'location_resources'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Monthly Email:  <a ui-sref=\"go.u.site.content.editadd({category: 'monthly_email'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Shared Logging Content:  <a ui-sref=\"go.u.site.content.editadd({category: 'shared_logging_content'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Tips:  <a ui-sref=\"go.u.site.content.editadd({category: 'tips'})\" >edit</a>\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Walkthrough: <a ui-sref=\"go.u.site.content.editadd({category: 'walkthrough'})\" >edit</a >\n" +
    "            </li>\n" +
    "            <li>\n" +
    "              Wall: <a ui-sref=\"go.u.site.content.editadd({category: 'wall'})\" >edit</a  >\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"promotion-box dynamic\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Coordinators</h4>\n" +
    "          <a ui-sref=\"go.u.site.coordinators\">manage</a>\n" +
    "        </div>\n" +
    "        <div class=\"delete-list\">\n" +
    "          <ul>\n" +
    "            <li\n" +
    "              ng-if=\"dbSite.coordinators\"\n" +
    "              ng-repeat=\"email in dbSite.coordinators.split(',')\"\n" +
    "            >\n" +
    "              {{email}}\n" +
    "            </li>\n" +
    "          </ul>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"promotion-row\">\n" +
    "      <div class=\"promotion-box fit\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Programs</h4>\n" +
    "          <div class=\"padding-sm font-md\">\n" +
    "            <a\n" +
    "              ui-sref=\"go.u.site.program({siteId: dbSite.id, programId: 'new'})\"\n" +
    "              >Create New Program</a\n" +
    "            >\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"box-body set-up\">\n" +
    "            <div hes-table tbl-data=\"data.tblPrograms\"></div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"promotion-row\">\n" +
    "      <div class=\"promotion-box\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Hero/Banners</h4>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"box-body\">\n" +
    "          <div class=\"column\">\n" +
    "            <ul>\n" +
    "              <li>\n" +
    "                <a ui-sref=\"go.u.billboards({site_id: {{ dbSite.id }}, group: 'hero', custom_only: true })\"\n" +
    "                  >Hero</a\n" +
    "                >\n" +
    "              </li>\n" +
    "              <li><a ui-sref=\"go.u.site.banners\">Banners</a></li>\n" +
    "            </ul>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"promotion-box\" ng-if=\"dbSite.flags.is_location_displayed\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Locations</h4>\n" +
    "          <a ui-sref=\"go.u.site.locations\">manage</a>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"box-body\">\n" +
    "          <div class=\"column\">\n" +
    "            <h5>Top Level Locations</h5>\n" +
    "            <div ng-repeat=\"location in data.locations\">\n" +
    "              <span>{{location.name}}</span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"promotion-box\" ng-if=\"dbSite.flags.is_eligibility_displayed\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Verification (elig)</h4>\n" +
    "          <a ui-sref=\"go.u.site.content.editadd({category: 'eligibility'})\"\n" +
    "            >edit</a\n" +
    "          >\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"box-body\">\n" +
    "          <div class=\"column\">\n" +
    "            <strong>Verification Label:</strong>\n" +
    "            <span\n" +
    "              markdown\n" +
    "              ng-model=\"getEligCustomContent('label_message').summary_html\"\n" +
    "              no-paragraph\n" +
    "            ></span>\n" +
    "            <br />\n" +
    "            <strong>Verification Message:</strong> &nbsp;&nbsp;<a\n" +
    "              ng-click=\"showContent(getEligCustomContent('label_message'))\"\n" +
    "              >view</a\n" +
    "            >\n" +
    "            <br />\n" +
    "            <strong>Eligibility Total Count:</strong> {{dbSite.total_eligible}}\n" +
    "            <a ui-sref=\"go.u.site.eligibilities\">manage</a>\n" +
    "            <br />\n" +
    "            <strong>Eligibility Active Count:</strong>\n" +
    "            {{dbSite.total_active_eligible}}\n" +
    "            <br />\n" +
    "            <br />\n" +
    "            <a ui-sref=\"go.u.site.eligibilityfiles\" class=\"action-link\"\n" +
    "              >Add Eligibility File</a\n" +
    "            >\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"promotion-box\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Logging</h4>\n" +
    "        </div>\n" +
    "        <h5>\n" +
    "          Exercise Activities &nbsp;&nbsp;<a ui-sref=\"go.u.site.activities\"\n" +
    "            >edit</a\n" +
    "          >\n" +
    "        </h5>\n" +
    "        <div class=\"box-body\"></div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"promotion-box\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Badges</h4>\n" +
    "          &nbsp;\n" +
    "          <a ui-sref=\"go.u.site.badges\">edit</a>\n" +
    "        </div>\n" +
    "        <div class=\"box-body\">\n" +
    "          <span ng-repeat=\"(cat,badges) in data.badges\">\n" +
    "            <strong>{{ humanize(cat) }}</strong>\n" +
    "            <ul>\n" +
    "              <li ng-repeat=\"badge in badges\">\n" +
    "                {{ badge.name }} {{ badge.goal3 && badge.goal3 }}\n" +
    "              </li>\n" +
    "            </ul>\n" +
    "          </span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"promotion-row\">\n" +
    "      <div class=\"promotion-box\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Challenges</h4>\n" +
    "          <a ui-sref=\"go.u.site.challenges\">manage</a>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"box-body\">\n" +
    "          <div class=\"column\">\n" +
    "            <div ng-repeat=\"challenge in data.challenges\">\n" +
    "              <span>{{challenge.name}}</span>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"promotion-box\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Goals</h4>\n" +
    "          <a ui-sref=\"go.u.site.goals\">manage</a>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"box-body\">\n" +
    "          <div class=\"column\">\n" +
    "            <div ng-repeat=\"month in data.months\" ng-if=\"month\">\n" +
    "              <div><strong>{{ month }}</strong></div>\n" +
    "              <div ng-repeat=\"goal in goalsByMonth(month)\">\n" +
    "                <div>{{goal.title}}</div>\n" +
    "              </div>\n" +
    "              <br />\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"promotion-box\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Evaluations</h4>\n" +
    "          <a ui-sref=\"go.u.site.site_evaluation({siteEvaluationId: 'new'})\"\n" +
    "            >new</a\n" +
    "          >\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"box-body\">\n" +
    "          <div class=\"column\">\n" +
    "            <div ng-repeat=\"eval in data.siteEvals\">\n" +
    "              <h4 class=\"inline\">{{eval.name}}</h4>\n" +
    "              <a\n" +
    "                ui-sref=\"go.u.site.site_evaluation({siteEvaluationId: eval.id})\"\n" +
    "                >edit</a\n" +
    "              >\n" +
    "              <div ng-if=\"eval.days_from_start\">\n" +
    "                <span>Days from start: </span>\n" +
    "                <span>{{eval.days_from_start}}</span>\n" +
    "              </div>\n" +
    "              <div ng-if=\"eval.start_date\">\n" +
    "                <div>\n" +
    "                  <span>Start Date: </span>\n" +
    "                  <span>{{eval.start_date | date:'EEE, MMM d, yyyy'}}</span>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                  <span>End Date: </span>\n" +
    "                  <span>{{eval.end_date | date:'EEE, MMM d, yyyy'}}</span>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- <div class=\"promotion-row\">\n" +
    "\n" +
    "      <div class=\"promotion-box\">\n" +
    "        <div class=\"box-header\">\n" +
    "          <h4>Preview Emails</h4>\n" +
    "          <a ui-sref=\"\">manage</a>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"box-body\">\n" +
    "          <div class='column'>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      \n" +
    "    </div> -->\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/sites/sites.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sites/sites.html",
    "<div class='padded-page'>\n" +
    "  <div class='padded-page'> \n" +
    "    <h4>All Sites</h4>\n" +
    "    <div class=\"promotions-content\">\n" +
    "      <a class=\"red-link-button\" ui-sref=\"go.u.site.create({siteId: 'new'})\">Create New Site</a>\n" +
    "      <div hes-table tbl-data=\"data.tblSites\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/sms/dialogs/editSmsDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sms/dialogs/editSmsDialog.html",
    "<div class=\"sms-form\">\n" +
    "  <h2>Edit Batch {{batch.id}}</h2>\n" +
    "\n" +
    "  <div class=\"promotion-box fit\">\n" +
    "    <form ng-submit=\"update_batch()\">\n" +
    "      <label for=\"phone_number\"> Send to: </label>\n" +
    "      <span class=\"sub-text\"\n" +
    "        >If multiple numbers, seperate numbers with , or |\n" +
    "      </span>\n" +
    "      <textarea\n" +
    "        id=\"recipients\"\n" +
    "        name=\"recipients\"\n" +
    "        placeholder=\"+12013564567,+12013564567|+12013564567.....\"\n" +
    "        ng-model=\"batch.recipients\"\n" +
    "        ng-required=\"!batch.filters.ALL_SUBSCRIBED_PARTICIPANTS && !batch.filters.PROGRAM_PARTICIPANTS && !batch.filters.NON_PROGRAM_PARTICIPANTS\"\n" +
    "      ></textarea>\n" +
    "\n" +
    "      <label for=\"ALL_SUBSCRIBED_PARTICIPANTS\" class=\"margin-10-top\"\n" +
    "        >Audience</label\n" +
    "      ><span class=\"sub-text\"> Only select one</span>\n" +
    "      <table>\n" +
    "        <tr>\n" +
    "          <td>\n" +
    "            <div\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "              aria-describedBy=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "              hes-checkbox\n" +
    "              class=\"hes-checkbox inline\"\n" +
    "              label-name=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "              ng-model=\"batch.filters.ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "            ></div>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <div name=\"ALL_SUBSCRIBED_PARTICIPANTS\" class=\"checkbox-label\">\n" +
    "              <span id=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "                >All Subscribed Participants</span\n" +
    "              >\n" +
    "            </div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "        <tr>\n" +
    "          <td>\n" +
    "            <div\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"PROGRAM_PARTICIPANTS\"\n" +
    "              aria-describedBy=\"PROGRAM_PARTICIPANTS\"\n" +
    "              hes-checkbox\n" +
    "              class=\"hes-checkbox inline\"\n" +
    "              label-name=\"PROGRAM_PARTICIPANTS\"\n" +
    "              ng-change=\"reset()\"\n" +
    "              ng-model=\"batch.filters.PROGRAM_PARTICIPANTS\"\n" +
    "            ></div>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <div name=\"PROGRAM_PARTICIPANTS\" class=\"checkbox-label\">\n" +
    "              <span id=\"PROGRAM_PARTICIPANTS\"\n" +
    "                >Participants who have opted into program</span\n" +
    "              >\n" +
    "            </div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "        <tr>\n" +
    "          <td>\n" +
    "            <div\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"NON_PROGRAM_PARTICIPANTS\"\n" +
    "              aria-describedBy=\"NON_PROGRAM_PARTICIPANTS\"\n" +
    "              hes-checkbox\n" +
    "              class=\"hes-checkbox inline\"\n" +
    "              label-name=\"NON_PROGRAM_PARTICIPANTS\"\n" +
    "              ng-change=\"reset()\"\n" +
    "              ng-model=\"batch.filters.NON_PROGRAM_PARTICIPANTS\"\n" +
    "            ></div>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <div name=\"NON_PROGRAM_PARTICIPANTS\" class=\"checkbox-label\">\n" +
    "              <span id=\"NON_PROGRAM_PARTICIPANTS\">\n" +
    "                Participants who have not opted into program</span\n" +
    "              >\n" +
    "            </div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "      </table>\n" +
    "      <div\n" +
    "        name=\"program_id\"\n" +
    "        class=\"checkbox-label\"\n" +
    "        ng-if=\"!!batch.filters.PROGRAM_PARTICIPANTS || !!batch.filters.NON_PROGRAM_PARTICIPANTS\"\n" +
    "      >\n" +
    "        <select\n" +
    "          ng-model=\"batch.program_id\"\n" +
    "          ng-options=\"program.id as program.name for program in dbSite.programs\"\n" +
    "        >\n" +
    "          <option value=\"\">-- None --</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "      </table>\n" +
    "\n" +
    "      <div class=\"margin-10-top\">\n" +
    "        <label for=\"template\">Templates</label>\n" +
    "        <br />\n" +
    "        <select\n" +
    "          ng-model=\"current_template\"\n" +
    "          ng-options=\"template as template.name for template in templates\"\n" +
    "          ng-change=\"setTemplate()\"\n" +
    "        >\n" +
    "          <option value=\"\">-- None --</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "\n" +
    "      <div>\n" +
    "        <label for=\"message\">Message: </label>\n" +
    "        <span class=\"sub-text\">Characters - {{batch.message.length}}</span>\n" +
    "        <a\n" +
    "          class=\"back-link float-right\"\n" +
    "          href=\"https://free-url-shortener.rb.gy/\"\n" +
    "          target=\"_blank\"\n" +
    "          >Url Shortener</a\n" +
    "        >\n" +
    "        <textarea\n" +
    "          id=\"message\"\n" +
    "          name=\"message\"\n" +
    "          placeholder=\"message\"\n" +
    "          ng-model=\"batch.message\"\n" +
    "          required\n" +
    "        ></textarea>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"time-div\">\n" +
    "        <table>\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div\n" +
    "                type=\"checkbox\"\n" +
    "                id=\"send_at_checkbox\"\n" +
    "                aria-describedBy=\"send_at_checkbox\"\n" +
    "                hes-checkbox\n" +
    "                class=\"hes-checkbox inline\"\n" +
    "                label-name=\"send_at_checkbox\"\n" +
    "                ng-model=\"is_scheduled\"\n" +
    "              ></div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div name=\"send_at_checkbox\" class=\"checkbox-label\">\n" +
    "                <label id=\"send_at_checkbox\">Schedule send time</label>\n" +
    "              </div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "        <div ng-if=\"!!is_scheduled\">\n" +
    "          <input\n" +
    "            id=\"send_at\"\n" +
    "            class=\"send_at\"\n" +
    "            type=\"datetime-local\"\n" +
    "            required\n" +
    "            ng-model=\"batch.send_at\"\n" +
    "          />\n" +
    "          - Eastern\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"button-area\">\n" +
    "        <span>{{sentMessage}}</span><button type=\"submit\">Update</button>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/sms/dialogs/sendSmsDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sms/dialogs/sendSmsDialog.html",
    "<div class=\"sms-dialog\">\n" +
    "  <h2>\n" +
    "    <span\n" +
    "      class=\"dialog-title\"\n" +
    "      markdown-div\n" +
    "      ng-model=\"confirmation.title\"\n" +
    "      no-paragraph\n" +
    "    ></span>\n" +
    "  </h2>\n" +
    "  <div style=\"margin-bottom: 10px\">\n" +
    "    Characters: {{confirmation.data.message.length}}\n" +
    "  </div>\n" +
    "  <div\n" +
    "    class=\"speech-bubble\"\n" +
    "    markdown-div\n" +
    "    ng-model=\"confirmation.data.message\"\n" +
    "  ></div>\n" +
    "  <div class=\"dialog-text\" markdown-div ng-model=\"confirmation.message\"></div>\n" +
    "  <div>\n" +
    "    <details>\n" +
    "      <summary>Recipients</summary>\n" +
    "      <input\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"confirmation.search\"\n" +
    "        placeholder=\"Search for number..\"\n" +
    "      />\n" +
    "      <div class=\"repeat-wrap\">\n" +
    "        <span\n" +
    "          ng-repeat=\"r in confirmation.data.recipients | filter:confirmation.search track by $index \"\n" +
    "          >{{r}},\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </details>\n" +
    "  </div>\n" +
    "  <div ng-if=\"confirmation.data.total_failed > 0\">\n" +
    "    <details>\n" +
    "      <summary>\n" +
    "        Failed Recipients: {{confirmation.data.total_failed}}\n" +
    "        <span class=\"failed\">!</span>\n" +
    "      </summary>\n" +
    "      <input\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"confirmation.searchFailed\"\n" +
    "        placeholder=\"Search for number..\"\n" +
    "      />\n" +
    "      <div class=\"repeat-wrap\">\n" +
    "        <span\n" +
    "          ng-repeat=\"r in confirmation.data.failed_recipients | filter:confirmation.searchFailed track by $index \"\n" +
    "          >{{r}},\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </details>\n" +
    "  </div>\n" +
    "  <div>\n" +
    "    <details>\n" +
    "      <summary>Balance</summary>\n" +
    "      <div>\n" +
    "        <span style=\"font-size: 12px; margin-left: 112px\">\n" +
    "          <b>Note:</b> Does not include any tests\n" +
    "        </span>\n" +
    "        <br />\n" +
    "        Total Balance: <u>${{confirmation.data.balance}}</u>\n" +
    "        <br />\n" +
    "        Adjusted Balance(approx. after sending):\n" +
    "        <u>${{confirmation.data.adjusted_balance}}</u>\n" +
    "      </div>\n" +
    "    </details>\n" +
    "  </div>\n" +
    "  <div class=\"dialog-buttons\">\n" +
    "    <button class=\"link-look\" ng-click=\"closeThisDialog()\">\n" +
    "      {{confirmation.cancelText}}\n" +
    "    </button>\n" +
    "    <button class=\"done\" ng-click=\"confirm()\">\n" +
    "      {{confirmation.confirmText}}\n" +
    "    </button>\n" +
    "  </div>\n" +
    "  <div>\n" +
    "    <hr />\n" +
    "    <table>\n" +
    "      <tr>\n" +
    "        <td>\n" +
    "          <div\n" +
    "            type=\"checkbox\"\n" +
    "            aria-describedBy=\"test_checkbox\"\n" +
    "            hes-checkbox\n" +
    "            class=\"hes-checkbox inline\"\n" +
    "            label-name=\"test_checkbox\"\n" +
    "            ng-model=\"test_message\"\n" +
    "          ></div>\n" +
    "        </td>\n" +
    "        <td>\n" +
    "          <div name=\"test_checkbox\" class=\"checkbox-label\">\n" +
    "            <label id=\"test_checkbox\"\n" +
    "              >Would you like to test the SMS first?</label\n" +
    "            >\n" +
    "          </div>\n" +
    "        </td>\n" +
    "      </tr>\n" +
    "    </table>\n" +
    "    <div ng-if=\"!!test_message\">\n" +
    "      <label>Numbers you want to test with</label>\n" +
    "      <textarea\n" +
    "        ng-model=\"test_sms.recipients\"\n" +
    "        placeholder=\"+12013564567,+12013564567|.....\"\n" +
    "      ></textarea>\n" +
    "      <button class=\"done\" ng-click=\"test()\">{{sending}}</button>\n" +
    "      <span style=\"padding-left: 10px\">{{sentTestMessage}}</span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/sms/queued/queued.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sms/queued/queued.html",
    "<h2>SMS</h2>\n" +
    "<div>\n" +
    "  <div class=\"col3\">\n" +
    "    <div class=\"page-tile lg\">\n" +
    "      <div class=\"standard-header\">Queued SMS</div>\n" +
    "      <div>\n" +
    "        <a\n" +
    "          class=\"back-link\"\n" +
    "          ui-sref=\"go.u.site({siteId: dbSite.id})\"\n" +
    "          ui-sref-opts=\"{reload: true}\"\n" +
    "          >Back To Site</a\n" +
    "        >\n" +
    "        <a style=\"float: right\" ui-sref=\"go.u.site.sms.send\"> Send SMS </a>\n" +
    "      </div>\n" +
    "      <a style=\"float: right\" class=\"back-link\" ng-click=\"refreshBatches()\">\n" +
    "        Refresh\n" +
    "      </a>\n" +
    "      <div class=\"sites-content\">\n" +
    "        <div\n" +
    "          hes-table\n" +
    "          tbl-data=\"data.table\"\n" +
    "          show-export=\"true\"\n" +
    "          report-name=\"'queued sms batches'\"\n" +
    "        ></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/sms/send.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sms/send.html",
    "<div class=\"sms-form\">\n" +
    "  <h2>Send SMS</h2>\n" +
    "  <div>\n" +
    "    <a ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\"\n" +
    "      >Back To Site</a\n" +
    "    >\n" +
    "    |\n" +
    "    <a ui-sref=\"go.u.site.sms.queued\" ui-sref-opts=\"{reload: true}\"\n" +
    "      >Back To SMS</a\n" +
    "    >\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"promotion-box fit\">\n" +
    "    <form ng-submit=\"submit()\">\n" +
    "      <label for=\"phone_number\"> Send to: </label>\n" +
    "      <a\n" +
    "        class=\"back-link float-right hes-popover\"\n" +
    "        hes-popover\n" +
    "        template=\"/scripts/content/keywords/keywords.html\"\n" +
    "        event=\"click\"\n" +
    "        hide-event=\"click\"\n" +
    "        popover-class=\"hes-popover-style no-print keyword-container\"\n" +
    "        >See Keywords</a\n" +
    "      >\n" +
    "      <span class=\"sub-text\"\n" +
    "        >If multiple numbers, seperate numbers with , or |\n" +
    "      </span>\n" +
    "      <textarea\n" +
    "        id=\"recipients\"\n" +
    "        name=\"recipients\"\n" +
    "        placeholder=\"+12013564567,+12013564567|+12013564567.....\"\n" +
    "        ng-model=\"sms.recipients\"\n" +
    "        ng-required=\"!sms.filters.ALL_SUBSCRIBED_PARTICIPANTS && !sms.filters.PROGRAM_PARTICIPANTS && !sms.filters.NON_PROGRAM_PARTICIPANTS\"\n" +
    "      ></textarea>\n" +
    "\n" +
    "      <label for=\"ALL_SUBSCRIBED_PARTICIPANTS\" class=\"margin-10-top\"\n" +
    "        >Audience: </label\n" +
    "      ><span class=\"sub-text\"> Only select one</span>\n" +
    "      <table>\n" +
    "        <tr>\n" +
    "          <td>\n" +
    "            <div\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "              aria-describedBy=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "              hes-checkbox\n" +
    "              class=\"hes-checkbox inline\"\n" +
    "              label-name=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "              ng-model=\"sms.filters.ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "            ></div>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <div name=\"ALL_SUBSCRIBED_PARTICIPANTS\" class=\"checkbox-label\">\n" +
    "              <span id=\"ALL_SUBSCRIBED_PARTICIPANTS\"\n" +
    "                >All Subscribed Participants</span\n" +
    "              >\n" +
    "            </div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "        <tr>\n" +
    "          <td>\n" +
    "            <div\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"PROGRAM_PARTICIPANTS\"\n" +
    "              aria-describedBy=\"PROGRAM_PARTICIPANTS\"\n" +
    "              hes-checkbox\n" +
    "              class=\"hes-checkbox inline\"\n" +
    "              label-name=\"PROGRAM_PARTICIPANTS\"\n" +
    "              ng-change=\"reset()\"\n" +
    "              ng-model=\"sms.filters.PROGRAM_PARTICIPANTS\"\n" +
    "            ></div>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <div name=\"PROGRAM_PARTICIPANTS\" class=\"checkbox-label\">\n" +
    "              <span id=\"PROGRAM_PARTICIPANTS\"\n" +
    "                >Participants who have opted into program</span\n" +
    "              >\n" +
    "            </div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "        <tr>\n" +
    "          <td>\n" +
    "            <div\n" +
    "              type=\"checkbox\"\n" +
    "              id=\"NON_PROGRAM_PARTICIPANTS\"\n" +
    "              aria-describedBy=\"NON_PROGRAM_PARTICIPANTS\"\n" +
    "              hes-checkbox\n" +
    "              class=\"hes-checkbox inline\"\n" +
    "              label-name=\"NON_PROGRAM_PARTICIPANTS\"\n" +
    "              ng-change=\"reset()\"\n" +
    "              ng-model=\"sms.filters.NON_PROGRAM_PARTICIPANTS\"\n" +
    "            ></div>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <div name=\"NON_PROGRAM_PARTICIPANTS\" class=\"checkbox-label\">\n" +
    "              <span id=\"NON_PROGRAM_PARTICIPANTS\">\n" +
    "                Participants who have not opted into program</span\n" +
    "              >\n" +
    "            </div>\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "      </table>\n" +
    "      <div\n" +
    "        name=\"program_id\"\n" +
    "        class=\"checkbox-label\"\n" +
    "        ng-if=\"!!sms.filters.PROGRAM_PARTICIPANTS || !!sms.filters.NON_PROGRAM_PARTICIPANTS\"\n" +
    "      >\n" +
    "        <select\n" +
    "          ng-model=\"sms.program_id\"\n" +
    "          ng-options=\"program.id as program.name for program in dbSite.programs\"\n" +
    "        >\n" +
    "          <option value=\"\">-- None --</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"margin-10-top\">\n" +
    "        <label for=\"template\">Templates</label>\n" +
    "        <br />\n" +
    "        <select\n" +
    "          ng-model=\"data.current_template\"\n" +
    "          ng-options=\"template as template.name for template in data.templates\"\n" +
    "          ng-change=\"setTemplate()\"\n" +
    "        >\n" +
    "          <option value=\"\">-- None --</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "\n" +
    "      <div>\n" +
    "        <label for=\"message\">Message: </label>\n" +
    "        <span class=\"sub-text\"\n" +
    "          >Characters remaining - {{250 - sms.message.length}}</span\n" +
    "        >\n" +
    "        <a\n" +
    "          class=\"back-link float-right\"\n" +
    "          href=\"https://free-url-shortener.rb.gy/\"\n" +
    "          target=\"_blank\"\n" +
    "          >Url Shortener</a\n" +
    "        >\n" +
    "        <textarea\n" +
    "          id=\"message\"\n" +
    "          name=\"message\"\n" +
    "          placeholder=\"message\"\n" +
    "          ng-model=\"sms.message\"\n" +
    "          maxlength=\"250\"\n" +
    "          rows=\"4\"\n" +
    "          required\n" +
    "        ></textarea>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"time-div\">\n" +
    "        <table>\n" +
    "          <tr>\n" +
    "            <td>\n" +
    "              <div\n" +
    "                type=\"checkbox\"\n" +
    "                id=\"send_at_checkbox\"\n" +
    "                aria-describedBy=\"send_at_checkbox\"\n" +
    "                hes-checkbox\n" +
    "                class=\"hes-checkbox inline\"\n" +
    "                label-name=\"send_at_checkbox\"\n" +
    "                ng-model=\"sms.is_scheduled\"\n" +
    "              ></div>\n" +
    "            </td>\n" +
    "            <td>\n" +
    "              <div name=\"send_at_checkbox\" class=\"checkbox-label\">\n" +
    "                <label id=\"send_at_checkbox\">Schedule send time</label>\n" +
    "              </div>\n" +
    "            </td>\n" +
    "          </tr>\n" +
    "        </table>\n" +
    "        <div ng-if=\"!!sms.is_scheduled\">\n" +
    "          <input\n" +
    "            id=\"send_at\"\n" +
    "            class=\"send_at\"\n" +
    "            type=\"datetime-local\"\n" +
    "            required\n" +
    "            ng-model=\"sms.send_at\"\n" +
    "          />\n" +
    "          - Eastern\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"button-area\">\n" +
    "        <span>{{sentMessage}}</span\n" +
    "        ><button type=\"submit\">\n" +
    "          {{!!sms.is_scheduled? \"Schedule\" : \"Send\"}}\n" +
    "        </button>\n" +
    "      </div>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/sms/show/show.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/sms/show/show.template.html",
    "<div class=\"sms-dialog\">\n" +
    "  <h2>Batch: {{data.batch.id}}</h2>\n" +
    "\n" +
    "  <div class=\"speech-bubble\" markdown-div ng-model=\"data.batch.message\"></div>\n" +
    "\n" +
    "  <div class=\"margin-20-top\">\n" +
    "    <div>Processed recipents in batch: <b>{{data.messages.length}}</b></div>\n" +
    "    <div>\n" +
    "      Expected number of recipents in batch:\n" +
    "      <b>{{data.batch_recipients_length}}</b>\n" +
    "    </div>\n" +
    "    <details>\n" +
    "      <summary>Expected recipients:</summary>\n" +
    "      <input\n" +
    "        type=\"text\"\n" +
    "        ng-model=\"data.confirmation.search\"\n" +
    "        placeholder=\"Search for number..\"\n" +
    "        class=\"search-input\"\n" +
    "      />\n" +
    "      <div class=\"repeat-wrap\">\n" +
    "        <span\n" +
    "          ng-repeat=\"r in data.expected_recipents | filter:data.confirmation.search track by $index \"\n" +
    "          >{{r}},</span\n" +
    "        >\n" +
    "      </div>\n" +
    "    </details>\n" +
    "  </div>\n" +
    "\n" +
    "  <a style=\"float: right\" ng-click=\"refreshMessages()\">Refresh</a>\n" +
    "  <div class=\"sites-content\">\n" +
    "    <div\n" +
    "      hes-table\n" +
    "      tbl-data=\"data.table\"\n" +
    "      show-export=\"true\"\n" +
    "      report-name=\"'qmessages in batch'\"\n" +
    "    ></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/ssoDetail/ssoDetail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/ssoDetail/ssoDetail.html",
    "<div class=\"col3\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "    </div>\n" +
    "    <h4>SSO Details</h4>\n" +
    "    <table class=\"sso_details_tbl\">\n" +
    "      <thead>\n" +
    "        <th>wskey</th>\n" +
    "        <th ng-if=\"dbSite.isLocationDisplayed()\">location</th>\n" +
    "        <!-- <th>label</th> -->\n" +
    "        <th>enabled</th>\n" +
    "        <th></th>\n" +
    "      </thead>\n" +
    "      <tbody>\n" +
    "        <tr ng-repeat=\"ssoDetail in data.ssoDetails\">\n" +
    "          <td class='sso_details_tbl'>\n" +
    "            <span>{{ ssoDetail.wskey || 'null' }}</span>\n" +
    "          </td>\n" +
    "          <td ng-if=\"dbSite.isLocationDisplayed()\">\n" +
    "            <span>{{ getLocationName(ssoDetail.location_id) || 'null' }}</span>\n" +
    "          </td>\n" +
    "          <!-- <td>\n" +
    "            <span>{{ ssoDetail.sso_label || 'null' }}</span>\n" +
    "          </td> -->\n" +
    "          <td>\n" +
    "            <span>{{ ssoDetail.is_sso_enabled ? 'yes' : 'no' }}</span>\n" +
    "          </td>\n" +
    "          <td>\n" +
    "            <a ng-click=\"editSsoDetail(ssoDetail, false)\">Edit</a>\n" +
    "            <br />\n" +
    "            <br/ >\n" +
    "            <a class='sso_detail_destroy' ng-click=\"destroySsoDetail(ssoDetail)\">Destroy</a>\n" +
    "            <br />\n" +
    "          </td>\n" +
    "        </tr>\n" +
    "      </tbody>\n" +
    "    </table>\n" +
    "    <br />\n" +
    "    <a ng-click=\"newSsoDetail()\">New SSO Detail</a>\n" +
    "  </div>\n" +
    "  <br />\n" +
    "\n" +
    "  <!-- SSO Detail Test -->\n" +
    "\n" +
    "  <form class=\"hes\" id=\"test_sso\" ng-submit=\"doSsoTest()\" method=\"POST\" ng-if=\"hasSSODetails()\">\n" +
    "    <h4>\n" +
    "      Test SSO\n" +
    "    </h4>\n" +
    "\n" +
    "    <fieldset>\n" +
    "      <div class='row'>\n" +
    "        <span>\n" +
    "          <label for='key'>WSKEY</label>\n" +
    "          <input id='key' name=\"key\" type='text' ng-model='testSSO.key' />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "      <div class='row'>\n" +
    "        <span>\n" +
    "          <label for='url'>URL</label>\n" +
    "          <input id='url' name=\"url\" type='text' ng-model='testSSO.url' />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for='identifier'>Identifier</label>\n" +
    "          <input id='identifier' name=\"identifier\" type='text' ng-model='testSSO.identifier' />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='row'>\n" +
    "        <span>\n" +
    "          <label for='firstName'>First Name</label>\n" +
    "          <input id='firstName' name=\"firstName\" type='text' ng-model='testSSO.first_name' />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for='lastName'>Last Name</label>\n" +
    "          <input id='lastName' name=\"lastName\" type='text' ng-model='testSSO.last_name' />\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class='row'>\n" +
    "        <span>\n" +
    "          <label for='email'>Email</label>\n" +
    "          <input id='email' name=\"email\" type='text' ng-model='testSSO.email' />\n" +
    "        </span>\n" +
    "        <span>\n" +
    "          <label for='extras'>Extras (extra_name=value ... divided by new lines)</label>\n" +
    "          <textarea id='extras' name=\"extras\" type='text' ng-model='testSSO.extras' ></textarea>\n" +
    "        </span>\n" +
    "      </div>\n" +
    "    </fieldset>\n" +
    "\n" +
    "    <div class=\"center\">\n" +
    "      <button type='submit'>test</button>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/ssoDetail/ssoDetailCreateEdit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/ssoDetail/ssoDetailCreateEdit.html",
    "<div class=\"padded-page\">\n" +
    "  <h4>{{ ssoDetail.isNew() ? 'New' : 'Edit' }} SSO Detail</h4>\n" +
    "  <form name='hes' name=\"ssoDetailForm\" ng-submit='saveSsoDetail(ssoDetail)'>\n" +
    "    <fieldset>\n" +
    "      <div ng-if=\"!ssoDetail.isNew()\" class=\"row\"> \n" +
    "        <label for='wskey'>wskey</label>\n" +
    "        <input id='wskey' type='text' ng-model='ssoDetail.wskey' />\n" +
    "      </div>\n" +
    "\n" +
    "      <div ng-if=\"dbSite.isLocationDisplayed()\" class=\"row\"> \n" +
    "        <label for='location'>location</label>\n" +
    "        <select id='location' type='text' ng-model='ssoDetail.location_id' ng-model=\"ssoDetail.location_id\" ng-options=\"location.id as location.name group by getLocationName(location.parent_location_id) for location in data.locations\">\n" +
    "          <option value=\"\">-- All --</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- <div class=\"row\"> \n" +
    "        <label for='label'>label</label>\n" +
    "        <input id='label' type=\"text\" ng-model=\"ssoDetail.sso_label\"/>\n" +
    "      </div> -->\n" +
    "\n" +
    "      <div class=\"row\"> \n" +
    "        <label for='redirect'>redirect</label>\n" +
    "        <textarea id='redirect' ng-model=\"ssoDetail.redirect\" />\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\"> \n" +
    "        <label for='login_url'>login url</label>\n" +
    "        <input id='login_url' type=\"text\" ng-model=\"ssoDetail.login_url\"/>\n" +
    "      </div>\n" +
    "\n" +
    "      <div ng-if=\"!ssoDetail.isNew()\" class=\"row\">\n" +
    "        <label for='is_enabled'>enabled?</label>\n" +
    "        <input type='checkbox' id=\"is_enabled\" ng-model=\"ssoDetail.is_sso_enabled\"/>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- console-managed during rollout: disabled so saves can't change the enforcement mode -->\n" +
    "      <div ng-if=\"!ssoDetail.isNew()\" class=\"row\">\n" +
    "        <label for='sso_enforcement'>saml request enforcement</label>\n" +
    "        <select id='sso_enforcement' ng-model='ssoDetail.sso_enforcement' disabled>\n" +
    "          <option value='disabled'>Disabled</option>\n" +
    "          <option value='warn'>Warn</option>\n" +
    "          <option value='error'>Error</option>\n" +
    "        </select>\n" +
    "      </div>\n" +
    "\n" +
    "    </fieldset>\n" +
    "    <br />\n" +
    "    <div class='bottom-row-rel center'>\n" +
    "      <button ng-disabled=\"ssoDetail.saving\" ng-class=\"{disabled: ssoDetail.saving}\" type='submit'>{{!ssoDetail.isNew() ? 'Save' : 'Create'}}</button>\n" +
    "      <div class='save-feedback' ng-show=\"ssoDetail.saving\">Saving...</div>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/ssoDetail/ssoDetailDestroy.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/ssoDetail/ssoDetailDestroy.html",
    "<div class=\"padded-page\">\n" +
    "  <div class='bottom-row-rel center'>\n" +
    "    <h4>Are you sure you want to destroy this SSO Detail?</h4>\n" +
    "    <button ng-click=\"confirm()\">Yes</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/star-rating/starRating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/star-rating/starRating.html",
    "<div>\n" +
    "  <div layout=\"row\" class=\"rating-system\" layout-align=\"space-between end\">\n" +
    "    <span ng-if=\"user\"\n" +
    "      ng-repeat=\"star in stars track by $index\"\n" +
    "      class=\"rating-star\"\n" +
    "      ng-class=\"{'highlighted-by-user': ($index + 1 <= value && highlightedByUser), \n" +
    "        'highlighted': ($index + 1 <= value && highlightedAverage), \n" +
    "        'none': notHighlighted}\">\n" +
    "        <button class=\"icon-btn\"\n" +
    "          ng-focus=\"onHover($index)\"\n" +
    "          ng-blur=\"outHover()\"\n" +
    "          ng-mouseout=\"outHover()\"\n" +
    "          ng-mouseenter=\"onHover($index)\"\n" +
    "          tabindex=\"0\"\n" +
    "          ng-click=\"setRating($index)\"\n" +
    "          ng-keydown=\"setRatingAria($event, $index)\"\n" +
    "          aria-label=\"{{'Rate ' + ($index + 1) + ($index > 0 ? ' Stars' : ' Star')}}\">\n" +
    "          <md-tooltip md-direction=\"bottom\">{{ratingTip}}</md-tooltip>\n" +
    "          <span hes-icon icon-name=\"{{'recipe:rating-star' + (($index + 1 <= value && (highlightedByUser || highlightedAverage)) ? '-filled' : '')}}\" alt=\"\"></md-icon>\n" +
    "        </button>\n" +
    "    </span>\n" +
    "    <span ng-if=\"!user\"\n" +
    "      ng-repeat=\"star in stars track by $index\"\n" +
    "      class=\"rating-star icon-rating-star\"\n" +
    "      ng-class=\"{'highlighted': ($index + 1 <= value && highlightedAverage), 'none': notHighlighted}\">\n" +
    "      <span hes-icon icon-name='recipes:rating-star'></span>\n" +
    "    </span>\n" +
    "  </div>\n" +
    "  <div layout='row' layout-align=\"space-between end\">\n" +
    "    <div flex=\"30\" flex-gt-sm=\"30\">\n" +
    "      <button class=\"link-look\" ng-click=\"clearRating()\" aria-label=\"clear rating\"\n" +
    "        ng-show=\"!!userRating && user\">Clear</button>\n" +
    "    </div>\n" +
    "     <span class=\"rating-message\" ng-bind-html=\"rating_message\" ng-show=\"user\" \n" +
    "      aria-live=\"polite\">\n" +
    "    </span>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/stats/campaigns_container.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/stats/campaigns_container.html",
    "<div class=\"stats-container\" style=\"margin-top: 10px;\" ng-if=\"data.campaigns.length\">\n" +
    "  <div class=\"stats-header\">\n" +
    "    <h2>Campaigns</h2>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class=\"campaign-data\">\n" +
    "    <div class=\"stats__item\"\n" +
    "      ng-repeat=\"campaign in data.campaigns\"\n" +
    "      ng-class=\"{'dashed': (isCurrent(campaign) && !hasUserOptedInToProgram(campaign)) || \n" +
    "                              (!isCurrent(campaign) && !hasUserOptedInToProgram(campaign))\n" +
    "       }\">\n" +
    "      <div class=\"campaign-data__image-wrapper\">\n" +
    "        <img ng-src=\"{{campaign.logo.url}}\" alt=\"{{campaign.name}}\"></img>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"dates\">{{ formattedDate(campaign.effective_date_start)  }} - {{ formattedDate(campaign.effective_date_end) }}</div>\n" +
    "      <span ng-if=\"isCurrent(campaign)\">\n" +
    "        <button aria-label=\"Enter {{ campaign.name }}\" ng-if=\"hasUserOptedInToProgram(campaign)\" ng-click=\"goToProgram(campaign.id)\">Enter</button>\n" +
    "        <button aria-label=\"Opt in to {{ campaign.name }}\" ng-if=\"!hasUserOptedInToProgram(campaign)\" ng-click=\"goToProgram(campaign.id)\">Opt In</button>\n" +
    "      </span>\n" +
    "      <span ng-if=\"!isCurrent(campaign)\">\n" +
    "        <button aria-label=\"Download report for {{ campaign.name }}\" class=\"secondary\" ng-if=\"hasUserOptedInToProgram(campaign) && !isMobile()\" ng-click=\"downloadHistory(campaign)\">Download Report</button>\n" +
    "        <div tabindex=\"0\" aria-label=\"You did not opt in to {{ campaign.name }}\" ng-if=\"!hasUserOptedInToProgram(campaign)\">You missed opting in to this one.</div>\n" +
    "      </span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/stats/gokp_legacy_stats.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/stats/gokp_legacy_stats.html",
    "<div class=\"stats\">\n" +
    "  <div class=\"stats-container\">\n" +
    "    <div class=\"stats-header\">\n" +
    "      <h2 class=\"italic\">{{ site.name }}</h2>\n" +
    "    </div>\n" +
    "    \n" +
    "    <div class=\"legacy-tile-row\" ng-repeat=\"chunk in gokp_years\">\n" +
    "      <div class=\"legacy-tile\" ng-repeat=\"year in chunk\">\n" +
    "        <h2>{{ year }}</h2>\n" +
    "        <div>&nbsp;<span ng-if=\"year == 2020\">January - August</span>&nbsp;</div>\n" +
    "        <button class=\"secondary\" ng-if=\"!isMobile()\" ng-click=\"getGokpUserData(year)\">Download Report</button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    \n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/stats/legacy_stats.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/stats/legacy_stats.html",
    "<div class=\"stats\">\n" +
    "  <div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/stats/campaigns_container.html')\"></div>\n" +
    "</div>");
}]);

angular.module("/scripts/stats/stats.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/stats/stats.html",
    "<div class=\"stats\">\n" +
    "  <div ng-if=\"site.flags.is_launchpad_plus && site.features_on\" class=\"stats-container\">\n" +
    "    <div class=\"stats-header\">\n" +
    "      <h2 class=\"italic\">{{ site.name }}</h2>\n" +
    "      <button class=\"secondary\" ng-if=\"canExportStats()\" ng-click=\"exportStats($state.params.year)\">Download Report</button>\n" +
    "    </div>\n" +
    "    <div class=\"stats-data\">\n" +
    "      <div class=\"stats__item\">\n" +
    "        <div class=\"row\"\n" +
    "          aria-label=\"{{ data.stats.total_completed_challenges }} Successful Challenges\"\n" +
    "          tabindex=\"0\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-challenges\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number challenges-color\">{{ data.stats.total_completed_challenges }}</div>\n" +
    "            <div class=\"data-label\">Successful Challenges</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\"\n" +
    "          aria-label=\"{{ data.stats.total_completed_goals }} Completed Goals\"\n" +
    "          tabindex=\"0\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-goals\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number goals-color\">{{ data.stats.total_completed_goals }}</div>\n" +
    "            <div class=\"data-label\">Goals Completed</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"stats__item\" ng-if=\"site.flags.is_logging_enabled\">\n" +
    "        <div class=\"row\"\n" +
    "          aria-label=\"{{ data.stats.total_steps }} Steps Taken\"\n" +
    "          tabindex=\"0\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-steps\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number steps-color\">{{ data.stats.total_steps | number }}</div>\n" +
    "            <div class=\"data-label\">Total Steps</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\"\n" +
    "          aria-label=\"{{ data.stats.total_badges_earned }} Badges Earned\"\n" +
    "          tabindex=\"0\">\n" +
    "          <span hes-icon icon-name=\"standard:stats-badges\"></span>\n" +
    "          <div class=\"data\">\n" +
    "            <div class=\"data-number badges-color\">{{ data.stats.total_badges_earned }}</div>\n" +
    "            <div class=\"data-label\">Badges Earned</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div ng-include=\"hesTemplateService.getTemplateUrl('/scripts/stats/campaigns_container.html')\"></div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/table/actionColTemplate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/table/actionColTemplate.html",
    "<span ng-repeat=\"value in COL_FIELD\">\n" +
    "  <a ng-href=\"{{value[1]}}\" ng-if=\"value[1] | isString\">{{value[0]}}</a>&nbsp;&nbsp;\n" +
    "  <a ng-if=\"value[1] | isFunction\" ng-click=\"value[1](value[2])\">{{value[0]}}</a>&nbsp;&nbsp;\n" +
    "</span>");
}]);

angular.module("/scripts/table/hesTable.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/table/hesTable.html",
    "<div>\n" +
    "  <a ng-click='exportReport()' class=\"action-link\" ng-show='!table.noRows && showExport'>Export</a>\n" +
    "  <div id=\"grid1\" ui-grid=\"table.gridOptions\" ui-grid-resize-columns ui-grid-infinite-scroll ui-grid-exporter ui-grid-auto-resize  class=\"grid\"></div>\n" +
    "  <div ng-if=\"table.noRows && tblData.fields && showNoData && !loading\">{{customNoDataMsg ? customNoDataMsg : 'No Data Available'}}</div>\n" +
    "  <div class=\"loading-more-data center\" ng-if=\"table.noRows && tblData.fields && loading\" style=\"padding-bottom: 40px;\">\n" +
    "    <div class='inline loading-div'>\n" +
    "      <div hes-loading-gif loading='table.noRows && tblData.fields && loading'></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/table/htmlColTemplate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/table/htmlColTemplate.html",
    "<span ng-bind-html=\"COL_FIELD\"></span>");
}]);

angular.module("/scripts/tablePager/tablePager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/tablePager/tablePager.html",
    "<div class=\"table-paging\" ng-if='isPaged()'>\n" +
    "  <span class='normal-text'>Showing {{getCurrentPage() * getPageSize() + 1}} - {{(getCurrentPage() * getPageSize()) + getPagedDataSize()}} of {{getFilteredDataSize()}}</span>\n" +
    "  <img class='clickable' ng-show='getCurrentPage() > 0' ng-click='previousTeamsPage()' ng-src=\"{{leftIcon ? leftIcon : '/images/icons/nav-left-1.png'}}\">\n" +
    "  <img ng-show='getCurrentPage() == 0' src='/images/icons/arrow-grey-left-page.png'>\n" +
    "  <img class='clickable' ng-show='hasMorePages()' ng-click='nextTeamsPage()' ng-src=\"{{rightIcon ? rightIcon : '/images/icons/nav-right-1.png'}}\">\n" +
    "  <img ng-show='!hasMorePages()' src='/images/icons/arrow-grey-right-page.png'>\n" +
    "</div>");
}]);

angular.module("/scripts/tabs/secondary-tabs-only-layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/tabs/secondary-tabs-only-layout.html",
    "<div class=\"tile {{navigation.current_menu.frame}}\">\n" +
    "  <div class=\"page-top\" layout=\"row\" layout-align=\"space-between center\">\n" +
    "    <div>\n" +
    "      {{ navigation.current_menu.parent.name || navigation.current_menu.name }}\n" +
    "    </div>\n" +
    "    <a ng-if=\"navigation.current_menu.parent.name == 'Wall' && site.name == 'Go KP'\"\n" +
    "       target=\"_blank\"\n" +
    "       class=\"title\" href=\"http://files.hesapps.com/gokp/wellness-wall-guidelines.pdf\">Guidelines</a>\n" +
    "    <button ng-if=\"navigation.current_menu.parent.name == 'Notifications'\" class=\"button\" ng-click=\"clearAll()\">\n" +
    "        <span hes-icon class=\"clear-all-icon\"\n" +
    "        icon-name=\"standard:clear-all\"\n" +
    "        watch-parent=\"button\"></span>\n" +
    "        Clear All\n" +
    "      </button>\n" +
    "    <hes-user-total-steps ng-if=\"$state.current.name === 'go.u.personal.entries'\" \n" +
    "      user=\"::user\" year=\"$state.params.year\">\n" +
    "    </hes-user-total-steps>\n" +
    "  </div>\n" +
    "\n" +
    "  <ul role=\"tablist\"\n" +
    "      class=\"sublinks no-print\"\n" +
    "      ng-if=\"hasChildren() && hasMoreThanOneChildren()\">\n" +
    "    <li role=\"tab\"\n" +
    "        aria-selected=\"{{ isSelected(menu) }}\"\n" +
    "        ng-repeat=\"menu in navigation.current_menu.parent.menus()\"\n" +
    "        ng-hide=\"$index > 5\"\n" +
    "        ng-class=\"{'active': includes(menu), 'three': navigation.current_menu.parent.name == 'Settings' }\">\n" +
    "      <span class=\"unread ng-scope\" ng-if=\"data.notificationState == menu.link\"></span>\n" +
    "      <a ui-sref=\"{{ menu.link }}({{ menu.params }})\" \n" +
    "        hes-focus set-focus=\"{{ isSelected(menu) }}\"\n" +
    "        aria-label=\"{{ menu.name }} {{ menu.parent.name }}\">{{ menu.name }}</a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "\n" +
    "  <ul role=\"tablist\"\n" +
    "      class=\"sublinks no-print\"\n" +
    "      ng-if=\"hasChildren() && hasMoreThanOneChildren() && navigation.current_menu.parent.menus().length > 6\">\n" +
    "    <li role=\"tab\"\n" +
    "        aria-selected=\"{{ isSelected(menu) }}\"\n" +
    "        ng-repeat=\"menu in navigation.current_menu.parent.menus()\"\n" +
    "        ng-hide=\"$index < 6\"\n" +
    "        ng-class=\"{'active': includes(menu), 'three': navigation.current_menu.parent.name == 'Settings' }\">\n" +
    "      <span class=\"unread ng-scope\" ng-if=\"data.notificationState == menu.link\"></span>\n" +
    "      <a ui-sref=\"{{ menu.link }}({{ menu.params }})\" \n" +
    "        hes-focus set-focus=\"{{ isSelected(menu) }}\"\n" +
    "        aria-label=\"{{ menu.name }} {{ menu.parent.name }}\">{{ menu.name }}</a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "\n" +
    "  <h1 class=\"visuallyhidden\">{{$state.current.title}}</h1>\n" +
    "  <div class=\"frame\" role=\"main\" ui-view></div>\n" +
    "</div>");
}]);

angular.module("/scripts/tabs/tabbed-tile-layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/tabs/tabbed-tile-layout.html",
    "<div class=\"tile\">\n" +
    "  <ul role=\"tablist\" class=\"links no-print\">\n" +
    "    <li aria-selected=\"{{ isActiveParent(menu) }}\"\n" +
    "        role=\"tab\"\n" +
    "        ng-class=\"{'active': isActiveParent(menu) }\" \n" +
    "        ng-repeat=\"menu in navigation.current_menu.parentGroup().menus()\">\n" +
    "      <a ui-sref=\"{{ menu.getDefaultLink() }}({{ menu.params }})\"\n" +
    "        hes-focus set-focus=\"{{isActiveParent(menu)}}\">{{ menu.name }}</a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "\n" +
    "  <ul role=\"tablist\"\n" +
    "      class=\"sublinks no-print\"\n" +
    "      ng-if=\"hasChildren()\">\n" +
    "    <li role=\"tab\"\n" +
    "        aria-selected=\"{{ isSelected(menu) }}\"\n" +
    "        ng-repeat=\"menu in navigation.current_menu.parent.menus()\"\n" +
    "        ng-class=\"{'active': includes(menu) }\">\n" +
    "      <a ui-sref=\"{{ menu.link }}({{ menu.params }})\" \n" +
    "        hes-focus set-focus=\"{{ isSelected(menu) }}\">{{ menu.name }}</a>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "  \n" +
    "  <h1 class=\"visuallyhidden\">{{$state.current.title}}</h1>\n" +
    "  <div class=\"frame\" role=\"main\" ui-view></div>\n" +
    "</div>");
}]);

angular.module("/scripts/terms/terms.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/terms/terms.html",
    "<div class=\"privacy-wrapper\">\n" +
    "	\n" +
    "	<div required-term-prompts='terms'></div>\n" +
    "	\n" +
    "	<div ng-repeat='item in terms'>\n" +
    "		<div class='terms-title' ng-bind-html='item.title_html' hes-external-links></div>\n" +
    "		<div class='terms-content' ng-bind-html='item.content_html' hes-external-links></div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/themes/editTheme.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/themes/editTheme.html",
    "<div class=\"page\">\n" +
    "    <div class=\"xpage-tile\">\n" +
    "        <div class=\"xpage-title boldCusto\">\n" +
    "            <span >Colors</span>\n" +
    "        </div><br>\n" +
    "        <div class=\"row padding-xlg-left-right padding-xlg-top clearfix bgCusto\" >\n" +
    "            <div>\n" +
    "                <a class='back-link bold' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "            </div>\n" +
    "            <div class=\"variable float-left margin-lg-right\" ng-repeat=\"variable in theme.workingData\">\n" +
    "                <div class=\"clearfix\">\n" +
    "                    <div class=\"variable-display float-left\">\n" +
    "                        <label for=\"{{variable.variable}}\">{{variable.display_name}}</label>\n" +
    "                        <input type=\"text\" id=\"{{variable.variable}}\" ng-model=\"variable.value\" minicolors=\"colorpickerSettings\"/>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"variable-description\">\n" +
    "                    {{variable.description}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row clearfix margin-lg-top padding-xlg-left-right buttons-row\">\n" +
    "            <div class=\"buttons float-right\">\n" +
    "                <a class='back-link' ng-click=\"cancel()\">Cancel</a>\n" +
    "                <button ng-disabled=\"view.saving\" ng-click=\"saveTheme()\">Save</button>\n" +
    "            </div>\n" +
    "            <p ng-if=\"view.saving\" class=\"float-right padding-md-right\">Saving...</p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/tips/tips-layout.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/tips/tips-layout.html",
    "<div>\n" +
    "  <h1 class=\"visuallyhidden\">{{$state.current.title}}</h1>\n" +
    "  <div ui-view></div>\n" +
    "</div>");
}]);

angular.module("/scripts/tips/views/tip.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/tips/views/tip.html",
    "<hes-breadcrumb class=\"resource\" ng-if=\"settings.showBreadcrumb\" crumbs=\"settings.crumbs\"></hes-breadcrumb>\n" +
    "<div ng-if=\"!show_broken_tip\" class=\"tip content-item\">\n" +
    "  <div flex layout=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\"\n" +
    "    class=\"headline\">\n" +
    "    <div class=\"content-item__header\">\n" +
    "        <div class=\"picture-frame\">\n" +
    "        <img alt=\"\" class=\"resource-image\" hes-image=\"{{::tip.image1.url}}\" no-theme use-domain=\"true\" />\n" +
    "      </div>\n" +
    "      <div class=\"content-item__meta xs\">\n" +
    "        <div flex class=\"secondary-text\">\n" +
    "          {{tip.date | date: \"EEE, MMM d\"}}\n" +
    "        </div>\n" +
    "        <h2 tabindex=\"-1\">\n" +
    "          <span markdown no-paragraph ng-model=\"tip.title\"></span>\n" +
    "        </h2>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div flex class=\"intro\">\n" +
    "      <div flex class=\"secondary-text sm md\">\n" +
    "        {{tip.date | date: \"EEE, MMM d\"}}\n" +
    "      </div>\n" +
    "      <div flex class=\"sm md\">\n" +
    "        <h2 tabindex=\"-1\">\n" +
    "          <span markdown no-paragraph ng-model=\"tip.title\"></span>\n" +
    "        </h2>\n" +
    "      </div>\n" +
    "      <div flex layout-gt-sm=\"row\" class=\"actions\" layout-align=\"start center\" ng-show=\"user\">\n" +
    "        <div class=\"favorite\">\n" +
    "          <div plus-one\n" +
    "            toggle-var='{{tip.favorited}}'\n" +
    "            image-span=\"<span hes-icon icon-name='standard:favorite-filled'>\n" +
    "              </span>\">\n" +
    "            <button class=\"icon-btn favorite\" aria-label=\"Favorite tip\"\n" +
    "              ng-class=\"{'active': user && tip.favorited}\"\n" +
    "              ng-click=\"tip.toggleFavorite()\"\n" +
    "              ng-mouseenter=\"tip.hover = true\"\n" +
    "              ng-mouseleave=\"tip.hover = false\"\n" +
    "              aria-pressed=\"{{!!tip.favorited}}\">\n" +
    "              <md-tooltip md-direction=\"bottom\">Favorite</md-tooltip>\n" +
    "              <span hes-icon\n" +
    "                icon-name=\"standard:favorite{{!!tip.favorited || tip.hover ? '-filled' : ''}}\">\n" +
    "              </span>\n" +
    "            </button>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"sharing\" ng-cloak>\n" +
    "          <hes-share-dial type=\"Tip\" resource=\"tip\"></hes-share-dial>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"comments-preview no-print\" layout-align=\"start center\">\n" +
    "        <div>\n" +
    "          <button ng-if=\"settings.tipWall.posts.length != 1\" class=\"link-look\" ng-click=\"scrollToComments()\">\n" +
    "            {{settings.tipWall.posts.length}} comments\n" +
    "          </button>\n" +
    "          <button ng-if=\"settings.tipWall.posts.length == 1\" class=\"link-look\" ng-click=\"scrollToComments()\">\n" +
    "            {{settings.tipWall.posts.length}} comment\n" +
    "          </button>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "\n" +
    "  <div>\n" +
    "    <article>\n" +
    "      <div hes-external-links markdown ng-model=\"tip.content_html\"></div>\n" +
    "    </article>\n" +
    "  </div>\n" +
    "  <hes-resource-comments ng-if=\"tip\" id=\"tip_comments\" flex-offset-gt-xs=\"20\" flex\n" +
    "    ng-if=\"user\" wallable=\"tip\" wall=\"settings.tipWall\"\n" +
    "    resource-name=\"Tip\"></hes-resource-comments>\n" +
    "</div>\n" +
    "<div ng-if=\"show_broken_tip\" class=\"tip content-item\">\n" +
    "  <div style=\"width:100%;height:200px;\" hes-icon\n" +
    "    icon-name=\"standard:tip-error\">\n" +
    "  </div>\n" +
    "  <h2 style=\"margin-top:20px;\" class=\"text-center\">Tip does not exist</h2>\n" +
    "</div>");
}]);

angular.module("/scripts/tips/views/tips.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/tips/views/tips.html",
    "<div class=\"tips\">\n" +
    "  <h2 \"visuallyhidden\" tabindex=\"-1\"></h2>\n" +
    "  <div class=\"all\">\n" +
    "    <div layout=\"column\" class=\"filter\">\n" +
    "      <md-radio-group md-no-ink ng-model=\"data.selectedFilter\" class=\"resource-filters\" tabindex=\"-1\">\n" +
    "        <md-radio-button tabindex=\"0\" ng-repeat=\"filter in ::data.allFilters\"\n" +
    "          ng-value=\"filter.key\"\n" +
    "          ng-keydown=\"ariaClick($event)\"\n" +
    "          aria-label=\"{{filter.display}}\">\n" +
    "          {{filter.display}}\n" +
    "        </md-radio-button>\n" +
    "      </md-radio-group>\n" +
    "      <div>\n" +
    "        <hes-search-input on-search=\"applySearch(value)\" \n" +
    "          search-value=\"data.search\"\n" +
    "          placeholder-text=\"Search by title or keyword...\"></hes-search-input>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"resource-list\" ng-if=\"data.filteredItems.length === 0\">\n" +
    "      <md-divider></md-divider>\n" +
    "      <div class=\"item\" layout-xs=\"column\" layout-gt-xs=\"row\" layout-align=\"start center\">\n" +
    "        <div class=\"image-frame\">\n" +
    "          <img alt=\"\" class=\"preview-image\" hes-image=\"/images/placeholders/tip-placeholder.jpg\" />\n" +
    "        </div>\n" +
    "        <div ng-if=\"data.selectedFilter === 'favorites' && !data.hasFavorites\" flex class=\"preview\">\n" +
    "          <div flex class=\"title\">You have no Favorites yet.</div>\n" +
    "          <div flex  class=\"summary\">Select the heart icon (<span hes-icon \n" +
    "                icon-name=\"standard:favorite\" aria-hidden=\"true\">\n" +
    "              </span>) on your favorite tips to save them here.</div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"data.selectedFilter === 'favorites' && data.hasFavorites\" flex class=\"preview\">\n" +
    "          <!-- <div flex class=\"title\">Oops, try again.</div> -->\n" +
    "          <div flex  class=\"summary\" ng-bind-html=\"searchEmptyMessage()\"></div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"data.selectedFilter !== 'favorites'\" flex class=\"preview\">\n" +
    "          <!-- <div flex class=\"title\">Oops, try again.</div> -->\n" +
    "          <div flex  class=\"summary\" ng-bind-html=\"searchEmptyMessage()\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <md-divider></md-divider>\n" +
    "    </div>\n" +
    "    <div class=\"resource-list\">\n" +
    "      <span class=\"visuallyhidden\" aria-live=\"polite\">{{searchFilterMessage()}}</span>\n" +
    "      <a id=\"{{tip.id}}\" ng-repeat=\"tip in (data.filteredItems = (allTips | tipCategoryFilter:data.selectedFilter\n" +
    "        | tipSearchFilter:data.appliedSearch | orderBy: '-days_from_start') | limitTo: data.limit)\"\n" +
    "         ui-sref=\"go.u.content.tips.single({id: tip.id})\" aria-label=\"{{tip.title}}\">\n" +
    "        <md-divider></md-divider>\n" +
    "        <div class=\"item\" layout-xs=\"row\" layout-gt-xs=\"row\" layout-align=\"start start\">\n" +
    "          <div class=\"image-frame\">\n" +
    "            <img alt=\"\" class=\"preview-image\" hes-image=\"{{::tip.image1.url}}\" use-domain=\"true\" no-theme/>\n" +
    "          </div>\n" +
    "          <div flex class=\"preview\">\n" +
    "            <div flex class=\"secondary-text\">{{tip.date | date: \"EEE, MMM d\"}}</div>\n" +
    "            <div flex class=\"title\" markdown-div no-paragraph ng-model='::tip.title_html'></div>\n" +
    "            <div  flex class=\"summary\" markdown-div ng-model=\"::tip.summary_html\"></div>\n" +
    "            <div class=\"secondary-text\">{{::tip.getHealthCategories()}}</div>\n" +
    "          </div>\n" +
    "          <div class=\"arrow\" hide-xs flex=\"10\">\n" +
    "            <span hes-icon icon-name=\"standard:arrow\"></span>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <md-divider ng-if=\"$last\"></md-divider>\n" +
    "      </a>\n" +
    "      <hes-load-more-button on-click=\"showMore()\" \n" +
    "        ng-if=\"data.filteredItems.length && data.filteredItems.length > data.limit\">\n" +
    "      </hes-load-more-button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/totalSteps/total-steps.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/totalSteps/total-steps.html",
    "<div layout=\"row\" layout-align=\"space-between end\">\n" +
    "  <div class=\"steps-box\">\n" +
    "    <div>\n" +
    "      <span class=\"total-steps\">{{$ctrl.view.totalSteps | numberFormatter}}</span>\n" +
    "      Steps\n" +
    "    </div>\n" +
    "    <button class=\"link-look\" ng-if=\"!isMobile()\" ng-click=\"$ctrl.exportEntries($ctrl.year)\">\n" +
    "      Download Report\n" +
    "    </button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/unsubscribe/unsubscribe.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/unsubscribe/unsubscribe.html",
    "<div class=\"page\">\n" +
    "  <div class='tile'>\n" +
    "    <ul ng-if=\"!setup.loading\" role=\"tablist\" class=\"links\">\n" +
    "      <li role=\"tab\" ng-class=\"active\">\n" +
    "        <span>Email Unsubscribe</span>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    \n" +
    "    <div ng-if=\"!setup.loading\" class='frame page-form'>\n" +
    "      <p ng-bind-html=\"setup.content.content\"></p>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!!setup.loading\" style=\"display:flex;justify-content:center;\">\n" +
    "      <div hes-loading-gif loading=\"!!setup.loading\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("/scripts/upload/fileUpload.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/upload/fileUpload.html",
    "<div class=\"file-uploader\" layout=\"row\" layout-align=\"start top\">\n" +
    "  <div class=\"upload-view\">\n" +
    "    <div nv-file-drop uploader=\"setup.uploader\" class=\"upload-button-container-mobile\">\n" +
    "      <form name=\"imageUpload1\" style=\"display: inline-block\">\n" +
    "        <div class=\"hide-on-mobile\" ng-if=\"showDragDrop\"><b>Drop image here</b></div>\n" +
    "        <div class=\"hide-on-mobile\" ng-if=\"showDragDrop\">or</div>\n" +
    "        <div class=\"button fileinput-button\">\n" +
    "          <input id=\"{{'fileUploader' + uploadId}}\" type=\"file\" nv-file-select uploader=\"setup.uploader\" multiple tabindex=\"-1\"/>\n" +
    "          <label class=\"button-style\" id=\"file_upload_label\" for=\"{{'fileUploader' +uploadId}}\" \n" +
    "                ng-show='!useImage && !useWebFont'\n" +
    "                aria-label=\"Upload\" role=\"button\" ng-click=\"ariaClickLabel($event)\" tabindex=\"0\">Upload</label>\n" +
    "\n" +
    "          <!-- Image Label -->\n" +
    "          <label for=\"fileUploader{{uploadId}}\" ng-show='useImage'>\n" +
    "            <img alt=\"\" ng-src='{{labelImage}}' class='custom-label {{labelClass}}' />\n" +
    "          </label>\n" +
    "\n" +
    "          <span ng-show='useWebFont' ng-class='{\"{{webFont}}\" : useWebFont}' class='clickthrough font-lg font-icon'></span>\n" +
    "\n" +
    "        </div>\n" +
    "      </form>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <span class=\"user-photo-box\" ng-if=\"true || !allowAnyType\">\n" +
    "    <div ng-if=\"!!setup.previewUrl && setup.previewUrl != placeHolder\" \n" +
    "      hes-image-viewer=\"{{setup.previewUrl}}\"\n" +
    "      disable-popup=\"{{disablePopup}}\"\n" +
    "      screen-reading=\"View picture\"\n" +
    "      image-class=\"{{imageClass}}\">\n" +
    "    </div>\n" +
    "    <button type=\"button\" ng-if=\"!!setup.previewUrl && setup.previewUrl != placeHolder && showRemove\" \n" +
    "      class=\"remove link-look\"\n" +
    "      ng-click=\"removeImage()\">remove</button>\n" +
    "    <img class=\"{{imageClass}}\" ng-if=\"!!setup.previewUrl && setup.previewUrl == placeHolder\" hes-image=\"{{setup.previewUrl}}\" tabindex=\"-1\"  />\n" +
    "  </span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("/scripts/upload/fileUploadPhoto.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/upload/fileUploadPhoto.html",
    "<div class=\"photo-icon-uploader\" nv-file-drop uploader=\"setup.uploader\">\n" +
    "  <form name=\"imageUpload1\" style=\"display: inline-block\">\n" +
    "    <div class=\"photoinput-button\">\n" +
    "      <input id=\"{{'fileUploader' + uploadId}}\"  type=\"file\" accept=\"image/*\"\n" +
    "        nv-file-select uploader=\"setup.uploader\" no-resize=\"true\" multiple\n" +
    "        tabindex=\"-1\">\n" +
    "      <label for=\"fileUploader{{uploadId}}\">\n" +
    "        <span hes-icon icon-name=\"standard:upload-photo\" \n" +
    "        icon-hover-name='standard:upload-photo-filled' \n" +
    "        aria-label=\"Upload image\"\n" +
    "        tabindex=\"0\"\n" +
    "        ng-click=\"ariaClickLabel($event)\"\n" +
    "        watch-parent=\".photoinput-button\">\n" +
    "        </span>\n" +
    "\n" +
    "        <div class=\"dropzone sm md\" file-dropzone=\"[image/png, image/jpeg, image/gif]\"\n" +
    "        file=\"image\" file-name=\"imageFileName\" data-max-file-size=\"3\" ng-if=\"dragAndDrop\"></div>\n" +
    "      </label>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</div>");
}]);

angular.module("/scripts/upload/hesUploadImage.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/upload/hesUploadImage.html",
    "<div class=\"photo-bottom-actions\">\n" +
    "  <div class=\"choose-photo-container\">\n" +
    "    <div hes-file-upload ng-model='config.tempPhoto' label='{{(!hasImage() || hasDefaultImage()) ? \"+ Add Photo\" : \"Change Photo\"}}' show-link=\"true\" start='uploadPhotoStart()' complete='uploadPhotoFinished()'></div>\n" +
    "  </div>\n" +
    "  <div class=\"center\" go-fade-in-out on-switch='config.uploadingPhoto' s-options=\"config.inOutOptions\">Uploading...</div>\n" +
    "</div>");
}]);

angular.module("/scripts/upload/hesUploadImageDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/upload/hesUploadImageDialog.html",
    "<div class=\"ngDialog-padding\">\n" +
    "   <div class='ngDialog-title'>{{title}}</div>\n" +
    "   <div class='ngDialog-body'>{{message}}</div>\n" +
    "   <div class=\"photo-container\">\n" +
    "      <div class=\"crop-photo-container\" ng-show=\"showCropper && config.tempPhoto\">\n" +
    "<!--          <span id=\"uploadImage show-upload-image\">\n" +
    "            <div class='hes-img-cropper' uncropped-photo='config.photoTemp' ng-model='profilePhoto' thumbnail-url='thumbnail' options=\"{boxWidth: 300, boxHeight: 300}\" aspect-ratio='1' on-crop='saveProfilePhoto()'></div>\n" +
    "         </span> -->\n" +
    "         <span id='uploadImage' class=\"show-uploaded-image\" ng-if=\"config.cropType === 'rect'\">\n" +
    "            <div class='hes-img-cropper' uncropped-photo='config.photoNotCropped' options='{boxWidth: 300, boxHeight:150, aspectRatio: 3/2}' ng-model='config.tempPhoto' thumbnail-url='settings.imageUrl' aspect-ratio='1' on-crop='confirm()' crop-style=\"'rect'\" on-cancel=\"closeThisDialog()\"></div>\n" +
    "         </span>\n" +
    "         <span id=\"uploadImage\" ng-if=\"config.cropType === 'generic'\">\n" +
    "            <div class='hes-img-cropper' uncropped-photo='config.photoNotCropped' ng-model='config.tempPhoto' options='{boxWidth: 350, boxHeight:350, aspectRatio: null, setSelect: null}'thumbnail-url='settings.imageUrl' aspect-ratio='1' on-crop='confirm()' crop-style=\"'rect'\" on-cancel=\"closeThisDialog()\" allow-no-crop save-text=\"Use Image\"></div>\n" +
    "         </span>\n" +
    "      </div>\n" +
    "   </div>\n" +
    "   <div class=\"center text-right\" ng-if=\"!showCropper\">\n" +
    "      <a class=\"back-link\" ng-click=\"closeThisDialog()\">Cancel</a>\n" +
    "      <button ng-click=\"confirm()\">Select</button>\n" +
    "   </div>\n" +
    "</div>");
}]);

angular.module("/scripts/users/confirmUserDelete.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/users/confirmUserDelete.html",
    "<p>Are you sure you want to delete \"{{userToDelete.first_name + ' ' + userToDelete.last_name}}\"?</p> \n" +
    "<div class=\"center\">\n" +
    "  <button ng-click = \"confirm(userToDelete)\">Confirm</button>\n" +
    "  <button ng-click = \"closeThisDialog()\">Cancel</button> \n" +
    "</div>");
}]);

angular.module("/scripts/users/users.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/users/users.html",
    "<div class='col3' ng-if=\"$state.current.name === 'go.u.site.users'\">\n" +
    "  <div class=\"page-tile lg\">\n" +
    "    <div class=\"standard-header\">Participants</div>\n" +
    "    <div>\n" +
    "      <a class='back-link' ui-sref=\"go.u.site({siteId: dbSite.id})\" ui-sref-opts=\"{reload: true}\">Back To Site</a>\n" +
    "      <br/>\n" +
    "    </div>\n" +
    "    <div class=\"sites-content\">\n" +
    "      <div hes-table tbl-data=\"data.table\" show-export=\"true\" report-name=\"'Participants'\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<div ui-view class=\"dynamic-container\"></div>");
}]);

angular.module("/scripts/users/usersPopover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/users/usersPopover.html",
    "<hes-popover ng-if=\"items.length\"  \n" +
    "  content=\"{{buildContent()}}\">({{items.length}})</hes-popover>\n" +
    "  <span class=\"visuallyhidden\" ng-bind-html=\"buildContent()\"></span>");
}]);

angular.module("/scripts/utilities/Pikaday/examples/amd.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/utilities/Pikaday/examples/amd.html",
    "<!DOCTYPE html>\n" +
    "<html>\n" +
    "<head>\n" +
    "    <meta charset=\"utf-8\">\n" +
    "    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1, minimum-scale=1\">\n" +
    "    <title>Pikaday - AMD example</title>\n" +
    "    <meta name=\"author\" content=\"Ramiro Rikkert\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/pikaday.css\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/site.css\">\n" +
    "</head>\n" +
    "<body>\n" +
    "    <a href=\"https://github.com/dbushell/Pikaday\"><img style=\"position: absolute; top: 0; right: 0; border: 0;\" src=\"https://s3.amazonaws.com/github/ribbons/forkme_right_gray_6d6d6d.png\" alt=\"Fork me on GitHub\"></a>\n" +
    "\n" +
    "    <h1>Pikaday - AMD example</h1>\n" +
    "\n" +
    "    <p class=\"large\">A refreshing JavaScript Datepicker — lightweight, no dependencies, modular CSS.</p>\n" +
    "\n" +
    "    <label for=\"datepicker\">Date:</label>\n" +
    "    <br>\n" +
    "    <input type=\"text\" id=\"datepicker\">\n" +
    "\n" +
    "    <h2>What is this?</h2>\n" +
    "\n" +
    "    <p>This is a development preview! Feel free to use it however you like but please report any bugs or feature requests to <a href=\"http://twitter.com/dbushell/\">@dbushell</a> (on the GitHub issue tracker), thanks!</p>\n" +
    "\n" +
    "    <p class=\"small\">Copyright © 2013 <a href=\"http://dbushell.com/\">David Bushell</a> | BSD &amp; MIT license | Example by <a href=\"https://github.com/rikkert\">Ramiro Rikkert</a></p>\n" +
    "\n" +
    "    <script src=\"//cdnjs.cloudflare.com/ajax/libs/require.js/2.1.5/require.js\"></script>\n" +
    "    <script>\n" +
    "\n" +
    "    require.config({\n" +
    "        baseUrl: '../',\n" +
    "        // To get timely, correct error triggers in IE, force a define/shim exports check.\n" +
    "        enforceDefine: true\n" +
    "    });\n" +
    "    require(['pikaday'], function(Pikaday)\n" +
    "    {\n" +
    "        var picker = new Pikaday(\n" +
    "        {\n" +
    "            field: document.getElementById('datepicker'),\n" +
    "            firstDay: 1,\n" +
    "            minDate: new Date('2000-01-01'),\n" +
    "            maxDate: new Date('2020-12-31'),\n" +
    "            yearRange: [2000,2020]\n" +
    "        });\n" +
    "    });\n" +
    "\n" +
    "    </script>\n" +
    "</body>\n" +
    "</html>");
}]);

angular.module("/scripts/utilities/Pikaday/examples/jquery-amd.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/utilities/Pikaday/examples/jquery-amd.html",
    "<!DOCTYPE html>\n" +
    "<html>\n" +
    "<head>\n" +
    "    <meta charset=\"utf-8\">\n" +
    "    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1, minimum-scale=1\">\n" +
    "    <title>Pikaday - jQuery + AMD example</title>\n" +
    "    <meta name=\"author\" content=\"Ramiro Rikkert\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/pikaday.css\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/site.css\">\n" +
    "</head>\n" +
    "<body>\n" +
    "    <a href=\"https://github.com/dbushell/Pikaday\"><img style=\"position: absolute; top: 0; right: 0; border: 0;\" src=\"https://s3.amazonaws.com/github/ribbons/forkme_right_gray_6d6d6d.png\" alt=\"Fork me on GitHub\"></a>\n" +
    "\n" +
    "    <h1>Pikaday - jQuery + AMD example</h1>\n" +
    "\n" +
    "    <p class=\"large\">A refreshing JavaScript Datepicker — lightweight, no dependencies, modular CSS.</p>\n" +
    "\n" +
    "    <label for=\"datepicker\">Date:</label>\n" +
    "    <br>\n" +
    "    <input type=\"text\" id=\"datepicker\">\n" +
    "\n" +
    "    <h2>What is this?</h2>\n" +
    "\n" +
    "    <p>This is a development preview! Feel free to use it however you like but please report any bugs or feature requests to <a href=\"http://twitter.com/dbushell/\">@dbushell</a> (on the GitHub issue tracker), thanks!</p>\n" +
    "\n" +
    "    <p class=\"small\">Copyright © 2013 <a href=\"http://dbushell.com/\">David Bushell</a> | BSD &amp; MIT license | Example by <a href=\"https://github.com/rikkert\">Ramiro Rikkert</a></p>\n" +
    "\n" +
    "\n" +
    "    <script src=\"//cdnjs.cloudflare.com/ajax/libs/require.js/2.1.5/require.js\"></script>\n" +
    "    <script>\n" +
    "\n" +
    "    require.config({\n" +
    "        baseUrl: '../',\n" +
    "        // To get timely, correct error triggers in IE, force a define/shim exports check.\n" +
    "        enforceDefine: true,\n" +
    "        paths: {\n" +
    "            jquery: '//cdnjs.cloudflare.com/ajax/libs/jquery/1.9.1/jquery.min'\n" +
    "        }\n" +
    "    });\n" +
    "    require(['jquery', 'plugins/pikaday.jquery'], function($)\n" +
    "    {\n" +
    "        var $datepicker = $('#datepicker').pikaday({\n" +
    "            firstDay: 1,\n" +
    "            minDate: new Date('2000-01-01'),\n" +
    "            maxDate: new Date('2020-12-31'),\n" +
    "            yearRange: [2000,2020]\n" +
    "        });\n" +
    "        // chain a few methods for the first datepicker, jQuery style!\n" +
    "        $datepicker.pikaday('show').pikaday('nextMonth');\n" +
    "    });\n" +
    "\n" +
    "    </script>\n" +
    "</body>\n" +
    "</html>");
}]);

angular.module("/scripts/utilities/Pikaday/examples/jquery.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/utilities/Pikaday/examples/jquery.html",
    "<!DOCTYPE html>\n" +
    "<html>\n" +
    "<head>\n" +
    "    <meta charset=\"utf-8\">\n" +
    "    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1, minimum-scale=1\">\n" +
    "    <title>Pikaday - jQuery example</title>\n" +
    "    <meta name=\"author\" content=\"Ramiro Rikkert\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/pikaday.css\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/site.css\">\n" +
    "</head>\n" +
    "<body>\n" +
    "    <a href=\"https://github.com/dbushell/Pikaday\"><img style=\"position: absolute; top: 0; right: 0; border: 0;\" src=\"https://s3.amazonaws.com/github/ribbons/forkme_right_gray_6d6d6d.png\" alt=\"Fork me on GitHub\"></a>\n" +
    "\n" +
    "    <h1>Pikaday - jQuery example</h1>\n" +
    "\n" +
    "    <p class=\"large\">A refreshing JavaScript Datepicker — lightweight, no dependencies, modular CSS.</p>\n" +
    "\n" +
    "    <label for=\"datepicker\">Date:</label>\n" +
    "    <br>\n" +
    "    <input type=\"text\" id=\"datepicker\">\n" +
    "\n" +
    "    <h2>What is this?</h2>\n" +
    "\n" +
    "    <p>This is a development preview! Feel free to use it however you like but please report any bugs or feature requests to <a href=\"http://twitter.com/dbushell/\">@dbushell</a> (on the GitHub issue tracker), thanks!</p>\n" +
    "\n" +
    "    <p class=\"small\">Copyright © 2013 <a href=\"http://dbushell.com/\">David Bushell</a> | BSD &amp; MIT license | Example by <a href=\"https://github.com/rikkert\">Ramiro Rikkert</a></p>\n" +
    "\n" +
    "\n" +
    "    <script src=\"//cdnjs.cloudflare.com/ajax/libs/jquery/1.9.1/jquery.min.js\"></script>\n" +
    "    <!-- First load pikaday.js and then the jQuery plugin -->\n" +
    "    <script src=\"../pikaday.js\"></script>\n" +
    "    <script src=\"../plugins/pikaday.jquery.js\"></script>\n" +
    "    <script>\n" +
    "\n" +
    "    var $datepicker = $('#datepicker').pikaday({\n" +
    "        firstDay: 1,\n" +
    "        minDate: new Date('2000-01-01'),\n" +
    "        maxDate: new Date('2020-12-31'),\n" +
    "        yearRange: [2000,2020]\n" +
    "    });\n" +
    "    // chain a few methods for the first datepicker, jQuery style!\n" +
    "    $datepicker.pikaday('show').pikaday('nextMonth');\n" +
    "\n" +
    "    </script>\n" +
    "</body>\n" +
    "</html>");
}]);

angular.module("/scripts/utilities/Pikaday/examples/moment.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/utilities/Pikaday/examples/moment.html",
    "<!DOCTYPE html>\n" +
    "<html>\n" +
    "<head>\n" +
    "    <meta charset=\"utf-8\">\n" +
    "    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1, minimum-scale=1\">\n" +
    "    <title>Pikaday - moment.js example</title>\n" +
    "    <meta name=\"author\" content=\"Ramiro Rikkert\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/pikaday.css\">\n" +
    "    <link rel=\"stylesheet\" href=\"../css/site.css\">\n" +
    "</head>\n" +
    "<body>\n" +
    "    <a href=\"https://github.com/dbushell/Pikaday\"><img style=\"position: absolute; top: 0; right: 0; border: 0;\" src=\"https://s3.amazonaws.com/github/ribbons/forkme_right_gray_6d6d6d.png\" alt=\"Fork me on GitHub\"></a>\n" +
    "\n" +
    "    <h1>Pikaday + moment.js</h1>\n" +
    "\n" +
    "    <p class=\"large\">A refreshing JavaScript Datepicker — lightweight, no dependencies, modular CSS.</p>\n" +
    "\n" +
    "    <label for=\"datepicker\">Date:</label>\n" +
    "    <br>\n" +
    "    <input type=\"text\" id=\"datepicker\">\n" +
    "    <div id=\"selected\"></div>\n" +
    "    <br>\n" +
    "\n" +
    "    <h2>What is this?</h2>\n" +
    "\n" +
    "    <p>This is a development preview! Feel free to use it however you like but please report any bugs or feature requests to <a href=\"http://twitter.com/dbushell/\">@dbushell</a> (on the GitHub issue tracker), thanks!</p>\n" +
    "\n" +
    "    <p class=\"small\">Copyright © 2013 <a href=\"http://dbushell.com/\">David Bushell</a> | BSD &amp; MIT license | Example by <a href=\"https://github.com/rikkert\">Ramiro Rikkert</a></p>\n" +
    "\n" +
    "\n" +
    "    <script src=\"//cdnjs.cloudflare.com/ajax/libs/moment.js/2.0.0/moment.min.js\"></script>\n" +
    "    <script src=\"../pikaday.js\"></script>\n" +
    "    <script>\n" +
    "\n" +
    "    // You can get and set dates with moment objects\n" +
    "    var picker = new Pikaday(\n" +
    "    {\n" +
    "        field: document.getElementById('datepicker'),\n" +
    "        firstDay: 1,\n" +
    "        minDate: new Date('2000-01-01'),\n" +
    "        maxDate: new Date('2020-12-31'),\n" +
    "        yearRange: [2000,2020],\n" +
    "        onSelect: function() {\n" +
    "            var date = document.createTextNode(this.getMoment().format('Do MMMM YYYY') + ' ');\n" +
    "            document.getElementById('selected').appendChild(date);\n" +
    "        }\n" +
    "    });\n" +
    "    \n" +
    "    picker.setMoment(moment().dayOfYear(366));\n" +
    "    \n" +
    "    </script>\n" +
    "</body>\n" +
    "</html>");
}]);

angular.module("/scripts/walkthrough/walkthrough.template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/walkthrough/walkthrough.template.html",
    "<div class=\"goal-block\">\n" +
    "	<div class=\"goal my-goal goal-found\">\n" +
    "		<div>\n" +
    "      <div class=\"walkthrough-img-container\">\n" +
    "  			<img hes-image=\"{{ data.walkthrough_items[data.current_pos].image1.url }}\" />\n" +
    "        <span class=\"backward\"\n" +
    "              ng-hide=\"data.current_pos == 0\"\n" +
    "              ng-click=\"page('backward')\"\n" +
    "              hes-icon icon-name=\"standard:page-back\"\n" +
    "              icon-hover-name=\"standard:page-back-hover\">\n" +
    "        </span>\n" +
    "        <span class=\"forward\"\n" +
    "              ng-hide=\"data.current_pos == data.max_pos\"\n" +
    "              ng-click=\"page('forward')\"\n" +
    "              hes-icon icon-name=\"standard:page-forward\"\n" +
    "              icon-hover-name=\"standard:page-forward-hover\">\n" +
    "        </span>\n" +
    "      </div>\n" +
    "			<div class=\"goal-body\">\n" +
    "				<div class=\"category\" ng-if=\"!site.flags.launch_with_features_on\">New features now available!</div>\n" +
    "				<div class=\"title\">{{ data.walkthrough_items[data.current_pos].title }}</div>\n" +
    "				<div style=\"font-size:18px;\" class='description' hes-external-links ng-bind-html=\"data.walkthrough_items[data.current_pos].content\"></div>\n" +
    "			</div>\n" +
    "			<div ng-if=\"data.max_pos > 0\" class='goal-buttons' style=\"text-align:center;\">\n" +
    "        <span class=\"walkthrough-pos\"\n" +
    "              ng-repeat=\"_ in data.walkthrough_items\"\n" +
    "              ng-class=\"{ 'active': $index == data.current_pos }\"\n" +
    "              ng-click=\"data.current_pos = $index\">\n" +
    "        </span>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/comments/resourceComments.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/comments/resourceComments.html",
    "<div class=\"\">\n" +
    "  <hes-create-post\n" +
    "    on-create=\"$ctrl.placeNewComment(newPost)\"\n" +
    "    wallable=\"$ctrl.wallable\"\n" +
    "    depth=\"0\"\n" +
    "    button-label=\"Post\"\n" +
    "    hide-photo=\"true\"\n" +
    "    hide-tag=\"true\"\n" +
    "    form-class=\"comment-form\"\n" +
    "    place-holder-message=\"Add a comment…\">\n" +
    "  </hes-create-post>\n" +
    "  <hes-post ng-repeat=\"comment in $ctrl.view.resourceWall.posts | orderBy: '-created_at'\"\n" +
    "    post=\"comment\"\n" +
    "    wallable=\"$ctrl.wallable\"\n" +
    "    on-delete=\"$ctrl.commentRemoved(post)\"\n" +
    "    hide-comment=\"true\"\n" +
    "    hide-follow=\"true\"\n" +
    "    hide-location=\"true\"\n" +
    "    post-class=\"comment\">\n" +
    "  </hes-post>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/comments/wallComments.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/comments/wallComments.html",
    "<div>\n" +
    "    <button ng-click=\"$ctrl.increaseLimit()\"\n" +
    "        ng-if=\"$ctrl.view.limit < $ctrl.view.commentWall.posts.length\" class=\"load-posts\">\n" +
    "        load previous\n" +
    "    </button>\n" +
    "    <div class=\"comments\">\n" +
    "        <hes-post ng-repeat=\"comment in $ctrl.view.commentWall.posts | orderBy: 'created_at' \"\n" +
    "            id=\"comment_{{comment.id}}\"\n" +
    "            ng-hide=\"$index < $ctrl.view.commentWall.posts.length - $ctrl.view.limit\"\n" +
    "            post=\"comment\"\n" +
    "            wallable=\"$ctrl.post\"\n" +
    "            on-delete=\"$ctrl.commentRemoved(post)\"\n" +
    "            hide-comment=\"true\"\n" +
    "            hide-location=\"true\"\n" +
    "            post-class=\"comment\"\n" +
    "            users-following='$ctrl.view.commentWall.usersFollowing'>\n" +
    "        </hes-post>\n" +
    "    </div>\n" +
    "    <div ng-if=\"$ctrl.view.commentWall.newPosts.length\">\n" +
    "        <button ng-click=\"$ctrl.placeNewComments()\"\n" +
    "            class=\"load-posts\">\n" +
    "            {{$ctrl.view.commentWall.newPosts.length}} New Comment{{$ctrl.view.commentWall.newPosts.length > 1 ? 's' :''}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "    <md-divider ng-show=\"$ctrl.post.posts.length\"></md-divider>\n" +
    "    <div class=\"comments-form\">\n" +
    "        <hes-create-post\n" +
    "            on-create=\"$ctrl.placeNewComment(newPost)\"\n" +
    "            wallable=\"$ctrl.wallable\"\n" +
    "            parent=\"$ctrl.post\"\n" +
    "            depth=\"1\"\n" +
    "            button-label=\"Comment\"\n" +
    "            hide-photo=\"false\"\n" +
    "            hide-tag=\"true\"\n" +
    "            form-class=\"comment-form\"\n" +
    "            place-holder-message=\"Leave a comment...\">\n" +
    "        </hes-create-post>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/expert/wall_expert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/expert/wall_expert.html",
    "<div>\n" +
    "	<h2>Wall: {{view.wallable.name}}</h2>\n" +
    "\n" +
    "	<div ng-if='view.canSelectWall'>\n" +
    "		<select ng-model='view.activeSiteId' ng-change='changedSite()' \n" +
    "			ng-options=\"s.id as s.name for s in view.allSites | orderBy:'name'\">\n" +
    "		</select>\n" +
    "	</div>\n" +
    "\n" +
    "	<div class=\"bg-secondary\">\n" +
    "	  <hes-create-post ng-if=\"allowCreate()\" class=\"card\" \n" +
    "	    on-create=\"placeNewPost(newPost)\" wallable=\"view.wallable\"\n" +
    "	    hide-tag=\"true\">\n" +
    "	  </hes-create-post>\n" +
    "	  <hes-post class=\"card\" \n" +
    "	    ng-repeat-start=\"post in view.posts | orderBy: '-created_at'\"\n" +
    "	    post=\"post\"\n" +
    "	    wallable=\"view.wallable\"\n" +
    "	    on-delete=\"removePost(post)\">\n" +
    "	  </hes-post>\n" +
    "	  <div ng-repeat-end class=\"card\" ng-if=\"post.showComments()\">\n" +
    "	    <hes-wall-comments post=\"post\" wallable=\"view.wallable\"></hes-wall-comments>\n" +
    "	  </div>\n" +
    "	  <hes-load-more-button on-click=\"showMore()\" \n" +
    "	    ng-if=\"view.total && view.total > view.posts.length\">\n" +
    "	  </hes-load-more-button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/following/followingUsers.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/following/followingUsers.html",
    "<div ng-if=\"view.usersFollowing.all().length == 1\" class=\"bg-secondary\">\n" +
    "<div class=\"card text-center container\" ng-if=\"!view.wall.posts.length && !view.wall.loading\">\n" +
    "  <p ng-bind-html=\"explanations.wall_no_following.content\"></p>\n" +
    "</div>\n" +
    "</div>\n" +
    "<div ng-if=\"view.usersFollowing.all().length != 1\" class=\"following\" layout=\"row\" layout-wrap layout-align-gt-sm=\"space-between\" layout-align=\"center\" >\n" +
    "  <div ng-if=\"view.usersFollowing.all().length > 1\" class=\"follow-item\" flex-sm=\"100\" ng-repeat=\"follow in view.usersFollowing.all()\"\n" +
    "    layout-align='start center' layout=\"row\" style=\"margin-right: 10px\">\n" +
    "    <img class=\"md-img\" hes-image=\"{{follow.profile.image.url}}\"/>\n" +
    "    <div flex class=\"user\">\n" +
    "      <div class='user-name' user-popup='follow'>\n" +
    "        {{follow.getName()}}\n" +
    "      </div>\n" +
    "      <hes-follow-toggle ng-if=\"follow.id !== 'following'\" user=\"follow\" users-following='view.usersFollowing'>\n" +
    "      </hes-follow-toggle>\n" +
    "    </div>\n" +
    "    <div flex=\"none\">\n" +
    "      <button class=\"secondary\" ng-click=\"goToWallFollow(follow)\" aria-label=\"View {{follow.getName()}}'s profile\">View</button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/following/toggleFollow.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/following/toggleFollow.html",
    "<button class='link-look' ng-click='$ctrl.toggleFollow()'\n" +
    "   aria-pressed=\"{{$ctrl.followingUser()}}\"\n" +
    "   aria-label=\"Unfollow {{$ctrl.user.profile.full_name}}\"\n" +
    "   role=\"button\">\n" +
    "    {{$ctrl.followingUser() ? 'unfollow' : 'follow'}}\n" +
    "</button>");
}]);

angular.module("/scripts/wall/guidelines/guidelines.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/guidelines/guidelines.html",
    "<div class=\"container guidelines\">\n" +
    "  <div ng-bind-html=\"view.guidelines.content_html\"></div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/post/create/createPost.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/post/create/createPost.html",
    "<div class=\"{{$ctrl.view.formClass}}\">\n" +
    "  <div class=\"post-header\">\n" +
    "    Comment\n" +
    "  </div>\n" +
    "  <div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\">\n" +
    "    <div class=\"post__form-area\">\n" +
    "      <textarea \n" +
    "        class='post inline' \n" +
    "        growing-input \n" +
    "        min_height=\"40\"\n" +
    "        height-offset='2' \n" +
    "        placeholder='{{$ctrl.view.placeHolderMessage}}' \n" +
    "        aria-label='{{$ctrl.view.placeHolderMessage}}'\n" +
    "        ng-model='$ctrl.data.newPost.content'\n" +
    "        id=\"comment_on_{{$ctrl.parent.id}}\">\n" +
    "      </textarea>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"post__actions\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\">\n" +
    "    <div hide-xs class=\"sm-flex\">\n" +
    "      <span ng-if=\"!$ctrl.view.hidePhoto\" \n" +
    "        hes-file-upload \n" +
    "        complete='$ctrl.addPhoto(imageUrl)'\n" +
    "        failure='$ctrl.onFailure()'\n" +
    "        ng-model='data.newPost.photo' \n" +
    "        class='button-style icon-btn' \n" +
    "        resize-width=\"1920\" \n" +
    "        resize-height=\"1080\"\n" +
    "        template=\"/scripts/upload/fileUploadPhoto.html\"></span>\n" +
    "      <button class=\"icon-btn\" \n" +
    "        aria-label=\"Tag someone\" \n" +
    "        ng-if=\"!$ctrl.view.hideTag\"\n" +
    "        ng-click=\"$ctrl.openTagUsers()\">\n" +
    "        <span hes-icon icon-name=\"wall:tag-user\"\n" +
    "          icon-hover-name='wall:tag-user-filled' watch-parent=\"button\"></span>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "    <div class=\"wall__post-tags\">\n" +
    "      <div hide-gt-xs>\n" +
    "          <span ng-if=\"!$ctrl.view.hidePhoto\" \n" +
    "            hes-file-upload \n" +
    "            complete='$ctrl.addPhoto(imageUrl)'\n" +
    "            failure='$ctrl.onFailure()'\n" +
    "            ng-model='data.newPost.photo' \n" +
    "            class='button-style icon-btn' \n" +
    "            resize-width=\"1920\" \n" +
    "            resize-height=\"1080\"\n" +
    "            template=\"/scripts/upload/fileUploadPhoto.html\"></span>\n" +
    "          <button class=\"icon-btn\" \n" +
    "            aria-label=\"Tag someone\" \n" +
    "            ng-if=\"!$ctrl.view.hideTag\"\n" +
    "            ng-click=\"$ctrl.openTagUsers()\">\n" +
    "            <span hes-icon icon-name=\"wall:tag-user\"\n" +
    "              icon-hover-name='wall:tag-user-filled' watch-parent=\"button\"></span>\n" +
    "          </button>\n" +
    "        </div>\n" +
    "        <button class=\"button-secondary\" ng-click=\"$ctrl.create()\" ng-disabled=\"$ctrl.view.saving\">{{$ctrl.view.buttonLabel}}</button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <hes-post-tagged-users post=\"$ctrl.data.newPost\"></hes-post-tagged-users>\n" +
    "  <div class=\"preview-image\" ng-if=\"!!$ctrl.data.newPost.photo\">\n" +
    "    <img hes-image=\"{{$ctrl.data.newPost.photo}}\" use-domain=\"true\" no-theme/>\n" +
    "    <button class=\"icon-btn remove-photo\" ng-click=\"$ctrl.removePhoto()\" md-autofocus>\n" +
    "      <span hes-icon icon-name='standard:close-x'>Close</span>\n" +
    "    </button>\n" +
    "  </div>\n" +
    "  <ng-messages ng-show=\"$ctrl.validation.empty\" for=\"$ctrl.validation\" role=\"alert\">\n" +
    "    <span ng-message=\"empty\">Oops&hellip; you need to add your {{ $ctrl.isState('go.u.content.wall.all') ? 'message' : 'comment' }} first.</span>\n" +
    "  </ng-messages>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/post/create/tagUsers/tagUsersDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/post/create/tagUsers/tagUsersDialog.html",
    "<div class=\"tag-users\">\n" +
    "  <h2 class=\"dialog-title\">Tag Your {{site.getFriendsLabel(true)}}</h2>\n" +
    "  <div ng-if=\"view.friends.length === 0\">\n" +
    "    <p>\n" +
    "      Oops! You don't have any {{site.getFriendsLabel(true)}} to tag. Want to <a ui-sref='go.u.usermenu.friends.search' ng-click='closeModal()'>add some</a>? \n" +
    "    </p>\n" +
    "  </div>\n" +
    "  <hes-search-input on-search=\"applySearch(value)\" \n" +
    "    search-value=\"data.search\"\n" +
    "    ng-hide=\"view.friends.length === 0\"\n" +
    "    placeholder-text=\"Search by name...\">\n" +
    "  </hes-search-input>\n" +
    "  <md-chips ng-if=\"view.taggedUsers.length > 0\" ng-model=\"view.taggedUsers\" md-on-remove=\"removeTaggedChip($chip)\"\n" +
    "    md-transform-chip=\"transformChip($chip)\" md-removeable=\"true\" readonly=\"true\">\n" +
    "    <md-chip-template>\n" +
    "      <div layout=\"row\" layout-align=\"space-between center\">\n" +
    "        <img alt=\"\" hes-image='{{$chip.profile.image.url}}' />\n" +
    "        <strong>{{$chip.profile.full_name}}</strong>\n" +
    "        <button class=\"icon-btn\" ng-click='removeTaggedChip($chip)'\n" +
    "          aria-label=\"Untag {{$chip.profile.full_name}}\">\n" +
    "          <span hes-icon icon-name=\"standard:close-x\"></span>\n" +
    "        </button>\n" +
    "      </div>\n" +
    "    </md-chip-template>\n" +
    "  </md-chips>\n" +
    "  <md-divider ng-if=\"view.taggedUsers.length > 0\"></md-divider>\n" +
    "  <div ng-if=\"view.friends.length > 0\">\n" +
    "    <!-- <h3 ng-hide=\"view.filteredAvailable.length == 0\">Available</h3> -->\n" +
    "    <div class=\"tag-list\">\n" +
    "      <div class=\"tag-list-item\" ng-repeat=\"friend in (view.filteredAvailable = \n" +
    "        (view.friends | friendSearch : view.search\n" +
    "        | orderBy: friend.friendee.profile.first_name))\" \n" +
    "        layout=\"row\" layout-align=\"start center\">\n" +
    "        <div flex=\"nogrow\">\n" +
    "          <img alt=\"\" hes-image='{{friend.friendee.profile.image.url}}' class='sm-img' />\n" +
    "        </div>\n" +
    "        <div flex=\"80\" class=\"tag-name\">\n" +
    "          <span>{{friend.getFriendFullName()}}</span>\n" +
    "        </div>\n" +
    "        <div flex>\n" +
    "          <span type=\"checkbox\" class=\"hes-checkbox\" hes-checkbox \n" +
    "            ng-model='friend.is_tagged' ng-change='changeTagSelection(friend)'\n" +
    "            aria-label=\"{{(friend.is_tagged ? 'Untag ' : 'Tag ') + friend.getFriendFullName()}}\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class='dialog-buttons'>\n" +
    "    <button class='link-look' ng-click='closeThisDialog()'>Cancel</button>\n" +
    "    <button ng-click='applyChanges()'>Done</button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/post/menu/postMenu.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/post/menu/postMenu.html",
    "<div ng-if=\"$ctrl.hasAction()\">\n" +
    "  <button class=\"icon-btn tooltip-btn\" ng-click=\"$ctrl.toggleTooltip($event)\">\n" +
    "    <span hes-icon icon-name=\"standard:dots-horizontal\"></span>\n" +
    "    <div class=\"tooltip\">\n" +
    "      <span ng-if=\"$ctrl.post.canDelete($ctrl.user)\" ng-click=\"$ctrl.confirmDelete()\">\n" +
    "        Delete\n" +
    "      </span>\n" +
    "      <span ng-if=\"$ctrl.post.canReport($ctrl.user)\" ng-click=\"$ctrl.confirmReport($ctrl.user)\">\n" +
    "        Report\n" +
    "      </span>\n" +
    "      <span ng-if=\"$ctrl.post.canUnreport($ctrl.user)\" ng-click=\"$ctrl.unReportPlusUpdate()\">\n" +
    "        Unreport\n" +
    "      </span>\n" +
    "      <span ng-if=\"$ctrl.post.userIsTagged($ctrl.user)\" ng-click=\"$ctrl.confirmRemoveTag()\">\n" +
    "        Remove Tag\n" +
    "      </span>\n" +
    "    </div>\n" +
    "  </button>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/post/post.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/post/post.html",
    "<div class=\"{{$ctrl.view.postClass}}\">\n" +
    "  <header class=\"post__header\">\n" +
    "\n" +
    "    <img alt=\"\" class='md-img' hes-image='{{$ctrl.post.getPosterImage()}}' />\n" +
    "\n" +
    "    <div class=\"post__header-meta\">\n" +
    "      <div>\n" +
    "        <div class='user-name' user-popup='$ctrl.post.user'>\n" +
    "          {{$ctrl.post.getPosterName()}}\n" +
    "        </div>\n" +
    "        <hes-follow-toggle ng-if=\"!$ctrl.view.hideFollow && $ctrl.post.canFollow()\"\n" +
    "          user=\"$ctrl.post.user\" users-following='$ctrl.usersFollowing'>\n" +
    "        </hes-follow-toggle>\n" +
    "        <span class='user-region' ng-if='!$ctrl.post.is_flagged \n" +
    "            && $ctrl.site.flags.is_location_displayed \n" +
    "            && !$ctrl.post.user.is_wall_expert'>{{$ctrl.post.user.location.name}}\n" +
    "        </span>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"post__date-menu\">\n" +
    "        <hes-post-menu post=\"$ctrl.post\" user='$ctrl.user'\n" +
    "          on-delete=\"$ctrl.postDeleted()\"\n" +
    "          on-update=\"$ctrl.postUpdated()\">\n" +
    "        </hes-post-menu>\n" +
    "        <div class='timestamp' flex=\"noshrink\">{{$ctrl.post.formatDate(true)}}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </header>\n" +
    "\n" +
    "  <div class=\"post__content\">\n" +
    "    <div>\n" +
    "      <div class='post-text' flex=\"95\" flex-gt-xs=\"80\">\n" +
    "        <p ng-if='!$ctrl.post.is_flagged || $ctrl.post.displayReportedContent'>\n" +
    "          <span ng-model='$ctrl.post.content' hes-allow-hyperlinks text='$ctrl.post.content'>\n" +
    "          </span>\n" +
    "          <hes-post-tagged-users post=\"$ctrl.post\"></hes-post-tagged-users>\n" +
    "          <button class='link-look' ng-if='$ctrl.post.is_flagged'\n" +
    "            ng-click='$ctrl.post.toggleReportedContent()'>hide\n" +
    "          </button>\n" +
    "        </p>\n" +
    "        <p ng-if='$ctrl.post.is_flagged && !$ctrl.post.displayReportedContent'>This post has been reported.\n" +
    "          <button class='link-look' ng-if='$ctrl.post.canUnreport($ctrl.user) || $ctrl.post.isFromMe()'\n" +
    "            ng-click='$ctrl.post.toggleReportedContent()'>view\n" +
    "          </button>\n" +
    "        </p>\n" +
    "      </div>\n" +
    "      <div class='photo' aria-label=\"Wall Post Image\" ng-if='$ctrl.post.hasPhoto() && (!$ctrl.post.is_flagged || $ctrl.post.displayReportedContent)'\n" +
    "        hes-image-viewer=\"{{::$ctrl.post.photo.url}}\"></div>\n" +
    "      <div flex=\"95\" flex-gt-xs=\"80\"\n" +
    "        ng-if='!!$ctrl.post.postable_type && !!$ctrl.post.postable_id && (!$ctrl.post.is_flagged || $ctrl.post.displayReportedContent)'>\n" +
    "        <hes-shared-post postable-id=\"{{$ctrl.post.postable_id}}\" postable-type=\"{{$ctrl.post.postable_type}}\">\n" +
    "        </hes-shared-post>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"interactions\" ng-if=\"!$ctrl.post.is_flagged\">\n" +
    "      <div class=\"interaction\" ng-if=\"!$ctrl.view.hideLike\">\n" +
    "        <button class=\"icon-btn like\"\n" +
    "          ng-class=\"{'active': $ctrl.post.hasLiked($ctrl.user)}\"\n" +
    "          ng-click=\"$ctrl.post.toggleLike($ctrl.user)\"\n" +
    "          aria-label=\"like {{$ctrl.view.postClass}}\"\n" +
    "          aria-pressed=\"{{$ctrl.post.hasLiked($ctrl.user)}}\">\n" +
    "          <span hes-icon\n" +
    "            icon-name=\"{{'wall:like' + ($ctrl.post.hasLiked($ctrl.user) ? '-filled' : '')}}\"\n" +
    "            icon-hover-name=\"wall:like-filled\"\n" +
    "            watch-parent=\"button\"></span>\n" +
    "          <span class=\"text\">&nbsp;Like</span>\n" +
    "        </button>\n" +
    "        <hes-users-popover class=\"like-comment-cnt\" items=\"$ctrl.post.likes\"\n" +
    "          user=\"$ctrl.user\">\n" +
    "        </hes-users-popover>\n" +
    "      </div>\n" +
    "      <div class=\"interaction\" ng-if=\"!$ctrl.view.hideComment\">\n" +
    "        <button class=\"icon-btn\"\n" +
    "          ng-class=\"{'active': $ctrl.post.showComments()}\"\n" +
    "          ng-click=\"$ctrl.post.toggleComments()\"\n" +
    "          aria-pressed=\"{{$ctrl.post.showComments()}}\"\n" +
    "          aria-label=\"{{$ctrl.post.showComments() ? 'hide comments' : 'show comments'}}\">\n" +
    "          <span hes-icon\n" +
    "            icon-name=\"{{'wall:comment' + ($ctrl.post.showComments($ctrl.user) ? '-filled' : '')}}\"\n" +
    "            icon-hover-name=\"wall:comment-filled\"\n" +
    "            watch-parent=\"button\"></span>\n" +
    "          <span class=\"text\">&nbsp;Comment</span>\n" +
    "        </button>\n" +
    "        <hes-users-popover class=\"like-comment-cnt\" items=\"$ctrl.post.posts\"\n" +
    "          user=\"$ctrl.user\">\n" +
    "        </hes-users-popover>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/post/shared/sharedPost.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/post/shared/sharedPost.html",
    "<div class=\"shared-post\" ng-switch=\"$ctrl.postableType\" ng-class='{\"no-border\": $ctrl.postableType == \"Goal\"}'>\n" +
    "  <div ng-switch-when=\"Goal\" class=\"resource-item\">\n" +
    "    <img alt=\"\" class='goal-image' hes-image=\"{{$ctrl.resource.image.url}}\" />\n" +
    "    <br /><br />\n" +
    "    <div class=\"title\">Completed Goal: {{ $ctrl.resource.title }}</span></div>\n" +
    "    <div class=\"summary\" markdown ng-model=\"::$ctrl.resource.description\"></div>\n" +
    "  </div>\n" +
    "  <div ng-switch-when=\"Recipe\"\n" +
    "       class=\"resource-item clickable\"\n" +
    "       layout-xs=\"row\"\n" +
    "       layout-gt-xs=\"row\"\n" +
    "       layout-align=\"start center\"\n" +
    "       ui-sref=\"go.u.content.recipes.single({id: $ctrl.resource.id})\">\n" +
    "    <div class=\"image-frame\">\n" +
    "      <img alt=\"\" class=\"preview-image\" hes-image=\"{{$ctrl.resource.image_url}}\" />\n" +
    "    </div>\n" +
    "    <div class=\"preview\">\n" +
    "      <div class=\"title\" markdown-div no-paragraph ng-model='::$ctrl.resource.title'></div>\n" +
    "      <div class=\"summary\" markdown ng-model=\"::$ctrl.resource._summary\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-switch-when=\"Tip\"\n" +
    "       class=\"resource-item clickable\"\n" +
    "       layout-xs=\"row\" \n" +
    "       layout-gt-xs=\"row\"\n" +
    "       layout-align=\"start center\"\n" +
    "       ui-sref=\"go.u.content.tips.single({id: $ctrl.resource.id})\">\n" +
    "    <div class=\"image-frame\">\n" +
    "      <img alt=\"\" class=\"preview-image\" hes-image=\"{{::$ctrl.resource.image1.url}}\" \n" +
    "        use-domain=\"true\" no-theme/>\n" +
    "    </div>\n" +
    "    <div class=\"preview\">\n" +
    "      <div class=\"secondary-text\">{{$ctrl.resource.date | date: \"EEE, MMM d\"}}</div>\n" +
    "      <div class=\"title\" markdown-div no-paragraph \n" +
    "        ng-model='::$ctrl.resource.title_html'>\n" +
    "      </div>\n" +
    "      <div class=\"summary\" markdown ng-model=\"::$ctrl.resource.summary_html\">\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/post/tagged/allTaggedUsersDialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/post/tagged/allTaggedUsersDialog.html",
    "<div class=\"tag-users\">\n" +
    "  <h2>Tagged Users</h2>\n" +
    "  <div class=\"tag-list\">\n" +
    "    <div class=\"tag-list-item\" ng-repeat=\"user in post.tagged_users\" \n" +
    "      layout=\"row\" layout-align=\"start center\">\n" +
    "      <div flex=\"nogrow\">\n" +
    "        <img alt=\"\" hes-image='{{user.profile.image.url}}' class='sm-img' />\n" +
    "      </div>\n" +
    "      <div flex class=\"tag-name\">\n" +
    "        <span>{{user.fullName()}}</span>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/post/tagged/taggedUsers.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/post/tagged/taggedUsers.html",
    "<span ng-if='$ctrl.post.tagged_users.length > 0'>\n" +
    "  <nobr>&ndash; with\n" +
    "    <span class='' ng-if='!isMe($ctrl.post.tagged_users[0])' user-popup='$ctrl.post.tagged_users[0]'>{{$ctrl.post.tagged_users[0].profile.first_name}} {{$ctrl.post.tagged_users[0].profile.last_name}}</span>\n" +
    "    <span ng-if='isMe($ctrl.post.tagged_users[0])'>{{$ctrl.post.tagged_users[0].profile.first_name}} {{$ctrl.post.tagged_users[0].profile.last_name}}</span>\n" +
    "    <span ng-if='$ctrl.post.tagged_users.length == 2'> and </span>\n" +
    "    <span class='' user-popup='$ctrl.post.tagged_users[1]' ng-if='$ctrl.post.tagged_users.length == 2 && !isMe($ctrl.post.tagged_users[1])'>{{$ctrl.post.tagged_users[1].profile.first_name}} {{$ctrl.post.tagged_users[1].profile.last_name}}</span>\n" +
    "    <span ng-if='$ctrl.post.tagged_users.length == 2 && isMe($ctrl.post.tagged_users[1])'>{{$ctrl.post.tagged_users[1].profile.first_name}} {{$ctrl.post.tagged_users[1].profile.last_name}}</span>\n" +
    "    <button class=\"link-look\" ng-click=\"$ctrl.showAllTaggedUsers()\" ng-if='$ctrl.post.tagged_users.length > 2'>and\n" +
    "      <strong>{{$ctrl.post.tagged_users.length - 1}} </strong>others\n" +
    "    </span>\n" +
    "  </nobr>\n" +
    "</span>");
}]);

angular.module("/scripts/wall/posts/posts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/posts/posts.html",
    "");
}]);

angular.module("/scripts/wall/views/singlePost.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/views/singlePost.html",
    "<div class=\"bg-secondary\">\n" +
    "  <div class=\"card crumb\">\n" +
    "    <hes-breadcrumb crumbs=\"view.crumbs\">\n" +
    "    </hes-breadcrumb>\n" +
    "  </div>\n" +
    "  <div ng-if=\"!!view.singlePost\">\n" +
    "    <hes-post class=\"card\" \n" +
    "      post=\"view.singlePost\"\n" +
    "      wallable=\"view.wallable\"\n" +
    "      users-following='view.wall.usersFollowing'\n" +
    "      on-delete=\"removePost(post)\">\n" +
    "    </hes-post>\n" +
    "    <div class=\"card\" ng-if=\"view.singlePost.showComments()\">\n" +
    "      <hes-wall-comments post=\"view.singlePost\" wallable=\"view.wallable\"></hes-wall-comments>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("/scripts/wall/views/wall.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/wall/views/wall.html",
    "<div class=\"bg-secondary\">\n" +
    "  <div class=\"card crumb\" ng-if=\"view.showBreadcrumb\">\n" +
    "    <hes-breadcrumb crumbs=\"view.crumbs\">\n" +
    "    </hes-breadcrumb>\n" +
    "  </div>\n" +
    "  <hes-create-post ng-if=\"allowCreate()\" class=\"card\" \n" +
    "    on-create=\"placeNewPost(newPost)\" wallable=\"site\"></hes-create-post>\n" +
    "  <div class=\"card\" ng-if=\"view.wall.newPosts.length\">\n" +
    "    <button class=\"load-posts\" \n" +
    "      ng-click=\"view.wall.placeIncomingPosts()\">\n" +
    "      {{view.wall.newPosts.length}} New Post{{view.wall.newPosts.length > 1 ? 's' :''}}\n" +
    "    </button>\n" +
    "  </div>\n" +
    "  <div class=\"card text-center container\" ng-if=\"!view.wall.posts.length && !view.wall.loading\">\n" +
    "    <p ng-if=\"$state.params.filter == 'friends' && data.has_no_friends\" ng-bind-html=\"explanations.wall_no_peers.content\">\n" +
    "    </p>\n" +
    "    <p ng-if=\"$state.params.filter != 'friends' || !data.has_no_friends\" ng-bind-html=\"explanations.wall_no_posts.content\"></p>\n" +
    "  </div>\n" +
    "  <div class=\"post-divider\" ng-if=\"view.wall.posts.length\"></div>\n" +
    "  <hes-post class=\"card\" \n" +
    "    ng-repeat-start=\"post in view.posts | orderBy: '-created_at'\"\n" +
    "    post=\"post\"\n" +
    "    wallable=\"site\"\n" +
    "    users-following='view.wall.usersFollowing'\n" +
    "    on-delete=\"removePost(post)\"\n" +
    "    on-update=\"updatePost(post)\">\n" +
    "  </hes-post>\n" +
    "  <div ng-repeat-end class=\"card thin\" ng-if=\"post.showComments()\">\n" +
    "    <hes-wall-comments post=\"post\" wallable=\"site\"></hes-wall-comments>\n" +
    "  </div>\n" +
    "  <hes-load-more-button on-click=\"showMore()\" \n" +
    "    ng-if=\"view.total && view.total > view.posts.length\">\n" +
    "  </hes-load-more-button>\n" +
    "</div>");
}]);

angular.module("/scripts/webcart/webcart.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/webcart/webcart.html",
    "<p ng-show=\"!contentLoaded\">\n" +
    "    Loading content...\n" +
    "</p>\n" +
    "<div ng-show=\"contentLoaded && !loadingError\">\n" +
    "    <div class=\"ngDialog-title\" ng-bind-html=\"popupContent.title_html\"></div>\n" +
    "    <div class=\"webcart-body-text margin-xlg-bottom\" ng-bind-html=\"popupContent.content_html\"></div>\n" +
    "    <div class=\"text-right\">\n" +
    "        <a href=\"{{site.webcart_link}}\" class=\"webcart-open-button\" target=\"_blank\">Order a Fitbit</a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-show=\"contentLoaded && loadingError\">\n" +
    "    {{loadingError}}\n" +
    "</div>");
}]);

angular.module("/scripts/webcart/webcartLink.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/webcart/webcartLink.html",
    "<a ng-click=\"showWebcartPopup()\">{{ label }}</a>");
}]);

angular.module("/scripts/welcome/welcome.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("/scripts/welcome/welcome.html",
    "<div class=\"welcome-view\">\n" +
    "  <div class='welcome-banner'>\n" +
    "\n" +
    "    <div class='logo'>\n" +
    "      <img hes-image=\"{{configWelcome.welcomeLogo}}\" no-theme alt='App Logo' use-domain=\"true\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class='welcome-text'>\n" +
    "      <div class='welcome-text-block'>\n" +
    "        <div class='welcome-banner-title'>\n" +
    "          <div markdown ng-model=\"configWelcome.welcomeContent.title_html\" no-paragraph='true' hes-external-links></div>\n" +
    "        </div>\n" +
    "        <div class='welcome-banner-content'>\n" +
    "          <div markdown ng-model=\"configWelcome.welcomeContent.summary_html\" no-paragraph='true' hes-external-links></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if='site.hasLaunched()' class='button-container'>\n" +
    "      <button ng-if=\"!site.is_sso_enabled\" class='login button-tertiary' ui-sref=\"go.welcome.login\">Log In</button>\n" +
    "      <button class=\"color log-button-secondary\" ui-sref=\"go.register\">Register</button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "\n" +
    "  <div class='welcome-body'>\n" +
    "\n" +
    "    <div class='body-content' flex hes-external-links>\n" +
    "\n" +
    "      <!-- Has Launched -->\n" +
    "      <div ng-if='site.hasLaunched()' class=\"welcome-content\">\n" +
    "        <div class='content-body' layout=\"column\" layout-gt-sm='row' markdown ng-model=\"configWelcome.welcomeContent.content_html\" hes-external-links></div>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- Has Not Launched Yet -->\n" +
    "      <div ng-if='!site.hasLaunched()'>\n" +
    "        <div class='body-countdown' ng-include=\"'/scripts/countdown/countdownPage.html'\"></div>\n" +
    "      </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "  </div>\n" +
    "</div>");
}]);
